import _toArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toArray";
import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _wrapNativeSuper from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { __rest } from 'tslib';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import cn from 'clsx';
import { forwardRef, memo, Children, cloneElement, useState, useRef, useCallback, useEffect, createContext, useContext, useLayoutEffect, useMemo, isValidElement, Fragment as Fragment$1 } from 'react';
import { findIconDefinition, library } from '@fortawesome/fontawesome-svg-core';
import { faCaretDown, faCaretLeft, faCaretRight, faCaretUp, faCheck, faChevronDown, faChevronLeft, faChevronRight, faChevronUp, faCopy, faExclamationCircle, faExclamationTriangle, faExpandArrowsAlt, faExternalLinkAlt, faInfoCircle, faLink, faSort } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import create from 'zustand';
import { parseToHsl, parseToRgb, rgba, getLuminance, mix, readableColor } from 'polished';
import { useDOMRef, useFocusableRef, useUnwrapDOMRef, useValueEffect } from '@react-spectrum/utils';
import { useButton } from '@react-aria/button';
import { FocusRing, focusSafely, FocusScope, useFocusRing, FocusableProvider } from '@react-aria/focus';
import { useHover, useInteractOutside, useFocusWithin, getInteractionModality as getInteractionModality$1, PressResponder, usePress, useMove, Pressable } from '@react-aria/interactions';
export { PressResponder, Pressable } from '@react-aria/interactions';
import { mergeProps, isMac, useId } from '@react-aria/utils';
export { useId } from '@react-aria/utils';
import { useMenu, useMenuSection, useMenuItem, useMenuTrigger } from '@react-aria/menu';
import { useOverlayPosition as useOverlayPosition$1, useOverlayTrigger, useModal, DismissButton, usePreventScroll, OverlayProvider } from '@react-aria/overlays';
import copy from 'copy-to-clipboard';
import ReactDOM, { unstable_batchedUpdates } from 'react-dom';
import { SSRProvider } from '@react-aria/ssr';
export { useIsSSR, useSSRSafeId } from '@react-aria/ssr';
import useSize from '@react-hook/size';
import _get from 'lodash.get';
import { persist } from 'zustand/middleware';
import shallow from 'zustand/shallow';
import { useSeparator } from '@react-aria/separator';
import { useCollection, Item as Item$1 } from '@react-stately/collections';
import { useDialog } from '@react-aria/dialog';
import { useWindowSize } from '@react-hook/window-size';
import { useTextField } from '@react-aria/textfield';
import { useListBox, useOption, useListBoxSection } from '@react-aria/listbox';
import { useListState, ListCollection } from '@react-stately/list';
import { Key } from 'ts-keycode-enum';
import { useRadio, useRadioGroup } from '@react-aria/radio';
import { VisuallyHidden } from '@react-aria/visually-hidden';
import { useRadioGroupState } from '@react-stately/radio';
import { useSelect, HiddenSelect } from '@react-aria/select';
import { useSelectState } from '@react-stately/select';
import { useSwitch } from '@react-aria/switch';
import { useTab, useTabList, useTabPanel } from '@react-aria/tabs';
import { useTabListState } from '@react-stately/tabs';
import { useTooltipTrigger, useTooltip } from '@react-aria/tooltip';
import { useTooltipTriggerState } from '@react-stately/tooltip';
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

var check = function check(it) {
  return it && it.Math == Math && it;
}; // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028


var global_1 = // eslint-disable-next-line es/no-global-this -- safe
check(typeof globalThis == 'object' && globalThis) || check(typeof window == 'object' && window) || // eslint-disable-next-line no-restricted-globals -- safe
check(typeof self == 'object' && self) || check(typeof commonjsGlobal == 'object' && commonjsGlobal) || // eslint-disable-next-line no-new-func -- fallback
function () {
  return this;
}() || Function('return this')();

var fails = function fails(exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
}; // Detect IE8's incomplete defineProperty implementation


var descriptors = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, {
    get: function get() {
      return 7;
    }
  })[1] != 7;
});
var $propertyIsEnumerable = {}.propertyIsEnumerable; // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe

var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor; // Nashorn ~ JDK8 bug

var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({
  1: 2
}, 1); // `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable

var f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;
var objectPropertyIsEnumerable = {
  f: f
};

var createPropertyDescriptor = function createPropertyDescriptor(bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var toString = {}.toString;

var classofRaw = function classofRaw(it) {
  return toString.call(it).slice(8, -1);
};

var split = ''.split; // fallback for non-array-like ES3 and non-enumerable old V8 strings

var indexedObject = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classofRaw(it) == 'String' ? split.call(it, '') : Object(it);
} : Object; // `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible

var requireObjectCoercible = function requireObjectCoercible(it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
}; // toObject with fallback for non-array-like ES3 strings


var toIndexedObject = function toIndexedObject(it) {
  return indexedObject(requireObjectCoercible(it));
};

var isObject = function isObject(it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
}; // `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string


var toPrimitive = function toPrimitive(input, PREFERRED_STRING) {
  if (!isObject(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
}; // `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject


var toObject = function toObject(argument) {
  return Object(requireObjectCoercible(argument));
};

var hasOwnProperty = {}.hasOwnProperty;

var has = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty.call(toObject(it), key);
};

var document$1 = global_1.document; // typeof document.createElement is 'object' in old IE

var EXISTS = isObject(document$1) && isObject(document$1.createElement);

var documentCreateElement = function documentCreateElement(it) {
  return EXISTS ? document$1.createElement(it) : {};
}; // Thank's IE8 for his funny defineProperty


var ie8DomDefine = !descriptors && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
  return Object.defineProperty(documentCreateElement('div'), 'a', {
    get: function get() {
      return 7;
    }
  }).a != 7;
}); // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe

var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor; // `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor

var f$1 = descriptors ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPrimitive(P, true);
  if (ie8DomDefine) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) {
    /* empty */
  }
  if (has(O, P)) return createPropertyDescriptor(!objectPropertyIsEnumerable.f.call(O, P), O[P]);
};
var objectGetOwnPropertyDescriptor = {
  f: f$1
};

var anObject = function anObject(it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + ' is not an object');
  }

  return it;
}; // eslint-disable-next-line es/no-object-defineproperty -- safe


var $defineProperty = Object.defineProperty; // `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty

var f$2 = descriptors ? $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (ie8DomDefine) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) {
    /* empty */
  }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};
var objectDefineProperty = {
  f: f$2
};
var createNonEnumerableProperty = descriptors ? function (object, key, value) {
  return objectDefineProperty.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var setGlobal = function setGlobal(key, value) {
  try {
    createNonEnumerableProperty(global_1, key, value);
  } catch (error) {
    global_1[key] = value;
  }

  return value;
};

var SHARED = '__core-js_shared__';
var store = global_1[SHARED] || setGlobal(SHARED, {});
var sharedStore = store;
var functionToString = Function.toString; // this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper

if (typeof sharedStore.inspectSource != 'function') {
  sharedStore.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

var inspectSource = sharedStore.inspectSource;
var WeakMap$1 = global_1.WeakMap;
var nativeWeakMap = typeof WeakMap$1 === 'function' && /native code/.test(inspectSource(WeakMap$1));
var shared = createCommonjsModule(function (module) {
  (module.exports = function (key, value) {
    return sharedStore[key] || (sharedStore[key] = value !== undefined ? value : {});
  })('versions', []).push({
    version: '3.14.0',
    mode: 'global',
    copyright: '© 2021 Denis Pushkarev (zloirock.ru)'
  });
});
var id = 0;
var postfix = Math.random();

var uid = function uid(key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};

var keys = shared('keys');

var sharedKey = function sharedKey(key) {
  return keys[key] || (keys[key] = uid(key));
};

var hiddenKeys = {};
var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var WeakMap$2 = global_1.WeakMap;
var set, get, has$1;

var enforce = function enforce(it) {
  return has$1(it) ? get(it) : set(it, {});
};

var getterFor = function getterFor(TYPE) {
  return function (it) {
    var state;

    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    }

    return state;
  };
};

if (nativeWeakMap || sharedStore.state) {
  var store$1 = sharedStore.state || (sharedStore.state = new WeakMap$2());
  var wmget = store$1.get;
  var wmhas = store$1.has;
  var wmset = store$1.set;

  set = function set(it, metadata) {
    if (wmhas.call(store$1, it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset.call(store$1, it, metadata);
    return metadata;
  };

  get = function get(it) {
    return wmget.call(store$1, it) || {};
  };

  has$1 = function has$1(it) {
    return wmhas.call(store$1, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;

  set = function set(it, metadata) {
    if (has(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };

  get = function get(it) {
    return has(it, STATE) ? it[STATE] : {};
  };

  has$1 = function has$1(it) {
    return has(it, STATE);
  };
}

var internalState = {
  set: set,
  get: get,
  has: has$1,
  enforce: enforce,
  getterFor: getterFor
};
var redefine = createCommonjsModule(function (module) {
  var getInternalState = internalState.get;
  var enforceInternalState = internalState.enforce;
  var TEMPLATE = String(String).split('String');
  (module.exports = function (O, key, value, options) {
    var unsafe = options ? !!options.unsafe : false;
    var simple = options ? !!options.enumerable : false;
    var noTargetGet = options ? !!options.noTargetGet : false;
    var state;

    if (typeof value == 'function') {
      if (typeof key == 'string' && !has(value, 'name')) {
        createNonEnumerableProperty(value, 'name', key);
      }

      state = enforceInternalState(value);

      if (!state.source) {
        state.source = TEMPLATE.join(typeof key == 'string' ? key : '');
      }
    }

    if (O === global_1) {
      if (simple) O[key] = value;else setGlobal(key, value);
      return;
    } else if (!unsafe) {
      delete O[key];
    } else if (!noTargetGet && O[key]) {
      simple = true;
    }

    if (simple) O[key] = value;else createNonEnumerableProperty(O, key, value); // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
  })(Function.prototype, 'toString', function toString() {
    return typeof this == 'function' && getInternalState(this).source || inspectSource(this);
  });
});
var path = global_1;

var aFunction = function aFunction(variable) {
  return typeof variable == 'function' ? variable : undefined;
};

var getBuiltIn = function getBuiltIn(namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global_1[namespace]) : path[namespace] && path[namespace][method] || global_1[namespace] && global_1[namespace][method];
};

var ceil = Math.ceil;
var floor = Math.floor; // `ToInteger` abstract operation
// https://tc39.es/ecma262/#sec-tointeger

var toInteger = function toInteger(argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};

var min = Math.min; // `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength

var toLength = function toLength(argument) {
  return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var max = Math.max;
var min$1 = Math.min; // Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).

var toAbsoluteIndex = function toAbsoluteIndex(index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min$1(integer, length);
}; // `Array.prototype.{ indexOf, includes }` methods implementation


var createMethod = function createMethod(IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value; // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check

    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++]; // eslint-disable-next-line no-self-compare -- NaN check

      if (value != value) return true; // Array#indexOf ignores holes, Array#includes - not
    } else for (; length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    }
    return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};
var indexOf = arrayIncludes.indexOf;

var objectKeysInternal = function objectKeysInternal(object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;

  for (key in O) {
    !has(hiddenKeys, key) && has(O, key) && result.push(key);
  } // Don't enum bug & hidden keys


  while (names.length > i) {
    if (has(O, key = names[i++])) {
      ~indexOf(result, key) || result.push(key);
    }
  }

  return result;
}; // IE8- don't enum bug keys


var enumBugKeys = ['constructor', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'toLocaleString', 'toString', 'valueOf'];
var hiddenKeys$1 = enumBugKeys.concat('length', 'prototype'); // `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe

var f$3 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return objectKeysInternal(O, hiddenKeys$1);
};

var objectGetOwnPropertyNames = {
  f: f$3
}; // eslint-disable-next-line es/no-object-getownpropertysymbols -- safe

var f$4 = Object.getOwnPropertySymbols;
var objectGetOwnPropertySymbols = {
  f: f$4
}; // all object keys, includes non-enumerable and symbols

var ownKeys = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = objectGetOwnPropertyNames.f(anObject(it));
  var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};

var copyConstructorProperties = function copyConstructorProperties(target, source) {
  var keys = ownKeys(source);
  var defineProperty = objectDefineProperty.f;
  var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};

var replacement = /#|\.prototype\./;

var isForced = function isForced(feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true : value == NATIVE ? false : typeof detection == 'function' ? fails(detection) : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';
var isForced_1 = isForced;
var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;
/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/

var _export = function _export(options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;

  if (GLOBAL) {
    target = global_1;
  } else if (STATIC) {
    target = global_1[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global_1[TARGET] || {}).prototype;
  }

  if (target) for (key in source) {
    sourceProperty = source[key];

    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor$1(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];

    FORCED = isForced_1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced); // contained in target

    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    } // add a flag to not completely full polyfills


    if (options.sham || targetProperty && targetProperty.sham) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    } // extend global


    redefine(target, key, sourceProperty, options);
  }
}; // `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe


var objectKeys = Object.keys || function keys(O) {
  return objectKeysInternal(O, enumBugKeys);
}; // eslint-disable-next-line es/no-object-assign -- safe


var $assign = Object.assign; // eslint-disable-next-line es/no-object-defineproperty -- required for testing

var defineProperty = Object.defineProperty; // `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign

var objectAssign = !$assign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (descriptors && $assign({
    b: 1
  }, $assign(defineProperty({}, 'a', {
    enumerable: true,
    get: function get() {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), {
    b: 2
  })).b !== 1) return true; // should work with symbols and should have deterministic property order (V8 bug)

  var A = {};
  var B = {}; // eslint-disable-next-line es/no-symbol -- safe

  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) {
    B[chr] = chr;
  });
  return $assign({}, A)[symbol] != 7 || objectKeys($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) {
  // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
  var propertyIsEnumerable = objectPropertyIsEnumerable.f;

  while (argumentsLength > index) {
    var S = indexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? objectKeys(S).concat(getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;

    while (length > j) {
      key = keys[j++];
      if (!descriptors || propertyIsEnumerable.call(S, key)) T[key] = S[key];
    }
  }

  return T;
} : $assign; // `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing

_export({
  target: 'Object',
  stat: true,
  forced: Object.assign !== objectAssign
}, {
  assign: objectAssign
});

var aFunction$1 = function aFunction$1(it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  }

  return it;
}; // `Array.prototype.{ reduce, reduceRight }` methods implementation


var createMethod$1 = function createMethod$1(IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aFunction$1(callbackfn);
    var O = toObject(that);
    var self = indexedObject(O);
    var length = toLength(O.length);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }

      index += i;

      if (IS_RIGHT ? index < 0 : length <= index) {
        throw TypeError('Reduce of empty array with no initial value');
      }
    }

    for (; IS_RIGHT ? index >= 0 : length > index; index += i) {
      if (index in self) {
        memo = callbackfn(memo, self[index], index, O);
      }
    }

    return memo;
  };
};

var arrayReduce = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: createMethod$1(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: createMethod$1(true)
};

var arrayMethodIsStrict = function arrayMethodIsStrict(METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal -- required for testing
    method.call(null, argument || function () {
      throw 1;
    }, 1);
  });
};

var engineUserAgent = getBuiltIn('navigator', 'userAgent') || '';
var process$1 = global_1.process;
var versions = process$1 && process$1.versions;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] < 4 ? 1 : match[0] + match[1];
} else if (engineUserAgent) {
  match = engineUserAgent.match(/Edge\/(\d+)/);

  if (!match || match[1] >= 74) {
    match = engineUserAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

var engineV8Version = version && +version;
var engineIsNode = classofRaw(global_1.process) == 'process';
var $reduce = arrayReduce.left;
var STRICT_METHOD = arrayMethodIsStrict('reduce'); // Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982

var CHROME_BUG = !engineIsNode && engineV8Version > 79 && engineV8Version < 83; // `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce

_export({
  target: 'Array',
  proto: true,
  forced: !STRICT_METHOD || CHROME_BUG
}, {
  reduce: function reduce(callbackfn
  /* , initialValue */
  ) {
    return $reduce(this, callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var isPseudoObject = function isPseudoObject(obj) {
  return obj && typeof obj === 'object';
};

var isNegative = function isNegative(v) {
  return v < 0 || v === '-px';
};

var buildClassname = function buildClassname(p, v) {
  if (v === true) return "sl-".concat(p);
  var isNeg = isNegative(v);
  return "sl-".concat(isNeg ? '-' : '').concat(p).concat(!p || isNeg ? '' : '-').concat(v);
};

var computePseudoClasses = function computePseudoClasses(prop, val) {
  var classes = {}; // if val is literal true value, then we're trying to use default and do not need to append a value
  // val can be 0, account for this

  if (isPseudoObject(val)) {
    var _classes;

    classes = (_classes = {}, _defineProperty(_classes, buildClassname(prop, val.default), val.default || val.default === 0), _defineProperty(_classes, "sm:".concat(buildClassname(prop, val.sm)), val.sm || val.sm === 0), _defineProperty(_classes, "md:".concat(buildClassname(prop, val.md)), val.md || val.md === 0), _defineProperty(_classes, "first:".concat(buildClassname(prop, val.first)), val.first || val.first === 0), _defineProperty(_classes, "last:".concat(buildClassname(prop, val.last)), val.last || val.last === 0), _defineProperty(_classes, "odd:".concat(buildClassname(prop, val.odd)), val.odd || val.odd === 0), _defineProperty(_classes, "even:".concat(buildClassname(prop, val.even)), val.even || val.even === 0), _defineProperty(_classes, "hover:".concat(buildClassname(prop, val.hover)), val.hover || val.hover === 0), _defineProperty(_classes, "focus:".concat(buildClassname(prop, val.focus)), val.focus || val.focus === 0), _defineProperty(_classes, "active:".concat(buildClassname(prop, val.active)), val.active || val.active === 0), _defineProperty(_classes, "visited:".concat(buildClassname(prop, val.visited)), val.visited || val.visited === 0), _defineProperty(_classes, "group-hover:".concat(buildClassname(prop, val.groupHover)), val.groupHover || val.groupHover === 0), _defineProperty(_classes, "group-focus:".concat(buildClassname(prop, val.groupFocus)), val.groupFocus || val.groupFocus === 0), _defineProperty(_classes, "disabled:".concat(buildClassname(prop, val.disabled)), val.disabled || val.disabled === 0), _classes);
  } else {
    classes["sl".concat(prop ? "-".concat(prop) : '').concat(val === true ? '' : '-' + val)] = val || val === 0;
  }

  return cn(classes);
};

var borderPropNames = ['borderColor', 'border', 'borderT', 'borderR', 'borderL', 'borderB', 'rounded', 'roundedT', 'roundedR', 'roundedL', 'roundedB', 'roundedTL', 'roundedTR', 'roundedBL', 'roundedBR'];

var borderProps = function borderProps(props) {
  var _cn;

  var outline = props.outline,
      rounded = props.rounded,
      roundedB = props.roundedB,
      roundedT = props.roundedT,
      roundedR = props.roundedR,
      roundedL = props.roundedL,
      roundedBL = props.roundedBL,
      roundedBR = props.roundedBR,
      roundedTL = props.roundedTL,
      roundedTR = props.roundedTR,
      borderColor = props.borderColor,
      border = props.border,
      borderT = props.borderT,
      borderR = props.borderR,
      borderL = props.borderL,
      borderB = props.borderB,
      rest = __rest(props, ["outline", "rounded", "roundedB", "roundedT", "roundedR", "roundedL", "roundedBL", "roundedBR", "roundedTL", "roundedTR", "borderColor", "border", "borderT", "borderR", "borderL", "borderB"]);

  var className = cn((_cn = {}, _defineProperty(_cn, "sl-outline-".concat(outline), outline !== void 0), _defineProperty(_cn, "sl-rounded".concat(rounded === true ? '' : '-' + rounded), rounded), _defineProperty(_cn, "sl-rounded-b".concat(roundedB === true ? '' : '-' + roundedB), roundedB), _defineProperty(_cn, "sl-rounded-t".concat(roundedT === true ? '' : '-' + roundedT), roundedT), _defineProperty(_cn, "sl-rounded-r".concat(roundedR === true ? '' : '-' + roundedR), roundedR), _defineProperty(_cn, "sl-rounded-l".concat(roundedL === true ? '' : '-' + roundedL), roundedL), _defineProperty(_cn, "sl-rounded-bl".concat(roundedBL === true ? '' : '-' + roundedBL), roundedBL), _defineProperty(_cn, "sl-rounded-br".concat(roundedBR === true ? '' : '-' + roundedBR), roundedBR), _defineProperty(_cn, "sl-rounded-tl".concat(roundedTL === true ? '' : '-' + roundedTL), roundedTL), _defineProperty(_cn, "sl-rounded-tr".concat(roundedTR === true ? '' : '-' + roundedTR), roundedTR), _cn), computePseudoClasses('border', borderColor), computePseudoClasses('border', border), computePseudoClasses('border-t', borderT), computePseudoClasses('border-r', borderR), computePseudoClasses('border-l', borderL), computePseudoClasses('border-b', borderB));
  return {
    props: rest,
    className: className
  };
};

var ringPropNames = ['ring', 'ringColor'];

var ringProps = function ringProps(props) {
  var ring = props.ring,
      ringColor = props.ringColor,
      ringOpacity = props.ringOpacity,
      rest = __rest(props, ["ring", "ringColor", "ringOpacity"]);

  return {
    props: rest,
    className: cn(computePseudoClasses('ring', ring), computePseudoClasses('ring', ringColor), computePseudoClasses('ring-opacity', ringOpacity))
  };
};
/* eslint-disable es/no-symbol -- required for testing */
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing


var nativeSymbol = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol(); // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances

  return !String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
  !Symbol.sham && engineV8Version && engineV8Version < 41;
});
/* eslint-disable es/no-symbol -- required for testing */

var useSymbolAsUid = nativeSymbol && !Symbol.sham && typeof Symbol.iterator == 'symbol';
var WellKnownSymbolsStore = shared('wks');
var Symbol$1 = global_1.Symbol;
var createWellKnownSymbol = useSymbolAsUid ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid;

var wellKnownSymbol = function wellKnownSymbol(name) {
  if (!has(WellKnownSymbolsStore, name) || !(nativeSymbol || typeof WellKnownSymbolsStore[name] == 'string')) {
    if (nativeSymbol && has(Symbol$1, name)) {
      WellKnownSymbolsStore[name] = Symbol$1[name];
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
    }
  }

  return WellKnownSymbolsStore[name];
};

var MATCH = wellKnownSymbol('match'); // `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp

var isRegexp = function isRegexp(it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classofRaw(it) == 'RegExp');
};

var notARegexp = function notARegexp(it) {
  if (isRegexp(it)) {
    throw TypeError("The method doesn't accept regular expressions");
  }

  return it;
};

var MATCH$1 = wellKnownSymbol('match');

var correctIsRegexpLogic = function correctIsRegexpLogic(METHOD_NAME) {
  var regexp = /./;

  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH$1] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) {
      /* empty */
    }
  }

  return false;
};

var getOwnPropertyDescriptor$2 = objectGetOwnPropertyDescriptor.f; // eslint-disable-next-line es/no-string-prototype-startswith -- safe

var $startsWith = ''.startsWith;
var min$2 = Math.min;
var CORRECT_IS_REGEXP_LOGIC = correctIsRegexpLogic('startsWith'); // https://github.com/zloirock/core-js/pull/702

var MDN_POLYFILL_BUG = !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor$2(String.prototype, 'startsWith');
  return descriptor && !descriptor.writable;
}(); // `String.prototype.startsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.startswith

_export({
  target: 'String',
  proto: true,
  forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC
}, {
  startsWith: function startsWith(searchString
  /* , position = 0 */
  ) {
    var that = String(requireObjectCoercible(this));
    notARegexp(searchString);
    var index = toLength(min$2(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith ? $startsWith.call(that, search, index) : that.slice(index, index + search.length) === search;
  }
});

var colorPropNames = ['bg', 'color' // 'placeholderColor' // not a standard box prop, this always goes on the input
];

var colorProps = function colorProps(props) {
  var color = props.color,
      bg = props.bg,
      placeholderColor = props.placeholderColor,
      rest = __rest(props, ["color", "bg", "placeholderColor"]);

  var skipBg = false;
  var skipColor = false; // Support hex bg values - not in the typings because adding string to typings clobbers them.. annoying typescript

  if (typeof bg === 'string' && bg.startsWith('#')) {
    // @ts-expect-error
    rest.style = Object.assign({}, rest.style || {}, {
      backgroundColor: bg
    });
    skipBg = true;
  } // Support hex color values


  if (typeof color === 'string' && color.startsWith('#')) {
    // @ts-expect-error
    rest.style = Object.assign({}, rest.style || {}, {
      color: color
    });
    skipColor = true;
  }

  return {
    props: rest,
    className: cn(!skipBg && computePseudoClasses('bg', bg), !skipColor && computePseudoClasses('text', color), computePseudoClasses('placeholder', placeholderColor))
  };
};

var flexPropNames = ['flex', 'flexDirection', 'flexWrap', 'flexGrow', 'flexShrink', 'justifyContent', 'justifyItems', 'justifySelf', 'alignContent', 'alignItems', 'alignSelf'];

var flexProps = function flexProps(props) {
  var _cn2;

  var flex = props.flex,
      flexDirection = props.flexDirection,
      flexWrap = props.flexWrap,
      flexGrow = props.flexGrow,
      flexShrink = props.flexShrink,
      justifyContent = props.justifyContent,
      justifyItems = props.justifyItems,
      justifySelf = props.justifySelf,
      alignContent = props.alignContent,
      alignItems = props.alignItems,
      alignSelf = props.alignSelf,
      rest = __rest(props, ["flex", "flexDirection", "flexWrap", "flexGrow", "flexShrink", "justifyContent", "justifyItems", "justifySelf", "alignContent", "alignItems", "alignSelf"]);

  var className = cn((_cn2 = {}, _defineProperty(_cn2, "sl-flex-".concat(flex), flex !== void 0), _defineProperty(_cn2, "sl-flex-".concat(flexDirection), flexDirection !== void 0), _defineProperty(_cn2, "sl-flex-".concat(flexWrap === true ? 'wrap' : flexWrap), flexWrap !== void 0), _defineProperty(_cn2, "sl-flex-grow".concat(flexGrow === true ? '' : '-0'), flexGrow !== void 0), _defineProperty(_cn2, "sl-flex-shrink".concat(flexShrink === true ? '' : '-0'), flexShrink !== void 0), _defineProperty(_cn2, "sl-justify-".concat(justifyContent), justifyContent !== void 0), _defineProperty(_cn2, "sl-justify-items-".concat(justifyItems), justifyItems !== void 0), _defineProperty(_cn2, "sl-justify-self-".concat(justifySelf), justifySelf !== void 0), _defineProperty(_cn2, "sl-content-".concat(alignContent), alignContent !== void 0), _defineProperty(_cn2, "sl-items-".concat(alignItems), alignItems !== void 0), _defineProperty(_cn2, "sl-self-".concat(alignSelf), alignSelf !== void 0), _cn2));
  return {
    props: rest,
    className: className
  };
};

var interactivityPropNames = ['cursor', 'opacity', 'pointerEvents', 'resize', 'userSelect', 'visibility'];

var interactivityProps = function interactivityProps(props) {
  var _cn3;

  var cursor = props.cursor,
      userSelect = props.userSelect,
      pointerEvents = props.pointerEvents,
      opacity = props.opacity,
      resize = props.resize,
      visibility = props.visibility,
      rest = __rest(props, ["cursor", "userSelect", "pointerEvents", "opacity", "resize", "visibility"]);

  var newClassName = cn((_cn3 = {}, _defineProperty(_cn3, buildClassname('cursor', cursor), cursor), _defineProperty(_cn3, "sl-select-".concat(userSelect), userSelect), _defineProperty(_cn3, "sl-pointer-events-".concat(pointerEvents), pointerEvents), _defineProperty(_cn3, buildClassname('resize', resize), resize), _cn3), // the visibility value itself is the class, no need to pass name
  computePseudoClasses('', visibility), computePseudoClasses('opacity', opacity));
  return {
    props: rest,
    className: newClassName
  };
};

var layoutPropNames = ['display', 'overflowX', 'overflowY', 'objectFit', 'objectPosition'];

var layoutProps = function layoutProps(props) {
  var _cn4;

  var display = props.display,
      overflowX = props.overflowX,
      overflowY = props.overflowY,
      objectFit = props.objectFit,
      objectPosition = props.objectPosition,
      rest = __rest(props, ["display", "overflowX", "overflowY", "objectFit", "objectPosition"]);

  var className = cn((_cn4 = {}, _defineProperty(_cn4, "sl-".concat(display), display !== void 0), _defineProperty(_cn4, "sl-overflow-x-".concat(overflowX), overflowX), _defineProperty(_cn4, "sl-overflow-y-".concat(overflowY), overflowY), _defineProperty(_cn4, "sl-object-".concat(overflowY), objectFit), _defineProperty(_cn4, "sl-object-".concat(objectPosition), objectPosition), _cn4));
  return {
    props: rest,
    className: className
  };
};

var positionPropNames = ['bottom', 'pin', 'pinX', 'pinY', 'left', 'pos', 'right', 'top', 'zIndex'];

var positionProps = function positionProps(props) {
  var _cn5;

  var position = props.pos,
      pin = props.pin,
      pinY = props.pinY,
      pinX = props.pinX,
      top = props.top,
      left = props.left,
      right = props.right,
      bottom = props.bottom,
      zIndex = props.zIndex,
      rest = __rest(props, ["pos", "pin", "pinY", "pinX", "top", "left", "right", "bottom", "zIndex"]);

  var className = cn((_cn5 = {}, _defineProperty(_cn5, "sl-".concat(position), position), _defineProperty(_cn5, buildClassname('inset', pin === true ? '0' : pin), pin !== void 0), _defineProperty(_cn5, buildClassname('inset-y', pinY === true ? '0' : pinY), pinY !== void 0), _defineProperty(_cn5, buildClassname('inset-x', pinX === true ? '0' : pinX), pinX !== void 0), _defineProperty(_cn5, buildClassname('top', top), top !== void 0), _defineProperty(_cn5, buildClassname('left', left), left !== void 0), _defineProperty(_cn5, buildClassname('right', right), right !== void 0), _defineProperty(_cn5, buildClassname('bottom', bottom), bottom !== void 0), _cn5), computePseudoClasses('z', zIndex));
  return {
    props: rest,
    className: className
  };
};

var shadowPropNames = ['boxShadow'];

var shadowProps = function shadowProps(props) {
  var boxShadow = props.boxShadow,
      rest = __rest(props, ["boxShadow"]);

  return {
    props: rest,
    className: cn(computePseudoClasses('shadow', boxShadow))
  };
};

var sizePropNames = ['h', 'maxH', 'minH', 'maxW', 'minW', 'w'];

var sizeProps = function sizeProps(props) {
  var _cn6;

  var h = props.h,
      maxH = props.maxH,
      minH = props.minH,
      w = props.w,
      maxW = props.maxW,
      minW = props.minW,
      rest = __rest(props, ["h", "maxH", "minH", "w", "maxW", "minW"]);

  var className = cn((_cn6 = {}, _defineProperty(_cn6, "sl-w-".concat(w), w), _defineProperty(_cn6, "sl-max-w-".concat(maxW), maxW), _defineProperty(_cn6, "sl-min-w-".concat(minW), minW), _defineProperty(_cn6, "sl-h-".concat(h), h), _defineProperty(_cn6, "sl-max-h-".concat(maxH), maxH), _defineProperty(_cn6, "sl-min-h-".concat(minH), minH), _cn6));
  return {
    props: rest,
    className: className
  };
};

var spacingPropNames = ['m', 'mb', 'ml', 'mr', 'mt', 'mx', 'my', 'p', 'pb', 'pl', 'pr', 'pt', 'px', 'py'];

var marginProps = function marginProps(props) {
  var _cn7;

  var m = props.m,
      mx = props.mx,
      my = props.my,
      mt = props.mt,
      mr = props.mr,
      mb = props.mb,
      ml = props.ml,
      rest = __rest(props, ["m", "mx", "my", "mt", "mr", "mb", "ml"]);

  var className = cn((_cn7 = {}, _defineProperty(_cn7, buildClassname('m', m), m), _defineProperty(_cn7, buildClassname('mx', mx), mx), _defineProperty(_cn7, buildClassname('my', my), my), _defineProperty(_cn7, buildClassname('mt', mt), mt), _defineProperty(_cn7, buildClassname('mr', mr), mr), _defineProperty(_cn7, buildClassname('mb', mb), mb), _defineProperty(_cn7, buildClassname('ml', ml), ml), _cn7));
  return {
    props: rest,
    className: className
  };
};

var paddingProps = function paddingProps(props) {
  var _cn8;

  var p = props.p,
      px = props.px,
      py = props.py,
      pt = props.pt,
      pr = props.pr,
      pb = props.pb,
      pl = props.pl,
      rest = __rest(props, ["p", "px", "py", "pt", "pr", "pb", "pl"]);

  var className = cn((_cn8 = {}, _defineProperty(_cn8, buildClassname('p', p), p), _defineProperty(_cn8, buildClassname('px', px), px), _defineProperty(_cn8, buildClassname('py', py), py), _defineProperty(_cn8, buildClassname('pt', pt), pt), _defineProperty(_cn8, buildClassname('pr', pr), pr), _defineProperty(_cn8, buildClassname('pb', pb), pb), _defineProperty(_cn8, buildClassname('pl', pl), pl), _cn8));
  return {
    props: rest,
    className: className
  };
};

var transformPropNames = ['transform', 'transition', 'transitionDelay', 'transitionDuration', 'translateX', 'translateY'];

var transformProps = function transformProps(props) {
  var _cn9;

  var transform = props.transform,
      transition = props.transition,
      transitionDelay = props.transitionDelay,
      transitionDuration = props.transitionDuration,
      translateX = props.translateX,
      translateY = props.translateY,
      rest = __rest(props, ["transform", "transition", "transitionDelay", "transitionDuration", "translateX", "translateY"]);

  var className = cn((_cn9 = {}, _defineProperty(_cn9, "sl-transform", transform), _defineProperty(_cn9, "sl-transition", transition), _defineProperty(_cn9, "sl-delay-".concat(transitionDelay), transitionDelay), _defineProperty(_cn9, "sl-duration-".concat(transitionDuration), transitionDuration), _cn9), computePseudoClasses('translate-x', translateX), computePseudoClasses('translate-y', translateY));
  return {
    props: rest,
    className: className
  };
};

var typographyPropNames = ['fontFamily', 'fontSize', 'fontStyle', 'fontWeight', 'letterSpacing', 'lineHeight', 'textAlign', 'textDecoration', 'textOverflow', 'textTransform', 'verticalAlign', 'whitespace', 'wordBreak'];

var typographyProps = function typographyProps(props) {
  var _cn10;

  var fontSize = props.fontSize,
      lineHeight = props.lineHeight,
      letterSpacing = props.letterSpacing,
      fontFamily = props.fontFamily,
      fontWeight = props.fontWeight,
      fontStyle = props.fontStyle,
      textAlign = props.textAlign,
      textDecoration = props.textDecoration,
      textTransform = props.textTransform,
      textOverflow = props.textOverflow,
      verticalAlign = props.verticalAlign,
      whitespace = props.whitespace,
      wordBreak = props.wordBreak,
      rest = __rest(props, ["fontSize", "lineHeight", "letterSpacing", "fontFamily", "fontWeight", "fontStyle", "textAlign", "textDecoration", "textTransform", "textOverflow", "verticalAlign", "whitespace", "wordBreak"]);

  var className = cn((_cn10 = {}, _defineProperty(_cn10, "sl-text-".concat(fontSize), fontSize), _defineProperty(_cn10, "sl-leading-".concat(lineHeight), lineHeight), _defineProperty(_cn10, "sl-tracking-".concat(letterSpacing), letterSpacing), _defineProperty(_cn10, "sl-font-".concat(fontFamily), fontFamily), _defineProperty(_cn10, "sl-font-".concat(fontWeight), fontWeight), _defineProperty(_cn10, "sl-".concat(fontStyle), fontStyle), _defineProperty(_cn10, "sl-text-".concat(textAlign), textAlign), _defineProperty(_cn10, "sl-".concat(textDecoration), textDecoration), _defineProperty(_cn10, "sl-".concat(textTransform), textTransform), _defineProperty(_cn10, "sl-".concat(textOverflow), textOverflow), _defineProperty(_cn10, "sl-align-".concat(verticalAlign), verticalAlign), _defineProperty(_cn10, "sl-whitespace-".concat(whitespace), whitespace), _defineProperty(_cn10, "sl-break-".concat(wordBreak), wordBreak), _cn10));
  return {
    props: rest,
    className: className
  };
};

var defaultElement = 'div';
var Box = /*#__PURE__*/forwardRef(function Box(_a, ref) {
  var as = _a.as,
      className = _a.className,
      role = _a.role,
      noFocusRing = _a.noFocusRing,
      props = __rest(_a, ["as", "className", "role", "noFocusRing"]);

  var classNames = []; // custom pipe to just make accumulating the generated classNames, and pulling out props, easier

  var pipe = function pipe() {
    for (var _len4 = arguments.length, fns = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      fns[_key4] = arguments[_key4];
    }

    return function (x) {
      return fns.reduce(function (v, f) {
        var _f = f(v),
            props = _f.props,
            className = _f.className;

        classNames.push(className);
        return props;
      }, x);
    };
  }; // run the props through all the enhancers - what we're left with is the extra props that we're not specifically handling
  // these get passed on to the underlying Element as is


  var restProps = pipe(layoutProps, flexProps, positionProps, sizeProps, typographyProps, marginProps, paddingProps, colorProps, borderProps, ringProps, shadowProps, interactivityProps, transformProps)(props);

  var _className = cn(className, classNames, {
    'sl-group': role === 'group',
    'sl-no-focus-ring': noFocusRing
  });

  var Element = as || defaultElement;
  return jsx(Element, Object.assign({
    ref: ref
  }, restProps, {
    className: _className || undefined,
    role: role
  }), void 0);
}); // @ts-ignore

Box.displayName = 'Box'; // @ts-ignore

Box.defaultProps = {
  as: defaultElement
};
var containerSizes = {
  xs: {
    maxWidth: 300,
    p: 3
  },
  sm: {
    maxWidth: 640,
    p: 3
  },
  md: {
    maxWidth: 950,
    p: 3
  },
  lg: {
    maxWidth: 1280,
    p: 5
  },
  xl: {
    maxWidth: 1450,
    p: 5
  },
  full: {
    p: 5
  }
};
var Container = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(function Container(_a, ref) {
  var _a$size = _a.size,
      size = _a$size === void 0 ? 'full' : _a$size,
      className = _a.className,
      _a$style = _a.style,
      style = _a$style === void 0 ? {} : _a$style,
      props = __rest(_a, ["size", "className", "style"]);

  return jsx(Box, Object.assign({
    ref: ref,
    px: containerSizes[size].p,
    mx: "auto",
    w: "full",
    style: Object.assign({
      maxWidth: containerSizes[size].maxWidth
    }, style),
    className: cn('Container', className)
  }, props), void 0);
}));
var Article = /*#__PURE__*/memo(function Article(_a) {
  var className = _a.className,
      children = _a.children,
      props = __rest(_a, ["className", "children"]);

  return jsx(Container, Object.assign({
    as: "article",
    className: cn('sl-article', className),
    size: "md",
    py: 20
  }, props, {
    children: children
  }), void 0);
});

function AspectRatio(_a) {
  var _a$ratio = _a.ratio,
      ratio = _a$ratio === void 0 ? 4 / 3 : _a$ratio,
      className = _a.className,
      children = _a.children,
      _a$style2 = _a.style,
      style = _a$style2 === void 0 ? {} : _a$style2,
      props = __rest(_a, ["ratio", "className", "children", "style"]); // enforce single child


  var child = Children.only(children);
  return jsx(Box, Object.assign({}, props, {
    pos: "relative",
    className: cn('sl-aspect-ratio', className),
    style: Object.assign(Object.assign({}, style), {
      // @ts-expect-error react css typings intentionally don't include index type, this is expected
      '--ratio': ratio
    })
  }, {
    children: child
  }), void 0);
}

var defaultElement$1 = 'div';
var Flex = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(function (_a, ref) {
  var align = _a.align,
      justify = _a.justify,
      wrap = _a.wrap,
      direction = _a.direction,
      grow = _a.grow,
      shrink = _a.shrink,
      inline = _a.inline,
      restProps = __rest(_a, ["align", "justify", "wrap", "direction", "grow", "shrink", "inline"]);

  var remapped = {
    alignItems: align,
    justifyContent: justify,
    flexWrap: wrap,
    flexDirection: direction,
    flexGrow: grow,
    flexShrink: shrink
  };
  return jsx(Box, Object.assign({
    as: defaultElement$1
  }, remapped, restProps, {
    ref: ref,
    display: inline ? 'inline-flex' : 'flex'
  }), void 0);
}));
var useIconStore = create(function (set) {
  return {
    defaultStyle: 'fas',
    setDefaultStyle: function setDefaultStyle(style) {
      return set(function (state) {
        return Object.assign(Object.assign({}, state), {
          defaultStyle: style
        });
      });
    }
  };
});
var _className = 'sl-icon';
var addedToLibrary = false;

var initLibrary = function initLibrary() {
  library.add(faCaretDown, faCaretLeft, faCaretRight, faCaretUp, faCheck, faChevronDown, faChevronLeft, faChevronRight, faChevronUp, faCopy, faExclamationCircle, faExclamationTriangle, faExpandArrowsAlt, faExternalLinkAlt, faInfoCircle, faLink, faSort);
  addedToLibrary = true;
};

var Icon = /*#__PURE__*/memo(function Icon(_a) {
  var className = _a.className,
      icon = _a.icon,
      props = __rest(_a, ["className", "icon"]);

  var style = useIconStore(function (state) {
    return state.defaultStyle;
  });
  var iconProp = normalizeIconArgs(icon, style);
  /**
   * So that if Icon is imported, the library stuff is not tree-shaken out. If `library.add` was hoisted out of this
   * function then it would be shaken out at consumer build time.
   */

  if (!addedToLibrary) initLibrary();

  if (isIconDefinition(iconProp) || findIconDefinition(iconProp)) {
    return jsx(FontAwesomeIcon, Object.assign({
      className: cn(_className, className),
      icon: iconProp
    }, props), void 0);
  } // if the icon is not bundled with the mosaic core (via library in Icon/index.ts), then render fallback <i> in
  // case font awesome kit or css is loaded on page


  return jsx("i", {
    role: "img",
    "aria-hidden": "true",
    className: cn(_className, className, iconProp.prefix, "fa-".concat(iconProp.iconName), _defineProperty({
      'fa-spin': props.spin,
      'fa-pulse': props.pulse,
      'fa-fw': props.fixedWidth
    }, "fa-".concat(props.size), props.size)),
    style: props.style
  }, void 0);
});

function isIconDefinition(prop) {
  if (prop && typeof prop === 'object' && prop.hasOwnProperty('icon')) return true;
  return false;
}

function isIconProp(prop) {
  if (prop && typeof prop === 'string' || Array.isArray(prop)) return true;
  if (prop && typeof prop === 'object' && prop.hasOwnProperty('iconName')) return true;
  return false;
} // Adapted from https://github.com/FortAwesome/react-fontawesome/blob/master/src/utils/normalize-icon-args.js
// Adds defaultPrefix and adjusts to fix some typings issues


function normalizeIconArgs(icon) {
  var defaultPrefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'fas';

  // if the icon is null, there's nothing to do
  if (icon === null) {
    return null;
  }

  if (Array.isArray(icon)) {
    // use the first item as prefix, second as icon name
    return {
      prefix: icon[0],
      iconName: icon[1]
    };
  } // if the icon is an object and has a prefix and an icon name, return it


  if (typeof icon === 'object' && icon.iconName) {
    return icon;
  } // if it's a string, use it as the icon name


  if (typeof icon === 'string') {
    return {
      prefix: defaultPrefix,
      iconName: icon
    };
  }
}

var defaultElement$2 = 'span';
var Text = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(function (_a, ref) {
  var size = _a.size,
      restProps = __rest(_a, ["size"]);

  return jsx(Box, Object.assign({
    as: defaultElement$2,
    ref: ref,
    fontSize: size
  }, restProps), void 0);
}));
var sizes = {
  lg: ['md', 8],
  md: ['sm', 6],
  sm: ['xs', 5]
};
var Avatar = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(function Avatar(props, ref) {
  // TODO: the union types make spreading out rest and passing through to box difficult, since we can't
  // easily pull out letter, blank, etc. they're getting sent to box right now...
  // @ts-expect-error
  var className = props.className,
      _props$size = props.size,
      size = _props$size === void 0 ? 'md' : _props$size,
      bg = props.bg,
      icon = props.icon,
      letter = props.letter,
      blank = props.blank,
      rest = __rest(props, ["className", "size", "bg", "icon", "letter", "blank"]);

  var extraProps = {};

  if (bg) {
    extraProps.style = {
      color: 'white',
      backgroundColor: bg
    };
  }

  var innerElem;

  if (icon) {
    innerElem = jsx(Icon, {
      icon: icon
    }, void 0);
  } else if (letter) {
    innerElem = jsx(Text, {
      children: letter
    }, void 0);
  }

  return jsx(Flex, Object.assign({
    ref: ref,
    className: cn('sl-avatar', className),
    align: "center",
    justify: "center",
    h: sizes[size][0],
    w: sizes[size][1],
    rounded: "full"
  }, rest, extraProps, {
    children: innerElem
  }), void 0);
})); // `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags

var regexpFlags = function regexpFlags() {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};

var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var nativeToString = RegExpPrototype[TO_STRING];
var NOT_GENERIC = fails(function () {
  return nativeToString.call({
    source: 'a',
    flags: 'b'
  }) != '/a/b';
}); // FF44- RegExp#toString has a wrong name

var INCORRECT_NAME = nativeToString.name != TO_STRING; // `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring

if (NOT_GENERIC || INCORRECT_NAME) {
  redefine(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject(this);
    var p = String(R.source);
    var rf = R.flags;
    var f = String(rf === undefined && R instanceof RegExp && !('flags' in RegExpPrototype) ? regexpFlags.call(R) : rf);
    return '/' + p + '/' + f;
  }, {
    unsafe: true
  });
} // Number assertions


function isNumber(value) {
  return typeof value === 'number';
}

var isNotNumber = function isNotNumber(value) {
  return typeof value !== 'number' || Number.isNaN(value) || !Number.isFinite(value);
};

function isNumeric(value) {
  return value != null && value - parseFloat(value) + 1 >= 0;
} // Array assertions


function isArray(value) {
  return Array.isArray(value);
}

var isEmptyArray = function isEmptyArray(value) {
  return isArray(value) && value.length === 0;
}; // Function assertions


function isFunction(value) {
  return typeof value === 'function';
} // Generic assertions


var isDefined = function isDefined(value) {
  return typeof value !== 'undefined' && value !== undefined;
};

var isUndefined = function isUndefined(value) {
  return typeof value === 'undefined' || value === undefined;
}; // Object assertions


var isObject$1 = function isObject$1(value) {
  var type = typeof value;
  return value != null && (type === 'object' || type === 'function') && !isArray(value);
};

var isEmptyObject = function isEmptyObject(value) {
  return isObject$1(value) && Object.keys(value).length === 0;
};

function isNotEmptyObject(value) {
  return value && !isEmptyObject(value);
}

var isNull = function isNull(value) {
  return value == null;
}; // String assertions


function isString(value) {
  return Object.prototype.toString.call(value) === '[object String]';
} // Event assertions


function isInputEvent(value) {
  return value && isObject$1(value) && isObject$1(value.target);
} // Empty assertions


var isEmpty = function isEmpty(value) {
  if (isArray(value)) return isEmptyArray(value);
  if (isObject$1(value)) return isEmptyObject(value);
  if (value == null || value === '') return true;
  return false;
}; // eslint-disable-next-line @typescript-eslint/naming-convention


var __DEV__ = process.env.NODE_ENV !== 'production'; // iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods


var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
}; // `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe

var objectDefineProperties = descriptors ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;

  while (length > index) {
    objectDefineProperty.f(O, key = keys[index++], Properties[key]);
  }

  return O;
};
var html = getBuiltIn('document', 'documentElement');
var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function EmptyConstructor() {
  /* empty */
};

var scriptTag = function scriptTag(content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
}; // Create object with fake `null` prototype: use ActiveX Object with cleared prototype


var NullProtoObjectViaActiveX = function NullProtoObjectViaActiveX(activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak

  return temp;
}; // Create object with fake `null` prototype: use iframe Object with cleared prototype


var NullProtoObjectViaIFrame = function NullProtoObjectViaIFrame() {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe); // https://github.com/zloirock/core-js/issues/475

  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
}; // Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug


var activeXDocument;

var _NullProtoObject = function NullProtoObject() {
  try {
    /* global ActiveXObject -- old IE */
    activeXDocument = document.domain && new ActiveXObject('htmlfile');
  } catch (error) {
    /* ignore */
  }

  _NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
  var length = enumBugKeys.length;

  while (length--) {
    delete _NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  }

  return _NullProtoObject();
};

hiddenKeys[IE_PROTO] = true; // `Object.create` method
// https://tc39.es/ecma262/#sec-object.create

var objectCreate = Object.create || function create(O, Properties) {
  var result;

  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null; // add "__proto__" for Object.getPrototypeOf polyfill

    result[IE_PROTO] = O;
  } else result = _NullProtoObject();

  return Properties === undefined ? result : objectDefineProperties(result, Properties);
};

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype; // Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables

if (ArrayPrototype[UNSCOPABLES] == undefined) {
  objectDefineProperty.f(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: objectCreate(null)
  });
} // add a key to Array.prototype[@@unscopables]


var addToUnscopables = function addToUnscopables(key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};

var correctPrototypeGetter = !fails(function () {
  function F() {
    /* empty */
  }

  F.prototype.constructor = null; // eslint-disable-next-line es/no-object-getprototypeof -- required for testing

  return Object.getPrototypeOf(new F()) !== F.prototype;
});
var IE_PROTO$1 = sharedKey('IE_PROTO');
var ObjectPrototype = Object.prototype; // `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe

var objectGetPrototypeOf = correctPrototypeGetter ? Object.getPrototypeOf : function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO$1)) return O[IE_PROTO$1];

  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  }

  return O instanceof Object ? ObjectPrototype : null;
};
var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

var returnThis = function returnThis() {
  return this;
}; // `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object


var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;
/* eslint-disable es/no-array-prototype-keys -- safe */

if ([].keys) {
  arrayIterator = [].keys(); // Safari 8 has buggy iterators w/o `next`

  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;else {
    PrototypeOfArrayIteratorPrototype = objectGetPrototypeOf(objectGetPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = IteratorPrototype == undefined || fails(function () {
  var test = {}; // FF44- legacy iterators case

  return IteratorPrototype[ITERATOR].call(test) !== test;
});
if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {}; // `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator

if (!has(IteratorPrototype, ITERATOR)) {
  createNonEnumerableProperty(IteratorPrototype, ITERATOR, returnThis);
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};
var defineProperty$1 = objectDefineProperty.f;
var TO_STRING_TAG = wellKnownSymbol('toStringTag');

var setToStringTag = function setToStringTag(it, TAG, STATIC) {
  if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG)) {
    defineProperty$1(it, TO_STRING_TAG, {
      configurable: true,
      value: TAG
    });
  }
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;

var createIteratorConstructor = function createIteratorConstructor(IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = objectCreate(IteratorPrototype$1, {
    next: createPropertyDescriptor(1, next)
  });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false);
  return IteratorConstructor;
};

var aPossiblePrototype = function aPossiblePrototype(it) {
  if (!isObject(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  }

  return it;
};
/* eslint-disable no-proto -- safe */
// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe


var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;

  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) {
    /* empty */
  }

  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);else O.__proto__ = proto;
    return O;
  };
}() : undefined);
var IteratorPrototype$2 = iteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS$1 = iteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$1 = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis$1 = function returnThis$1() {
  return this;
};

var defineIterator = function defineIterator(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function getIterationMethod(KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS$1 && KIND in IterablePrototype) return IterablePrototype[KIND];

    switch (KIND) {
      case KEYS:
        return function keys() {
          return new IteratorConstructor(this, KIND);
        };

      case VALUES:
        return function values() {
          return new IteratorConstructor(this, KIND);
        };

      case ENTRIES:
        return function entries() {
          return new IteratorConstructor(this, KIND);
        };
    }

    return function () {
      return new IteratorConstructor(this);
    };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$1] || IterablePrototype['@@iterator'] || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS$1 && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY; // fix native

  if (anyNativeIterator) {
    CurrentIteratorPrototype = objectGetPrototypeOf(anyNativeIterator.call(new Iterable()));

    if (IteratorPrototype$2 !== Object.prototype && CurrentIteratorPrototype.next) {
      if (objectGetPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype$2) {
        if (objectSetPrototypeOf) {
          objectSetPrototypeOf(CurrentIteratorPrototype, IteratorPrototype$2);
        } else if (typeof CurrentIteratorPrototype[ITERATOR$1] != 'function') {
          createNonEnumerableProperty(CurrentIteratorPrototype, ITERATOR$1, returnThis$1);
        }
      } // Set @@toStringTag to native iterators


      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  } // fix Array.prototype.{ values, @@iterator }.name in V8 / FF


  if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    INCORRECT_VALUES_NAME = true;

    defaultIterator = function values() {
      return nativeIterator.call(this);
    };
  } // define iterator


  if (IterablePrototype[ITERATOR$1] !== defaultIterator) {
    createNonEnumerableProperty(IterablePrototype, ITERATOR$1, defaultIterator);
  } // export additional methods


  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS$1 || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine(IterablePrototype, KEY, methods[KEY]);
      }
    } else _export({
      target: NAME,
      proto: true,
      forced: BUGGY_SAFARI_ITERATORS$1 || INCORRECT_VALUES_NAME
    }, methods);
  }

  return methods;
};

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = internalState.set;
var getInternalState = internalState.getterFor(ARRAY_ITERATOR); // `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator

var es_array_iterator = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated),
    // target
    index: 0,
    // next index
    kind: kind // kind

  }); // `%ArrayIteratorPrototype%.next` method
  // https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;

  if (!target || index >= target.length) {
    state.target = undefined;
    return {
      value: undefined,
      done: true
    };
  }

  if (kind == 'keys') return {
    value: index,
    done: false
  };
  if (kind == 'values') return {
    value: target[index],
    done: false
  };
  return {
    value: [index, target[index]],
    done: false
  };
}, 'values'); // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');
var ITERATOR$2 = wellKnownSymbol('iterator');
var TO_STRING_TAG$1 = wellKnownSymbol('toStringTag');
var ArrayValues = es_array_iterator.values;

for (var COLLECTION_NAME in domIterables) {
  var Collection = global_1[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;

  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR$2] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR$2, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR$2] = ArrayValues;
    }

    if (!CollectionPrototype[TO_STRING_TAG$1]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG$1, COLLECTION_NAME);
    }

    if (domIterables[COLLECTION_NAME]) for (var METHOD_NAME in es_array_iterator) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== es_array_iterator[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, es_array_iterator[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = es_array_iterator[METHOD_NAME];
      }
    }
  }
}

var accumulateCollectionKeysByProp = function accumulateCollectionKeysByProp(targetProp, targetValue) {
  var keysHash = '[]';
  var keys = [];

  var accumulate = function accumulate(nodes, newKeys) {
    var _iterator = _createForOfIteratorHelper(nodes),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var node = _step.value;

        if (node.props && node.props[targetProp] === targetValue) {
          newKeys.push(node.key);
        }

        if (node.hasChildNodes) {
          accumulate(node.childNodes, newKeys);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  };

  var accumulator = function accumulator(nodes) {
    var newKeys = [];
    accumulate(nodes, newKeys);
    var newKeysHash = JSON.stringify(newKeys);

    if (keysHash !== newKeysHash) {
      keysHash = newKeysHash;
      keys = newKeys;
    }

    return keys;
  };

  return accumulator;
}; // `thisNumberValue` abstract operation
// https://tc39.es/ecma262/#sec-thisnumbervalue


var thisNumberValue = function thisNumberValue(value) {
  if (typeof value != 'number' && classofRaw(value) != 'Number') {
    throw TypeError('Incorrect invocation');
  }

  return +value;
}; // `String.prototype.repeat` method implementation
// https://tc39.es/ecma262/#sec-string.prototype.repeat


var stringRepeat = function repeat(count) {
  var str = String(requireObjectCoercible(this));
  var result = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError('Wrong number of repetitions');

  for (; n > 0; (n >>>= 1) && (str += str)) {
    if (n & 1) result += str;
  }

  return result;
};

var nativeToFixed = 1.0.toFixed;
var floor$1 = Math.floor;

var pow = function pow(x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};

var log = function log(x) {
  var n = 0;
  var x2 = x;

  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }

  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  }

  return n;
};

var multiply = function multiply(data, n, c) {
  var index = -1;
  var c2 = c;

  while (++index < 6) {
    c2 += n * data[index];
    data[index] = c2 % 1e7;
    c2 = floor$1(c2 / 1e7);
  }
};

var divide = function divide(data, n) {
  var index = 6;
  var c = 0;

  while (--index >= 0) {
    c += data[index];
    data[index] = floor$1(c / n);
    c = c % n * 1e7;
  }
};

var dataToString = function dataToString(data) {
  var index = 6;
  var s = '';

  while (--index >= 0) {
    if (s !== '' || index === 0 || data[index] !== 0) {
      var t = String(data[index]);
      s = s === '' ? t : s + stringRepeat.call('0', 7 - t.length) + t;
    }
  }

  return s;
};

var FORCED = nativeToFixed && (0.00008.toFixed(3) !== '0.000' || 0.9.toFixed(0) !== '1' || 1.255.toFixed(2) !== '1.25' || 1000000000000000128.0.toFixed(0) !== '1000000000000000128') || !fails(function () {
  // V8 ~ Android 4.3-
  nativeToFixed.call({});
}); // `Number.prototype.toFixed` method
// https://tc39.es/ecma262/#sec-number.prototype.tofixed

_export({
  target: 'Number',
  proto: true,
  forced: FORCED
}, {
  toFixed: function toFixed(fractionDigits) {
    var number = thisNumberValue(this);
    var fractDigits = toInteger(fractionDigits);
    var data = [0, 0, 0, 0, 0, 0];
    var sign = '';
    var result = '0';
    var e, z, j, k;
    if (fractDigits < 0 || fractDigits > 20) throw RangeError('Incorrect fraction digits'); // eslint-disable-next-line no-self-compare -- NaN check

    if (number != number) return 'NaN';
    if (number <= -1e21 || number >= 1e21) return String(number);

    if (number < 0) {
      sign = '-';
      number = -number;
    }

    if (number > 1e-21) {
      e = log(number * pow(2, 69, 1)) - 69;
      z = e < 0 ? number * pow(2, -e, 1) : number / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;

      if (e > 0) {
        multiply(data, 0, z);
        j = fractDigits;

        while (j >= 7) {
          multiply(data, 1e7, 0);
          j -= 7;
        }

        multiply(data, pow(10, j, 1), 0);
        j = e - 1;

        while (j >= 23) {
          divide(data, 1 << 23);
          j -= 23;
        }

        divide(data, 1 << j);
        multiply(data, 1, 1);
        divide(data, 2);
        result = dataToString(data);
      } else {
        multiply(data, 0, z);
        multiply(data, 1 << -e, 0);
        result = dataToString(data) + stringRepeat.call('0', fractDigits);
      }
    }

    if (fractDigits > 0) {
      k = result.length;
      result = sign + (k <= fractDigits ? '0.' + stringRepeat.call('0', fractDigits - k) + result : result.slice(0, k - fractDigits) + '.' + result.slice(k - fractDigits));
    } else {
      result = sign + result;
    }

    return result;
  }
});

var getContrastColor = function getContrastColor(bgLuminance, fgLuminance, targetContrast, hue) {
  var saturation = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
  var lightness = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 50;
  var targetLuminance;

  if (fgLuminance < bgLuminance) {
    targetLuminance = (bgLuminance + 0.05) / targetContrast - 0.05;
  } else {
    targetLuminance = targetContrast * (bgLuminance + 0.05) - 0.05;
  }

  return setLuminance(targetLuminance, stringifyHsl({
    h: hue,
    s: saturation,
    l: lightness
  }));
};

var parseHsl = function parseHsl(hsl) {
  var hslRegexp = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g;
  var hslaRegexp = /hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*([\d.]+)\)/g;
  var parts = hslRegexp.exec(hsl);

  if (!parts) {
    parts = hslaRegexp.exec(hsl);
  }

  if (!parts) {
    try {
      var hslParts = parseToHsl(hsl);
      return {
        h: Math.round(hslParts.hue),
        s: parseFloat((hslParts.saturation * 100).toFixed(0)),
        l: Math.max(1, Math.min(99, Math.round(hslParts.lightness * 100))),
        // @ts-expect-error
        a: hslParts.alpha !== void 0 ? hslParts.alpha : 1
      };
    } catch (e) {
      console.warn(e);
      return {
        h: 0,
        s: 0,
        l: 100,
        a: 1
      };
    }
  }

  return {
    h: parseInt(parts[1]),
    s: parseFloat(parts[2]),
    l: parseFloat(parts[3])
  };
};

var stringifyHsl = function stringifyHsl(hsl) {
  if (hsl.a !== void 0) {
    return "hsla(".concat(hsl.h, ", ").concat(hsl.s, "%, ").concat(hsl.l, "%, ").concat(hsl.a, ")");
  } else {
    return "hsl(".concat(hsl.h, ", ").concat(hsl.s, "%, ").concat(hsl.l, "%)");
  }
};

var EPS = 1e-7;

var setLuminance = function setLuminance(amount, color) {
  // @ts-expect-error
  var _parseToRgb = parseToRgb(color),
      _parseToRgb$alpha = _parseToRgb.alpha,
      alpha = _parseToRgb$alpha === void 0 ? 1 : _parseToRgb$alpha;

  var rgb;

  if (amount === 0) {
    rgb = rgba(0, 0, 0, alpha);
  } else if (amount === 1) {
    rgb = rgba(255, 255, 255, alpha);
  } else {
    var maxIteration = 20;

    var test = function test(color1, color2) {
      var mixed = mix(0.5, color1, color2);
      var mixedLuminance = getLuminance(mixed);

      if (Math.abs(amount - mixedLuminance) < EPS || !maxIteration--) {
        return mixed;
      }

      if (mixedLuminance > amount) {
        return test(color1, mixed);
      }

      return test(mixed, color2);
    };

    rgb = getLuminance(color) > amount ? test('#000', color) : test(color, '#fff');
  }

  return rgb;
};

var isServer = typeof document === 'undefined';

var findCss = function findCss(id) {
  if (isServer) return;
  return document.head.querySelector('#' + id);
};

var appendCss = function appendCss(id, css) {
  if (isServer) return; // only inject once

  if (!findCss(id)) {
    var node = document.createElement('style');
    node.textContent = css;
    node.type = 'text/css';
    node.id = id;
    document.head.appendChild(node);
  }
};

var replaceCss = function replaceCss(id, css) {
  if (isServer) return;
  var node = findCss(id);

  if (!node) {
    node = document.createElement('style');
    node.type = 'text/css';
    node.id = id;
    node.textContent = css;
    document.head.appendChild(node);
  } else {
    node.textContent = css;
  }
};

function runIfFn(valueOrFn) {
  for (var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    args[_key5 - 1] = arguments[_key5];
  }

  return isFunction(valueOrFn) ? valueOrFn.apply(void 0, args) : valueOrFn;
}

function once(fn) {
  var result;
  return function func() {
    if (fn) {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      result = fn.apply(this, args); // eslint-disable-next-line no-param-reassign

      fn = null;
    }

    return result;
  };
}

var noop = function noop() {};

var warn = once(function (options) {
  var condition = options.condition,
      message = options.message;

  if (condition && __DEV__) {
    console.warn(message);
  }
});
var error = once(function (options) {
  var condition = options.condition,
      message = options.message;

  if (condition && __DEV__) {
    console.error(message);
  }
}); // `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes

_export({
  target: 'String',
  proto: true,
  forced: !correctIsRegexpLogic('includes')
}, {
  includes: function includes(searchString
  /* , position = 0 */
  ) {
    return !!~String(requireObjectCoercible(this)).indexOf(notARegexp(searchString), arguments.length > 1 ? arguments[1] : undefined);
  }
});

var propNames = ['as'].concat(borderPropNames, colorPropNames, flexPropNames, interactivityPropNames, layoutPropNames, positionPropNames, shadowPropNames, sizePropNames, spacingPropNames, typographyPropNames, transformPropNames);
/**
 * Convenience method to split the Box props.
 *
 * Useful for when you want to pass all of the Box props to the root Box and
 * pass the remaining props to a child element (e.g: disabled, readOnly, required, etc).
 */

function splitBoxProps(props) {
  return splitProps(props, propNames);
}
/**
 * Utility to split props based on an array of keys
 */


function splitProps(props, keys) {
  var matchedProps = {};
  var remainingProps = {};
  var propKeys = Object.keys(props);

  for (var i = 0; i < propKeys.length; i++) {
    var propKey = propKeys[i];
    var propValue = props[propKey];

    if (keys.includes(propKey)) {
      matchedProps[propKey] = propValue;
    } else {
      remainingProps[propKey] = propValue;
    }
  }

  return {
    matchedProps: matchedProps,
    remainingProps: remainingProps
  };
}

var isMergeableObject = function isMergeableObject(value) {
  return isNonNullObject(value) && !isSpecial(value);
};

function isNonNullObject(value) {
  return !!value && typeof value === 'object';
}

function isSpecial(value) {
  var stringValue = Object.prototype.toString.call(value);
  return stringValue === '[object RegExp]' || stringValue === '[object Date]' || isReactElement(value);
} // see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25


var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
  return value.$$typeof === REACT_ELEMENT_TYPE;
}

function emptyTarget(val) {
  return Array.isArray(val) ? [] : {};
}

function cloneUnlessOtherwiseSpecified(value, options) {
  return options.clone !== false && options.isMergeableObject(value) ? deepmerge(emptyTarget(value), value, options) : value;
}

function defaultArrayMerge(target, source, options) {
  return target.concat(source).map(function (element) {
    return cloneUnlessOtherwiseSpecified(element, options);
  });
}

function getMergeFunction(key, options) {
  if (!options.customMerge) {
    return deepmerge;
  }

  var customMerge = options.customMerge(key);
  return typeof customMerge === 'function' ? customMerge : deepmerge;
}

function getEnumerableOwnPropertySymbols(target) {
  return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function (symbol) {
    return target.propertyIsEnumerable(symbol);
  }) : [];
}

function getKeys(target) {
  return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target));
}

function propertyIsOnObject(object, property) {
  try {
    return property in object;
  } catch (_) {
    return false;
  }
} // Protects from prototype poisoning and unexpected merging up the prototype chain.


function propertyIsUnsafe(target, key) {
  return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
  && !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
  && Object.propertyIsEnumerable.call(target, key)); // and also unsafe if they're nonenumerable.
}

function mergeObject(target, source, options) {
  var destination = {};

  if (options.isMergeableObject(target)) {
    getKeys(target).forEach(function (key) {
      destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
    });
  }

  getKeys(source).forEach(function (key) {
    if (propertyIsUnsafe(target, key)) {
      return;
    }

    if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
      destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
    } else {
      destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
    }
  });
  return destination;
}

function deepmerge(target, source, options) {
  options = options || {};
  options.arrayMerge = options.arrayMerge || defaultArrayMerge;
  options.isMergeableObject = options.isMergeableObject || isMergeableObject; // cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
  // implementations can use it. The caller may not replace it.

  options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;
  var sourceIsArray = Array.isArray(source);
  var targetIsArray = Array.isArray(target);
  var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

  if (!sourceAndTargetTypesMatch) {
    return cloneUnlessOtherwiseSpecified(source, options);
  } else if (sourceIsArray) {
    return options.arrayMerge(target, source, options);
  } else {
    return mergeObject(target, source, options);
  }
}

deepmerge.all = function deepmergeAll(array, options) {
  if (!Array.isArray(array)) {
    throw new Error('first argument should be an array');
  }

  return array.reduce(function (prev, next) {
    return deepmerge(prev, next, options);
  }, {});
};

var deepmerge_1 = deepmerge;
var cjs = deepmerge_1;
var defaultTheme = {
  colors: {
    background: 'hsl(218, 40%, 100%)',
    // text: 'hsl(214, 15%, 9%)', // defaults to compute based on background
    primary: 'hsl(202, 100%, 55%)',
    success: 'hsl(156, 95%, 37%)',
    warning: 'hsl(20, 90%, 56%)',
    danger: 'hsl(0, 84%, 63%)'
  }
};

var getCssVariable = function getCssVariable(name, element) {
  if (typeof document === void 0) return null;
  return getComputedStyle(element || document.body).getPropertyValue(name);
}; // so that lines don't wrap so much, hard to read


var r = Math.round;

var prefersDarkMode = function prefersDarkMode() {
  return typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)');
};
/**
 * Handles figuring out what 'system' mode resolves to if user has that picked. Always returns light | dark.
 */


var getResolvedThemeMode = function getResolvedThemeMode(userMode) {
  if (userMode === 'system') {
    return prefersDarkMode() ? 'dark' : 'light';
  }

  return userMode;
};

var computeTheme = function computeTheme(customTheme) {
  var $mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'system';
  var mode = getResolvedThemeMode($mode);
  var theme = cjs(defaultTheme, customTheme); // when the user has a preference for dark screen, reduce the saturation and lightness

  var mult = {
    s: mode === 'dark' ? 0.8 : 1,
    l: mode === 'dark' ? 0.65 : 1
  };
  var backgroundHsl = parseHsl(theme.colors.background);

  if (mode === 'dark' && backgroundHsl.l > 20) {
    backgroundHsl.s = r(Math.min(60, backgroundHsl.s * mult.s));
    backgroundHsl.l = 8;
  } // main colors


  var cv = {
    light: backgroundHsl.l >= 50,
    background: backgroundHsl,
    text: theme.colors.text ? parseHsl(theme.colors.text) : parseHsl(readableColor(stringifyHsl(backgroundHsl), stringifyHsl({
      h: backgroundHsl.h,
      s: backgroundHsl.s,
      l: Math.max(95, backgroundHsl.l)
    }), stringifyHsl({
      h: backgroundHsl.h,
      s: backgroundHsl.s,
      l: Math.min(5, backgroundHsl.l)
    }), true)),
    primary: parseHsl(theme.colors.primary),
    success: parseHsl(theme.colors.success),
    warning: parseHsl(theme.colors.warning),
    danger: parseHsl(theme.colors.danger)
  };
  /**
   * Inverted colors
   */

  var invertedBackgroundHsl = invertColorValue(cv.background, cv.light);
  /**
   * If user is asking for dark mode, then regular background will always be dark, and we make inverted background
   * just a little lighter than regular background, to raise it (opposite of how "raise" works on light backgrounds, where you darken to give a raise effect)
   */

  if (mode === 'dark') {
    invertedBackgroundHsl.l = cv.background.l + 5;
  }
  /** Is the inverted bg a light color? */


  var icvLight = invertedBackgroundHsl.l >= 50;
  var icv = {
    light: icvLight,
    background: invertedBackgroundHsl,
    text: {
      h: cv.text.h,
      s: r(cv.text.s / 2),
      l: icvLight ? 5 : Math.max(98, cv.text.l)
    },
    primary: invertColorValue(cv.primary, icvLight),
    success: invertColorValue(cv.success, icvLight),
    warning: invertColorValue(cv.warning, icvLight),
    danger: invertColorValue(cv.danger, icvLight)
  };

  if (cv.background.s > 50) {
    // help w contrast by lowering the saturation and lightness if the background is highly saturated
    mult.s = mult.s * 0.75;
    mult.l = mult.l * 0.7;
  }

  return {
    mult: mult,
    colorValues: cv,
    invertedColorValues: icv,
    css: "".concat(mode === 'light' ? ':root,' : '', "\n  [data-theme=\"").concat(mode, "\"],\n  [data-theme=\"").concat(mode, "\"] .sl-inverted .sl-inverted,\n  [data-theme=\"").concat(mode, "\"] .sl-inverted .sl-inverted .sl-inverted .sl-inverted {\n    color: var(--color-text);\n\n    ").concat(cssVariablesToStyles(computeCssVariables(cv, Object.assign({}, mult))), "\n}\n\n  ").concat(mode === 'light' ? ':root .sl-inverted,' : '', "\n  [data-theme=\"").concat(mode, "\"] .sl-inverted,\n  [data-theme=\"").concat(mode, "\"] .sl-inverted .sl-inverted .sl-inverted {\n    color: var(--color-text);\n\n    ").concat(cssVariablesToStyles(computeCssVariables(icv, Object.assign(Object.assign({}, mult), {
      // lower saturation a bit more in inverted
      s: Math.min(mult.s, 0.9)
    }))), "\n}")
  };
};

var invertColorValue = function invertColorValue(cv, isBgLight) {
  return {
    h: cv.h,
    s: isBgLight ? r(cv.s * 0.8) : cv.s,
    // inverted bg is lighter based on how light regular bg is, w lightness of at least 10
    // l: isBgLight ? r(Math.max(10, 10 * ((cv.l * mult.l) / 100))) : r(100 - cv.l * 0.75),
    // inverted bg is darker if regular db is light, or darker otherwise
    l: isBgLight ? r(Math.max(10, Math.min(20, 100 - cv.l))) : r(100 - cv.l * 0.9)
  };
};

var cssVariablesToStyles = function cssVariablesToStyles(vars) {
  var styles = '';

  for (var k in vars) {
    styles += "    --".concat(k, ": ").concat(vars[k], ";\n");
  }

  return styles;
};

var computeCssVariables = function computeCssVariables(cv, mult) {
  var bgLuminance = getLuminance(stringifyHsl(cv.background));
  var textLuminance = getLuminance(stringifyHsl(cv.text));
  var textColor = getContrastColor(bgLuminance, textLuminance, 15, cv.text.h, cv.text.s, cv.text.l);
  cv.text = parseHsl(textColor); // if we're rendering light text, then we should also use brightened canvas + borders rather than darkened

  var brightenCanvas = cv.text.l > 50;
  var brightenBorder = brightenCanvas;
  var canvasHsl = {
    // pure is the darkest or lightest possible canvas color
    pure: {
      h: cv.background.h,
      s: cv.background.s,
      l: brightenCanvas ? Math.max(cv.background.l - 3, 3) : Math.min(cv.background.l + 10, 100)
    },
    50: {
      h: cv.background.h,
      s: r(cv.background.s * 0.8),
      l: r(cv.background.l * 0.97)
    },
    100: {
      h: cv.background.h,
      s: r(cv.background.s * 0.83),
      l: r(cv.background.l * 0.94)
    },
    200: {
      h: cv.background.h,
      s: r(cv.background.s * 0.88),
      l: r(cv.background.l * 0.91)
    },
    300: {
      h: cv.background.h,
      s: r(cv.background.s * 0.91),
      l: r(cv.background.l * 0.88)
    },
    400: {
      h: cv.background.h,
      s: r(cv.background.s * 0.93),
      l: r(cv.background.l * 0.85)
    },
    500: {
      h: cv.background.h,
      s: r(cv.background.s * 0.93),
      l: r(cv.background.l * 0.82)
    },
    dialog: {
      h: cv.background.h,
      s: cv.background.s,
      l: brightenCanvas ? Math.max(cv.background.l - 3, 3) : Math.min(cv.background.l + 10, 100)
    }
  };

  if (brightenCanvas) {
    // the darker the canvas is, the less we need to brighten things
    var brightenMult = 5 / (10 - Math.ceil(bgLuminance * 10));
    canvasHsl[50].l = r(cv.background.l + 40 * brightenMult);
    canvasHsl[100].l = r(cv.background.l + 25 * brightenMult);
    canvasHsl[200].l = r(cv.background.l + 15 * brightenMult);
    canvasHsl[300].l = r(cv.background.l + 8 * brightenMult);
    canvasHsl[400].l = r(cv.background.l + 6 * brightenMult);
    canvasHsl[500].l = r(cv.background.l + 4 * brightenMult); // on dark canvas, brighten dialog

    canvasHsl.dialog = canvasHsl[100];
  }

  var shadows = {
    sm: '0px 0px 1px rgba(67, 90, 111, 0.3)',
    md: '0px 2px 4px -2px rgba(0, 0, 0, 0.25), 0px 0px 1px rgba(67, 90, 111, 0.3)',
    lg: '0 4px 17px rgba(67, 90, 111, .2), 0 2px 3px rgba(0, 0, 0, .1), inset 0 0 0 .5px var(--color-canvas-pure), 0 0 0 .5px rgba(0, 0, 0, 0.2)',
    xl: '0px 0px 1px rgba(67, 90, 111, 0.3), 0px 8px 10px -4px rgba(67, 90, 111, 0.45)',
    '2xl': '0px 0px 1px rgba(67, 90, 111, 0.3), 0px 16px 24px -8px rgba(67, 90, 111, 0.45)'
  };
  var dropShadows = {
    default1: '0 0 0.5px rgba(0, 0, 0, 0.6)',
    default2: '0 2px 5px rgba(67, 90, 111, 0.3)'
  };

  if (brightenCanvas) {
    // darker shadows on dark canvas
    shadows = {
      sm: '0px 0px 1px rgba(11, 13, 19, 0.5)',
      md: '0px 2px 4px -2px rgba(0, 0, 0, 0.35), 0px 0px 1px rgba(11, 13, 19, 0.4)',
      lg: '0 2px 14px rgba(0,0,0,.55), 0 0 0 0.5px rgba(255,255,255,.2)',
      xl: '0px 0px 1px rgba(11, 13, 19, 0.4), 0px 8px 10px -4px rgba(11, 13, 19, 0.55)',
      '2xl': '0px 0px 1px rgba(11, 13, 19, 0.4), 0px 16px 24px -8px rgba(11, 13, 19, 0.55)'
    };
    dropShadows = {
      default1: '0 0 0.5px rgba(255, 255, 255, .5)',
      default2: '0 3px 8px rgba(0, 0, 0, 0.6)'
    };
  }

  return {
    'text-h': cv.text.h,
    'text-s': "".concat(brightenBorder ? r(cv.text.s * 0.8) : cv.text.s, "%"),
    'text-l': "".concat(brightenBorder ? r(cv.text.l * 0.94) : cv.text.l, "%"),
    'shadow-sm': shadows.sm,
    'shadow-md': shadows.md,
    'shadow-lg': shadows.lg,
    'shadow-xl': shadows.xl,
    'shadow-2xl': shadows['2xl'],
    'drop-shadow-default1': dropShadows.default1,
    'drop-shadow-default2': dropShadows.default2,
    'color-text-heading': "hsla(var(--text-h), var(--text-s), max(3, calc(var(--text-l) - 15)), 1)",
    'color-text': "hsla(var(--text-h), var(--text-s), var(--text-l), 1)",
    'color-text-paragraph': "hsla(var(--text-h), var(--text-s), var(--text-l), 0.9)",
    'color-text-muted': "hsla(var(--text-h), var(--text-s), var(--text-l), 0.7)",
    'color-text-light': "hsla(var(--text-h), var(--text-s), var(--text-l), 0.55)",
    'canvas-h': "".concat(cv.background.h),
    'canvas-s': "".concat(cv.background.s, "%"),
    'canvas-l': "".concat(cv.background.l, "%"),
    'color-canvas': "hsla(var(--canvas-h), var(--canvas-s), var(--canvas-l), 1)",
    'color-canvas-pure': "hsla(".concat(canvasHsl['pure'].h, ", ").concat(canvasHsl['pure'].s, "%, ").concat(r(canvasHsl['pure'].l), "%, 1)"),
    'color-canvas-tint': "hsla(".concat(canvasHsl[50].h, ", ").concat(canvasHsl[50].s, "%, ").concat(r(canvasHsl[50].l), "%, ").concat(brightenCanvas ? 0.2 : 0.5, ")"),
    'color-canvas-50': "hsla(".concat(canvasHsl[50].h, ", ").concat(canvasHsl[50].s, "%, ").concat(r(canvasHsl[50].l * mult.l), "%, 1)"),
    'color-canvas-100': "hsla(".concat(canvasHsl[100].h, ", ").concat(canvasHsl[100].s, "%, ").concat(r(canvasHsl[100].l * mult.l), "%, 1)"),
    'color-canvas-200': "hsla(".concat(canvasHsl[200].h, ", ").concat(canvasHsl[200].s, "%, ").concat(r(canvasHsl[200].l * mult.l), "%, 1)"),
    'color-canvas-300': "hsla(".concat(canvasHsl[300].h, ", ").concat(canvasHsl[300].s, "%, ").concat(r(canvasHsl[300].l * mult.l), "%, 1)"),
    'color-canvas-400': "hsla(".concat(canvasHsl[400].h, ", ").concat(canvasHsl[400].s, "%, ").concat(r(canvasHsl[400].l * mult.l), "%, 1)"),
    'color-canvas-500': "hsla(".concat(canvasHsl[500].h, ", ").concat(canvasHsl[500].s, "%, ").concat(r(canvasHsl[500].l * mult.l), "%, 1)"),
    'color-canvas-dialog': "hsla(".concat(canvasHsl.dialog.h, ", ").concat(canvasHsl.dialog.s, "%, ").concat(r(canvasHsl.dialog.l * mult.l), "%, 1)"),
    'color-border-dark': "hsla(var(--canvas-h), ".concat(r(cv.background.s * 0.75), "%, ").concat(cv.background.l + (brightenBorder ? 13 : -28), "%, 0.5)"),
    'color-border': "hsla(var(--canvas-h), ".concat(r(cv.background.s * 0.8), "%, ").concat(cv.background.l + (brightenBorder ? 18 : -22), "%, 0.5)"),
    'color-border-light': "hsla(var(--canvas-h), ".concat(r(cv.background.s * 0.6), "%, ").concat(cv.background.l + (brightenBorder ? 24 : -16), "%, 0.5)"),
    'color-border-input': "hsla(var(--canvas-h), ".concat(r(cv.background.s * 0.6), "%, ").concat(cv.background.l + (brightenBorder ? 20 : -28), "%, 0.8)"),
    'color-border-button': "hsla(var(--canvas-h), ".concat(r(cv.background.s * 0.6), "%, ").concat(brightenBorder ? 80 : 20, "%, 0.65)"),
    'primary-h': "".concat(cv.primary.h),
    'primary-s': "".concat(r(cv.primary.s * mult.s), "%"),
    'primary-l': "".concat(r(cv.primary.l * mult.l), "%"),
    'color-text-primary': "hsla(".concat(cv.primary.h, ", ").concat(r(cv.primary.s), "%, ").concat(brightenBorder ? 70 : 40, "%, 1)"),
    'color-primary-dark': "hsla(".concat(cv.primary.h, ", ").concat(r(cv.primary.s * 0.8 * mult.s), "%, ").concat(r(cv.primary.l * 0.85 * mult.l), "%, 1)"),
    'color-primary-darker': "hsla(".concat(cv.primary.h, ", ").concat(r(cv.primary.s * 0.8 * mult.s), "%, ").concat(r(cv.primary.l * 0.65 * mult.l), "%, 1)"),
    'color-primary': "hsla(".concat(cv.primary.h, ", ").concat(r(cv.primary.s * mult.s), "%, ").concat(r(cv.primary.l * mult.l), "%, 1)"),
    'color-primary-light': "hsla(".concat(cv.primary.h, ", ").concat(r(cv.primary.s * mult.s), "%, ").concat(r(cv.primary.l * 1.2 * mult.l), "%, 1)"),
    'color-primary-tint': "hsla(".concat(cv.primary.h, ", ").concat(r(cv.primary.s * mult.s), "%, ").concat(r(65 * mult.l), "%, 0.25)"),
    'color-on-primary': "hsla(".concat(cv.primary.h, ", ").concat(cv.primary.s, "%, 100%, 1)"),
    'success-h': "".concat(cv.success.h),
    'success-s': "".concat(cv.success.s, "%"),
    'success-l': "".concat(cv.success.l, "%"),
    'color-text-success': "hsla(".concat(cv.success.h, ", ").concat(r(cv.success.s * mult.s), "%, ").concat(brightenBorder ? 60 : 40, "%, 1)"),
    'color-success-dark': "hsla(".concat(cv.success.h, ", ").concat(r(cv.success.s * 0.8 * mult.s), "%, ").concat(r(cv.success.l * 0.85 * mult.l), "%, 1)"),
    'color-success-darker': "hsla(".concat(cv.success.h, ", ").concat(r(cv.success.s * 0.8 * mult.s), "%, ").concat(r(cv.success.l * 0.65 * mult.l), "%, 1)"),
    'color-success': "hsla(".concat(cv.success.h, ", ").concat(r(cv.success.s * mult.s), "%, ").concat(r(cv.success.l * mult.l), "%, 1)"),
    'color-success-light': "hsla(".concat(cv.success.h, ", ").concat(r(cv.success.s * mult.s), "%, ").concat(r(cv.success.l * 1.2 * mult.l), "%, 1)"),
    'color-success-tint': "hsla(".concat(cv.success.h, ", ").concat(r(cv.success.s * mult.s), "%, ").concat(r(65 * mult.l), "%, 0.25)"),
    'color-on-success': "hsla(".concat(cv.success.h, ", ").concat(cv.success.s, "%, 100%, 1)"),
    'warning-h': "".concat(cv.warning.h),
    'warning-s': "".concat(cv.warning.s, "%"),
    'warning-l': "".concat(cv.warning.l, "%"),
    'color-text-warning': "hsla(".concat(cv.warning.h, ", ").concat(r(cv.warning.s * mult.s), "%, ").concat(brightenBorder ? 60 : 40, "%, 1)"),
    'color-warning-dark': "hsla(".concat(cv.warning.h, ", ").concat(r(cv.warning.s * 0.8 * mult.s), "%, ").concat(r(cv.warning.l * 0.85 * mult.l), "%, 1)"),
    'color-warning-darker': "hsla(".concat(cv.warning.h, ", ").concat(r(cv.warning.s * 0.8 * mult.s), "%, ").concat(r(cv.warning.l * 0.65 * mult.l), "%, 1)"),
    'color-warning': "hsla(".concat(cv.warning.h, ", ").concat(r(cv.warning.s * mult.s), "%, ").concat(r(cv.warning.l * mult.l), "%, 1)"),
    'color-warning-light': "hsla(".concat(cv.warning.h, ", ").concat(r(cv.warning.s * mult.s), "%, ").concat(r(cv.warning.l * 1.2 * mult.l), "%, 1)"),
    'color-warning-tint': "hsla(".concat(cv.warning.h, ", ").concat(r(cv.warning.s * mult.s), "%, ").concat(r(65 * mult.l), "%, 0.25)"),
    'color-on-warning': "hsla(".concat(cv.warning.h, ", ").concat(cv.warning.s, "%, 100%, 1)"),
    'danger-h': "".concat(cv.danger.h),
    'danger-s': "".concat(cv.danger.s, "%"),
    'danger-l': "".concat(cv.danger.l, "%"),
    'color-text-danger': "hsla(".concat(cv.danger.h, ", ").concat(r(cv.danger.s * mult.s), "%, ").concat(brightenBorder ? 60 : 40, "%, 1)"),
    'color-danger-dark': "hsla(".concat(cv.danger.h, ", ").concat(r(cv.danger.s * 0.8 * mult.s), "%, ").concat(r(cv.danger.l * 0.85 * mult.l), "%, 1)"),
    'color-danger-darker': "hsla(".concat(cv.danger.h, ", ").concat(r(cv.danger.s * 0.8 * mult.s), "%, ").concat(r(cv.danger.l * 0.65 * mult.l), "%, 1)"),
    'color-danger': "hsla(".concat(cv.danger.h, ", ").concat(r(cv.danger.s * mult.s), "%, ").concat(r(cv.danger.l * mult.l), "%, 1)"),
    'color-danger-light': "hsla(".concat(cv.danger.h, ", ").concat(r(cv.danger.s * mult.s), "%, ").concat(r(cv.danger.l * 1.2 * mult.l), "%, 1)"),
    'color-danger-tint': "hsla(".concat(cv.danger.h, ", ").concat(r(cv.danger.s * mult.s), "%, ").concat(r(65 * mult.l), "%, 0.25)"),
    'color-on-danger': "hsla(".concat(cv.danger.h, ", ").concat(cv.danger.s, "%, 100%, 1)")
  };
};

var WithDomRef = /*#__PURE__*/forwardRef(function WithDomRef(_ref, ref) {
  var children = _ref.children;
  return /*#__PURE__*/cloneElement(children, {
    ref: useDOMRef(ref)
  });
});
var sizes$1 = {
  lg: {
    h: 'md',
    px: 3,
    py: 0.5,
    fontSize: 'lg',
    rounded: 'full',
    leftIconMx: -2,
    leftIconMr: 2,
    rightIconMl: 1,
    rightIconMr: -0.5,
    iconSize: '15px'
  },
  md: {
    h: 'sm',
    px: 2,
    py: 0.5,
    fontSize: 'base',
    rounded: 'full',
    leftIconMx: -1,
    leftIconMr: 1.5,
    rightIconMl: 0.5,
    rightIconMr: -0.5,
    iconSize: '13px'
  },
  sm: {
    h: 'xs',
    px: 1.5,
    py: 0.5,
    fontSize: 'sm',
    rounded: 'full',
    leftIconMx: -1,
    leftIconMr: 1,
    rightIconMl: 0.5,
    rightIconMr: -0.5,
    iconSize: '13px'
  }
};
var variants = {
  solid: {
    default: {
      border: 0,
      color: 'paragraph',
      fontSize: 'paragraph-tiny',
      bg: {
        default: 'canvas-100'
      },
      borderColor: {
        default: 'input'
      }
    },
    success: {
      color: 'on-success',
      borderColor: 'success',
      bg: {
        default: 'success'
      }
    },
    warning: {
      color: 'on-warning',
      borderColor: 'warning',
      bg: {
        default: 'warning'
      }
    },
    danger: {
      color: 'on-danger',
      borderColor: 'danger',
      bg: {
        default: 'danger'
      }
    }
  },
  minimal: {
    default: {
      color: 'paragraph',
      fontSize: 'paragraph-tiny',
      bg: {
        default: 'transparent'
      },
      borderColor: 'transparent'
    },
    success: {
      color: 'success'
    },
    warning: {
      color: 'warning'
    },
    danger: {
      color: 'danger'
    }
  },
  outline: {
    default: {
      color: 'paragraph',
      fontSize: 'paragraph-tiny',
      bg: {
        default: 'canvas'
      },
      borderColor: {
        default: 'input'
      },
      ring: false
    },
    success: {
      borderColor: 'success',
      color: 'success'
    },
    warning: {
      borderColor: 'warning',
      color: 'warning'
    },
    danger: {
      borderColor: 'danger',
      color: 'danger'
    }
  }
};
var defaultElement$3 = 'span';
var Badge = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(function Input(_a, ref) {
  var _a$appearance = _a.appearance,
      appearance = _a$appearance === void 0 ? 'solid' : _a$appearance,
      _a$size2 = _a.size,
      size = _a$size2 === void 0 ? 'md' : _a$size2,
      _a$as = _a.as,
      as = _a$as === void 0 ? defaultElement$3 : _a$as,
      className = _a.className,
      intent = _a.intent,
      icon = _a.icon,
      iconRight = _a.iconRight,
      onRemove = _a.onRemove,
      children = _a.children,
      props = __rest(_a, ["appearance", "size", "as", "className", "intent", "icon", "iconRight", "onRemove", "children"]);

  var _splitBoxProps = splitBoxProps(props),
      remainingProps = _splitBoxProps.remainingProps;

  var stateProps = Object.assign(Object.assign({}, variants[appearance].default), variants[appearance][intent]);
  return jsx(Box, Object.assign({
    ref: ref,
    as: as,
    h: sizes$1[size].h,
    px: sizes$1[size].px,
    py: sizes$1[size].py,
    fontSize: sizes$1[size].fontSize,
    rounded: sizes$1[size].rounded,
    borderColor: "on-primary",
    className: cn('sl-badge', className, {
      'sl-badge--remove': !!onRemove
    })
  }, stateProps, remainingProps, {
    children: jsxs(Flex, Object.assign({
      justifyItems: "start",
      alignItems: "center"
    }, {
      children: [icon ? jsx(BadgeIcon, {
        icon: icon,
        size: size,
        hasContent: !!children
      }, void 0) : null, jsx(Flex, {
        children: children
      }, void 0), iconRight && !onRemove ? jsx(BadgeRightIcon, {
        icon: iconRight,
        size: size
      }, void 0) : null, onRemove ? jsx(Box, Object.assign({
        as: 'a',
        onClick: onRemove,
        ml: 0.5
      }, {
        children: jsx(BadgeRightIcon, {
          icon: ['fas', 'times-circle'],
          size: size
        }, void 0)
      }), void 0) : null]
    }), void 0)
  }), void 0);
}));

var BadgeIcon = function BadgeIcon(_ref2) {
  var icon = _ref2.icon,
      size = _ref2.size,
      hasContent = _ref2.hasContent,
      pulse = _ref2.pulse;
  var elem = icon;

  if (isIconProp(icon)) {
    elem = jsx(Icon, {
      icon: icon,
      style: {
        fontSize: sizes$1[size].iconSize
      },
      pulse: pulse,
      fixedWidth: true
    }, void 0);
  }

  return jsx(Box, Object.assign({
    "data-testid": "icon",
    mr: hasContent ? sizes$1[size].leftIconMr : undefined,
    mx: hasContent ? undefined : sizes$1[size].leftIconMx
  }, {
    children: elem
  }), void 0);
};

var BadgeRightIcon = function BadgeRightIcon(_ref3) {
  var icon = _ref3.icon,
      size = _ref3.size;
  var elem = icon;

  if (isIconProp(icon)) {
    elem = jsx(Icon, {
      icon: icon,
      style: {
        fontSize: sizes$1[size].iconSize
      },
      fixedWidth: true
    }, void 0);
  }

  return jsx(Box, Object.assign({
    "data-testid": "iconright",
    ml: sizes$1[size].rightIconMl,
    mr: sizes$1[size].rightIconMr
  }, {
    children: elem
  }), void 0);
};

var sizes$2 = {
  md: {
    px: 3,
    fontSize: 'base',
    rounded: true,
    iconSize: 'xs',
    leftIconMx: -1,
    leftIconMr: 1.5,
    rightIconMl: 1.5,
    rightIconMr: -0.5
  },
  sm: {
    px: 1.5,
    fontSize: 'base',
    rounded: true,
    iconSize: 'xs',
    leftIconMx: 0,
    leftIconMr: 1,
    rightIconMl: 1,
    rightIconMr: -0.5
  }
};
var variants$1 = {
  default: {
    default: {
      borderColor: 'button',
      bg: {
        default: 'canvas',
        hover: 'canvas-50',
        active: 'canvas-100'
      },
      opacity: {
        disabled: 60
      }
    },
    success: {
      borderColor: 'success',
      ringColor: 'success'
    },
    warning: {
      borderColor: 'warning',
      ringColor: 'warning'
    },
    danger: {
      borderColor: 'danger',
      ringColor: 'danger'
    }
  },
  minimal: {
    default: {
      color: {
        default: 'muted',
        hover: 'body',
        focus: 'body'
      },
      bg: {
        hover: 'canvas-50',
        active: 'canvas-100'
      },
      borderColor: 'transparent',
      opacity: {
        disabled: 70
      }
    },
    success: {
      color: 'success'
    },
    warning: {
      color: 'warning'
    },
    danger: {
      color: 'danger'
    }
  },
  select: {
    default: {
      fontWeight: 'normal',
      color: {
        default: 'body'
      },
      ring: false,
      bg: {
        default: 'transparent',
        active: 'canvas-100'
      },
      borderColor: {
        default: 'transparent',
        hover: 'input',
        focus: 'input',
        active: 'button'
      }
    },
    success: {
      color: 'success',
      borderColor: {
        default: 'transparent',
        hover: 'success',
        focus: 'success'
      }
    },
    warning: {
      color: 'warning',
      borderColor: {
        default: 'transparent',
        hover: 'warning',
        focus: 'warning'
      }
    },
    danger: {
      color: 'danger',
      borderColor: {
        default: 'transparent',
        hover: 'danger',
        focus: 'danger'
      }
    }
  },
  primary: {
    default: {
      color: {
        default: 'on-primary',
        disabled: 'body'
      },
      bg: {
        default: 'primary',
        hover: 'primary-dark',
        active: 'primary-darker',
        disabled: 'canvas-100'
      },
      borderColor: 'transparent',
      opacity: {
        disabled: 70
      }
    },
    success: {
      color: {
        default: 'on-success',
        disabled: 'body'
      },
      bg: {
        default: 'success',
        hover: 'success-dark',
        active: 'success-darker',
        disabled: 'canvas-100'
      }
    },
    warning: {
      color: {
        default: 'on-warning',
        disabled: 'body'
      },
      bg: {
        default: 'warning',
        hover: 'warning-dark',
        active: 'warning-darker'
      }
    },
    danger: {
      color: {
        default: 'on-danger',
        disabled: 'body'
      },
      bg: {
        default: 'danger',
        hover: 'danger-dark',
        active: 'danger-darker'
      }
    }
  }
};
var defaultElement$4 = 'button';

function Button(_a, ref) {
  var _a$appearance2 = _a.appearance,
      appearance = _a$appearance2 === void 0 ? 'default' : _a$appearance2,
      _a$intent = _a.intent,
      intent = _a$intent === void 0 ? 'default' : _a$intent,
      _a$size3 = _a.size,
      size = _a$size3 === void 0 ? 'md' : _a$size3,
      disabled = _a.disabled,
      loading = _a.loading,
      className = _a.className,
      icon = _a.icon,
      iconRight = _a.iconRight,
      label = _a.label,
      children = _a.children,
      active = _a.active,
      autoFocus = _a.autoFocus,
      onPress = _a.onPress,
      onPressChange = _a.onPressChange,
      onPressEnd = _a.onPressEnd,
      onPressStart = _a.onPressStart,
      onPressUp = _a.onPressUp,
      props = __rest(_a, ["appearance", "intent", "size", "disabled", "loading", "className", "icon", "iconRight", "label", "children", "active", "autoFocus", "onPress", "onPressChange", "onPressEnd", "onPressStart", "onPressUp"]);

  var domRef = useFocusableRef(ref);

  var _useButton = useButton(Object.assign({
    isDisabled: disabled,
    onPress: onPress,
    onPressChange: onPressChange,
    onPressEnd: onPressEnd,
    onPressStart: onPressStart,
    onPressUp: onPressUp
  }, props), domRef),
      buttonProps = _useButton.buttonProps;

  var _useHover = useHover(Object.assign({
    isDisabled: disabled
  }, props)),
      hoverProps = _useHover.hoverProps;

  var _splitBoxProps2 = splitBoxProps(props),
      matchedProps = _splitBoxProps2.matchedProps,
      remainingProps = _splitBoxProps2.remainingProps;

  var stateProps = Object.assign(Object.assign(Object.assign(Object.assign({}, variants$1.default.default), variants$1.default[intent]), variants$1[appearance].default), variants$1[appearance][intent]);
  /**
   * If active, remove other state effects
   */

  if (active) {
    for (var i in stateProps) {
      var prop = stateProps[i];

      if (prop && typeof prop === 'object') {
        if (prop.hasOwnProperty('active')) {
          stateProps[i] = prop.active;
        } else if (prop.hasOwnProperty('hover')) {
          // remove props immutably
          var _b = stateProps[i],
              newProps = __rest(_b, ["hover"]);

          stateProps[i] = newProps;
        }
      }
    }
  }
  /**
   * If in loading or disabled states, remove other ui effects like hover
   */


  if (loading || disabled) {
    for (var _i in stateProps) {
      var _prop = stateProps[_i];

      if (_prop && typeof _prop === 'object') {
        // remove props immutably
        var _c = stateProps[_i],
            _newProps = __rest(_c, ["active", "hover"]);

        stateProps[_i] = _newProps;
      }
    }
  }

  var _d = mergeProps(matchedProps, buttonProps, hoverProps),
      propsWithoutColor = __rest(_d, ["color"]);

  return jsx(FocusRing, Object.assign({
    focusRingClass: "sl-focus-ring",
    autoFocus: autoFocus
  }, {
    children: jsxs(Box, Object.assign({
      as: defaultElement$4,
      px: sizes$2[size].px,
      fontSize: sizes$2[size].fontSize,
      fontWeight: "medium",
      rounded: sizes$2[size].rounded,
      h: size,
      borderColor: "button",
      className: cn('sl-button', className),
      disabled: loading || disabled,
      cursor: loading ? 'wait' : disabled ? 'not-allowed' : undefined,
      border: true,
      opacity: loading ? 70 : undefined
    }, remainingProps, stateProps, propsWithoutColor, {
      ref: domRef
    }, {
      children: [loading ? jsx(ButtonIcon, {
        icon: "spinner",
        pulse: true,
        size: size,
        hasContent: !!children
      }, void 0) : null, icon && !loading ? jsx(ButtonIcon, {
        icon: icon,
        size: size,
        hasContent: !!children
      }, void 0) : null, jsx(Flex, Object.assign({
        flex: 1,
        justifyItems: "start",
        alignItems: "center"
      }, {
        children: children
      }), void 0), iconRight ? jsx(ButtonRightIcon, {
        icon: iconRight,
        size: size
      }, void 0) : null]
    }), void 0)
  }), void 0);
}

var _Button = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(Button));

var ButtonIcon = function ButtonIcon(_ref4) {
  var icon = _ref4.icon,
      size = _ref4.size,
      hasContent = _ref4.hasContent,
      pulse = _ref4.pulse;
  var elem = icon;

  if (isIconProp(icon)) {
    elem = jsx(Icon, {
      icon: icon,
      size: size === 'sm' ? 'sm' : undefined,
      pulse: pulse,
      fixedWidth: true
    }, void 0);
  }

  return jsx(Box, Object.assign({
    mr: hasContent ? sizes$2[size].leftIconMr : undefined,
    mx: hasContent ? undefined : sizes$2[size].leftIconMx
  }, {
    children: elem
  }), void 0);
};

var ButtonRightIcon = function ButtonRightIcon(_ref5) {
  var icon = _ref5.icon,
      size = _ref5.size;
  var elem = icon;

  if (isIconProp(icon)) {
    elem = jsx(Icon, {
      icon: icon,
      fixedWidth: true
    }, void 0);
  }

  return jsx(Box, Object.assign({
    ml: sizes$2[size].rightIconMl,
    mr: sizes$2[size].rightIconMr,
    fontSize: sizes$2[size].iconSize
  }, {
    children: elem
  }), void 0);
};

function useControlledState(value, defaultValue, onChange) {
  var _useState = useState(value || defaultValue),
      _useState2 = _slicedToArray(_useState, 2),
      stateValue = _useState2[0],
      setStateValue = _useState2[1];

  var ref = useRef(value !== undefined);
  var wasControlled = ref.current;
  var isControlled = value !== undefined; // Internal state reference for useCallback

  var stateRef = useRef(stateValue);

  if (wasControlled !== isControlled) {
    console.warn("WARN: A component changed from " + (wasControlled ? 'controlled' : 'uncontrolled') + " to " + (isControlled ? 'controlled' : 'uncontrolled') + ".");
  }

  ref.current = isControlled;
  var setValue = useCallback(function (value) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var onChangeCaller = function onChangeCaller(value) {
      if (onChange) {
        if (!Object.is(stateRef.current, value)) {
          for (var _len2 = arguments.length, onChangeArgs = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            onChangeArgs[_key2 - 1] = arguments[_key2];
          }

          onChange.apply(void 0, [value].concat(onChangeArgs));
        }
      }

      if (!isControlled) {
        stateRef.current = value;
      }
    };

    if (typeof value === 'function') {
      // this supports functional updates https://reactjs.org/docs/hooks-reference.html#functional-updates
      // when someone using useControlledState calls setControlledState(myFunc)
      // this will call our useState setState with a function as well which invokes myFunc and calls onChange with the value from myFunc
      // if we're in an uncontrolled state, then we also return the value of myFunc which to setState looks as though it was just called with myFunc from the beginning
      // otherwise we just return the controlled value, which won't cause a rerender because React knows to bail out when the value is the same
      var updateFunction = function updateFunction(oldValue) {
        for (var _len3 = arguments.length, functionArgs = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
          functionArgs[_key3 - 1] = arguments[_key3];
        }

        var interceptedValue = value.apply(void 0, [isControlled ? stateRef.current : oldValue].concat(functionArgs));
        onChangeCaller.apply(void 0, [interceptedValue].concat(args));

        if (!isControlled) {
          return interceptedValue;
        }

        return oldValue;
      };

      setStateValue(updateFunction);
    } else {
      if (!isControlled) {
        setStateValue(value);
      }

      onChangeCaller.apply(void 0, [value].concat(args));
    }
  }, [isControlled, onChange]); // If a controlled component's value prop changes, we need to update stateRef

  if (isControlled) {
    stateRef.current = value;
  } else {
    value = stateValue;
  }

  return [value, setValue];
}
/**
 * Manages state for an overlay trigger. Tracks whether the overlay is open, and provides
 * methods to toggle this state.
 */


function useOverlayTriggerState(props) {
  var _useControlledState = useControlledState(props.isOpen, props.defaultOpen || false, props.onOpenChange),
      _useControlledState2 = _slicedToArray(_useControlledState, 2),
      isOpen = _useControlledState2[0],
      setOpen = _useControlledState2[1];

  return {
    isOpen: isOpen,
    open: function open() {
      setOpen(true);
    },
    close: function close() {
      setOpen(false);
    },
    toggle: function toggle() {
      setOpen(!isOpen);
    }
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}
/**
 * Manages state for a menu trigger. Tracks whether the menu is currently open,
 * and controls which item will receive focus when it opens.
 */


function useMenuTriggerState(props) {
  var overlayTriggerState = useOverlayTriggerState(props);

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      focusStrategy = _useState4[0],
      setFocusStrategy = _useState4[1];

  return _extends({
    focusStrategy: focusStrategy
  }, overlayTriggerState, {
    open: function open(focusStrategy) {
      if (focusStrategy === void 0) {
        focusStrategy = null;
      }

      setFocusStrategy(focusStrategy);
      overlayTriggerState.open();
    },
    toggle: function toggle(focusStrategy) {
      if (focusStrategy === void 0) {
        focusStrategy = null;
      }

      setFocusStrategy(focusStrategy);
      overlayTriggerState.toggle();
    }
  });
}

function useClipboard(text) {
  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1500;

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      hasCopied = _useState6[0],
      setHasCopied = _useState6[1];

  var onCopy = useCallback(function () {
    var didCopy = copy(text);
    setHasCopied(didCopy);
  }, [text]);
  useEffect(function () {
    if (hasCopied) {
      var _id = setTimeout(function () {
        setHasCopied(false);
      }, timeout);

      return function () {
        return clearTimeout(_id);
      };
    }
  }, [timeout, hasCopied]);
  return {
    value: text,
    onCopy: onCopy,
    hasCopied: hasCopied
  };
}

function useCollectionKeyAccumulator(nodes, targetProp, targetValue) {
  var accumulator = useRef(accumulateCollectionKeysByProp(targetProp, targetValue));
  return accumulator.current(nodes);
}

function useControllableProp(prop, state) {
  var _useRef = useRef(prop !== undefined),
      isControlled = _useRef.current;

  var value = isControlled && typeof prop !== 'undefined' ? prop : state;
  return [isControlled, value];
}

var defaultPropsMap = {
  value: 'value',
  defaultValue: 'defaultValue',
  onChange: 'onChange'
};
/**
 * React hook for using controlling component state.
 * @param props
 */

function useControllableState(props) {
  var valueProp = props.value,
      defaultValue = props.defaultValue,
      onChange = props.onChange,
      _props$name = props.name,
      name = _props$name === void 0 ? 'Component' : _props$name,
      _props$propsMap = props.propsMap,
      propsMap = _props$propsMap === void 0 ? defaultPropsMap : _props$propsMap;

  var _useState7 = useState(defaultValue),
      _useState8 = _slicedToArray(_useState7, 2),
      valueState = _useState8[0],
      setValue = _useState8[1];

  var _useRef2 = useRef(valueProp !== undefined),
      isControlled = _useRef2.current; // don't switch from controlled to uncontrolled


  useEffect(function () {
    var nextIsControlled = valueProp !== undefined;
    var nextMode = nextIsControlled ? 'a controlled' : 'an uncontrolled';
    var mode = isControlled ? 'a controlled' : 'an uncontrolled';
    warn({
      condition: isControlled !== nextIsControlled,
      message: "Warning: ".concat(name, " is changing from ").concat(mode, " to ").concat(nextMode, " component. ") + "Components should not switch from controlled to uncontrolled (or vice versa). " + "Use the '".concat(propsMap.value, "' with an '").concat(propsMap.onChange, "' handler. ") + "If you want an uncontrolled component, remove the ".concat(propsMap.value, " prop and use '").concat(propsMap.defaultValue, "' instead. \"") + "More info: https://fb.me/react-controlled-components"
    });
  }, [valueProp, isControlled, name]);

  var _useRef3 = useRef(defaultValue),
      initialDefaultValue = _useRef3.current;

  useEffect(function () {
    warn({
      condition: initialDefaultValue !== defaultValue,
      message: "Warning: A component is changing the default value of an uncontrolled ".concat(name, " after being initialized. ") + "To suppress this warning opt to use a controlled ".concat(name, ".")
    });
  }, [JSON.stringify(defaultValue)]);
  var value = isControlled ? valueProp : valueState;
  var updateValue = useCallback(function (next) {
    var nextValue = runIfFn(next, value);
    if (!isControlled) setValue(nextValue);
    onChange === null || onChange === void 0 ? void 0 : onChange(nextValue);
  }, [onChange]);
  return [value, updateValue];
}

var useModalityStore = create(function (set) {
  return {
    currentModality: null,
    setInteractionModality: function setInteractionModality(modality) {
      return set(function (state) {
        return Object.assign(Object.assign({}, state), {
          currentModality: modality
        });
      });
    }
  };
});

function useInteractionModality() {
  return useModalityStore(function (state) {
    return state.currentModality;
  });
}

function getInteractionModality() {
  return useModalityStore.getState().currentModality;
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */


function isValidKey(e) {
  // Control and Shift keys trigger when navigating back to the tab with keyboard.
  return !(e.metaKey || !isMac() && e.altKey || e.ctrlKey || e.type === 'keyup' && (e.key === 'Control' || e.key === 'Shift'));
}

function handleKeyboardEvent(e) {
  if (isValidKey(e)) {
    var _useModalityStore$get = useModalityStore.getState(),
        currentModality = _useModalityStore$get.currentModality;

    if (currentModality !== 'keyboard') {
      unstable_batchedUpdates(function () {
        useModalityStore.getState().setInteractionModality('keyboard');
      });
    }
  }
}

function handlePointerEvent() {
  var state = useModalityStore.getState();

  if (state.currentModality !== 'pointer') {
    unstable_batchedUpdates(function () {
      useModalityStore.getState().setInteractionModality('pointer');
    });
  }
}

function isVirtualClick(event) {
  // JAWS/NVDA with Firefox.
  if (event.mozInputSource === 0 && event.isTrusted) {
    return true;
  }

  return event.detail === 0 && !event.pointerType;
}

function handleClickEvent(e) {
  if (isVirtualClick(e)) {
    var state = useModalityStore.getState();

    if (state.currentModality !== 'virtual') {
      unstable_batchedUpdates(function () {
        useModalityStore.getState().setInteractionModality('virtual');
      });
    }
  }
}

var hasSetupGlobalListeners = false;

function setupGlobalFocusEvents() {
  if (typeof window === 'undefined' || hasSetupGlobalListeners) {
    return;
  }

  document.addEventListener('keydown', handleKeyboardEvent, true);
  document.addEventListener('keyup', handleKeyboardEvent, true);
  document.addEventListener('click', handleClickEvent, true);

  if (typeof PointerEvent !== 'undefined') {
    document.addEventListener('pointerdown', handlePointerEvent, true);
    document.addEventListener('pointermove', handlePointerEvent, true);
    document.addEventListener('pointerup', handlePointerEvent, true);
  } else {
    document.addEventListener('mousedown', handlePointerEvent, true);
    document.addEventListener('mousemove', handlePointerEvent, true);
    document.addEventListener('mouseup', handlePointerEvent, true);
  }

  hasSetupGlobalListeners = true;
}

if (typeof document !== 'undefined') {
  if (document.readyState !== 'loading') {
    setupGlobalFocusEvents();
  } else {
    document.addEventListener('DOMContentLoaded', setupGlobalFocusEvents);
  }
}

var defaultMosaicContext = {
  componentOverrides: {}
};
var MosaicContext = /*#__PURE__*/createContext(defaultMosaicContext);

var useMosaicContext = function useMosaicContext() {
  return useContext(MosaicContext);
};

var visibleOverlays = [];
/**
 * Provides the behavior for overlays such as dialogs, popovers, and menus.
 * Hides the overlay when the user interacts outside it, when the Escape key is pressed,
 * or optionally, on blur. Only the top-most overlay will close at once.
 */

function useOverlay(props, ref) {
  var onClose = props.onClose,
      shouldCloseOnBlur = props.shouldCloseOnBlur,
      isOpen = props.isOpen,
      _props$isDismissable = props.isDismissable,
      isDismissable = _props$isDismissable === void 0 ? false : _props$isDismissable,
      _props$isKeyboardDism = props.isKeyboardDismissDisabled,
      isKeyboardDismissDisabled = _props$isKeyboardDism === void 0 ? false : _props$isKeyboardDism,
      shouldCloseOnInteractOutside = props.shouldCloseOnInteractOutside; // Add the overlay ref to the stack of visible overlays on mount, and remove on unmount.

  useEffect(function () {
    if (isOpen) {
      visibleOverlays.push(ref);
    }

    return function () {
      var index = visibleOverlays.indexOf(ref);

      if (index >= 0) {
        visibleOverlays.splice(index, 1);
      }
    };
  }, [isOpen, ref]); // Only hide the overlay when it is the topmost visible overlay in the stack.

  var onHide = function onHide() {
    if (visibleOverlays[visibleOverlays.length - 1] === ref && onClose) {
      onClose();
    }
  };

  var onInteractOutsideStart = function onInteractOutsideStart(e) {
    if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside(e.target)) {
      var modality = getInteractionModality$1();

      if (modality !== 'pointer' && visibleOverlays[visibleOverlays.length - 1] === ref) {
        e.stopPropagation();
        e.preventDefault();
      }
    }
  };

  var onInteractOutside = function onInteractOutside(e) {
    if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside(e.target)) {
      var modality = getInteractionModality$1();

      if (modality !== 'pointer' && visibleOverlays[visibleOverlays.length - 1] === ref) {
        e.stopPropagation();
        e.preventDefault();
      }

      onHide();
    }
  }; // Handle the escape key


  var onKeyDown = function onKeyDown(e) {
    if (e.key === 'Escape' && !isKeyboardDismissDisabled) {
      e.preventDefault();
      onHide();
    }
  }; // Handle clicking outside the overlay to close it


  useInteractOutside({
    ref: ref,
    onInteractOutside: isDismissable ? onInteractOutside : null,
    onInteractOutsideStart: onInteractOutsideStart
  });

  var _useFocusWithin = useFocusWithin({
    isDisabled: !shouldCloseOnBlur,
    onBlurWithin: function onBlurWithin() {
      if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside(document.activeElement)) {
        onClose();
      }
    }
  }),
      focusWithinProps = _useFocusWithin.focusWithinProps;

  var onPointerDownUnderlay = function onPointerDownUnderlay(e) {
    // fixes a firefox issue that starts text selection https://bugzilla.mozilla.org/show_bug.cgi?id=1675846
    if (e.target === e.currentTarget) {
      e.preventDefault();
    }
  };

  return {
    overlayProps: Object.assign({
      onKeyDown: onKeyDown
    }, focusWithinProps),
    underlayProps: {
      onPointerDown: onPointerDownUnderlay
    }
  };
}

function useOverlayPosition(_a) {
  var matchTriggerWidth = _a.matchTriggerWidth,
      props = __rest(_a, ["matchTriggerWidth"]);

  var _useSize = useSize(props.targetRef),
      _useSize2 = _slicedToArray(_useSize, 1),
      triggerWidth = _useSize2[0];

  var _useOverlayPosition$ = useOverlayPosition$1(props),
      overlayProps = _useOverlayPosition$.overlayProps,
      _useOverlayPosition$$ = _useOverlayPosition$.placement,
      placement = _useOverlayPosition$$ === void 0 ? 'bottom' : _useOverlayPosition$$,
      updatePosition = _useOverlayPosition$.updatePosition,
      arrowProps = _useOverlayPosition$.arrowProps;

  var style = Object.assign({}, arrowProps.style, {
    fontSize: 16,
    lineHeight: 0
  });
  var arrowIcon = 'caret-up';

  switch (placement) {
    case 'bottom':
      style.top = -10;
      style.marginLeft = -5;
      break;

    case 'top':
      style.bottom = -10;
      style.marginLeft = -5;
      arrowIcon = 'caret-down';
      break;

    case 'left':
      style.right = -6;
      style.marginTop = -8;
      arrowIcon = 'caret-right';
      break;

    case 'right':
      style.left = -5;
      style.marginTop = -8;
      arrowIcon = 'caret-left';
      break;

    default:
      console.warn("Hey, you're using an invalid placement prop! Check out the docs for appropriate usage, or remove it.");
  }

  arrowProps.style = style;
  var overlayStyle = overlayProps.style || {};

  if (matchTriggerWidth) {
    overlayStyle.width = triggerWidth;
  }

  overlayProps.style = overlayStyle;
  return {
    overlayProps: overlayProps,
    placement: placement,
    updatePosition: updatePosition,
    arrowProps: arrowProps,
    arrowIcon: ['fas', arrowIcon]
  };
}

var THEME_STORAGE_KEY = 'mosaic-theme';
var DEFAULT_THEME_MODE = 'light';
/**
 * For SSR
 */

var memoryDb = {};
var memoryStorage = {
  getItem: function getItem(name) {
    return memoryDb[name];
  },
  setItem: function setItem(name, value) {
    memoryDb[name] = value;
  }
};

var defaultMode = function defaultMode() {
  if (typeof localStorage === 'undefined') return DEFAULT_THEME_MODE;

  try {
    return JSON.parse(localStorage.getItem(THEME_STORAGE_KEY)).mode;
  } catch (_a) {}

  var dataTheme = document.documentElement.getAttribute('data-theme');
  if (dataTheme) return dataTheme;
  return DEFAULT_THEME_MODE;
};

var useThemeStore = create(persist(function (set) {
  return {
    mode: defaultMode(),
    theme: {
      colors: {}
    },
    // default is light theme
    colorValues: {
      light: true
    },
    invertedColorValues: {
      light: false
    },
    setMode: function setMode(mode) {
      var preferDark = prefersDarkMode();

      if (typeof document !== 'undefined') {
        var _mode = mode;

        if (mode === 'system') {
          _mode = preferDark ? 'dark' : 'light';
        }

        document.documentElement.setAttribute('data-theme', _mode);
      }

      set(function (state) {
        return Object.assign(Object.assign({}, state), {
          mode: mode
        });
      });
    },
    setColor: function setColor(name, val) {
      return set(function (state) {
        // if would result in no change, return
        if (defaultTheme.colors[name] === val || state.theme.colors[name] === val) return; // allow setting by hex or rgb val

        var hslObj;

        if (typeof val === 'string') {
          var x = parseToHsl(val);
          hslObj = {
            h: Math.round(x.hue),
            s: Math.round(x.saturation * 100),
            l: Math.round(x.lightness * 100)
          };
        } else {
          hslObj = val;
        }

        var hslString = stringifyHsl(hslObj); // if new val equals the default val, delete it so that it's removed from localStorage
        // this way if we update default theme in the future, the user will get the new values

        if (defaultTheme.colors[name] === hslString) {
          delete state.theme.colors[name];
          return;
        }

        return {
          theme: Object.assign(Object.assign({}, state.theme), {
            colors: Object.assign(Object.assign({}, state.theme.colors), _defineProperty({}, name, hslString))
          })
        };
      });
    },
    reset: function reset() {
      return set({
        theme: {
          colors: {}
        }
      });
    },
    setColorValues: function setColorValues(cv) {
      return set({
        colorValues: cv
      });
    },
    setInvertedColorValues: function setInvertedColorValues(cv) {
      return set({
        invertedColorValues: cv
      });
    }
  };
}, {
  name: THEME_STORAGE_KEY,
  getStorage: function getStorage() {
    return typeof localStorage === 'undefined' ? memoryStorage : localStorage;
  },
  // only remember the desired mode
  serialize: function serialize(_ref6) {
    var state = _ref6.state;
    return JSON.stringify({
      mode: state.mode
    });
  }
}));
/**
 * Pass a lodash style property path to pluck a specific theme property out. This helps with performance
 * if theme is being updated, since calling component will only re-render when the particular theme value
 * that is subscribed to changes.
 */

var useTheme = function useTheme(property) {
  var themeValue = useThemeStore(function (state) {
    return _get(cjs(defaultTheme, state.theme), property);
  });
  var setColor = useThemeStore(function (state) {
    return state.setColor;
  });
  var reset = useThemeStore(function (state) {
    return state.reset;
  });
  return {
    themeValue: themeValue,
    setColor: setColor,
    reset: reset
  };
};

var InvertThemeContext = /*#__PURE__*/createContext({});

var InvertTheme = function InvertTheme(_ref7) {
  var children = _ref7.children,
      inverted = _ref7.inverted;

  var _useContext = useContext(InvertThemeContext),
      parentInverted = _useContext.inverted;

  var _inverted = undefined;

  if (inverted !== false) {
    _inverted = parentInverted !== void 0 ? !parentInverted : true;
  }

  var _className = cn(children.props.className, {
    'sl-inverted': inverted === false ? undefined : true
  });

  return jsx(InvertThemeContext.Provider, Object.assign({
    value: {
      inverted: _inverted
    }
  }, {
    children: /*#__PURE__*/cloneElement(children, {
      className: _className || undefined
    })
  }), void 0);
};

var useThemeIsDark = function useThemeIsDark() {
  var _useContext2 = useContext(InvertThemeContext),
      inverted = _useContext2.inverted;

  var _useThemeStore = useThemeStore(function (s) {
    return [s.colorValues.light, s.invertedColorValues.light];
  }, shallow),
      _useThemeStore2 = _slicedToArray(_useThemeStore, 2),
      isLightBg = _useThemeStore2[0],
      isLightInvertedBg = _useThemeStore2[1];

  if (inverted) {
    return !isLightInvertedBg;
  }

  return !isLightBg;
};

var useThemeIsInverted = function useThemeIsInverted() {
  var _useContext3 = useContext(InvertThemeContext),
      inverted = _useContext3.inverted;

  return inverted;
};

var useThemeMode = function useThemeMode() {
  var mode = useThemeStore(function (state) {
    return state.mode;
  });
  var setMode = useThemeStore(function (state) {
    return state.setMode;
  });
  return {
    mode: mode,
    setMode: setMode
  };
};

function Overlay(props, ref) {
  var children = props.children,
      isOpen = props.isOpen,
      container = props.container;

  var _useMosaicContext = useMosaicContext(),
      providerRef = _useMosaicContext.providerRef;

  var mountOverlay = isOpen;

  if (!mountOverlay || typeof window === 'undefined') {
    // Don't bother showing anything if we don't have to.
    return null;
  }

  var contents = jsx(WithDomRef, Object.assign({
    ref: ref
  }, {
    children: jsx(Box, Object.assign({
      style: {
        background: 'transparent'
      }
    }, {
      children: children
    }), void 0)
  }), void 0);
  var portalContainer = container || (providerRef === null || providerRef === void 0 ? void 0 : providerRef.current) || document.body;
  return /*#__PURE__*/ReactDOM.createPortal(contents, portalContainer);
}

var _Overlay = /*#__PURE__*/forwardRef(Overlay);

var Popover = /*#__PURE__*/forwardRef(function (props, ref) {
  var renderTrigger = props.renderTrigger,
      children = props.children,
      isOpen = props.isOpen,
      defaultOpen = props.defaultOpen,
      _props$placement = props.placement,
      placement = _props$placement === void 0 ? 'bottom' : _props$placement,
      scrollRef = props.scrollRef,
      onOpen = props.onOpen,
      onClose = props.onClose,
      _props$contain = props.contain,
      contain = _props$contain === void 0 ? true : _props$contain,
      _props$autoFocus = props.autoFocus,
      autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus,
      _props$restoreFocus = props.restoreFocus,
      restoreFocus = _props$restoreFocus === void 0 ? true : _props$restoreFocus,
      _props$offset = props.offset,
      offset = _props$offset === void 0 ? props.showArrow ? 10 : 8 : _props$offset,
      _props$crossOffset = props.crossOffset,
      crossOffset = _props$crossOffset === void 0 ? 0 : _props$crossOffset,
      _props$shouldFlip = props.shouldFlip,
      shouldFlip = _props$shouldFlip === void 0 ? true : _props$shouldFlip,
      p = props.p,
      _props$appearance = props.appearance,
      appearance = _props$appearance === void 0 ? 'default' : _props$appearance,
      showArrow = props.showArrow,
      _props$type = props.type,
      type = _props$type === void 0 ? 'dialog' : _props$type,
      isNonModal = props.isNonModal,
      matchTriggerWidth = props.matchTriggerWidth;
  var onOpenChange = useCallback(function ($isOpen) {
    if ($isOpen && onOpen) onOpen();
    if (!$isOpen && onClose) onClose();
  }, [onClose, onOpen]);
  var state = useOverlayTriggerState({
    isOpen: isOpen,
    defaultOpen: defaultOpen,
    onOpenChange: onOpenChange
  });
  var triggerRef = useRef();
  var consumerProvidedRef = !!props.triggerRef;
  var popoverRef = useRef();
  var unwrappedPopoverRef = useUnwrapDOMRef(popoverRef); // Get props for the trigger and overlay. This also handles
  // hiding the overlay when a parent element of the trigger scrolls
  // (which invalidates the popover positioning).

  var _useOverlayTrigger = useOverlayTrigger({
    type: type
  }, state, triggerRef),
      triggerProps = _useOverlayTrigger.triggerProps,
      overlayProps = _useOverlayTrigger.overlayProps; // Get popover positioning props relative to the trigger


  var _useOverlayPosition = useOverlayPosition({
    targetRef: props.triggerRef || triggerRef,
    overlayRef: unwrappedPopoverRef,
    placement: placement,
    offset: offset,
    scrollRef: scrollRef,
    crossOffset: crossOffset,
    shouldFlip: shouldFlip,
    isOpen: state.isOpen,
    onClose: onClose,
    matchTriggerWidth: matchTriggerWidth
  }),
      positionProps = _useOverlayPosition.overlayProps,
      arrowProps = _useOverlayPosition.arrowProps,
      arrowIcon = _useOverlayPosition.arrowIcon;

  var triggerPropsWithRef = Object.assign(Object.assign({}, triggerProps), {
    ref: consumerProvidedRef ? undefined : triggerRef
  }); // if isOpen is provided (controlled mode), do not use our own onPress handler

  var onPress = isOpen === void 0 ? state.toggle : undefined;
  var triggerElem = renderTrigger ? runIfFn(renderTrigger, {
    isOpen: state.isOpen
  }) : null;
  return jsxs(Fragment, {
    children: [triggerElem && jsx(PressResponder, Object.assign({}, triggerPropsWithRef, {
      onPress: onPress,
      isPressed: state.isOpen
    }, {
      children: triggerElem
    }), void 0), jsx(_Overlay, Object.assign({
      isOpen: state.isOpen
    }, {
      children: jsxs(PopoverWrapper, Object.assign({}, overlayProps, positionProps, {
        ref: popoverRef,
        isOpen: state.isOpen,
        onClose: state.close,
        p: p,
        contain: contain,
        autoFocus: autoFocus,
        restoreFocus: restoreFocus,
        appearance: appearance,
        isNonModal: isNonModal
      }, {
        children: [runIfFn(children, {
          close: state.close
        }), showArrow && jsx(TooltipArrow, {
          icon: arrowIcon,
          style: arrowProps.style
        }, void 0)]
      }), void 0)
    }), void 0)]
  }, void 0);
});
var popoverVariants = {
  default: {
    p: 4,
    bg: 'canvas-dialog'
  },
  minimal: {}
};
var PopoverWrapper = /*#__PURE__*/forwardRef(function (_a, ref) {
  var children = _a.children,
      isOpen = _a.isOpen,
      onClose = _a.onClose,
      contain = _a.contain,
      autoFocus = _a.autoFocus,
      restoreFocus = _a.restoreFocus,
      appearance = _a.appearance,
      isNonModal = _a.isNonModal,
      otherProps = __rest(_a, ["children", "isOpen", "onClose", "contain", "autoFocus", "restoreFocus", "appearance", "isNonModal"]);

  var domRef = useDOMRef(ref); // Handle interacting outside the dialog and pressing
  // the Escape key to close the modal.

  var _useOverlay = useOverlay({
    onClose: onClose,
    isOpen: isOpen,
    isDismissable: true
  }, domRef),
      overlayProps = _useOverlay.overlayProps; // Hide content outside the modal from screen readers.


  var _useModal = useModal({
    isDisabled: isNonModal
  }),
      modalProps = _useModal.modalProps;

  var _b = mergeProps(overlayProps, otherProps, modalProps),
      containerProps = __rest(_b, ["color"]);

  var variantProps = popoverVariants[appearance] || {}; // Focus the popover itself on mount, unless a child element is already focused.

  useEffect(function () {
    // without the requestAnimationFrame, interactions with popover in cypress testing environment fail
    requestAnimationFrame(function () {
      if (domRef.current && !domRef.current.contains(document.activeElement)) {
        focusSafely(domRef.current);
      }
    });
  }, [domRef]);
  return jsxs(FocusScope, Object.assign({
    contain: contain,
    restoreFocus: restoreFocus,
    autoFocus: autoFocus
  }, {
    children: [jsx(DismissButton, {
      onDismiss: onClose
    }, void 0), jsx(Box, Object.assign({}, containerProps, variantProps, {
      className: "sl-popover",
      ref: domRef,
      role: "presentation",
      tabIndex: -1,
      display: "inline-flex",
      "data-testid": "popover"
    }, {
      children: children
    }), void 0), jsx(DismissButton, {
      onDismiss: onClose
    }, void 0)]
  }), void 0);
});

function TooltipArrow(_ref8) {
  var icon = _ref8.icon,
      style = _ref8.style;
  var isDark = useThemeIsDark();
  return jsx(Box, Object.assign({
    className: "sl-popover__tip",
    zIndex: 0,
    pos: "absolute",
    color: isDark ? 'canvas-dialog' : 'canvas-pure',
    style: style
  }, {
    children: jsx(Icon, {
      icon: icon
    }, void 0)
  }), void 0);
}

var idCounter = 1;
var cache = new WeakMap();

function generateKey(items) {
  var cached = cache.get(items);
  if (cached) return cached;
  var id = idCounter++;
  if (items) cache.set(items, id);
  return id;
}
/**
 * Pulled from https://github.com/adobe/react-spectrum/blob/main/packages/%40react-stately/collections/src/Item.ts
 * with some minor adjustments.
 */


function Item(props) {
  return null;
} // See examples of getCollectionNode https://github.com/adobe/react-spectrum/search?q=getCollectionNode


Item.getCollectionNode = /*#__PURE__*/_regeneratorRuntime.mark(function getCollectionNode(props, context) {
  var childItems, title, children, rendered, textValue;
  return _regeneratorRuntime.wrap(function getCollectionNode$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          childItems = props.childItems, title = props.title, children = props.children;
          rendered = props.title || props.children;
          textValue = props.textValue || (typeof rendered === 'string' ? rendered : '') || props['aria-label'] || '';
          _context2.next = 5;
          return {
            key: props.id,
            type: 'item',
            props: props,
            rendered: rendered,
            textValue: textValue,
            'aria-label': props['aria-label'],
            hasChildNodes: hasChildItems(props),
            childNodes: /*#__PURE__*/_regeneratorRuntime.mark(function childNodes() {
              var _iterator2, _step2, child, items;

              return _regeneratorRuntime.wrap(function childNodes$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      if (!childItems) {
                        _context.next = 25;
                        break;
                      }

                      _iterator2 = _createForOfIteratorHelper(childItems);
                      _context.prev = 2;

                      _iterator2.s();

                    case 4:
                      if ((_step2 = _iterator2.n()).done) {
                        _context.next = 15;
                        break;
                      }

                      child = _step2.value;

                      if (!(child && typeof child === 'object')) {
                        _context.next = 11;
                        break;
                      }

                      _context.next = 9;
                      return {
                        value: Object.assign({
                          // generate a key for groups/sections nested inside of items (for menus mostly)
                          // @ts-expect-error
                          id: typeof child.id !== 'undefined' ? child.id : "".concat(generateKey(child.children), "-subitem")
                        }, child)
                      };

                    case 9:
                      _context.next = 13;
                      break;

                    case 11:
                      _context.next = 13;
                      return {
                        value: child
                      };

                    case 13:
                      _context.next = 4;
                      break;

                    case 15:
                      _context.next = 20;
                      break;

                    case 17:
                      _context.prev = 17;
                      _context.t0 = _context["catch"](2);

                      _iterator2.e(_context.t0);

                    case 20:
                      _context.prev = 20;

                      _iterator2.f();

                      return _context.finish(20);

                    case 23:
                      _context.next = 29;
                      break;

                    case 25:
                      if (!title) {
                        _context.next = 29;
                        break;
                      }

                      items = [];
                      Children.forEach(children, function (child) {
                        items.push({
                          // type: 'item', // do not constrain to just item children - sections etc are ok
                          element: child
                        });
                      });
                      return _context.delegateYield(items, "t1", 29);

                    case 29:
                    case "end":
                      return _context.stop();
                  }
                }
              }, childNodes, null, [[2, 17, 20, 23]]);
            })
          };

        case 5:
        case "end":
          return _context2.stop();
      }
    }
  }, getCollectionNode);
});

function hasChildItems(props) {
  if (props.hasChildItems !== null) {
    return props.hasChildItems;
  }

  if (props.childItems) {
    return true;
  }

  if (props.title && Children.count(props.children) > 0) {
    return true;
  }

  return false;
}
/**
 * Pulled from https://github.com/adobe/react-spectrum/blob/main/packages/%40react-stately/collections/src/Section.ts
 * with some minor adjustments.
 */


function Section(props) {
  return null;
} // See examples of getCollectionNode https://github.com/adobe/react-spectrum/search?q=getCollectionNode


Section.getCollectionNode = /*#__PURE__*/_regeneratorRuntime.mark(function getCollectionNode(props, context) {
  var children, id, title, items;
  return _regeneratorRuntime.wrap(function getCollectionNode$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          children = props.children, id = props.id, title = props.title, items = props.items;
          _context4.next = 3;
          return {
            key: typeof id !== 'undefined' ? id : "".concat(generateKey(items), "-section"),
            type: 'section',
            hasChildNodes: true,
            props: props,
            rendered: title,
            'aria-label': props['aria-label'],
            childNodes: /*#__PURE__*/_regeneratorRuntime.mark(function childNodes() {
              var _iterator3, _step3, item, _items;

              return _regeneratorRuntime.wrap(function childNodes$(_context3) {
                while (1) {
                  switch (_context3.prev = _context3.next) {
                    case 0:
                      if (!(typeof children === 'function')) {
                        _context3.next = 22;
                        break;
                      }

                      if (items) {
                        _context3.next = 3;
                        break;
                      }

                      throw new Error('props.children was a function but props.items is missing');

                    case 3:
                      _iterator3 = _createForOfIteratorHelper(items);
                      _context3.prev = 4;

                      _iterator3.s();

                    case 6:
                      if ((_step3 = _iterator3.n()).done) {
                        _context3.next = 12;
                        break;
                      }

                      item = _step3.value;
                      _context3.next = 10;
                      return {
                        value: item,
                        renderer: children
                      };

                    case 10:
                      _context3.next = 6;
                      break;

                    case 12:
                      _context3.next = 17;
                      break;

                    case 14:
                      _context3.prev = 14;
                      _context3.t0 = _context3["catch"](4);

                      _iterator3.e(_context3.t0);

                    case 17:
                      _context3.prev = 17;

                      _iterator3.f();

                      return _context3.finish(17);

                    case 20:
                      _context3.next = 25;
                      break;

                    case 22:
                      _items = [];
                      Children.forEach(children, function (child) {
                        _items.push({
                          element: child
                        });
                      });
                      return _context3.delegateYield(_items, "t1", 25);

                    case 25:
                    case "end":
                      return _context3.stop();
                  }
                }
              }, childNodes, null, [[4, 14, 17, 20]]);
            })
          };

        case 3:
        case "end":
          return _context4.stop();
      }
    }
  }, getCollectionNode);
});
var useEnhancedEffect = typeof window !== 'undefined' && !process.env.TEST_SSR ? useLayoutEffect : useEffect;
/**
 * NoSsr purposely removes components from the subject of Server Side Rendering (SSR).
 *
 * This component can be useful in a variety of situations:
 * - Escape hatch for broken dependencies not supporting SSR.
 * - Improve the time-to-first paint on the client by only rendering above the fold.
 * - Reduce the rendering time on the server.
 * - Under too heavy server load, you can turn on service degradation.
 */

var NoSsr = function NoSsr(props) {
  var children = props.children,
      _props$defer = props.defer,
      defer = _props$defer === void 0 ? false : _props$defer,
      _props$fallback = props.fallback,
      fallback = _props$fallback === void 0 ? null : _props$fallback;

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      mountedState = _useState10[0],
      setMountedState = _useState10[1];

  useEnhancedEffect(function () {
    if (!defer && !process.env.TEST_SSR) {
      setMountedState(true);
    }
  }, [defer]);
  useEffect(function () {
    if (defer && !process.env.TEST_SSR) {
      setMountedState(true);
    }
  }, [defer]);
  return jsx(Fragment, {
    children: mountedState ? children : fallback
  }, void 0);
};

var isMenuGroup = function isMenuGroup(node) {
  return node && typeof node === 'object' && node['type'] === 'group';
};

var isMenuOptionGroup = function isMenuOptionGroup(node) {
  return node && typeof node === 'object' && node['type'] === 'option_group';
};

var isMenuOption = function isMenuOption(node) {
  return node && typeof node === 'object' && node.hasOwnProperty('value') && !node['type'];
};

var isMenuDivider = function isMenuDivider(node) {
  return node && typeof node === 'object' && node['type'] === 'divider';
};

var MenuContext = /*#__PURE__*/createContext(null);

var MenuKeyboardDelegate = /*#__PURE__*/function () {
  function MenuKeyboardDelegate(state) {
    _classCallCheck(this, MenuKeyboardDelegate);

    this.expandedKeys = state.expandedKeys;
    this.collection = state.collection;
    this.selectionManager = state.selectionManager;
    this.toggleKey = state.toggleKey;
    this.collapseKey = state.collapseKey;
  }

  _createClass(MenuKeyboardDelegate, [{
    key: "getKeyRightOf",
    value: function getKeyRightOf(key) {
      var selectionManager = this.selectionManager,
          collection = this.collection,
          toggleKey = this.toggleKey;
      var item = collection.getItem(key);
      if (!item || !item.hasChildNodes) return;
      toggleKey(key);
      selectionManager.setFocused(true); // return the first key in the nested menu

      var rightKey = this.getFirstKey();
      return rightKey;
    }
  }, {
    key: "getKeyLeftOf",
    value: function getKeyLeftOf(key) {
      var selectionManager = this.selectionManager,
          collection = this.collection,
          collapseKey = this.collapseKey;
      var item = collection.getItem(key);
      if (!item) return;
      var parent = collection.getItem(item.parentKey);
      var parentKey = null;

      while (parentKey === null) {
        if (!parent) return null;

        if (parent.menuLevel === item.menuLevel - 1) {
          parentKey = parent.key;
        } else {
          parent = collection.getItem(parent.parentKey);
        }
      }

      if (parentKey) {
        collapseKey(parentKey);
      }

      selectionManager.setFocusedKey(parentKey);
      selectionManager.setFocused(true); // return the parent key

      return parentKey;
    }
  }, {
    key: "getKeyAbove",
    value: function getKeyAbove(key) {
      var collection = this.collection;
      var deepestExpandedKey = this.getDeepestExpandedKey();
      var keyBefore = collection.getKeyBefore(key);

      while (keyBefore !== null) {
        var item = collection.getItem(keyBefore);

        if ((item === null || item === void 0 ? void 0 : item.type) === 'item' && !item.isDisabled && // only navigate up/down through items in this menu (not nested or parent menus)
        item.parentMenuItemKey === deepestExpandedKey) {
          return keyBefore;
        }

        keyBefore = collection.getKeyBefore(keyBefore);
      }

      return null;
    }
  }, {
    key: "getKeyBelow",
    value: function getKeyBelow(key) {
      var collection = this.collection;
      var deepestExpandedKey = this.getDeepestExpandedKey();
      var keyBelow = collection.getKeyAfter(key);

      while (keyBelow !== null) {
        var item = collection.getItem(keyBelow);

        if ((item === null || item === void 0 ? void 0 : item.type) === 'item' && !item.isDisabled && // only navigate up/down through items in this menu (not nested or parent menus)
        item.parentMenuItemKey === deepestExpandedKey) {
          return keyBelow;
        }

        keyBelow = collection.getKeyAfter(keyBelow);
      }

      return null;
    }
  }, {
    key: "getFirstKey",
    value: function getFirstKey() {
      var collection = this.collection;
      var deepestExpandedKey = this.getDeepestExpandedKey();
      var key = collection.getFirstKey();

      while (key !== null) {
        var item = collection.getItem(key);

        if ((item === null || item === void 0 ? void 0 : item.type) === 'item' && !item.isDisabled && item.parentMenuItemKey === deepestExpandedKey) {
          return key;
        }

        key = collection.getKeyAfter(key);
      }

      return null;
    }
  }, {
    key: "getLastKey",
    value: function getLastKey() {
      var collection = this.collection;
      var deepestExpandedKey = this.getDeepestExpandedKey();
      var key = collection.getLastKey();

      while (key !== null) {
        var item = collection.getItem(key);

        if ((item === null || item === void 0 ? void 0 : item.type) === 'item' && !item.isDisabled && item.parentMenuItemKey === deepestExpandedKey) {
          return key;
        }

        key = collection.getKeyBefore(key);
      }

      return null;
    }
  }, {
    key: "getDeepestExpandedKey",
    value: function getDeepestExpandedKey() {
      var expandedKeys = this.expandedKeys;
      var keyArray = Array.from(expandedKeys.keys());
      return keyArray[keyArray.length - 1] || null;
    }
  }]);

  return MenuKeyboardDelegate;
}();

var defaultElement$5 = 'a';
var Link = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(function (_a, ref) {
  var className = _a.className,
      restProps = __rest(_a, ["className"]);

  var _useMosaicContext2 = useMosaicContext(),
      LinkOverride = _useMosaicContext2.componentOverrides.Link;

  return jsx(Box, Object.assign({
    as: LinkOverride || defaultElement$5,
    ref: ref,
    className: cn('sl-link', className)
  }, restProps), void 0);
}));
var MENU_ITEM_IDENT_WIDTHS = {
  default: '28px',
  lg: '40px'
};
var Internal_MenuItemRow = /*#__PURE__*/forwardRef(function MenuItem(_a, ref) {
  var title = _a.title,
      isFocused = _a.isFocused,
      isActive = _a.isActive,
      isDisabled = _a.isDisabled,
      isSelected = _a.isSelected,
      hasSubmenu = _a.hasSubmenu,
      isIndented = _a.isIndented,
      icon = _a.icon,
      iconColor = _a.iconColor,
      meta = _a.meta,
      href = _a.href,
      _a$size4 = _a.size,
      size = _a$size4 === void 0 ? 'default' : _a$size4,
      _a$cursor = _a.cursor,
      cursor = _a$cursor === void 0 ? true : _a$cursor,
      restProps = __rest(_a, ["title", "isFocused", "isActive", "isDisabled", "isSelected", "hasSubmenu", "isIndented", "icon", "iconColor", "meta", "href", "size", "cursor"]);

  var isCheckableItem = typeof isSelected !== 'undefined';
  var shouldIndent = isIndented || isCheckableItem || typeof icon !== 'undefined';
  var modality = useInteractionModality();
  var pointerInteraction = modality === 'pointer';
  var isLink = !!href;
  var isExternalLink = isLink && !href.startsWith('/');
  var rowChildren = jsxs(Fragment, {
    children: [shouldIndent && jsx(Box, Object.assign({
      style: {
        width: MENU_ITEM_IDENT_WIDTHS[size],
        fontSize: isCheckableItem ? size === 'lg' ? 12 : 10 : undefined
      },
      flexShrink: 0,
      textAlign: "center",
      "data-testid": "icon"
    }, {
      children: (isSelected || icon) && jsx(Icon, {
        className: "sl-menu-item__icon",
        icon: isSelected ? 'check' : icon,
        style: {
          color: iconColor
        }
      }, void 0)
    }), void 0), jsx(Box, Object.assign({
      flex: 1,
      pr: 8,
      lineHeight: size === 'lg' ? 'relaxed' : undefined,
      textOverflow: "truncate"
    }, {
      children: title
    }), void 0), isExternalLink ? jsx(Box, Object.assign({
      className: "sl-menu-item__link-icon"
    }, {
      children: jsx(Icon, {
        icon: "external-link-alt",
        size: "sm"
      }, void 0)
    }), void 0) : null, (meta || meta === 0) && jsx(Box, Object.assign({
      className: "sl-menu-item__meta"
    }, {
      children: meta
    }), void 0), hasSubmenu && jsx(Box, {
      children: jsx(Icon, {
        icon: ['fas', 'caret-right']
      }, void 0)
    }, void 0)]
  }, void 0);
  var rowProps = Object.assign(Object.assign({}, restProps), {
    pl: size === 'lg' ? shouldIndent ? 2 : 5 : shouldIndent ? 1 : 3,
    pr: size === 'lg' ? 4 : 3,
    h: size === 'lg' ? 'md' : 'sm',
    alignItems: 'center',
    whitespace: 'nowrap',
    fontSize: size === 'lg' ? 'lg' : 'base',
    opacity: isDisabled ? 50 : undefined,
    className: cn('sl-menu-item', {
      'sl-menu-item--has-submenu': hasSubmenu,
      'sl-menu-item--disabled': isDisabled,
      'sl-menu-item--submenu-active': !isFocused && isActive,
      'sl-menu-item--focused': (!pointerInteraction || hasSubmenu) && isFocused
    })
  });

  if (isLink && !isDisabled) {
    return jsx(Link, Object.assign({
      ref: ref,
      href: href,
      target: href && !href.startsWith('/') ? '_blank' : undefined,
      display: "flex",
      cursor: cursor
    }, rowProps, {
      children: rowChildren
    }), void 0);
  }

  return jsx(Flex, Object.assign({
    ref: ref,
    cursor: isDisabled ? 'not-allowed' : cursor
  }, rowProps, {
    children: rowChildren
  }), void 0);
});

function MenuNodes(_a) {
  var items = _a.items,
      autoFocus = _a.autoFocus,
      className = _a.className,
      props = __rest(_a, ["items", "autoFocus", "className"]);

  var ref = useRef();
  var isDark = useThemeIsDark();

  var _useContext4 = useContext(MenuContext),
      state = _useContext4.state,
      keyboardDelegate = _useContext4.keyboardDelegate,
      size = _useContext4.size;

  var // pull color out for typing reasons
  // pull onBlur and onFocus out because react-aria isn't setup to work with portaled submenus
  _b = useMenu(Object.assign(Object.assign({}, props), {
    autoFocus: autoFocus,
    keyboardDelegate: keyboardDelegate
  }), state, ref).menuProps,
      menuProps = __rest(_b, ["color", "onBlur", "onFocus"]);

  var modality = useInteractionModality();
  var pointerInteraction = modality === 'pointer';
  return jsx(Box, Object.assign({
    ref: ref,
    bg: isDark ? 'canvas-dialog' : 'canvas-pure',
    w: "full",
    style: {
      minWidth: 150,
      maxWidth: 400
    },
    py: size === 'lg' ? 3 : 2,
    className: cn(className, {
      'sl-menu--pointer-interactions': pointerInteraction
    }),
    cursor: true,
    overflowY: "auto",
    display: "inline-block",
    noFocusRing: true
  }, menuProps, {
    children: Array.from(items).map(function (item, i) {
      if (isMenuGroup(item.value) || isMenuOptionGroup(item.value)) {
        return jsx(MenuSectionWrapper, {
          section: item,
          state: state
        }, item.key || i);
      }

      if (isMenuDivider(item.value)) {
        return jsx(Divider, {}, item.key || i);
      }

      return jsx(MenuItemWrapper, {
        item: item,
        state: state
      }, item.key || i);
    })
  }), void 0);
}

function Divider() {
  var _a = useSeparator({
    elementType: 'div'
  }).separatorProps,
      separatorProps = __rest(_a, ["color"]);

  var _useContext5 = useContext(MenuContext),
      size = _useContext5.size;

  return jsx(Box, Object.assign({
    my: size === 'lg' ? 2.5 : 2,
    borderT: true
  }, separatorProps), void 0);
}

function MenuSectionWrapper(_ref9) {
  var section = _ref9.section,
      state = _ref9.state;

  var _a = useMenuSection({
    heading: section.rendered,
    'aria-label': section['aria-label']
  }),
      itemProps = _a.itemProps,
      _b = _a.headingProps,
      headingProps = __rest(_b, ["color"]),
      groupProps = _a.groupProps;

  var _useContext6 = useContext(MenuContext),
      size = _useContext6.size,
      closeOnPress = _useContext6.closeOnPress;

  var value;
  var onChange;

  if (isMenuOptionGroup(section.value)) {
    value = section.value.value;
    onChange = section.value.onChange;
  }

  var childNodes = Array.from(section.childNodes); // do not render the section if it has no children

  if (!childNodes.length) return null;
  return jsxs(Fragment, {
    children: [!section.firstInMenu && jsx(Divider, {}, void 0), jsxs("div", Object.assign({}, itemProps, {
      children: [section.rendered && jsx(Box, Object.assign({}, headingProps, {
        pl: size === 'lg' ? 5 : 3,
        pt: size === 'lg' ? 1 : 0.5,
        pb: size === 'lg' ? 1.5 : 1,
        pr: 8,
        textTransform: "uppercase",
        color: "light",
        cursor: true,
        fontSize: size === 'lg' ? 'base' : 'sm'
      }, {
        children: section.rendered
      }), void 0), jsx("div", Object.assign({}, groupProps, {
        children: childNodes.map(function (node, i) {
          if (isMenuDivider(node.value)) {
            return jsx(Divider, {}, node.key || i);
          }

          if (isMenuOption(node.value) && isMenuOptionGroup(section.value)) {
            node.value = Object.assign(Object.assign({
              closeOnPress: typeof closeOnPress !== 'undefined' ? closeOnPress : false
            }, node.value), {
              isChecked: value === node.value.value,
              onPress: function onPress() {
                if (isMenuOption(node.value)) {
                  onChange(node.value.value);
                }
              }
            });
          } // @ts-expect-error


          return jsx(MenuItemWrapper, {
            item: node,
            state: state,
            isRadio: !!onChange
          }, node.key || i);
        })
      }), void 0)]
    }), void 0)]
  }, void 0);
}

function MenuItemWrapper(_ref10) {
  var item = _ref10.item,
      state = _ref10.state,
      isRadio = _ref10.isRadio;
  var ref = useRef();
  var key = item.key,
      hasChildNodes = item.hasChildNodes,
      isDisabled = item.isDisabled;
  var useIsFocusedKey = state.useIsFocusedKey,
      useIsExpandedKey = state.useIsExpandedKey,
      toggleKey = state.toggleKey;

  var _useContext7 = useContext(MenuContext),
      onClose = _useContext7.onClose,
      globalCloseOnPress = _useContext7.closeOnPress,
      size = _useContext7.size,
      cursor = _useContext7.cursor;

  var hasSubmenu = hasChildNodes;

  var _a = item.value,
      isSelected = _a.isChecked,
      title = _a.title,
      value = _a.value,
      onPress = _a.onPress,
      label = _a.label,
      isActive = _a.isActive,
      closeOnPress = _a.closeOnPress,
      afterRestoreFocus = _a.afterRestoreFocus,
      restItemProps = __rest(_a, ["isChecked", "title", "value", "onPress", "label", "isActive", "closeOnPress", "afterRestoreFocus"]);

  var isExpanded = useIsExpandedKey(key);
  var isFocused = useIsFocusedKey(key);
  var closeOnSelect = false; // priority to the value set on the item itself, if one is set

  if (typeof closeOnPress !== 'undefined') {
    closeOnSelect = closeOnPress;
  } else {
    // else default to true when NOT in checked/radio context and NOT a submenu, otherwise the global default
    closeOnSelect = typeof isSelected !== 'undefined' ? globalCloseOnPress : !hasSubmenu;
  } // links use `onClick` handlers, while most of menu works off of `onmouseup`. This dynamic causes the onClose()
  // logic to teardown the menu before link `onClick` event is triggered, causing the link to not work
  // disable closeOnSelect for links to prevent this - we call onClose in the onAction handler below for links.


  var isLink = !!item.value.href;

  if (isLink) {
    closeOnSelect = false;
  }

  var onAction = useCallback(function () {
    if (onPress) {
      if (afterRestoreFocus) {
        requestAnimationFrame(function () {
          return setTimeout(function () {
            return onPress(key);
          }, 10);
        });
      } else {
        onPress(key);
      }
    }

    if (isLink && onClose) {
      setTimeout(onClose, 0);
    }
  }, [onPress, isLink, onClose, afterRestoreFocus, key]);
  var handleHoverChange = useCallback(function () {
    toggleKey(key);
  }, [key, toggleKey]);

  var _useHover2 = useHover({
    onHoverStart: handleHoverChange,
    isDisabled: isDisabled
  }),
      hoverProps = _useHover2.hoverProps;

  var _useMenuItem = useMenuItem({
    key: key,
    isSelected: isSelected,
    isDisabled: isDisabled,
    onAction: onAction,
    closeOnSelect: closeOnSelect,
    onClose: onClose
  }, state, ref),
      menuItemProps = _useMenuItem.menuItemProps;

  var role = 'menuitem';

  if (isRadio) {
    role = 'menuitemradio';
  } else if (typeof isSelected !== 'undefined') {
    role = 'menuitemcheckbox';
  }

  var ariaProps = {
    role: role
  };

  if (typeof isSelected !== 'undefined') {
    ariaProps['aria-checked'] = isSelected;
  }

  var _b = mergeProps(restItemProps, menuItemProps, hoverProps),
      restProps = __rest(_b, ["color"]);

  var menuItemRowProps = Object.assign(Object.assign(Object.assign({}, restProps), ariaProps), {
    title: title || value,
    isFocused: isFocused,
    isActive: isActive || isExpanded,
    isSelected: isSelected,
    isDisabled: isDisabled,
    size: size,
    cursor: cursor
  });

  if (!hasSubmenu) {
    return jsx(Internal_MenuItemRow, Object.assign({}, menuItemRowProps, {
      ref: ref
    }), void 0);
  }

  return jsx(SubmenuItem, {
    item: item,
    menuItemRowProps: menuItemRowProps,
    menuItemRef: ref,
    isExpanded: isExpanded,
    label: label,
    onClose: onClose
  }, void 0);
}

function SubmenuItem(_ref11) {
  var item = _ref11.item,
      menuItemRowProps = _ref11.menuItemRowProps,
      menuItemRef = _ref11.menuItemRef,
      isExpanded = _ref11.isExpanded,
      label = _ref11.label,
      onClose = _ref11.onClose;
  var triggerId = useId();
  var submenuId = useId();
  var ariaTriggerProps = {
    'aria-haspopup': true,
    'aria-expanded': isExpanded ? 'true' : 'false'
  };

  if (isExpanded) {
    ariaTriggerProps['aria-controls'] = submenuId;
  }

  return jsxs(Fragment, {
    children: [jsx(Internal_MenuItemRow, Object.assign({}, menuItemRowProps, ariaTriggerProps, {
      id: triggerId,
      hasSubmenu: true,
      ref: menuItemRef
    }), void 0), isExpanded ? jsx(Popover, Object.assign({
      isOpen: true,
      placement: "right top",
      triggerRef: menuItemRef,
      contain: false,
      autoFocus: false,
      restoreFocus: false,
      appearance: "minimal",
      offset: 0,
      crossOffset: menuItemRowProps.size === 'lg' ? -12 : -8,
      onClose: onClose,
      type: "menu",
      isNonModal: true
    }, {
      children: jsx(MenuNodes, {
        id: submenuId,
        className: "sl-menu sl-menu--submenu",
        "aria-label": label || "".concat(menuItemRowProps.title, " submenu"),
        items: item.childNodes,
        "aria-labelledby": triggerId
      }, void 0)
    }), void 0) : null]
  }, void 0);
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

/**
 * A Selection is a special Set containing Keys, which also has an anchor
 * and current selected key for use when range selecting.
 */


var $c91e86e24f2dc9a2182dcc2674c58c$export$Selection = /*#__PURE__*/function (_Set) {
  _inherits($c91e86e24f2dc9a2182dcc2674c58c$export$Selection, _Set);

  var _super = _createSuper($c91e86e24f2dc9a2182dcc2674c58c$export$Selection);

  function $c91e86e24f2dc9a2182dcc2674c58c$export$Selection(keys, anchorKey, currentKey) {
    var _this;

    _classCallCheck(this, $c91e86e24f2dc9a2182dcc2674c58c$export$Selection);

    _this = _super.call(this, keys);
    _this.anchorKey = void 0;
    _this.currentKey = void 0;

    if (keys instanceof $c91e86e24f2dc9a2182dcc2674c58c$export$Selection) {
      _this.anchorKey = anchorKey || keys.anchorKey;
      _this.currentKey = currentKey || keys.currentKey;
    } else {
      _this.anchorKey = anchorKey;
      _this.currentKey = currentKey;
    }

    return _this;
  }

  return $c91e86e24f2dc9a2182dcc2674c58c$export$Selection;
}( /*#__PURE__*/_wrapNativeSuper(Set));
/**
 * An interface for reading and updating multiple selection state.
 */


var SelectionManager = /*#__PURE__*/function () {
  function SelectionManager(collection, state, options) {
    _classCallCheck(this, SelectionManager);

    var _options$allowsCellSe;

    this.collection = void 0;
    this.state = void 0;
    this.allowsCellSelection = void 0;
    this._isSelectAll = void 0;
    this.collection = collection;
    this.state = state;
    this.allowsCellSelection = (_options$allowsCellSe = options == null ? void 0 : options.allowsCellSelection) != null ? _options$allowsCellSe : false;
    this._isSelectAll = null;
  }
  /**
   * The type of selection that is allowed in the collection.
   */


  _createClass(SelectionManager, [{
    key: "selectionMode",
    get: function get() {
      return this.state.selectionMode;
    }
    /**
     * Whether the collection allows empty selection.
     */

  }, {
    key: "disallowEmptySelection",
    get: function get() {
      return this.state.disallowEmptySelection;
    }
    /**
     * Whether the collection is currently focused.
     */

  }, {
    key: "isFocused",
    get: function get() {
      return this.state.isFocused;
    }
    /**
     * Sets whether the collection is focused.
     */

  }, {
    key: "setFocused",
    value: function setFocused(isFocused) {
      this.state.setFocused(isFocused);
    }
    /**
     * The current focused key in the collection.
     */

  }, {
    key: "focusedKey",
    get: function get() {
      return this.state.focusedKey;
    }
    /** Whether the first or last child of the focused key should receive focus. */

  }, {
    key: "childFocusStrategy",
    get: function get() {
      return this.state.childFocusStrategy;
    }
    /**
     * Sets the focused key.
     */

  }, {
    key: "setFocusedKey",
    value: function setFocusedKey(key, childFocusStrategy) {
      this.state.setFocusedKey(key, childFocusStrategy);
    }
    /**
     * The currently selected keys in the collection.
     */

  }, {
    key: "selectedKeys",
    get: function get() {
      return this.state.selectedKeys === 'all' ? new Set(this.getSelectAllKeys()) : this.state.selectedKeys;
    }
    /**
     * The raw selection value for the collection.
     * Either 'all' for select all, or a set of keys.
     */

  }, {
    key: "rawSelection",
    get: function get() {
      return this.state.selectedKeys;
    }
    /**
     * Returns whether a key is selected.
     */

  }, {
    key: "isSelected",
    value: function isSelected(key) {
      if (this.state.selectionMode === 'none') {
        return false;
      }

      key = this.getKey(key);
      return this.state.selectedKeys === 'all' || this.state.selectedKeys.has(key);
    }
    /**
     * Whether the selection is empty.
     */

  }, {
    key: "isEmpty",
    get: function get() {
      return this.state.selectedKeys !== 'all' && this.state.selectedKeys.size === 0;
    }
    /**
     * Whether all items in the collection are selected.
     */

  }, {
    key: "isSelectAll",
    get: function get() {
      if (this.isEmpty) {
        return false;
      }

      if (this.state.selectedKeys === 'all') {
        return true;
      }

      if (this._isSelectAll != null) {
        return this._isSelectAll;
      }

      var allKeys = this.getSelectAllKeys();
      var selectedKeys = this.state.selectedKeys;
      this._isSelectAll = allKeys.every(function (k) {
        return selectedKeys.has(k);
      });
      return this._isSelectAll;
    }
  }, {
    key: "firstSelectedKey",
    get: function get() {
      var _first;

      var first = null;

      var _iterator4 = _createForOfIteratorHelper(this.state.selectedKeys),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var key = _step4.value;
          var item = this.collection.getItem(key);

          if (!first || (item == null ? void 0 : item.index) < first.index) {
            first = item;
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      return (_first = first) == null ? void 0 : _first.key;
    }
  }, {
    key: "lastSelectedKey",
    get: function get() {
      var _last;

      var last = null;

      var _iterator5 = _createForOfIteratorHelper(this.state.selectedKeys),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var key = _step5.value;
          var item = this.collection.getItem(key);

          if (!last || (item == null ? void 0 : item.index) > last.index) {
            last = item;
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      return (_last = last) == null ? void 0 : _last.key;
    }
    /**
     * Extends the selection to the given key.
     */

  }, {
    key: "extendSelection",
    value: function extendSelection(toKey) {
      toKey = this.getKey(toKey);
      var selection; // Only select the one key if coming from a select all.

      if (this.state.selectedKeys === 'all') {
        selection = new $c91e86e24f2dc9a2182dcc2674c58c$export$Selection([toKey], toKey, toKey);
      } else {
        var selectedKeys = this.state.selectedKeys;
        var anchorKey = selectedKeys.anchorKey || toKey;
        selection = new $c91e86e24f2dc9a2182dcc2674c58c$export$Selection(selectedKeys, anchorKey, toKey);

        var _iterator6 = _createForOfIteratorHelper(this.getKeyRange(anchorKey, selectedKeys.currentKey || toKey)),
            _step6;

        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var key = _step6.value;
            selection.delete(key);
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }

        var _iterator7 = _createForOfIteratorHelper(this.getKeyRange(toKey, anchorKey)),
            _step7;

        try {
          for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
            var _key7 = _step7.value;

            if (!this.state.disabledKeys.has(_key7)) {
              selection.add(_key7);
            }
          }
        } catch (err) {
          _iterator7.e(err);
        } finally {
          _iterator7.f();
        }
      }

      this.state.setSelectedKeys(selection);
    }
  }, {
    key: "getKeyRange",
    value: function getKeyRange(from, to) {
      var fromItem = this.collection.getItem(from);
      var toItem = this.collection.getItem(to);

      if (fromItem && toItem) {
        if (fromItem.index <= toItem.index) {
          return this.getKeyRangeInternal(from, to);
        }

        return this.getKeyRangeInternal(to, from);
      }

      return [];
    }
  }, {
    key: "getKeyRangeInternal",
    value: function getKeyRangeInternal(from, to) {
      var keys = [];
      var key = from;

      while (key) {
        var item = this.collection.getItem(key);

        if (item && item.type === 'item' || item.type === 'cell' && this.allowsCellSelection) {
          keys.push(key);
        }

        if (key === to) {
          return keys;
        }

        key = this.collection.getKeyAfter(key);
      }

      return [];
    }
  }, {
    key: "getKey",
    value: function getKey(key) {
      var item = this.collection.getItem(key);

      if (!item) {
        // ¯\_(ツ)_/¯
        return key;
      } // If cell selection is allowed, just return the key.


      if (item.type === 'cell' && this.allowsCellSelection) {
        return key;
      } // Find a parent item to select


      while (item.type !== 'item' && item.parentKey) {
        item = this.collection.getItem(item.parentKey);
      }

      if (!item || item.type !== 'item') {
        return null;
      }

      return item.key;
    }
    /**
     * Toggles whether the given key is selected.
     */

  }, {
    key: "toggleSelection",
    value: function toggleSelection(key) {
      key = this.getKey(key);

      if (key == null) {
        return;
      }

      var keys = new $c91e86e24f2dc9a2182dcc2674c58c$export$Selection(this.state.selectedKeys === 'all' ? this.getSelectAllKeys() : this.state.selectedKeys);

      if (keys.has(key)) {
        keys.delete(key); // TODO: move anchor to last selected key...
        // Does `current` need to move here too?
      } else {
        keys.add(key);
        keys.anchorKey = key;
        keys.currentKey = key;
      }

      this.state.setSelectedKeys(keys);
    }
    /**
     * Replaces the selection with only the given key.
     */

  }, {
    key: "replaceSelection",
    value: function replaceSelection(key) {
      key = this.getKey(key);

      if (key == null) {
        return;
      }

      this.state.setSelectedKeys(new $c91e86e24f2dc9a2182dcc2674c58c$export$Selection([key], key, key));
    }
    /**
     * Replaces the selection with the given keys.
     */

  }, {
    key: "setSelectedKeys",
    value: function setSelectedKeys(keys) {
      if (this.selectionMode === 'none') {
        return;
      }

      var selection = new $c91e86e24f2dc9a2182dcc2674c58c$export$Selection();

      var _iterator8 = _createForOfIteratorHelper(keys),
          _step8;

      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var key = _step8.value;
          key = this.getKey(key);

          if (key != null) {
            selection.add(key);

            if (this.selectionMode === 'single') {
              break;
            }
          }
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }

      this.state.setSelectedKeys(selection);
    }
  }, {
    key: "getSelectAllKeys",
    value: function getSelectAllKeys() {
      var _this2 = this;

      var keys = [];

      var addKeys = function addKeys(key) {
        while (key) {
          if (!_this2.state.disabledKeys.has(key)) {
            var item = _this2.collection.getItem(key);

            if (item.type === 'item') {
              keys.push(key);
            } // Add child keys. If cell selection is allowed, then include item children too.


            if (item.hasChildNodes && (_this2.allowsCellSelection || item.type !== 'item')) {
              addKeys(_toConsumableArray(item.childNodes)[0].key);
            }
          }

          key = _this2.collection.getKeyAfter(key);
        }
      };

      addKeys(this.collection.getFirstKey());
      return keys;
    }
    /**
     * Selects all items in the collection.
     */

  }, {
    key: "selectAll",
    value: function selectAll() {
      if (this.selectionMode === 'multiple') {
        this.state.setSelectedKeys('all');
      }
    }
    /**
     * Removes all keys from the selection.
     */

  }, {
    key: "clearSelection",
    value: function clearSelection() {
      if (this.state.selectedKeys === 'all' || this.state.selectedKeys.size > 0) {
        this.state.setSelectedKeys(new $c91e86e24f2dc9a2182dcc2674c58c$export$Selection());
      }
    }
    /**
     * Toggles between select all and an empty selection.
     */

  }, {
    key: "toggleSelectAll",
    value: function toggleSelectAll() {
      if (this.isSelectAll) {
        this.clearSelection();
      } else {
        this.selectAll();
      }
    }
  }, {
    key: "select",
    value: function select(key, e) {
      if (this.selectionMode === 'none') {
        return;
      }

      if (this.selectionMode === 'single') {
        if (this.isSelected(key) && !this.disallowEmptySelection) {
          this.toggleSelection(key);
        } else {
          this.replaceSelection(key);
        }
      } else if (e && e.shiftKey) {
        this.extendSelection(key);
      } else {
        this.toggleSelection(key);
      }
    }
    /**
     * Returns whether the current selection is equal to the given selection.
     */

  }, {
    key: "isSelectionEqual",
    value: function isSelectionEqual(selection) {
      if (selection === this.state.selectedKeys) {
        return true;
      } // Check if the set of keys match.


      var selectedKeys = this.selectedKeys;

      if (selection.size !== selectedKeys.size) {
        return false;
      }

      var _iterator9 = _createForOfIteratorHelper(selection),
          _step9;

      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var key = _step9.value;

          if (!selectedKeys.has(key)) {
            return false;
          }
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }

      var _iterator10 = _createForOfIteratorHelper(selectedKeys),
          _step10;

      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          var _key8 = _step10.value;

          if (!selection.has(_key8)) {
            return false;
          }
        }
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }

      return true;
    }
  }]);

  return SelectionManager;
}();

var defineProperty$2 = objectDefineProperty.f;
var NativeSymbol = global_1.Symbol;

if (descriptors && typeof NativeSymbol == 'function' && (!('description' in NativeSymbol.prototype) || // Safari 12 bug
NativeSymbol().description !== undefined)) {
  var EmptyStringDescriptionStore = {}; // wrap Symbol constructor for correct work with undefined description

  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : String(arguments[0]);
    var result = this instanceof SymbolWrapper ? new NativeSymbol(description) // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
    : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };

  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  var symbolPrototype = SymbolWrapper.prototype = NativeSymbol.prototype;
  symbolPrototype.constructor = SymbolWrapper;
  var symbolToString = symbolPrototype.toString;
  var native = String(NativeSymbol('test')) == 'Symbol(test)';
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  defineProperty$2(symbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = isObject(this) ? this.valueOf() : this;
      var string = symbolToString.call(symbol);
      if (has(EmptyStringDescriptionStore, symbol)) return '';
      var desc = native ? string.slice(7, -1) : string.replace(regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  _export({
    global: true,
    forced: true
  }, {
    Symbol: SymbolWrapper
  });
} // Adapted from https://github.com/adobe/react-spectrum/blob/main/packages/%40react-stately/tree/src/TreeCollection.ts


var MenuCollection = /*#__PURE__*/function () {
  function MenuCollection(nodes) {
    var _this3 = this;

    _classCallCheck(this, MenuCollection);

    this.keyMap = new Map();
    this.iterable = nodes;

    var visit = function visit(node, firstInMenu, menuLevel, parentMenuItemKey) {
      node.firstInMenu = firstInMenu;
      node.menuLevel = menuLevel;
      node.parentMenuItemKey = parentMenuItemKey;
      node.isDisabled = node.value.isDisabled || node.value.type === 'divider';

      _this3.keyMap.set(node.key, node);

      if (node.childNodes) {
        var _first2 = true;

        var _iterator11 = _createForOfIteratorHelper(node.childNodes),
            _step11;

        try {
          for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
            var child = _step11.value;
            visit(child, _first2, node.type === 'item' ? menuLevel + 1 : menuLevel, node.type === 'item' ? node.key : parentMenuItemKey);
            _first2 = false;
          }
        } catch (err) {
          _iterator11.e(err);
        } finally {
          _iterator11.f();
        }
      }
    };

    var first = true;

    var _iterator12 = _createForOfIteratorHelper(nodes),
        _step12;

    try {
      for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
        var node = _step12.value;
        visit(node, first, 1, null);
        first = false;
      }
    } catch (err) {
      _iterator12.e(err);
    } finally {
      _iterator12.f();
    }

    var last;
    var index = 0;

    var _iterator13 = _createForOfIteratorHelper(this.keyMap),
        _step13;

    try {
      for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
        var _step13$value = _slicedToArray(_step13.value, 2),
            key = _step13$value[0],
            _node = _step13$value[1];

        if (last) {
          last.nextKey = key;
          _node.prevKey = last.key;
        } else {
          this.firstKey = key;
          _node.prevKey = undefined;
        }

        if (_node.type === 'item') {
          _node.index = index++;
        }

        last = _node; // Set nextKey as undefined since this might be the last node
        // If it isn't the last node, last.nextKey will properly set at start of new loop

        last.nextKey = undefined;
      }
    } catch (err) {
      _iterator13.e(err);
    } finally {
      _iterator13.f();
    }

    this.lastKey = last === null || last === void 0 ? void 0 : last.key;
  }

  _createClass(MenuCollection, [{
    key: Symbol.iterator,
    value: /*#__PURE__*/_regeneratorRuntime.mark(function value() {
      return _regeneratorRuntime.wrap(function value$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.delegateYield(this.iterable, "t0", 1);

            case 1:
            case "end":
              return _context5.stop();
          }
        }
      }, value, this);
    })
  }, {
    key: "size",
    get: function get() {
      return this.keyMap.size;
    }
  }, {
    key: "getKeys",
    value: function getKeys() {
      return this.keyMap.keys();
    }
  }, {
    key: "getKeyBefore",
    value: function getKeyBefore(key) {
      var node = this.keyMap.get(key);
      return node ? node.prevKey : null;
    }
  }, {
    key: "getKeyAfter",
    value: function getKeyAfter(key) {
      var node = this.keyMap.get(key);
      return node ? node.nextKey : null;
    }
  }, {
    key: "getFirstKey",
    value: function getFirstKey() {
      return this.firstKey;
    }
  }, {
    key: "getLastKey",
    value: function getLastKey() {
      return this.lastKey;
    }
  }, {
    key: "getItem",
    value: function getItem(key) {
      return this.keyMap.get(key);
    }
  }]);

  return MenuCollection;
}(); // Originally adapated from https://github.com/adobe/react-spectrum/tree/main/packages/%40react-stately/selection

/**
 * A Selection is a special Set containing Keys, which also has an anchor
 * and current selected key for use when range selecting.
 */


var Selection = /*#__PURE__*/function (_Set2) {
  _inherits(Selection, _Set2);

  var _super2 = _createSuper(Selection);

  function Selection(keys, anchorKey, currentKey) {
    var _this4;

    _classCallCheck(this, Selection);

    _this4 = _super2.call(this, keys);

    if (keys instanceof Selection) {
      _this4.anchorKey = anchorKey || keys.anchorKey;
      _this4.currentKey = currentKey || keys.currentKey;
    } else {
      _this4.anchorKey = anchorKey;
      _this4.currentKey = currentKey;
    }

    return _this4;
  }

  return Selection;
}( /*#__PURE__*/_wrapNativeSuper(Set));
/**
 * Manages state for multiple selection and focus in a collection.
 */


function useMultipleSelectionState(props) {
  var _props$selectionMode = props.selectionMode,
      selectionMode = _props$selectionMode === void 0 ? 'none' : _props$selectionMode,
      disallowEmptySelection = props.disallowEmptySelection; // We want synchronous updates to `isFocused` and `focusedKey` after their setters are called.
  // But we also need to trigger a react re-render. So, we have both a ref (sync) and state (async).

  var isFocusedRef = useRef(false);
  var focusedKeyRef = useRef(null);
  var childFocusStrategyRef = useRef(null);
  var selectedKeysProp = useMemo(function () {
    return convertSelection(props.selectedKeys);
  }, [props.selectedKeys]);
  var defaultSelectedKeys = useMemo(function () {
    return convertSelection(props.defaultSelectedKeys, new Selection());
  }, [props.defaultSelectedKeys]);

  var _useControlledState3 = useControlledState(selectedKeysProp, defaultSelectedKeys, props.onSelectionChange),
      _useControlledState4 = _slicedToArray(_useControlledState3, 2),
      selectedKeys = _useControlledState4[0],
      setSelectedKeys = _useControlledState4[1];

  var disabledKeysProp = useMemo(function () {
    return props.disabledKeys ? new Set(props.disabledKeys) : new Set();
  }, [props.disabledKeys]);
  var useStore = useRef(create(function (set) {
    return {
      isFocused: false,
      focusedKey: null,
      setFocused: function setFocused(f) {
        return set(function (state) {
          isFocusedRef.current = f;
          return Object.assign(Object.assign({}, state), {
            isFocusedRef: f
          });
        });
      },
      setFocusedKey: function setFocusedKey(k) {
        var childFocusStrategy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'first';
        return set(function (state) {
          focusedKeyRef.current = k;
          childFocusStrategyRef.current = childFocusStrategy;
          return Object.assign(Object.assign({}, state), {
            focusedKey: k
          });
        });
      }
    };
  }));

  var _useStore$current = useStore.current(function (state) {
    return [state.setFocused, state.setFocusedKey];
  }, shallow),
      _useStore$current2 = _slicedToArray(_useStore$current, 2),
      setFocused = _useStore$current2[0],
      setFocusedKey = _useStore$current2[1];

  function useIsFocusedKey(key) {
    var cb = useCallback(function (state) {
      return state.focusedKey === key;
    }, [key]);
    if (!useStore.current) return false;
    return useStore.current(cb);
  }

  function useFocusedKey() {
    var cb = useCallback(function (state) {
      return state.focusedKey;
    }, []);
    if (!useStore.current) return false;
    return useStore.current(cb);
  }

  return {
    useIsFocusedKey: useIsFocusedKey,
    useFocusedKey: useFocusedKey,
    selectionMode: selectionMode,
    disallowEmptySelection: disallowEmptySelection,

    get isFocused() {
      return isFocusedRef.current;
    },

    setFocused: setFocused,

    get focusedKey() {
      return focusedKeyRef.current;
    },

    get childFocusStrategy() {
      return childFocusStrategyRef.current;
    },

    setFocusedKey: setFocusedKey,
    selectedKeys: selectedKeys,
    setSelectedKeys: setSelectedKeys,
    disabledKeys: disabledKeysProp
  };
}

function convertSelection(selection, defaultValue) {
  if (!selection) {
    return defaultValue;
  }

  return selection === 'all' ? 'all' : new Selection(selection);
}

var disabledKeys = new Set();
/**
 * Provides state management for tree-like components. Handles building a collection
 * of items from props, item expanded state, and manages multiple selection state.
 */

function useMenuState(props) {
  // stable expandedKeys set for use in keyboard delegate, etc
  var expandedKeysRef = useRef(new Set());
  var selectionState = useMultipleSelectionState(props);
  var tree = useCollection(props, function (nodes) {
    return new MenuCollection(nodes);
  }, null, []);
  var selectionManager = useMemo(function () {
    return new SelectionManager(tree, selectionState);
  }, [selectionState, tree]);
  var useStore = useRef(create(function (set) {
    return {
      // mirrored expanded keys set for use in observers in components etc
      expandedKeys: new Set(),
      toggleKey: function toggleKey(k) {
        var newSet = new Set(_toggleKey(tree, expandedKeysRef.current, k));
        return set(function (state) {
          return Object.assign(Object.assign({}, state), {
            expandedKeys: newSet
          });
        });
      },
      collapseKey: function collapseKey(k) {
        var newSet = new Set(_collapseKey(expandedKeysRef.current, k));
        return set(function (state) {
          return Object.assign(Object.assign({}, state), {
            expandedKeys: newSet
          });
        });
      },
      collapseAllKeys: function collapseAllKeys() {
        expandedKeysRef.current = new Set();
        return set(function (state) {
          return Object.assign(Object.assign({}, state), {
            expandedKeys: expandedKeysRef.current
          });
        });
      }
    };
  }));

  var _useStore$current3 = useStore.current(function (state) {
    return [state.toggleKey, state.collapseKey, state.collapseAllKeys];
  }, shallow),
      _useStore$current4 = _slicedToArray(_useStore$current3, 3),
      onToggle = _useStore$current4[0],
      onCollapse = _useStore$current4[1],
      onCollapseAllKeys = _useStore$current4[2];

  function useIsExpandedKey(key) {
    var cb = useCallback(function (state) {
      return state.expandedKeys.has(key);
    }, [key]);
    if (!useStore.current) return false;
    return useStore.current(cb);
  } // Reset focused key if that item is deleted from the collection.


  useEffect(function () {
    if (selectionState.focusedKey != null && !tree.getItem(selectionState.focusedKey)) {
      selectionState.setFocusedKey(null);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [tree, selectionState.focusedKey]);
  return {
    useIsFocusedKey: selectionState.useIsFocusedKey,
    useFocusedKey: selectionState.useFocusedKey,
    useIsExpandedKey: useIsExpandedKey,
    collection: tree,
    expandedKeys: expandedKeysRef.current,
    disabledKeys: disabledKeys,
    toggleKey: onToggle,
    collapseKey: onCollapse,
    collapseAllKeys: onCollapseAllKeys,
    selectionManager: selectionManager
  };
}

function _toggleKey(tree, set, key) {
  var parents = [];
  var item = tree.getItem(key);
  var hasChildNodes = item === null || item === void 0 ? void 0 : item.hasChildNodes;
  var parent = (item === null || item === void 0 ? void 0 : item.parentKey) ? tree.getItem(item.parentKey) : null;

  while (parent) {
    parents.unshift(parent.key);

    if (parent.parentKey) {
      parent = tree.getItem(parent.parentKey);
    } else {
      parent = null;
    }
  }

  var _iterator14 = _createForOfIteratorHelper(set),
      _step14;

  try {
    for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
      var expandedKey = _step14.value;

      if (!parents.includes(expandedKey)) {
        set.delete(expandedKey);
      }
    } // if item has child nodes and is not yet expanded, expand!

  } catch (err) {
    _iterator14.e(err);
  } finally {
    _iterator14.f();
  }

  if (hasChildNodes && !set.has(key)) {
    set.add(key);
  }

  return set;
}

function _collapseKey(set, key) {
  if (set.has(key)) {
    set.delete(key);
  }

  return set;
}

function MenuList(_a) {
  var items = _a.items,
      onClose = _a.onClose,
      closeOnPress = _a.closeOnPress,
      size = _a.size,
      cursor = _a.cursor,
      props = __rest(_a, ["items", "onClose", "closeOnPress", "size", "cursor"]);

  var state = useMenuState({
    items: items,
    children: MenuListChildren
  });
  var keyboardDelegate = useMemo(function () {
    return new MenuKeyboardDelegate(state);
  }, [state]);
  var handleOnClose = useCallback(function () {
    // make sure to collapse all submenus when menu close is triggered
    state.collapseAllKeys();
    if (onClose) onClose();
  }, [onClose, state]);
  return jsx(NoSsr, {
    children: jsx(MenuContext.Provider, Object.assign({
      value: {
        state: state,
        keyboardDelegate: keyboardDelegate,
        closeOnPress: closeOnPress,
        onClose: handleOnClose,
        size: size,
        cursor: cursor
      }
    }, {
      children: jsx(MenuNodes, Object.assign({}, props, {
        className: "sl-menu",
        autoFocus: true,
        items: state.collection
      }), void 0)
    }), void 0)
  }, void 0);
}

function MenuOption(item) {
  return jsx(Item, {
    id: item.id || item.value,
    title: item.value || item.title
  }, item.id || item.value || item.title);
}

var idCounter$1 = 1;

function MenuListChildren(item) {
  if (isMenuGroup(item)) {
    return jsx(Section, {
      id: item.id,
      title: item.title,
      // @ts-expect-error
      items: item.children || [],
      // eslint-disable-next-line react/no-children-prop
      children: MenuListChildren
    }, item.id || item.title);
  }

  if (isMenuOptionGroup(item)) {
    return jsx(Section, {
      id: item.id,
      title: item.title,
      items: item.children || [],
      // eslint-disable-next-line react/no-children-prop
      children: MenuOption
    }, item.id || item.title);
  }

  if (isMenuOption(item)) {
    return MenuOption(item);
  }

  if (isMenuDivider(item)) {
    return jsx(Item, {}, idCounter$1++);
  }

  return jsx(Item, {
    id: item.id,
    title: item.title,
    childItems: item.children,
    hasChildItems: !!(item.children && item.children.length),
    // eslint-disable-next-line react/no-children-prop
    children: MenuListChildren
  }, item.id || item.title);
}

var openMenus = {};
var menuId = 0;

function Menu(_a) {
  var renderTrigger = _a.renderTrigger,
      _a$placement = _a.placement,
      placement = _a$placement === void 0 ? 'bottom' : _a$placement,
      hideArrow = _a.hideArrow,
      onClose = _a.onClose,
      _a$closeOnPress = _a.closeOnPress,
      closeOnPress = _a$closeOnPress === void 0 ? false : _a$closeOnPress,
      ariaLabel = _a['aria-label'],
      matchTriggerWidth = _a.matchTriggerWidth,
      props = __rest(_a, ["renderTrigger", "placement", "hideArrow", "onClose", "closeOnPress", 'aria-label', "matchTriggerWidth"]);

  var id = useMemo(function () {
    return "".concat(++menuId);
  }, []);
  useEffect(function () {
    // make sure to cleanup on unmount in case the menu is unmounted via a method other than official close handler
    return function () {
      if (openMenus[id]) delete openMenus[id];
    };
  }, [id]); // only one menu allowed open at a time

  var closeOpenMenus = useCallback(function () {
    for (var hideMenuId in openMenus) {
      if (hideMenuId !== id) {
        openMenus[hideMenuId](true);
        delete openMenus[hideMenuId];
      }
    }
  }, [id]);

  var onOpenChange = function onOpenChange(isOpen) {
    if (isOpen) {
      closeOpenMenus();
      trackOpenMenu();
    } else {
      if (onClose) onClose();
    }
  }; // Create state based on the incoming props


  var state = useMenuTriggerState(Object.assign(Object.assign({}, props), {
    onOpenChange: onOpenChange,
    closeOnSelect: closeOnPress
  }));

  function trackOpenMenu() {
    openMenus[id] = state.close;
  } // Get props for the menu trigger and menu elements


  var ref = useRef();

  var _useMenuTrigger = useMenuTrigger({
    type: 'menu'
  }, state, ref),
      menuTriggerProps = _useMenuTrigger.menuTriggerProps,
      menuProps = _useMenuTrigger.menuProps;

  var triggerElem = runIfFn(renderTrigger, {
    isOpen: state.isOpen
  });
  return jsxs(Fragment, {
    children: [jsx(PressResponder, Object.assign({
      "aria-label": ariaLabel
    }, menuTriggerProps, {
      ref: ref,
      isPressed: state.isOpen
    }, {
      children: triggerElem
    }), void 0), state.isOpen ? jsx(Popover, Object.assign({
      isOpen: true,
      placement: placement,
      triggerRef: ref,
      appearance: "minimal",
      onClose: state.close,
      showArrow: !hideArrow,
      autoFocus: true,
      restoreFocus: true,
      contain: true,
      type: "menu",
      isNonModal: true,
      matchTriggerWidth: matchTriggerWidth
    }, {
      children: jsx(MenuList, Object.assign({}, props, menuProps, {
        "aria-labelleddby": ariaLabel,
        closeOnPress: closeOnPress,
        onClose: state.close
      }), void 0)
    }), void 0) : null]
  }, void 0);
}

var defaultElement$6 = 'div';
var ButtonGroup = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(function (_a, ref) {
  var children = _a.children,
      className = _a.className,
      rest = __rest(_a, ["children", "className"]);

  var items = Children.toArray(children);
  return jsx(Flex, Object.assign({
    as: defaultElement$6
  }, rest, {
    justifyItems: "start",
    alignItems: "center",
    className: cn('sl-button-group', className),
    ref: ref
  }, {
    children: items.map(function (item) {
      if (! /*#__PURE__*/isValidElement(item) || ![_Button, Menu].includes(item.type)) {
        error({
          condition: true,
          message: 'Invalid element provided to ButtonGroup children.'
        });
        return null;
      }

      return item;
    })
  }), void 0);
}));

function CopyButton(_a, ref) {
  var copyValue = _a.copyValue,
      props = __rest(_a, ["copyValue"]);

  var _useClipboard = useClipboard(copyValue),
      hasCopied = _useClipboard.hasCopied,
      onCopy = _useClipboard.onCopy;

  return jsx(_Button, Object.assign({
    appearance: "minimal",
    size: "sm",
    onPress: onCopy,
    icon: hasCopied ? undefined : 'copy',
    label: "Copy"
  }, props, {
    ref: ref
  }, {
    children: hasCopied ? 'Copied' : null
  }), void 0);
}

var _CopyButton = /*#__PURE__*/forwardRef(CopyButton);

function FieldButton(_a, ref) {
  var children = _a.children,
      placeholder = _a.placeholder,
      onClear = _a.onClear,
      props = __rest(_a, ["children", "placeholder", "onClear"]);

  var showClearButton = !!(onClear && children);
  return jsxs(Box, Object.assign({
    pos: "relative"
  }, {
    children: [jsxs(_Button, Object.assign({
      w: "full",
      iconRight: jsx(Box, Object.assign({
        pt: 0.5,
        pr: 0.5
      }, {
        children: jsx(Icon, {
          icon: "chevron-down",
          size: "xs"
        }, void 0)
      }), void 0)
    }, props, {
      appearance: "select",
      ref: ref
    }, {
      children: [jsx(Box, Object.assign({
        pr: 1,
        color: !children ? 'light' : undefined
      }, {
        children: children || placeholder || ''
      }), void 0), showClearButton && jsx("div", {
        style: {
          width: props.size === 'sm' ? 24 : 28
        }
      }, void 0)]
    }), void 0), showClearButton && jsx(FieldButtonClear, {
      triggerRef: ref,
      onClear: onClear,
      size: props.size
    }, void 0)]
  }), void 0);
}

var _FieldButton = /*#__PURE__*/forwardRef(FieldButton);

var FieldButtonClear = function FieldButtonClear(_ref12) {
  var triggerRef = _ref12.triggerRef,
      size = _ref12.size,
      onClear = _ref12.onClear;

  var _usePress = usePress({
    onPress: function onPress() {
      var _a;

      onClear(); // move focus back to the field button

      // move focus back to the field button
      (_a = triggerRef === null || triggerRef === void 0 ? void 0 : triggerRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }
  }),
      pressProps = _usePress.pressProps;

  return jsx(FocusRing, Object.assign({
    focusRingClass: "sl-focus-ring"
  }, {
    children: jsx(Flex, Object.assign({
      as: "button"
    }, pressProps, {
      borderR: true,
      borderColor: "input",
      fontSize: "base",
      px: size === 'sm' ? 1.5 : 2,
      alignItems: "center",
      color: {
        hover: 'danger',
        focus: 'danger'
      },
      pos: "absolute",
      cursor: "pointer",
      style: {
        top: '50%',
        right: size === 'sm' ? 20 : 24,
        height: 13,
        marginTop: -6,
        lineHeight: 0
      },
      "aria-label": "Clear selected value"
    }, {
      children: jsx(Icon, {
        icon: "times",
        size: "xs"
      }, void 0)
    }), void 0)
  }), void 0);
};

var sizes$3 = {
  1: {
    as: 'h1',
    fontSize: '5xl',
    fontWeight: 'bold',
    lineHeight: 'tight'
  },
  2: {
    as: 'h2',
    fontSize: '4xl',
    fontWeight: 'bold',
    lineHeight: 'tight'
  },
  3: {
    as: 'h3',
    fontSize: '2xl',
    fontWeight: 'bold',
    lineHeight: 'snug'
  },
  4: {
    as: 'h4',
    fontSize: 'paragraph',
    fontWeight: 'bold',
    lineHeight: 'snug'
  }
};
var Heading = /*#__PURE__*/memo(function Heading(_a) {
  var size = _a.size,
      props = __rest(_a, ["size"]);

  return jsx(Box, Object.assign({
    fontFamily: "prose",
    fontWeight: "bold",
    color: "heading"
  }, sizes$3[size], props), void 0);
});
var defaultElement$7 = 'div';
var directionToFlex = {
  vertical: 'col',
  horizontal: 'row'
};
var Stack = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(function (_a, ref) {
  var _cn12;

  var className = _a.className,
      spacing = _a.spacing,
      _a$direction = _a.direction,
      direction = _a$direction === void 0 ? 'vertical' : _a$direction,
      divider = _a.divider,
      children = _a.children,
      restProps = __rest(_a, ["className", "spacing", "direction", "divider", "children"]);

  var hasDivider = !!divider;

  var _className = cn('sl-stack', (_cn12 = {}, _defineProperty(_cn12, "sl-stack--".concat(direction), spacing !== void 0), _defineProperty(_cn12, "sl-stack--".concat(spacing), spacing !== void 0), _cn12), className);

  var clones = children;

  if (children && hasDivider) {
    var childCount = Children.count(children);
    clones = Children.map(children, function (child, index) {
      var isLast = index + 1 === childCount;
      var clonedDivider = typeof divider === 'boolean' ? jsx(Box, {
        borderT: direction === 'vertical' ? true : undefined,
        borderL: direction === 'horizontal' ? true : undefined,
        alignSelf: "stretch"
      }, "d") : /*#__PURE__*/cloneElement(divider, {
        key: 'd'
      });

      var _divider = isLast ? null : clonedDivider;

      return jsx(Fragment$1, {
        children: [child, _divider]
      }, index);
    });
  }

  return jsx(Flex, Object.assign({
    as: defaultElement$7,
    ref: ref,
    className: _className,
    direction: directionToFlex[direction]
  }, restProps, {
    children: clones
  }), void 0);
}));
var HStack = /*#__PURE__*/forwardRef(function (props, ref) {
  return jsx(Stack, Object.assign({
    align: "center"
  }, props, {
    ref: ref,
    direction: "horizontal"
  }), void 0);
});
var VStack = /*#__PURE__*/forwardRef(function (props, ref) {
  return jsx(Stack, Object.assign({
    align: "stretch"
  }, props, {
    ref: ref,
    direction: "vertical"
  }), void 0);
});
var iconVariants = {
  intent: {
    default: 'info-circle',
    success: 'check-circle',
    warning: 'exclamation-circle',
    danger: 'exclamation-circle'
  }
};
var variants$2 = {
  default: {
    default: {
      border: 2,
      borderColor: 'transparent',
      rounded: 'lg',
      bg: {
        default: 'primary-tint'
      }
    },
    success: {
      bg: {
        default: 'success-tint'
      }
    },
    warning: {
      bg: {
        default: 'warning-tint'
      }
    },
    danger: {
      bg: {
        default: 'danger-tint'
      }
    }
  },
  outline: {
    default: {
      border: 2,
      rounded: 'xl',
      borderColor: 'primary'
    },
    success: {
      borderColor: 'success'
    },
    warning: {
      borderColor: 'warning'
    },
    danger: {
      borderColor: 'danger'
    }
  }
};
var Callout = /*#__PURE__*/memo(function Callout(_a) {
  var _a$intent2 = _a.intent,
      intent = _a$intent2 === void 0 ? 'default' : _a$intent2,
      _a$appearance3 = _a.appearance,
      appearance = _a$appearance3 === void 0 ? 'default' : _a$appearance3,
      heading = _a.heading,
      className = _a.className,
      icon = _a.icon,
      children = _a.children,
      props = __rest(_a, ["intent", "appearance", "heading", "className", "icon", "children"]);

  var color = intent === 'default' || intent === 'info' ? 'primary' : intent;

  var _useTheme = useTheme("colors.".concat(color)),
      value = _useTheme.themeValue;

  var stateProps = Object.assign(Object.assign({}, variants$2[appearance].default), variants$2[appearance][intent]);
  return jsx(Box, Object.assign({
    className: cn('sl-callout', className),
    rounded: "xl",
    w: "full",
    pb: appearance === 'default' ? undefined : 1,
    bg: appearance === 'default' ? undefined : stateProps.borderColor,
    role: "alert"
  }, props, {
    children: jsxs(HStack, Object.assign({
      spacing: 3,
      pl: 4,
      pr: 10,
      py: 4,
      alignItems: "start",
      rounded: "xl",
      bg: appearance === 'default' ? undefined : 'canvas-pure'
    }, stateProps, {
      children: [icon !== null ? jsx(Box, Object.assign({
        mt: "px"
      }, {
        children: jsx(HeadingIcon, {
          icon: icon,
          intent: intent,
          intentColorValue: value
        }, void 0)
      }), void 0) : null, jsxs(VStack, {
        children: [heading ? jsx(Heading, Object.assign({
          size: 4,
          mb: 1.5
        }, {
          children: heading
        }), void 0) : null, children]
      }, void 0)]
    }), void 0)
  }), void 0);
});

var HeadingIcon = function HeadingIcon(_ref13) {
  var icon = _ref13.icon,
      intent = _ref13.intent,
      intentColorValue = _ref13.intentColorValue;
  var elem = null;

  if (intent && !icon) {
    var intentIcon = iconVariants.intent[intent];

    if (intentIcon) {
      elem = jsx(Icon, {
        icon: intentIcon,
        style: {
          color: intentColorValue
        },
        size: "lg"
      }, void 0);
    }
  } else if (icon && isIconProp(icon)) {
    elem = jsx(Icon, {
      icon: icon,
      style: {
        color: intentColorValue
      },
      size: "lg"
    }, void 0);
  }

  return elem ? jsx(Box, Object.assign({
    "data-testid": "icon"
  }, {
    children: elem
  }), void 0) : null;
};

var Card = function Card(props) {
  return jsx("div", Object.assign({}, props), void 0);
};

function Code(_a) {
  var className = _a.className,
      props = __rest(_a, ["className"]);

  return jsx(Box, Object.assign({
    as: "code",
    className: cn(className),
    fontWeight: "medium",
    fontFamily: "mono",
    bg: "code",
    color: "on-code",
    border: true,
    py: 0.5,
    px: 1,
    mx: 0.5,
    rounded: true,
    style: {
      fontSize: '0.8125em'
    }
  }, props), void 0);
}

var Divider$1 = function Divider$1(props) {
  return jsx("div", Object.assign({}, props), void 0);
};

var sizes$4 = {
  lg: {
    avatarSize: 'md',
    fontSize: 'lg'
  },
  md: {
    avatarSize: 'sm'
  }
};
var EntityName = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(function EntityName(props, ref) {
  var className = props.className,
      name = props.name,
      isHeading = props.isHeading,
      _props$size2 = props.size,
      size = _props$size2 === void 0 ? 'md' : _props$size2,
      avatar = props.avatar,
      rest = __rest(props, ["className", "name", "isHeading", "size", "avatar"]);

  var leftElem;

  if (isIconEntityName(props)) {
    leftElem = jsx(Box, Object.assign({
      mx: "auto"
    }, {
      children: jsx(Icon, {
        icon: props.icon
      }, void 0)
    }), void 0);
  } else if (isAvatarEntityName(props)) {
    leftElem = jsx(Avatar, Object.assign({
      size: sizes$4[size].avatarSize,
      mx: "auto"
    }, avatar), void 0);
  }

  return jsxs(Flex, Object.assign({}, rest, {
    ref: ref,
    align: "center",
    className: cn('sl-entity-name', className)
  }, {
    children: [leftElem ? jsx(Box, Object.assign({
      w: 12,
      ml: -3
    }, {
      children: leftElem
    }), void 0) : null, jsx(Text, Object.assign({
      fontWeight: isHeading ? 'semibold' : 'normal',
      size: sizes$4[size].fontSize
    }, {
      children: name
    }), void 0)]
  }), void 0);
}));

function isIconEntityName(props) {
  return props.icon !== undefined;
}

function isAvatarEntityName(props) {
  return props.avatar !== undefined;
}

var Grid = function Grid(props) {
  return jsx("div", Object.assign({}, props), void 0);
};

var defaultElement$8 = 'img';

function Image(_a) {
  var className = _a.className,
      invertOnDark = _a.invertOnDark,
      props = __rest(_a, ["className", "invertOnDark"]);

  var _useMosaicContext3 = useMosaicContext(),
      ImageOverride = _useMosaicContext3.componentOverrides.Image;

  var isDark = useThemeIsDark();
  return jsx(Box, Object.assign({
    as: ImageOverride || defaultElement$8,
    className: cn('sl-image', className, {
      'sl-image--inverted': invertOnDark && isDark
    })
  }, props), void 0);
}

var modalSizeVariants = {
  sm: {
    width: '100%',
    maxWidth: 400
  },
  md: {
    width: '100%',
    maxWidth: 600
  },
  lg: {
    width: '100%',
    maxWidth: 900
  },
  full: {
    width: '100%',
    maxWidth: '90%'
  },
  grow: {
    maxWidth: '90%'
  }
};

var useModalState = function useModalState() {
  var state = useOverlayTriggerState({});
  return {
    isOpen: state.isOpen,
    open: state.open,
    close: state.close
  };
};

var Modal = function Modal(props) {
  var children = props.children,
      footer = props.footer,
      isOpen = props.isOpen,
      onClose = props.onClose,
      isDraggable = props.isDraggable,
      isNotDismissable = props.isNotDismissable,
      rest = __rest(props, ["children", "footer", "isOpen", "onClose", "isDraggable", "isNotDismissable"]);

  return jsx(_Overlay, Object.assign({
    isOpen: isOpen
  }, {
    children: jsx(ModalWrapper, Object.assign({}, rest, {
      footer: footer,
      isOpen: isOpen,
      onClose: onClose,
      isDraggable: isDraggable,
      isNotDismissable: isNotDismissable
    }, {
      children: children
    }), void 0)
  }), void 0);
};

var ModalWrapper = function ModalWrapper(_a) {
  var children = _a.children,
      footer = _a.footer,
      isOpen = _a.isOpen,
      onClose = _a.onClose,
      isDraggable = _a.isDraggable,
      isNotDismissable = _a.isNotDismissable,
      props = __rest(_a, ["children", "footer", "isOpen", "onClose", "isDraggable", "isNotDismissable"]);

  var ref = useRef(); // Handle interacting outside the dialog and pressing
  // the Escape key to close the modal.

  var _useOverlay2 = useOverlay({
    onClose: onClose,
    isOpen: isOpen,
    isDismissable: !isDraggable && !isNotDismissable
  }, ref),
      overlayProps = _useOverlay2.overlayProps; // Hide content outside the modal from screen readers.


  var _useModal2 = useModal(),
      modalProps = _useModal2.modalProps; // Get props for the dialog


  var _useDialog = useDialog({}, ref),
      dialogProps = _useDialog.dialogProps,
      titleProps = _useDialog.titleProps; // TODO: having to pull out color for the typings is so annoying...


  var _b = mergeProps(overlayProps, modalProps),
      containerProps = __rest(_b, ["color"]);

  var dialogPropsWithoutColor = __rest(dialogProps, ["color"]);

  var dialogTitlePropsWithoutColor = __rest(titleProps, ["color"]);

  if (isDraggable) {
    return jsx(DraggableModalBox, Object.assign({}, props, {
      ref: ref,
      onClose: onClose,
      containerProps: containerProps,
      dialogProps: dialogPropsWithoutColor,
      titleProps: dialogTitlePropsWithoutColor,
      footer: footer,
      isNotDismissable: isNotDismissable
    }, {
      children: children
    }), void 0);
  }

  return jsx(StaticModalBox, Object.assign({}, props, {
    ref: ref,
    onClose: onClose,
    containerProps: containerProps,
    dialogProps: dialogPropsWithoutColor,
    titleProps: dialogTitlePropsWithoutColor,
    footer: footer,
    isNotDismissable: isNotDismissable
  }, {
    children: children
  }), void 0);
};

var ModalBox = /*#__PURE__*/forwardRef(function (_a, ref) {
  var isDraggable = _a.isDraggable,
      _a$moveProps = _a.moveProps,
      moveProps = _a$moveProps === void 0 ? {} : _a$moveProps,
      containerProps = _a.containerProps,
      dialogProps = _a.dialogProps,
      titleProps = _a.titleProps,
      onClose = _a.onClose,
      children = _a.children,
      footer = _a.footer,
      position = _a.position,
      isHidden = _a.isHidden,
      isNotDismissable = _a.isNotDismissable,
      _a$size5 = _a.size,
      size = _a$size5 === void 0 ? 'md' : _a$size5,
      props = __rest(_a, ["isDraggable", "moveProps", "containerProps", "dialogProps", "titleProps", "onClose", "children", "footer", "position", "isHidden", "isNotDismissable", "size"]);

  var isDark = useThemeIsDark();
  var style = Object.assign({}, modalSizeVariants[size] || {});

  if (position) {
    style.position = 'fixed';
    style.top = position.y;
    style.left = position.x;
  }

  var headerElem;

  if ('renderHeader' in props) {
    headerElem = props.renderHeader({
      containerProps: moveProps,
      titleProps: titleProps,
      onClose: onClose
    });
  } else if (props.title) {
    headerElem = jsxs(Flex, Object.assign({}, moveProps, {
      borderB: true,
      borderColor: isDark ? 'input' : undefined,
      alignItems: "center",
      pl: 5,
      pr: 3,
      cursor: !!position ? 'move' : undefined,
      h: "3xl"
    }, {
      children: [typeof props.title === 'string' ? jsx(Heading, Object.assign({
        size: 3,
        fontSize: "xl",
        flex: 1,
        fontWeight: "medium"
      }, titleProps, {
        children: props.title
      }), void 0) : jsx(Box, Object.assign({}, titleProps, {
        flex: 1,
        as: "header"
      }, {
        children: props.title
      }), void 0), !isNotDismissable && jsx(_Button, {
        appearance: "minimal",
        icon: jsx(Icon, {
          icon: "times",
          size: "2x"
        }, void 0),
        onPress: onClose,
        "aria-label": "dismiss"
      }, void 0)]
    }), void 0);
  }

  var footerElem;

  if (footer) {
    footerElem = jsx(Box, Object.assign({
      borderT: true,
      borderColor: isDark ? 'input' : undefined,
      alignItems: "center",
      pl: 5,
      pr: 3,
      py: 3
    }, {
      children: footer
    }), void 0);
  }

  return jsx(Box, Object.assign({}, containerProps, {
    bg: "canvas-dialog",
    boxShadow: "lg",
    rounded: "lg",
    pos: "relative",
    zIndex: 20,
    style: style,
    visibility: isHidden ? 'invisible' : undefined
  }, {
    children: jsx(FocusScope, Object.assign({
      restoreFocus: !isDraggable,
      contain: !isDraggable
    }, {
      children: jsxs(Box, Object.assign({}, dialogProps, {
        ref: ref,
        "aria-describedby": "".concat(dialogProps['aria-labelledby'], "-body"),
        "aria-modal": "true",
        "data-testid": "modal"
      }, {
        children: [headerElem, jsx(ModalContent, Object.assign({
          id: "".concat(dialogProps['aria-labelledby'], "-body"),
          p: headerElem || footerElem ? 5 : undefined
        }, {
          children: children
        }), void 0), footerElem]
      }), void 0)
    }), void 0)
  }), void 0);
});
/**
 * Memo modal content so that it does not re-render constantly in draggable modals
 */

var ModalContent = /*#__PURE__*/memo(function (_ref14) {
  var children = _ref14.children,
      id = _ref14.id,
      p = _ref14.p;
  return jsx(Box, Object.assign({
    p: p,
    id: id
  }, {
    children: children
  }), void 0);
});
var StaticModalBox = /*#__PURE__*/forwardRef(function (props, ref) {
  // Prevent scrolling while the modal is open
  usePreventScroll();
  return jsxs(Flex, Object.assign({
    pos: "fixed",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 40,
    pin: true,
    overflowY: "auto"
  }, {
    children: [jsx(Underlay, {}, void 0), jsx(ModalBox, Object.assign({}, props, {
      ref: ref
    }), void 0)]
  }), void 0);
});
var DraggableModalBox = /*#__PURE__*/forwardRef(function (props, ref) {
  var _useState11 = useState({
    x: 0,
    y: 0
  }),
      _useState12 = _slicedToArray(_useState11, 2),
      position = _useState12[0],
      setPosition = _useState12[1]; // get the width of the button trigger so that we can set the menu min width


  var _useSize3 = useSize(ref),
      _useSize4 = _slicedToArray(_useSize3, 2),
      modalWidth = _useSize4[0],
      modalHeight = _useSize4[1];

  var _useWindowSize = useWindowSize(),
      _useWindowSize2 = _slicedToArray(_useWindowSize, 2),
      windowWidth = _useWindowSize2[0],
      windowHeight = _useWindowSize2[1];

  useEffect(function () {
    if (modalWidth && windowWidth) {
      var y = windowHeight / 2 - modalHeight / 2;
      setPosition({
        x: windowWidth / 2 - modalWidth / 2,
        y: y - y * 0.7
      });
    }
  }, [modalWidth, windowWidth, setPosition, windowHeight, modalHeight]);

  var clamp = function clamp(pos, containerSize, componentSize) {
    return Math.min(Math.max(pos, 0), containerSize - componentSize);
  };

  var _useMove = useMove({
    onMove: function onMove(e) {
      setPosition(function (_ref15) {
        var x = _ref15.x,
            y = _ref15.y;

        // Normally, we want to allow the user to continue
        // dragging outside the box such that they need to
        // drag back over the ball again before it moves.
        // This is handled below by clamping during render.
        // If using the keyboard, however, we need to clamp
        // here so that dragging outside the container and
        // then using the arrow keys works as expected.
        if (e.pointerType === 'keyboard') {
          // eslint-disable-next-line no-param-reassign
          x = clamp(x, windowWidth, modalWidth); // eslint-disable-next-line no-param-reassign

          // eslint-disable-next-line no-param-reassign
          y = clamp(y, windowHeight, modalHeight);
        } // eslint-disable-next-line no-param-reassign


        // eslint-disable-next-line no-param-reassign
        x += e.deltaX; // eslint-disable-next-line no-param-reassign

        // eslint-disable-next-line no-param-reassign
        y += e.deltaY;
        return {
          x: clamp(x, windowWidth + modalWidth * 0.5, modalWidth),
          y: clamp(y, windowHeight + 50, modalHeight)
        };
      });
    }
  }),
      moveProps = _useMove.moveProps;

  return jsx(ModalBox, Object.assign({}, props, {
    moveProps: moveProps,
    position: position,
    ref: ref,
    isHidden: !modalWidth
  }), void 0);
});

var Underlay = function Underlay() {
  return jsx(Box, {
    pos: "fixed",
    zIndex: 10,
    pin: true,
    style: {
      backgroundColor: 'rgba(0, 0 , 0, .3)'
    }
  }, void 0);
};

function ProductImage(_a) {
  var _b, _c, _d, _e;

  var className = _a.className,
      children = _a.children,
      focus = _a.focus,
      caption = _a.caption,
      _a$bg = _a.bg,
      bg = _a$bg === void 0 ? 'success' : _a$bg,
      props = __rest(_a, ["className", "children", "focus", "caption", "bg"]);

  var _useModalState = useModalState(),
      isOpen = _useModalState.isOpen,
      open = _useModalState.open,
      close = _useModalState.close; // enforce single child


  var child = Children.only(children);
  var focusContainerProps = ((_b = FocusVariants[focus]) === null || _b === void 0 ? void 0 : _b.container) || {};
  var focusAspectProps = ((_c = FocusVariants[focus]) === null || _c === void 0 ? void 0 : _c.aspect) || {};
  var focusImageProps = ((_d = FocusVariants[focus]) === null || _d === void 0 ? void 0 : _d.image) || {};
  var focusCaptionProps = ((_e = FocusVariants[focus]) === null || _e === void 0 ? void 0 : _e.caption) || {};
  var imageElem = /*#__PURE__*/cloneElement(child, Object.assign(Object.assign({
    bg: 'canvas-pure',
    borderColor: 'body',
    overflowX: 'hidden',
    overflowY: 'hidden',
    mx: 'auto'
  }, focusImageProps), {
    style: Object.assign(focusImageProps.style || {}, child.props.style || {})
  }));
  var elem = imageElem;

  if (focusAspectProps.ratio) {
    elem = jsx(AspectRatio, Object.assign({
      mx: "auto",
      ratio: 1
    }, focusAspectProps, {
      children: imageElem
    }), void 0);
  }

  var resolvedCaption = caption || child.props.title;
  var captionElem;

  if (resolvedCaption) {
    if (focus) {
      captionElem = jsx(Box, Object.assign({
        as: "figcaption",
        display: "block",
        style: {
          color: 'white'
        },
        pb: 8,
        mt: -8,
        mx: "auto",
        px: 20,
        fontWeight: "semibold",
        fontSize: "paragraph",
        textAlign: "center"
      }, focusCaptionProps, {
        children: resolvedCaption
      }), void 0);
    } else {
      captionElem = jsx(Box, Object.assign({
        as: "figcaption"
      }, {
        children: resolvedCaption
      }), void 0);
    }
  }

  return jsxs(Fragment, {
    children: [jsx(Pressable, Object.assign({
      onPress: open
    }, {
      children: jsxs(Box, Object.assign({
        as: "figure"
      }, {
        children: [jsxs(Box, Object.assign({
          className: cn('sl-product-image', className),
          border: 2,
          borderColor: "body",
          rounded: "xl",
          bg: focus ? bg : undefined,
          overflowX: "hidden",
          overflowY: "hidden",
          transform: true,
          cursor: "zoom-in",
          transitionDuration: 300,
          translateX: {
            hover: 2
          },
          translateY: {
            hover: -2
          },
          style: {
            '--shadow-md': '-8px 8px 0 0 var(--color-text)'
          },
          boxShadow: {
            hover: true
          }
        }, props, focusContainerProps, {
          children: [focus && focus !== 'bottom' ? captionElem : null, elem, focus && focus === 'bottom' ? captionElem : null]
        }), void 0), !focus ? captionElem : null]
      }), void 0)
    }), void 0), jsx(Modal, Object.assign({
      isOpen: isOpen,
      onClose: close,
      size: "grow"
    }, {
      children: jsx(Box, Object.assign({
        as: Pressable,
        onPress: close,
        cursor: "zoom-out",
        overflowX: "hidden",
        overflowY: "hidden",
        rounded: "lg"
      }, {
        children: jsx(Box, {
          children: /*#__PURE__*/cloneElement(child, {
            style: Object.assign({
              maxHeight: 800
            }, child.props.style || {})
          })
        }, void 0)
      }), void 0)
    }), void 0)]
  }, void 0);
}

var FocusVariants = {
  center: {
    container: {
      p: 16
    },
    image: {
      border: 2,
      rounded: 'xl',
      boxShadow: 'lg',
      style: {
        maxHeight: 500
      }
    }
  },
  bottom: {
    container: {
      pb: 16
    },
    aspect: {
      ratio: 16 / 9,
      mx: 16
    },
    image: {
      borderB: 2,
      borderL: 2,
      borderR: 2,
      rounded: 'b-lg',
      objectFit: 'scale-down',
      objectPosition: 'bottom'
    },
    caption: {
      pb: 0,
      mt: 0,
      pt: 8,
      mb: -8
    }
  },
  top: {
    container: {
      pt: 16
    },
    aspect: {
      ratio: 16 / 9,
      mx: 16
    },
    image: {
      borderT: 2,
      borderL: 2,
      borderR: 2,
      rounded: 't-lg',
      objectFit: 'scale-down',
      objectPosition: 'top'
    }
  },
  'top-right': {
    container: {
      pt: 16
    },
    aspect: {
      ratio: 16 / 9,
      mr: 16
    },
    image: {
      borderT: 2,
      borderR: 2,
      rounded: 'tr-lg',
      objectFit: 'scale-down',
      objectPosition: 'left-top'
    }
  },
  'top-left': {
    container: {
      pt: 16
    },
    aspect: {
      ratio: 16 / 9,
      ml: 16
    },
    image: {
      borderT: 2,
      borderL: 2,
      rounded: 'tl-lg',
      objectFit: 'scale-down',
      objectPosition: 'right-top'
    }
  }
};
var variants$3 = {
  default: {
    default: {
      borderColor: {
        default: 'input',
        // TODO: when have more sophisticated theme val system, slightly darker color on hover as in ui designs
        // hover: 'input',
        focus: 'primary'
      }
    },
    success: {
      borderColor: {
        default: 'success',
        focus: 'success-dark'
      }
    },
    warning: {
      borderColor: {
        default: 'warning',
        focus: 'warning-dark'
      }
    },
    danger: {
      borderColor: {
        default: 'danger',
        focus: 'danger-dark'
      }
    }
  },
  minimal: {
    default: {
      borderColor: {
        default: 'transparent',
        hover: 'input',
        focus: 'primary'
      }
    },
    success: {
      borderColor: {
        default: 'transparent',
        hover: 'success',
        focus: 'success-dark'
      }
    },
    warning: {
      borderColor: {
        default: 'transparent',
        hover: 'warning',
        focus: 'warning-dark'
      }
    },
    danger: {
      borderColor: {
        default: 'transparent',
        hover: 'danger',
        focus: 'danger-dark'
      }
    }
  }
};
var sizes$5 = {
  lg: {
    px: 3
  },
  md: {
    px: 2.5
  },
  sm: {
    px: 1.5
  }
};
var fontSizes = {
  lg: 'lg',
  md: 'base',
  sm: 'base'
};
var Input = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(function Input(_a, ref) {
  var _a$appearance4 = _a.appearance,
      appearance = _a$appearance4 === void 0 ? 'default' : _a$appearance4,
      _a$intent3 = _a.intent,
      intent = _a$intent3 === void 0 ? 'default' : _a$intent3,
      _a$size6 = _a.size,
      size = _a$size6 === void 0 ? 'md' : _a$size6,
      readOnly = _a.readOnly,
      disabled = _a.disabled,
      className = _a.className,
      icon = _a.icon,
      required = _a.required,
      value = _a.value,
      defaultValue = _a.defaultValue,
      onChange = _a.onChange,
      props = __rest(_a, ["appearance", "intent", "size", "readOnly", "disabled", "className", "icon", "required", "value", "defaultValue", "onChange"]);

  var _splitBoxProps3 = splitBoxProps(props),
      matchedProps = _splitBoxProps3.matchedProps,
      remainingProps = _splitBoxProps3.remainingProps;

  var fallbackRef = useRef();
  var inputRef = ref || fallbackRef;

  var _b = useTextField(Object.assign(Object.assign({}, remainingProps), {
    value: typeof value !== 'undefined' ? String(value) : value,
    defaultValue: typeof defaultValue !== 'undefined' ? String(defaultValue) : defaultValue,
    onInput: onChange,
    isDisabled: disabled,
    isReadOnly: readOnly,
    isRequired: required
  }), inputRef).inputProps,
      inputProps = __rest(_b, ["color"]);

  var stateProps = Object.assign(Object.assign(Object.assign(Object.assign({}, variants$3.default.default), variants$3.default[intent]), variants$3[appearance].default), variants$3[appearance][intent]);
  var disabledProps = {};

  if (disabled) {
    disabledProps = {
      bg: 'canvas-100',
      color: 'muted',
      cursor: 'not-allowed'
    };
  }

  var readOnlyProps = {};

  if (readOnly) {
    readOnlyProps.tabIndex = -1;

    if (appearance === 'minimal') {
      readOnlyProps.borderColor = 'transparent';
    }
  }

  return jsxs(Box, Object.assign({
    className: cn('sl-input', className),
    pos: "relative"
  }, matchedProps, {
    children: [icon ? jsx(InputIcon, {
      icon: icon
    }, void 0) : null, jsx(Box, Object.assign({
      as: "input",
      ref: inputRef,
      pl: icon ? 8 : sizes$5[size].px,
      pr: sizes$5[size].px,
      fontSize: fontSizes[size],
      rounded: true,
      h: size,
      border: true,
      w: "full",
      disabled: disabled,
      readOnly: readOnly,
      pos: "relative",
      zIndex: 10
    }, remainingProps, stateProps, readOnlyProps, disabledProps, inputProps), void 0)]
  }), void 0);
}));

var InputIcon = function InputIcon(_ref16) {
  var icon = _ref16.icon;
  var elem = icon;

  if (isIconProp(icon)) {
    elem = jsx(Icon, {
      icon: icon,
      size: "sm",
      fixedWidth: true
    }, void 0);
  }

  return jsx(Flex, Object.assign({
    pos: "absolute",
    align: "center",
    className: "sl-z-0",
    style: {
      top: 0,
      bottom: 0,
      left: 0,
      lineHeight: 0
    },
    pl: 2
  }, {
    children: elem
  }), void 0);
};

var LinkHeading = /*#__PURE__*/memo(function LinkHeading(_a) {
  var id = _a.id,
      children = _a.children,
      className = _a.className,
      props = __rest(_a, ["id", "children", "className"]);

  var _className = cn('sl-link-heading', className); // Just in case browser doesn't scroll correctly - handle it


  useEffect(function () {
    if (document.location.hash === "#".concat(id)) {
      var timer = setTimeout(function () {
        document.querySelector("#".concat(id)).scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }, 300);
      return function () {
        return clearTimeout(timer);
      };
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);
  return jsx(Box, Object.assign({
    as: Heading,
    className: _className,
    id: id
  }, props, {
    children: jsx(FocusRing, Object.assign({
      focusRingClass: "sl-focus-ring",
      focusClass: "sl-focus-ring"
    }, {
      children: jsxs(Link, Object.assign({
        href: "#".concat(id),
        className: "sl-link-heading__link",
        display: "inline-flex",
        alignItems: "center",
        color: "current"
      }, {
        children: [jsx(Box, {
          children: children
        }, void 0), jsx(Box, Object.assign({
          className: "sl-link-heading__icon",
          ml: 4,
          fontSize: "base",
          color: "muted"
        }, {
          children: jsx(Icon, {
            icon: "link"
          }, void 0)
        }), void 0)]
      }), void 0)
    }), void 0)
  }), void 0);
});

function ListBoxBase(props, forwardRef) {
  var _splitBoxProps4 = splitBoxProps(props),
      matchedProps = _splitBoxProps4.matchedProps,
      remainingProps = _splitBoxProps4.remainingProps;

  var domRef = useRef();
  var ref = forwardRef || domRef;
  var state = useListState(props);

  var _useListBox = useListBox(remainingProps, state, ref),
      listBoxProps = _useListBox.listBoxProps;

  return jsx(Box, Object.assign({}, listBoxProps, matchedProps, {
    color: matchedProps.color,
    ref: ref
  }, {
    children: _toConsumableArray(state.collection).map(function (item) {
      return jsx(ListBoxOption, {
        item: item,
        state: state
      }, item.key);
    })
  }), void 0);
} // forwardRef doesn't support generic parameters, so cast the result to the correct type
// https://stackoverflow.com/questions/58469229/react-with-typescript-generics-while-using-react-forwardref


var ListBox = /*#__PURE__*/forwardRef(ListBoxBase);

function ListBoxOption(_ref17) {
  var item = _ref17.item,
      state = _ref17.state;
  var rendered = item.rendered,
      key = item.key;
  var isDisabled = state.disabledKeys.has(key);
  var ref = useRef();

  var _useOption = useOption({
    key: key,
    isDisabled: isDisabled
  }, state, ref),
      optionProps = _useOption.optionProps;

  var _useFocusRing = useFocusRing(),
      isFocusVisible = _useFocusRing.isFocusVisible,
      focusProps = _useFocusRing.focusProps;

  return jsx(Box, Object.assign({}, mergeProps(optionProps, focusProps), {
    bg: {
      default: isFocusVisible ? 'canvas-200' : 'transparent',
      hover: 'canvas-200'
    },
    color: "body",
    cursor: "pointer",
    ref: ref
  }, {
    children: rendered
  }), void 0);
}

var ListBoxItem = Item$1;

var PanelContent = function PanelContent(_a) {
  var children = _a.children,
      props = __rest(_a, ["children"]);

  return jsx(Box, Object.assign({
    p: 4,
    className: "sl-panel__content"
  }, props, {
    children: children
  }), void 0);
};

var titlebarVariants = {
  default: {
    bg: 'canvas-200',
    borderColor: {
      default: 'input',
      focus: 'primary'
    },
    color: 'muted'
  },
  minimal: {
    pos: 'relative',
    fontWeight: 'medium'
  }
};
var iconVariants$1 = {
  default: {
    mr: 1.5
  },
  minimal: {
    pos: 'absolute',
    left: -4,
    color: 'muted',
    fontWeight: 'normal'
  }
};
var PanelTitlebar = /*#__PURE__*/memo(function (_a) {
  var children = _a.children,
      icon = _a.icon,
      _a$appearance5 = _a.appearance,
      appearance = _a$appearance5 === void 0 ? 'default' : _a$appearance5,
      rightComponent = _a.rightComponent,
      onClick = _a.onClick,
      bg = _a.bg,
      tabIndex = _a.tabIndex,
      props = __rest(_a, ["children", "icon", "appearance", "rightComponent", "onClick", "bg", "tabIndex"]);

  return jsx(FocusRing, Object.assign({
    focusRingClass: "sl-focus-ring"
  }, {
    children: jsxs(Flex, Object.assign({
      className: "sl-panel__titlebar",
      pos: "relative",
      zIndex: {
        focus: 10
      },
      align: "center",
      fontSize: "base",
      userSelect: "none",
      pl: appearance === 'default' ? icon ? 3 : 4 : undefined,
      pr: appearance === 'default' ? rightComponent ? 3 : 4 : undefined
    }, titlebarVariants[appearance], {
      bg: bg || titlebarVariants[appearance].bg
    }, props, {
      tabIndex: tabIndex
    }, {
      children: [jsxs(Flex, Object.assign({
        flex: 1,
        align: "center",
        h: "lg",
        onClick: onClick
      }, {
        children: [icon && jsx(Box, Object.assign({}, iconVariants$1[appearance], {
          children: icon
        }), void 0), children]
      }), void 0), rightComponent]
    }), void 0)
  }), void 0);
});

var Panel = function Panel(_a) {
  var _a$appearance6 = _a.appearance,
      appearance = _a$appearance6 === void 0 ? 'default' : _a$appearance6,
      id = _a.id,
      className = _a.className,
      children = _a.children,
      _a$isCollapsible = _a.isCollapsible,
      isCollapsible = _a$isCollapsible === void 0 ? true : _a$isCollapsible,
      isOpenProp = _a.isOpen,
      _a$defaultIsOpen = _a.defaultIsOpen,
      defaultIsOpen = _a$defaultIsOpen === void 0 ? false : _a$defaultIsOpen,
      onChange = _a.onChange,
      rounded = _a.rounded,
      extraProps = __rest(_a, ["appearance", "id", "className", "children", "isCollapsible", "isOpen", "defaultIsOpen", "onChange", "rounded"]);

  var _useControllableState = useControllableState({
    value: isOpenProp,
    defaultValue: defaultIsOpen,
    onChange: onChange,
    propsMap: {
      value: 'isOpen',
      defaultValue: 'defaultIsOpen',
      onChange: 'onChange'
    }
  }),
      _useControllableState2 = _slicedToArray(_useControllableState, 2),
      isOpen = _useControllableState2[0],
      setIsOpen = _useControllableState2[1];

  var isMinimal = appearance === 'minimal';
  var isPanelOpen = !isCollapsible || isCollapsible && isOpen;
  var handleChange = useCallback(function () {
    if (!isCollapsible) return;
    setIsOpen(!isOpen);
  }, [isCollapsible, isOpen, setIsOpen]);
  var handleKeyDown = useCallback(function (e) {
    if (!isCollapsible) return;

    if (e.keyCode === Key.Space || e.keyCode === Key.Enter) {
      e.preventDefault();
      handleChange();
    }
  }, [handleChange, isCollapsible]);

  var _Children$toArray = Children.toArray(children),
      _Children$toArray2 = _toArray(_Children$toArray),
      titlebarElement = _Children$toArray2[0],
      contentElements = _Children$toArray2.slice(1);

  if (! /*#__PURE__*/isValidElement(titlebarElement) || /*#__PURE__*/isValidElement(titlebarElement) && titlebarElement.type !== PanelTitlebar) {
    throw new Error('Panel.Titlebar must be the first child in a Panel');
  }

  var icon;

  if (isCollapsible) {
    if (isMinimal) {
      icon = isPanelOpen ? 'chevron-down' : 'chevron-right';
    } else {
      icon = ['fas', isPanelOpen ? 'caret-down' : 'caret-right'];
    }
  }

  var titlebarComponent = /*#__PURE__*/cloneElement(titlebarElement, {
    icon: icon ? jsx(Icon, {
      icon: icon,
      fixedWidth: true,
      size: isMinimal ? 'xs' : undefined
    }, void 0) : undefined,
    role: isCollapsible ? 'button' : undefined,
    'aria-expanded': isCollapsible ? isPanelOpen : undefined,
    'aria-controls': isCollapsible ? id : undefined,
    cursor: isCollapsible ? 'pointer' : undefined,
    tabIndex: isCollapsible ? 0 : undefined,
    appearance: appearance,
    onClick: handleChange,
    onKeyDown: handleKeyDown
  });
  return jsxs(Box, Object.assign({
    w: "full",
    className: cn('sl-panel', 'sl-outline-none', className),
    overflowX: !isMinimal && rounded ? 'hidden' : undefined,
    overflowY: !isMinimal && rounded ? 'hidden' : undefined,
    rounded: rounded ? 'lg' : undefined
  }, extraProps, {
    children: [titlebarComponent, isPanelOpen ? jsx(Box, Object.assign({
      className: "sl-panel__content-wrapper",
      bg: isMinimal ? undefined : 'canvas-100',
      id: isCollapsible ? id : undefined,
      role: isCollapsible ? 'region' : undefined
    }, {
      children: contentElements
    }), void 0) : null]
  }), void 0);
};

Panel.Titlebar = PanelTitlebar;
Panel.Content = PanelContent;
var defaultElement$9 = 'p';
var sizes$6 = {
  leading: {
    fontSize: 'paragraph-leading',
    lineHeight: 'paragraph-leading'
  },
  default: {
    fontSize: 'paragraph',
    lineHeight: 'paragraph'
  },
  small: {
    fontSize: 'paragraph-small',
    lineHeight: 'paragraph-small'
  },
  tiny: {
    fontSize: 'paragraph-tiny',
    lineHeight: 'paragraph-tiny'
  }
};
var Paragraph = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(function (_a, ref) {
  var _a$size7 = _a.size,
      size = _a$size7 === void 0 ? 'default' : _a$size7,
      restProps = __rest(_a, ["size"]);
  /**
   * Explicitely do not allow end user to override font and color... Paragraph should only be used for prose, not UI.
   */


  return jsx(Box, Object.assign({
    as: defaultElement$9,
    ref: ref
  }, sizes$6[size], restProps, {
    fontFamily: "prose",
    color: "paragraph"
  }), void 0);
}));
var Prose = /*#__PURE__*/memo(function Prose(_a) {
  var className = _a.className,
      props = __rest(_a, ["className"]);

  return jsx(Box, Object.assign({
    className: cn('sl-prose', className)
  }, props), void 0);
});

function MosaicProvider(props) {
  return jsx(SSRProvider, {
    children: jsx(MosaicInnerProvider, Object.assign({}, props), void 0)
  }, void 0);
}

function MosaicInnerProvider(_a) {
  var children = _a.children,
      className = _a.className,
      style = _a.style,
      mosaicContext = __rest(_a, ["children", "className", "style"]);

  var providerId = "mosaic-provider-".concat(useId());
  var providerRef = useRef();
  return jsx("div", Object.assign({
    className: cn(className),
    style: style,
    id: providerId,
    ref: providerRef
  }, {
    children: jsx(OverlayProvider, Object.assign({
      className: cn(className),
      style: style
    }, {
      children: jsx(MosaicContext.Provider, Object.assign({
        value: Object.assign({}, defaultMosaicContext, mosaicContext, {
          providerId: providerId,
          providerRef: providerRef
        })
      }, {
        children: children
      }), void 0)
    }), void 0)
  }), void 0);
}

var RadioContext = /*#__PURE__*/createContext(undefined);

function useRadioContext() {
  return useContext(RadioContext);
}

var variants$4 = {
  default: {
    stroke: 'var(--color-text)',
    active: {
      stoke: 'var(--color-primary)'
    }
  },
  success: {
    stroke: 'var(--color-success)',
    color: 'success-dark',
    active: {
      stoke: 'var(--color-success)'
    }
  },
  warning: {
    stroke: 'var(--color-warning)',
    color: 'warning-dark',
    active: {
      stoke: 'var(--color-warning)'
    }
  },
  danger: {
    stroke: 'var(--color-danger)',
    color: 'danger-dark',
    active: {
      stoke: 'var(--color-danger)'
    }
  }
};
var sizes$7 = {
  lg: {
    fontSize: 'xl',
    svgHeight: 16,
    svgWidth: 16,
    svgStrokeWidth: 2
  },
  md: {
    fontSize: 'lg',
    svgHeight: 14,
    svgWidth: 14,
    svgStrokeWidth: 2
  },
  sm: {
    fontSize: 'base',
    svgHeight: 12,
    svgWidth: 12,
    svgStrokeWidth: 2
  }
};
var Radio = /*#__PURE__*/forwardRef(function Radio(_a, ref) {
  var disabled = _a.disabled,
      props = __rest(_a, ["disabled"]);

  var children = props.children;
  var isDisabled = props.isDisabled !== void 0 ? props.isDisabled : disabled;
  var state = useRadioContext();
  var fallbackRef = useRef();
  var inputRef = ref || fallbackRef;

  var _useRadio = useRadio(Object.assign(Object.assign({}, props), {
    isDisabled: isDisabled
  }), state, inputRef),
      inputProps = _useRadio.inputProps;

  var name = props.name,
      size = props.size,
      intent = props.intent;

  var _useFocusRing2 = useFocusRing(),
      isFocusVisible = _useFocusRing2.isFocusVisible,
      focusProps = _useFocusRing2.focusProps;

  var isSelected = state.selectedValue === props.value;
  var strokeWidth = isSelected ? sizes$7[size].svgStrokeWidth * 2 : sizes$7[size].svgStrokeWidth;
  inputProps.name = name !== null && name !== void 0 ? name : inputProps.name;
  return jsxs(Flex, Object.assign({
    as: "label",
    alignItems: "center",
    className: cn('sl-radio-group__radio', {
      'sl-radio-group__radio--disabled': isDisabled
    })
  }, {
    children: [jsx(VisuallyHidden, {
      children: jsx("input", Object.assign({}, inputProps, focusProps, {
        ref: inputRef
      }), void 0)
    }, void 0), jsx(Flex, Object.assign({
      flexDirection: 'col',
      justifyContent: 'center'
    }, {
      children: jsx("svg", Object.assign({
        width: sizes$7[size].svgWidth,
        height: sizes$7[size].svgHeight,
        "aria-hidden": "true",
        style: {
          marginRight: 4
        },
        className: isFocusVisible ? 'sl-svg-focus' : ''
      }, {
        children: jsx("circle", {
          cx: sizes$7[size].svgWidth / 2,
          cy: sizes$7[size].svgHeight / 2,
          r: sizes$7[size].svgHeight / 3 - 1,
          fill: "var(--color-canvas)",
          strokeWidth: strokeWidth,
          stroke: isSelected ? variants$4[intent].active.stoke : variants$4[intent].stroke
        }, void 0)
      }), void 0)
    }), void 0), jsx(Box, Object.assign({
      fontSize: sizes$7[size].fontSize,
      fontWeight: 'semibold'
    }, {
      children: children
    }), void 0)]
  }), void 0);
});
var defaultElement$a = 'div';
var RadioGroup = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(function (_a, ref) {
  var _a$intent4 = _a.intent,
      intent = _a$intent4 === void 0 ? 'default' : _a$intent4,
      _a$size8 = _a.size,
      size = _a$size8 === void 0 ? 'md' : _a$size8,
      _a$orientation = _a.orientation,
      orientation = _a$orientation === void 0 ? 'vertical' : _a$orientation,
      name = _a.name,
      className = _a.className,
      label = _a.label,
      isDisabled = _a.isDisabled,
      children = _a.children,
      props = __rest(_a, ["intent", "size", "orientation", "name", "className", "label", "isDisabled", "children"]);

  var state = useRadioGroupState(props);

  var _useRadioGroup = useRadioGroup({
    label: label
  }, state),
      radioGroupProps = _useRadioGroup.radioGroupProps,
      labelProps = _useRadioGroup.labelProps;

  var variant = Object.assign(Object.assign({}, variants$4.default), variants$4[intent]);
  var childrenWithProps = Children.map(children, function (child) {
    if ( /*#__PURE__*/isValidElement(child)) {
      return /*#__PURE__*/cloneElement(child, Object.assign({
        intent: intent,
        variant: variant,
        name: name,
        size: size,
        isDisabled: isDisabled
      }, child.props));
    }

    return child;
  });
  var radioBoxProps = {
    color: variant.color
  };
  return jsxs(Stack, Object.assign({
    as: defaultElement$a,
    direction: orientation,
    ref: ref,
    className: cn('sl-radio-group', className),
    spacing: 2
  }, radioGroupProps, radioBoxProps, props, {
    children: [label && jsx(Box, Object.assign({
      pr: orientation === 'horizontal' ? 3 : undefined
    }, {
      children: jsx("span", Object.assign({}, labelProps, {
        children: label
      }), void 0)
    }), void 0), jsx(RadioContext.Provider, Object.assign({
      value: state
    }, {
      children: childrenWithProps
    }), void 0)]
  }), void 0);
})); // See examples of getCollectionNode https://github.com/adobe/react-spectrum/search?q=getCollectionNode

var SelectAction = function SelectAction(_props) {
  return null;
};

var isSelectAction = function isSelectAction(item) {
  return item && typeof item === 'object' && item.hasOwnProperty('onPress') ? true : false;
};

SelectAction.getCollectionNode = /*#__PURE__*/_regeneratorRuntime.mark(function getCollectionNode(props) {
  var label, textValue;
  return _regeneratorRuntime.wrap(function getCollectionNode$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          label = props.label;
          textValue = label || '';
          _context6.next = 4;
          return {
            type: 'item',
            key: label,
            props: props,
            rendered: textValue,
            textValue: textValue,
            'aria-label': props['aria-label'],
            hasChildNodes: false
          };

        case 4:
        case "end":
          return _context6.stop();
      }
    }
  }, getCollectionNode);
}); // See examples of getCollectionNode https://github.com/adobe/react-spectrum/search?q=getCollectionNode

var SelectOption = function SelectOption(_props) {
  return null;
};

var isSelectOption = function isSelectOption(item) {
  return item && typeof item === 'object' && item.hasOwnProperty('value') ? true : false;
};

SelectOption.getCollectionNode = /*#__PURE__*/_regeneratorRuntime.mark(function getCollectionNode(props) {
  var value, label, textValue;
  return _regeneratorRuntime.wrap(function getCollectionNode$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          value = props.value, label = props.label;
          textValue = (typeof label === 'string' ? label : '') || props['aria-label'] || value || '';
          _context7.next = 4;
          return {
            type: 'item',
            key: String(value) || label || 'empty',
            props: props,
            rendered: label || value,
            textValue: textValue,
            'aria-label': props['aria-label'],
            hasChildNodes: false
          };

        case 4:
        case "end":
          return _context7.stop();
      }
    }
  }, getCollectionNode);
});

function SelectSection(props) {
  return null;
}

var isSelectSection = function isSelectSection(item) {
  return item && typeof item === 'object' && item.hasOwnProperty('options') ? true : false;
};

SelectSection.getCollectionNode = /*#__PURE__*/_regeneratorRuntime.mark(function getCollectionNode(props) {
  var children, options;
  return _regeneratorRuntime.wrap(function getCollectionNode$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          children = props.children, options = props.options;
          _context9.next = 3;
          return {
            key: props.id || props.title,
            type: 'section',
            hasChildNodes: true,
            rendered: props.title,
            props: props,
            'aria-label': props['aria-label'],
            childNodes: /*#__PURE__*/_regeneratorRuntime.mark(function childNodes() {
              var _iterator15, _step15, item, items;

              return _regeneratorRuntime.wrap(function childNodes$(_context8) {
                while (1) {
                  switch (_context8.prev = _context8.next) {
                    case 0:
                      if (!(typeof children === 'function')) {
                        _context8.next = 22;
                        break;
                      }

                      if (options) {
                        _context8.next = 3;
                        break;
                      }

                      throw new Error('SelectSection props.options is missing');

                    case 3:
                      _iterator15 = _createForOfIteratorHelper(options);
                      _context8.prev = 4;

                      _iterator15.s();

                    case 6:
                      if ((_step15 = _iterator15.n()).done) {
                        _context8.next = 12;
                        break;
                      }

                      item = _step15.value;
                      _context8.next = 10;
                      return {
                        type: 'item',
                        value: item,
                        renderer: children
                      };

                    case 10:
                      _context8.next = 6;
                      break;

                    case 12:
                      _context8.next = 17;
                      break;

                    case 14:
                      _context8.prev = 14;
                      _context8.t0 = _context8["catch"](4);

                      _iterator15.e(_context8.t0);

                    case 17:
                      _context8.prev = 17;

                      _iterator15.f();

                      return _context8.finish(17);

                    case 20:
                      _context8.next = 25;
                      break;

                    case 22:
                      items = [];
                      Children.forEach(children, function (child) {
                        items.push({
                          type: 'item',
                          element: child
                        });
                      });
                      return _context8.delegateYield(items, "t1", 25);

                    case 25:
                    case "end":
                      return _context8.stop();
                  }
                }
              }, childNodes, null, [[4, 14, 17, 20]]);
            })
          };

        case 3:
        case "end":
          return _context9.stop();
      }
    }
  }, getCollectionNode);
});

function Select(_a, ref) {
  var _b;

  var flexGrow = _a.flexGrow,
      flex = _a.flex,
      w = _a.w,
      size = _a.size,
      triggerTextPrefix = _a.triggerTextPrefix,
      options = _a.options,
      value = _a.value,
      defaultValue = _a.defaultValue,
      onChange = _a.onChange,
      isClearable = _a.isClearable,
      _a$placeholder = _a.placeholder,
      placeholder = _a$placeholder === void 0 ? 'select an option' : _a$placeholder,
      onOpen = _a.onOpen,
      onClose = _a.onClose,
      isDisabled = _a.isDisabled,
      props = __rest(_a, ["flexGrow", "flex", "w", "size", "triggerTextPrefix", "options", "value", "defaultValue", "onChange", "isClearable", "placeholder", "onOpen", "onClose", "isDisabled"]);

  var listboxRef = useRef();

  var _triggerRef = useRef();

  var triggerRef = useFocusableRef(ref) || _triggerRef; // @ts-expect-error these ref typings are wonk


  var unwrappedTriggerRef = useUnwrapDOMRef(triggerRef);
  var onOpenChange = useCallback(function ($isOpen) {
    if ($isOpen && onOpen) onOpen();
    if (!$isOpen && onClose) onClose();
  }, [onClose, onOpen]);

  function onSelectionChange(key) {
    if (onChange) {
      var item = state.collection.getItem(key); // here we make sure to pass as null when falsey, so that Select mode does not change from controlled to uncontrolled

      onChange(item ? item.props.value : null);
    }
  }

  var idAssigner = useMemo(function () {
    return createItemIdAssigner();
  }, []);
  var optionsWithids = useMemo(function () {
    return idAssigner(options);
  }, [idAssigner, options]);

  var _useState13 = useState([]),
      _useState14 = _slicedToArray(_useState13, 2),
      disabledKeys = _useState14[0],
      setDisabledKeys = _useState14[1]; // Create state based on the incoming props


  var state = useSelectState({
    selectedKey: value,
    defaultSelectedKey: defaultValue,
    onSelectionChange: onSelectionChange,
    isDisabled: isDisabled,
    placeholder: placeholder,
    items: optionsWithids,
    children: generateListChildren,
    onOpenChange: onOpenChange,
    disabledKeys: disabledKeys
  });
  var computedDisabledKeys = useCollectionKeyAccumulator(state.collection, 'isDisabled', true);
  useEffect(function () {
    setDisabledKeys(computedDisabledKeys);
  }, [computedDisabledKeys]);
  var clearSelection = useCallback(function () {
    if (isClearable) {
      state.setSelectedKey(null);
    }
  }, [isClearable, state]);

  var _useSelect = useSelect({
    selectedKey: value,
    defaultSelectedKey: defaultValue,
    isDisabled: isDisabled,
    disallowEmptySelection: true,
    placeholder: placeholder,
    items: optionsWithids,
    children: generateListChildren,
    'aria-label': props['aria-label']
  }, state, unwrappedTriggerRef),
      triggerProps = _useSelect.triggerProps,
      menuProps = _useSelect.menuProps;
  /**
   * Menu list items have a fixed height and padding, we can use
   * this information to adjust menu location so that active item
   * is focused on center, where the user's mouse is.
   *
   * This approach does not take <Section /> into account, or overflow / scrolling. Depending on need, we
   * might want to put effort into a more robust implementation at a later date.
   */


  var _useSize5 = useSize(unwrappedTriggerRef),
      _useSize6 = _slicedToArray(_useSize5, 1),
      buttonWidth = _useSize6[0];

  var index = ((_b = state.selectedItem) === null || _b === void 0 ? void 0 : _b.index) || 0;
  var baseOffset = size === 'sm' ? -32 : -37;
  var offset = baseOffset + index * -24;
  var crossOffset = size === 'sm' ? -21 : -17;
  var triggerElem = jsx(_FieldButton, Object.assign({}, triggerProps, {
    size: size,
    disabled: isDisabled,
    placeholder: placeholder,
    onClear: isClearable ? clearSelection : undefined,
    // @ts-expect-error these ref typings are wonk
    ref: triggerRef
  }, {
    children: state.selectedItem ? triggerTextPrefix ? "".concat(triggerTextPrefix).concat(state.selectedItem.rendered) : state.selectedItem.rendered : undefined
  }), void 0);
  return jsxs(Box, Object.assign({
    className: "sl-select",
    pos: "relative",
    flexGrow: flexGrow,
    flex: flex,
    w: w
  }, {
    children: [jsx(HiddenSelect, {
      state: state,
      triggerRef: unwrappedTriggerRef,
      name: props.name
    }, void 0), jsx(Popover, Object.assign({
      triggerRef: unwrappedTriggerRef,
      scrollRef: listboxRef,
      isOpen: state.isOpen,
      onClose: state.close,
      offset: offset,
      crossOffset: crossOffset,
      placement: "bottom left",
      shouldFlip: false,
      renderTrigger: triggerElem,
      appearance: "minimal",
      type: "listbox",
      isNonModal: true
    }, {
      children: jsx(ListBoxPopup, Object.assign({}, menuProps, {
        ref: listboxRef,
        options: optionsWithids,
        state: state,
        minW: buttonWidth + Math.abs(crossOffset) + 4
      }), void 0)
    }), void 0)]
  }), void 0);
}

var _Select = /*#__PURE__*/forwardRef(Select);

var ListBoxPopup = /*#__PURE__*/forwardRef(function (_a, ref) {
  var state = _a.state,
      minW = _a.minW,
      options = _a.options,
      otherProps = __rest(_a, ["state", "minW", "options"]);

  var isDark = useThemeIsDark(); // Get props for the listbox

  var _useListBox2 = useListBox(Object.assign({
    autoFocus: 'first',
    shouldFocusWrap: true,
    selectionMode: 'single',
    items: options,
    disallowEmptySelection: true
  }, otherProps), state, ref),
      listBoxProps = _useListBox2.listBoxProps; // pull color out, not needed and conflicting types


  var _b = mergeProps(listBoxProps, otherProps),
      restProps = __rest(_b, ["color"]);

  var pointerInteraction = getInteractionModality$1() === 'pointer';
  return jsxs(Fragment, {
    children: [jsx(DismissButton, {
      onDismiss: state.close
    }, void 0), jsx(Box, Object.assign({}, restProps, {
      ref: ref,
      bg: isDark ? 'canvas-dialog' : 'canvas-pure',
      style: {
        minWidth: minW,
        maxHeight: 'inherit'
      },
      py: 2,
      className: cn('sl-menu', {
        'sl-menu--pointer-interactions': pointerInteraction
      }),
      cursor: true,
      overflowY: "auto",
      noFocusRing: true
    }, {
      children: _toConsumableArray(state.collection).map(function (item) {
        var type = item.type;

        if (type === 'item') {
          return jsx(SelectItem, {
            item: item,
            state: state
          }, item.key);
        }

        if (type === 'section') {
          return jsx(Section$1, {
            item: item,
            state: state
          }, item.key);
        }

        if (type === 'placeholder') {
          return jsx("div", Object.assign({
            // aria-selected isn't needed here since this option is not selectable.
            role: "option"
          }, {
            children: "no items to select"
          }), void 0);
        }
      })
    }), void 0), jsx(DismissButton, {
      onDismiss: state.close
    }, void 0)]
  }, void 0);
});

function Divider$2() {
  var _a = useSeparator({
    elementType: 'div'
  }).separatorProps,
      separatorProps = __rest(_a, ["color"]);

  return jsx(Box, Object.assign({
    my: 2,
    h: "px",
    bg: "canvas-200"
  }, separatorProps), void 0);
}

function Section$1(_ref18) {
  var section = _ref18.item,
      state = _ref18.state;

  var _a = useListBoxSection({
    heading: section.rendered,
    'aria-label': section['aria-label']
  }),
      itemProps = _a.itemProps,
      _b = _a.headingProps,
      headingProps = __rest(_b, ["color"]),
      groupProps = _a.groupProps;

  return jsxs(Fragment, {
    children: [section.key !== state.collection.getFirstKey() && jsx(Divider$2, {}, void 0), jsxs("div", Object.assign({}, itemProps, {
      children: [section.rendered && jsx(Box, Object.assign({}, headingProps, {
        pl: 3,
        pt: 0.5,
        pb: 1,
        textTransform: "uppercase",
        color: "light",
        cursor: true,
        fontSize: "sm"
      }, {
        children: section.rendered
      }), void 0), jsx("div", Object.assign({}, groupProps, {
        children: Array.from(section.childNodes).map(function (node) {
          var item;

          if (node.type === 'item') {
            item = jsx(SelectItem, {
              item: node,
              state: state
            }, node.key);
          } else {
            item = null;
          }

          if (node.wrapper) {
            item = node.wrapper(item);
          }

          return item;
        })
      }), void 0)]
    }), void 0)]
  }, void 0);
}

function SelectItem(_ref19) {
  var item = _ref19.item,
      state = _ref19.state;
  var ref = useRef();
  var key = item.key;
  var selectionManager = state.selectionManager;
  var isDisabled = state.disabledKeys.has(item.key);
  var isSelected = selectionManager.isSelected(item.key);
  var isFocused = selectionManager.focusedKey === key;

  var _useOption2 = useOption({
    key: item.key,
    isDisabled: isDisabled,
    isSelected: isSelected,
    shouldFocusOnHover: true
  }, state, ref),
      optionProps = _useOption2.optionProps;

  var props = {};

  if (item.props.onPress) {
    props = mergeProps(optionProps, {
      onClick: function onClick() {
        if (isDisabled) return;
        item.props.onPress();
        state.close();
      },
      onKeyUp: function onKeyUp(e) {
        if (e.key === 'Enter') {
          if (isDisabled) return;
          item.props.onPress();
          state.close();
        }
      },
      onKeyDown: null,
      onMouseDown: null,
      onPointerDown: null,
      onPointerUp: null
    });
  } else {
    props = mergeProps(optionProps);
  }

  return jsx(Internal_MenuItemRow, Object.assign({}, props, {
    ref: ref,
    title: item.rendered,
    isSelected: !!isSelected,
    isDisabled: isDisabled,
    meta: item.props.meta,
    isFocused: isFocused
  }), void 0);
}

function createItemIdAssigner() {
  var counter = 0;
  return function assignItemIds(items) {
    var itemsWithIds = [];

    var _iterator16 = _createForOfIteratorHelper(items),
        _step16;

    try {
      for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
        var item = _step16.value;

        if (isSelectSection(item)) {
          counter++;
          itemsWithIds.push(Object.assign({
            id: counter
          }, item));
        } else {
          itemsWithIds.push(item);
        }
      }
    } catch (err) {
      _iterator16.e(err);
    } finally {
      _iterator16.f();
    }

    return itemsWithIds;
  };
}

function generateListChildren(item) {
  if (isSelectSection(item)) {
    return jsx(SelectSection, Object.assign({}, item, {
      children: function children(item) {
        if (isSelectOption(item)) {
          return jsx(SelectOption, Object.assign({}, item), void 0);
        }

        if (isSelectAction(item)) {
          return jsx(SelectAction, Object.assign({}, item), void 0);
        }
      }
    }), void 0);
  }

  if (isSelectOption(item)) {
    return jsx(SelectOption, Object.assign({}, item), void 0);
  }

  if (isSelectAction(item)) {
    return jsx(SelectAction, Object.assign({}, item), void 0);
  }

  return null;
}
/**
 * Provides state management for toggle components like checkboxes and switches.
 */


function useToggleState(props) {
  if (props === void 0) {
    props = {};
  }

  var _props2 = props,
      isReadOnly = _props2.isReadOnly,
      onChange = _props2.onChange; // have to provide an empty function so useControlledState doesn't throw a fit
  // can't use useControlledState's prop calling because we need the event object from the change

  var _useControlledState5 = useControlledState(props.isSelected, props.defaultSelected || false, function () {}),
      _useControlledState6 = _slicedToArray(_useControlledState5, 2),
      isSelected = _useControlledState6[0],
      setSelected = _useControlledState6[1];

  function updateSelected(value) {
    if (!isReadOnly) {
      setSelected(value);

      if (onChange) {
        onChange(value);
      }
    }
  }

  function toggleState() {
    if (!isReadOnly) {
      setSelected(function (prev) {
        var newVal = !prev;

        if (onChange) {
          onChange(newVal);
        }

        return newVal;
      });
    }
  }

  return {
    isSelected: isSelected,
    setSelected: updateSelected,
    toggle: toggleState
  };
}

var sizes$8 = {
  lg: {
    width: 12,
    height: 6,
    fontSize: 'lg'
  },
  md: {
    width: 10,
    height: 5,
    fontSize: 'sm'
  },
  sm: {
    width: 8,
    height: 4,
    fontSize: '2xs'
  }
};
var defaultElement$b = 'input';
var Switch = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(function (_a, ref) {
  var _a$size9 = _a.size,
      size = _a$size9 === void 0 ? 'md' : _a$size9,
      _a$showIcon = _a.showIcon,
      showIcon = _a$showIcon === void 0 ? false : _a$showIcon,
      className = _a.className,
      isDisabled = _a.isDisabled,
      isSelected = _a.isSelected,
      defaultSelected = _a.defaultSelected,
      onChange = _a.onChange,
      props = __rest(_a, ["size", "showIcon", "className", "isDisabled", "isSelected", "defaultSelected", "onChange"]);

  var fallbackRef = useRef();
  var inputRef = ref || fallbackRef;
  var isDark = useThemeIsDark();
  var state = useToggleState(Object.assign({
    onChange: onChange,
    isSelected: isSelected,
    defaultSelected: defaultSelected
  }, props));

  var _useSwitch = useSwitch(Object.assign({
    isDisabled: isDisabled
  }, props), state, inputRef),
      inputProps = _useSwitch.inputProps;

  var _splitBoxProps5 = splitBoxProps(props),
      matchedProps = _splitBoxProps5.matchedProps,
      remainingProps = _splitBoxProps5.remainingProps;

  var disabledProps = {};

  if (isDisabled) {
    disabledProps = {
      bg: isDark ? 'canvas-100' : 'canvas-200',
      cursor: 'not-allowed'
    };
  }

  var checkboxProps = mergeProps(inputProps, {
    color: undefined
  });
  return jsx(Box, Object.assign({
    className: cn('sl-switch', className),
    h: sizes$8[size].height,
    w: sizes$8[size].width,
    fontSize: sizes$8[size].fontSize,
    pos: "relative",
    display: "block",
    userSelect: "none"
  }, matchedProps, remainingProps, {
    children: jsxs(Box, Object.assign({
      as: "label",
      pos: "absolute",
      w: "full",
      h: "full"
    }, {
      children: [jsx(Box, Object.assign({
        ref: inputRef,
        as: defaultElement$b,
        pos: "absolute",
        m: 0,
        zIndex: -1,
        top: 0,
        left: 0,
        opacity: 0,
        disabled: isDisabled
      }, checkboxProps), void 0), jsx(Box, Object.assign({
        as: "span",
        cursor: "pointer",
        className: "sl-switch__indicator",
        rounded: "full",
        w: "full",
        h: "full",
        display: "block",
        bg: isDark ? 'canvas-50' : 'canvas-500'
      }, disabledProps, {
        children: showIcon && jsx(Flex, Object.assign({
          className: "sl-switch__icon",
          pos: "absolute",
          align: "center",
          style: {
            top: 0,
            bottom: 0,
            left: 0,
            lineHeight: 1
          },
          pl: 1,
          color: isDark ? 'body' : 'canvas-pure'
        }, {
          children: jsx(Icon, {
            icon: "check",
            fixedWidth: true
          }, void 0)
        }), void 0)
      }), void 0)]
    }), void 0)
  }), void 0);
}));
var TabsContext = /*#__PURE__*/createContext(null);
var variants$5 = {
  minimal: {
    horizontal: {
      regular: {
        tabList: {},
        tab: {
          py: 2,
          px: 3
        }
      },
      compact: {
        tabList: {},
        tab: {
          py: 1.5,
          px: 2
        }
      }
    },
    vertical: {
      regular: {
        tabList: {},
        tab: {
          py: 1.5,
          px: 3
        }
      },
      compact: {
        tabList: {},
        tab: {
          py: 1.5,
          px: 3
        }
      }
    }
  },
  line: {
    horizontal: {
      regular: {
        tabList: {
          borderB: 2
        },
        tab: {
          mb: -0.5,
          borderB: 2,
          py: 2,
          px: 4
        }
      },
      compact: {
        tabList: {
          borderB: 2
        },
        tab: {
          mb: -0.5,
          borderB: 2,
          py: 1.5,
          px: 2
        }
      }
    },
    vertical: {
      regular: {
        tabList: {
          borderR: 2
        },
        tab: {
          mr: -0.5,
          borderR: 2,
          py: 2,
          px: 4
        }
      },
      compact: {
        tabList: {
          borderR: 2
        },
        tab: {
          mr: -0.5,
          borderR: 2,
          py: 1.5,
          px: 3
        }
      }
    }
  }
};

var Tab = function Tab(props) {
  return jsx(Item, Object.assign({}, props), void 0);
};

Tab.getCollectionNode = Item.getCollectionNode;

function TabImpl(props) {
  var item = props.item,
      state = props.state,
      density = props.density,
      propsDisabled = props.isDisabled;
  var key = item.key,
      rendered = item.rendered,
      index = item.index;
  var isDisabled = propsDisabled || state.disabledKeys.has(key);
  var tabContext = useContext(TabsContext);
  var tabsProps = tabContext.tabsProps;
  var appearance = tabsProps.appearance,
      orientation = tabsProps.orientation;
  var disabledKeys = state.disabledKeys; // sync `isDisabled` prop with tab list state disabled keys

  useEffect(function () {
    if (propsDisabled && !disabledKeys.has(key)) {
      disabledKeys.add(key);
    } else if (!propsDisabled && disabledKeys.has(key)) {
      disabledKeys.delete(key);
    }
  }, [disabledKeys, propsDisabled, key]);
  var ref = useRef();

  var _useTab = useTab({
    key: key,
    isDisabled: isDisabled
  }, state, ref),
      tabProps = _useTab.tabProps;

  var _useHover3 = useHover(Object.assign({}, props)),
      hoverProps = _useHover3.hoverProps;

  var isSelected = state.selectedKey === key;

  var _a = mergeProps(tabProps, hoverProps),
      propsWithoutColor = __rest(_a, ["color"]);

  var stateProps = Object.assign({}, variants$5[appearance][orientation][density].tab);

  if (appearance === 'minimal') {
    if (orientation === 'vertical') {
      // @ts-expect-error
      stateProps.ml = -1 * stateProps.px;

      if (index === 0) {
        // @ts-expect-error
        stateProps.mt = -1 * stateProps.py;
      }
    } else {
      if (index === 0) {
        // @ts-expect-error
        stateProps.ml = -1 * stateProps.px;
      }
    }
  } else {
    if (orientation === 'vertical') {
      // @ts-expect-error
      stateProps.ml = -1 * stateProps.px;
    }
  }
  /**
   * If in loading or disabled states, remove other ui effects like hover
   */


  if (isDisabled) {
    for (var i in stateProps) {
      var prop = stateProps[i];

      if (prop && typeof prop === 'object') {
        // remove props immutably
        var _b = stateProps[i],
            newProps = __rest(_b, ["active", "hover"]);

        stateProps[i] = newProps;
      }
    }
  }

  return jsx(FocusRing, Object.assign({
    focusRingClass: "sl-focus-ring"
  }, {
    children: jsx(Box, Object.assign({}, propsWithoutColor, {
      ref: ref
    }, stateProps, {
      borderColor: isSelected ? 'primary' : 'transparent',
      cursor: isDisabled ? 'not-allowed' : isSelected ? true : 'pointer',
      fontWeight: "medium",
      opacity: isDisabled ? 60 : undefined,
      color: isSelected ? 'primary-dark' : {
        default: 'muted',
        hover: isDisabled ? undefined : 'body'
      }
    }, {
      children: rendered
    }), void 0)
  }), void 0);
}
/**
 * A TabList is used within Tabs to group tabs that a user can switch between.
 * The keys of the items within the <TabList> must match up with a corresponding item inside the <TabPanels>.
 */


function TabList(_a) {
  var _a$fontSize = _a.fontSize,
      fontSize = _a$fontSize === void 0 ? 'lg' : _a$fontSize,
      _a$density = _a.density,
      density = _a$density === void 0 ? 'regular' : _a$density,
      props = __rest(_a, ["fontSize", "density"]);

  var tabContext = useContext(TabsContext);
  var refs = tabContext.refs,
      tabState = tabContext.tabState,
      tabsProps = tabContext.tabsProps;
  var orientation = tabsProps.orientation,
      selectedId = tabsProps.selectedId,
      onChange = tabsProps.onChange;
  var collapse = tabState.collapse,
      setTabListState = tabState.setTabListState;
  var tablistRef = refs.tablistRef;
  var appearance = tabsProps.appearance; // Pass original Tab props but override children to create the collection.

  var state = useTabListState(Object.assign(Object.assign({}, tabsProps), {
    selectedKey: onChange ? selectedId : undefined,
    defaultSelectedKey: onChange ? undefined : selectedId,
    onSelectionChange: onChange,
    children: props.children
  }));

  var _useTabList = useTabList(Object.assign(Object.assign({}, tabsProps), props), state, tablistRef),
      tabListProps = _useTabList.tabListProps;

  useEffect(function () {
    // Passing back to root as useTabPanel needs the TabListState
    setTabListState(state); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.disabledKeys, state.selectedItem, state.selectedKey, props.children]);

  var tabListPropsWithoutColor = __rest(tabListProps, ["color"]);

  var stateProps = Object.assign({}, variants$5[appearance][orientation][density].tabList);
  var tabContent = jsx(Stack, Object.assign({}, tabListPropsWithoutColor, {
    ref: tablistRef,
    direction: orientation
  }, stateProps, {
    fontSize: fontSize
  }, {
    children: _toConsumableArray(state.collection).map(function (item) {
      var _a;

      return jsx(TabImpl, {
        item: item,
        state: state,
        density: density,
        isDisabled: (_a = item.props) === null || _a === void 0 ? void 0 : _a.isDisabled
      }, item.key);
    })
  }), void 0);
  return tabContent; // TODO: auto collapse w Select when overflows
  // if (orientation === 'vertical') {
  //   return tabContent;
  // } else {
  //   return (
  //     <div ref={wrapperRef} className={classNames(styles, 'collapseWrapper')}>
  //       {collapse ? (
  //         <Select
  //           {...props}
  //           {...tabProps}
  //           id={tabPanelProps['aria-labelledby']}
  //           state={state}
  //           className={tabListclassName}
  //         />
  //       ) : (
  //         tabContent
  //       )}
  //     </div>
  //   );
  // }
}

var TabPanel = function TabPanel(props) {
  return jsx(Item, Object.assign({}, props), void 0);
};

TabPanel.getCollectionNode = Item.getCollectionNode;

function TabPanels(_a) {
  var _a$p = _a.p,
      p = _a$p === void 0 ? 4 : _a$p,
      m = _a.m,
      props = __rest(_a, ["p", "m"]);

  var _useContext8 = useContext(TabsContext),
      tabState = _useContext8.tabState,
      ctxTabPanelProps = _useContext8.tabPanelProps,
      tabsProps = _useContext8.tabsProps;

  var tabListState = tabState.tabListState;
  var ref = useRef();

  var _useTabPanel = useTabPanel({}, tabListState, ref),
      tabPanelProps = _useTabPanel.tabPanelProps;

  if (ctxTabPanelProps['aria-labelledby']) {
    tabPanelProps['aria-labelledby'] = ctxTabPanelProps['aria-labelledby'];
  }

  var factory = function factory(nodes) {
    return new ListCollection(nodes);
  };

  var collection = useCollection(props, factory, {
    suppressTextValueWarning: true
  });
  var selectedItem = tabListState ? collection.getItem(tabListState.selectedKey) : null;
  var orientation = tabsProps.orientation;

  var tabPanelPropsWithoutColor = __rest(tabPanelProps, ["color"]);

  var py = orientation === 'vertical' ? undefined : p;
  var px = orientation === 'vertical' ? p : undefined;
  return jsx(FocusRing, Object.assign({
    focusRingClass: "sl-focus-ring"
  }, {
    children: jsx(Box, Object.assign({}, tabPanelPropsWithoutColor, {
      ref: ref,
      py: py,
      px: px,
      flex: 1,
      m: m
    }, {
      children: selectedItem && selectedItem.props.children
    }), void 0)
  }), void 0);
}

var Tabs = /*#__PURE__*/forwardRef(function (props, ref) {
  var children = props.children,
      _props$appearance2 = props.appearance,
      appearance = _props$appearance2 === void 0 ? 'minimal' : _props$appearance2,
      _props$orientation = props.orientation,
      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation;
  var domRef = useDOMRef(ref);
  var tablistRef = useRef();
  var wrapperRef = useRef();

  var _useValueEffect = useValueEffect(false),
      _useValueEffect2 = _slicedToArray(_useValueEffect, 2),
      collapse = _useValueEffect2[0],
      setCollapse = _useValueEffect2[1];

  var _useState15 = useState(),
      _useState16 = _slicedToArray(_useState15, 2),
      selectedTab = _useState16[0],
      setSelectedTab = _useState16[1];

  var _useState17 = useState(null),
      _useState18 = _slicedToArray(_useState17, 2),
      tabListState = _useState18[0],
      setTabListState = _useState18[1];

  useEffect(function () {
    if (tablistRef.current) {
      var _selectedTab = tablistRef.current.querySelector("[data-key=\"".concat(tabListState === null || tabListState === void 0 ? void 0 : tabListState.selectedKey, "\"]"));

      if (_selectedTab != null) {
        setSelectedTab(_selectedTab);
      }
    } // collapse is in the dep array so selectedTab can be updated for TabLine positioning

  }, [children, tabListState === null || tabListState === void 0 ? void 0 : tabListState.selectedKey, collapse, tablistRef]); // TODO: when we add logic to collapse overflow tabs
  // const direction: 'ltr' | 'rtl' = 'ltr';
  // const checkShouldCollapse = React.useCallback(() => {
  //   const computeShouldCollapse = () => {
  //     if (wrapperRef.current) {
  //       const tabsComponent = wrapperRef.current;
  //       const tabs = tablistRef.current.querySelectorAll('[role="tab"]');
  //       const lastTab = tabs[tabs.length - 1];
  //       // @ts-expect-error
  //       const end = direction === 'rtl' ? 'left' : 'right';
  //       const farEdgeTabList = tabsComponent.getBoundingClientRect()[end];
  //       const farEdgeLastTab = lastTab?.getBoundingClientRect()[end];
  //       // @ts-expect-error
  //       const shouldCollapse = direction === 'rtl' ? farEdgeLastTab < farEdgeTabList : farEdgeTabList < farEdgeLastTab;
  //       return shouldCollapse;
  //     }
  //   };
  //   if (orientation !== 'vertical') {
  //     setCollapse(function* () {
  //       // Make Tabs render in non-collapsed state
  //       yield false;
  //       // Compute if Tabs should collapse and update
  //       yield computeShouldCollapse();
  //     });
  //   }
  // }, [tablistRef, wrapperRef, direction, orientation, setCollapse]);
  // React.useEffect(() => {
  //   checkShouldCollapse();
  // }, [children, checkShouldCollapse]);
  // useResizeObserver({ref: wrapperRef, onResize: checkShouldCollapse});

  var tabPanelProps = {
    'aria-labelledby': undefined
  }; // When the tabs are collapsed, the tabPanel should be labelled by the Picker button element.

  var collapsibleTabListId = useId();

  if (collapse && orientation !== 'vertical') {
    tabPanelProps['aria-labelledby'] = collapsibleTabListId;
  }

  return jsx(NoSsr, {
    children: jsx(TabsContext.Provider, Object.assign({
      value: {
        tabsProps: Object.assign(Object.assign({}, props), {
          orientation: orientation,
          appearance: appearance
        }),
        tabState: {
          tabListState: tabListState,
          setTabListState: setTabListState,
          selectedTab: selectedTab,
          collapse: collapse
        },
        refs: {
          tablistRef: tablistRef,
          wrapperRef: wrapperRef
        },
        tabPanelProps: tabPanelProps
      }
    }, {
      children: jsx(Stack, Object.assign({
        ref: domRef,
        w: "full",
        direction: orientation === 'vertical' ? 'horizontal' : 'vertical'
      }, {
        children: props.children
      }), void 0)
    }), void 0)
  }, void 0);
});
var variants$6 = {
  default: {
    default: {
      borderColor: {
        default: 'input',
        // TODO: when have more sophisticated theme val system, slightly darker color on hover as in ui designs
        // hover: 'input',
        focus: 'primary'
      }
    },
    success: {
      borderColor: {
        default: 'success',
        focus: 'success-dark'
      }
    },
    warning: {
      borderColor: {
        default: 'warning',
        focus: 'warning-dark'
      }
    },
    danger: {
      borderColor: {
        default: 'danger',
        focus: 'danger-dark'
      }
    }
  },
  minimal: {
    default: {
      borderColor: {
        default: 'transparent',
        hover: 'input',
        focus: 'primary'
      }
    },
    success: {
      borderColor: {
        default: 'transparent',
        hover: 'success',
        focus: 'success-dark'
      }
    },
    warning: {
      borderColor: {
        default: 'transparent',
        hover: 'warning',
        focus: 'warning-dark'
      }
    },
    danger: {
      borderColor: {
        default: 'transparent',
        hover: 'danger',
        focus: 'danger-dark'
      }
    }
  }
};
var sizes$9 = {
  lg: {
    padding: 4,
    rows: 6
  },
  md: {
    padding: 2.5,
    rows: 4
  },
  sm: {
    padding: 1.5,
    rows: 2
  }
};
var fontSizes$1 = {
  lg: 'lg',
  md: 'base',
  sm: 'base'
};
var defaultElement$c = 'textarea';
var Textarea = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(function (_a, ref) {
  var _a$intent5 = _a.intent,
      intent = _a$intent5 === void 0 ? 'default' : _a$intent5,
      _a$size10 = _a.size,
      size = _a$size10 === void 0 ? 'md' : _a$size10,
      _a$resize = _a.resize,
      resize = _a$resize === void 0 ? 'y' : _a$resize,
      _a$appearance7 = _a.appearance,
      appearance = _a$appearance7 === void 0 ? 'default' : _a$appearance7,
      className = _a.className,
      disabled = _a.disabled,
      required = _a.required,
      readOnly = _a.readOnly,
      props = __rest(_a, ["intent", "size", "resize", "appearance", "className", "disabled", "required", "readOnly"]);

  var fallbackRef = useRef();
  var textAreaRef = ref || fallbackRef;

  var _useTextField = useTextField(Object.assign({
    isDisabled: disabled,
    isRequired: required,
    isReadOnly: readOnly
  }, props), textAreaRef),
      inputProps = _useTextField.inputProps;

  var _splitBoxProps6 = splitBoxProps(props),
      matchedProps = _splitBoxProps6.matchedProps,
      remainingProps = _splitBoxProps6.remainingProps;

  var stateProps = Object.assign(Object.assign(Object.assign(Object.assign({}, variants$6.default.default), variants$6.default[intent]), variants$6[appearance].default), variants$6[appearance][intent]);
  var onResizeChange = useCallback(function () {
    var input = textAreaRef.current;
    input.style.minHeight = "".concat(input.scrollHeight + 2, "px");
    input.style.minWidth = "".concat(input.scrollWidth + 2, "px");
  }, [textAreaRef]);
  useLayoutEffect(function () {
    if (textAreaRef.current) {
      onResizeChange();
    }
  }, [onResizeChange, textAreaRef]);
  var disabledProps = {};

  if (disabled) {
    disabledProps = {
      bg: 'canvas-100',
      color: 'muted',
      cursor: 'not-allowed'
    };
  }

  var readOnlyProps = {};

  if (readOnly) {
    readOnlyProps.tabIndex = -1;

    if (appearance === 'minimal') {
      readOnlyProps.borderColor = 'transparent';
    }
  }

  var textareaProps = mergeProps(inputProps, {
    color: undefined
  });
  return jsx(Box, Object.assign({
    className: cn('sl-textarea', className),
    pos: "relative"
  }, matchedProps, {
    children: jsx(Box, Object.assign({
      ref: textAreaRef,
      as: defaultElement$c,
      pl: sizes$9[size].padding,
      pr: sizes$9[size].padding,
      pt: 2,
      fontSize: fontSizes$1[size],
      rounded: true,
      resize: resize,
      rows: sizes$9[size].rows,
      border: true,
      w: "full",
      disabled: disabled,
      readOnly: true,
      pos: "relative"
    }, textareaProps, remainingProps, readOnlyProps, stateProps, disabledProps), void 0)
  }), void 0);
}));
var TOOLTIP_DELAY = 500;
var TOOLTIP_OFFSET = 10;

var Tooltip = function Tooltip(props) {
  var renderTrigger = props.renderTrigger,
      children = props.children,
      _props$placement2 = props.placement,
      placement = _props$placement2 === void 0 ? 'bottom' : _props$placement2,
      isOpen = props.isOpen,
      defaultOpen = props.defaultOpen,
      onOpen = props.onOpen,
      onClose = props.onClose,
      _props$delay = props.delay,
      delay = _props$delay === void 0 ? TOOLTIP_DELAY : _props$delay,
      _props$offset2 = props.offset,
      offset = _props$offset2 === void 0 ? TOOLTIP_OFFSET : _props$offset2,
      crossOffset = props.crossOffset,
      isDisabled = props.isDisabled,
      _props$shouldFlip2 = props.shouldFlip,
      shouldFlip = _props$shouldFlip2 === void 0 ? true : _props$shouldFlip2,
      hideArrow = props.hideArrow;
  var overlayRef = useRef();

  var _triggerRef = useRef();

  var tooltipTriggerRef = props.triggerRef || _triggerRef;
  var onOpenChange = useCallback(function ($isOpen) {
    if ($isOpen && onOpen) onOpen();
    if (!$isOpen && onClose) onClose();
  }, [onClose, onOpen]);
  var state = useTooltipTriggerState({
    isOpen: isOpen,
    defaultOpen: defaultOpen,
    delay: delay,
    isDisabled: isDisabled,
    onOpenChange: onOpenChange
  }); // Get props for the trigger and overlay. This also handles
  // hiding the overlay when a parent element of the trigger scrolls
  // (which invalidates the popover positioning).

  var _useTooltipTrigger = useTooltipTrigger({
    isDisabled: isDisabled
  }, state, tooltipTriggerRef),
      triggerProps = _useTooltipTrigger.triggerProps,
      tooltipProps = _useTooltipTrigger.tooltipProps; // Get popover positioning props relative to the trigger


  var _useOverlayPosition2 = useOverlayPosition({
    targetRef: tooltipTriggerRef,
    overlayRef: overlayRef,
    placement: placement,
    offset: offset,
    crossOffset: crossOffset,
    shouldFlip: shouldFlip,
    isOpen: state.isOpen,
    onClose: onClose
  }),
      positionProps = _useOverlayPosition2.overlayProps,
      arrowProps = _useOverlayPosition2.arrowProps,
      arrowIcon = _useOverlayPosition2.arrowIcon;

  var triggerElem = runIfFn(renderTrigger, {
    isOpen: state.isOpen
  });
  return jsxs(FocusableProvider, Object.assign({}, triggerProps, {
    ref: tooltipTriggerRef
  }, {
    children: [/*#__PURE__*/cloneElement(triggerElem, Object.assign(Object.assign({}, mergeProps(triggerElem.props, triggerProps)), {
      ref: tooltipTriggerRef
    })), jsx(_Overlay, Object.assign({
      isOpen: state.isOpen
    }, {
      children: jsxs(TooltipWrapper, Object.assign({}, tooltipProps, positionProps, {
        ref: overlayRef,
        state: state
      }, {
        children: [runIfFn(children, {
          close: state.close
        }), !hideArrow && jsx(TooltipArrow$1, {
          icon: arrowIcon,
          style: arrowProps.style
        }, void 0)]
      }), void 0)
    }), void 0)]
  }), void 0);
};

var TooltipWrapper = /*#__PURE__*/forwardRef(function (_a, ref) {
  var children = _a.children,
      state = _a.state,
      otherProps = __rest(_a, ["children", "state"]);

  var isDark = useThemeIsDark(); // Handle interacting outside the dialog and pressing
  // the Escape key to close the modal. Using expect-error so that we know when to remove this
  // @ts-expect-error useTooltip typing is incorrect, state is expected

  var _useTooltip = useTooltip({
    children: children
  }, state),
      tooltipProps = _useTooltip.tooltipProps;

  var _b = mergeProps(tooltipProps, otherProps),
      containerProps = __rest(_b, ["color"]);

  return jsx(Box, Object.assign({}, containerProps, {
    className: "sl-tooltip",
    ref: ref,
    "data-testid": "tooltip",
    "data-theme": "dark",
    bg: isDark ? 'canvas-dialog' : 'canvas-pure'
  }, {
    children: children
  }), void 0);
});

function TooltipArrow$1(_ref20) {
  var icon = _ref20.icon,
      style = _ref20.style;
  var isDark = useThemeIsDark();
  return jsx(Box, Object.assign({
    className: "sl-tooltip_tip",
    pos: "absolute",
    color: isDark ? 'canvas-dialog' : 'canvas-pure',
    style: style
  }, {
    children: jsx(Icon, {
      icon: icon
    }, void 0)
  }), void 0);
}

var TreeItem = function TreeItem(props) {
  return jsx("div", Object.assign({}, props), void 0);
};

var css = "blockquote,dd,dl,figure,h1,h2,h3,h4,h5,h6,hr,p,pre{margin:0}button{background-color:initial;background-image:none}:focus{outline:none}fieldset,ol,ul{margin:0;padding:0}ol,ul{list-style:none}html{font-family:var(--font-ui);line-height:1.5}body{text-rendering:optimizeSpeed;font-family:inherit;line-height:inherit;margin:0;min-height:100vh}*,:after,:before{border:0 solid var(--color-border,currentColor);box-sizing:border-box}hr{border-top-width:1px}img{border-style:solid}textarea{resize:vertical}input::-ms-input-placeholder,textarea::-ms-input-placeholder{color:#a1a1aa}input::-ms-input-placeholder, textarea::-ms-input-placeholder{color:#a1a1aa}input::placeholder,textarea::placeholder{color:#a1a1aa}[role=button],button{cursor:pointer}table{border-collapse:collapse}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}button,input,optgroup,select,textarea{color:inherit;line-height:inherit;padding:0}code,kbd,pre,samp{font-family:var(--font-mono)}audio,canvas,embed,iframe,img,object,svg,video{display:block;vertical-align:middle}img,video{height:auto;max-width:100%}button{font-family:var(--font-ui)}select{-moz-appearance:none;-webkit-appearance:none}select::-ms-expand{display:none}select{font-size:inherit}iframe{border:0}@media (prefers-reduced-motion:reduce){*{animation-duration:.01ms!important;animation-iteration-count:1!important;scroll-behavior:auto!important;transition-duration:.01ms!important}}.sl-content-center{align-content:center}.sl-content-start{align-content:flex-start}.sl-content-end{align-content:flex-end}.sl-content-between{align-content:space-between}.sl-content-around{align-content:space-around}.sl-content-evenly{align-content:space-evenly}.sl-items-start{align-items:flex-start}.sl-items-end{align-items:flex-end}.sl-items-center{align-items:center}.sl-items-baseline{align-items:baseline}.sl-items-stretch{align-items:stretch}.sl-self-auto{align-self:auto}.sl-self-start{align-self:flex-start}.sl-self-end{align-self:flex-end}.sl-self-center{align-self:center}.sl-self-stretch{align-self:stretch}.sl-bg-transparent{background-color:initial}.sl-bg-current{background-color:currentColor}.sl-bg-lighten-100{background-color:var(--color-lighten-100)}.sl-bg-darken-100{background-color:var(--color-darken-100)}.sl-bg-primary{background-color:var(--color-primary)}.sl-bg-primary-tint{background-color:var(--color-primary-tint)}.sl-bg-primary-light{background-color:var(--color-primary-light)}.sl-bg-primary-dark{background-color:var(--color-primary-dark)}.sl-bg-primary-darker{background-color:var(--color-primary-darker)}.sl-bg-success{background-color:var(--color-success)}.sl-bg-success-tint{background-color:var(--color-success-tint)}.sl-bg-success-light{background-color:var(--color-success-light)}.sl-bg-success-dark{background-color:var(--color-success-dark)}.sl-bg-success-darker{background-color:var(--color-success-darker)}.sl-bg-warning{background-color:var(--color-warning)}.sl-bg-warning-tint{background-color:var(--color-warning-tint)}.sl-bg-warning-light{background-color:var(--color-warning-light)}.sl-bg-warning-dark{background-color:var(--color-warning-dark)}.sl-bg-warning-darker{background-color:var(--color-warning-darker)}.sl-bg-danger{background-color:var(--color-danger)}.sl-bg-danger-tint{background-color:var(--color-danger-tint)}.sl-bg-danger-light{background-color:var(--color-danger-light)}.sl-bg-danger-dark{background-color:var(--color-danger-dark)}.sl-bg-danger-darker{background-color:var(--color-danger-darker)}.sl-bg-code{background-color:var(--color-code)}.sl-bg-on-code{background-color:var(--color-on-code)}.sl-bg-on-primary{background-color:var(--color-on-primary)}.sl-bg-on-success{background-color:var(--color-on-success)}.sl-bg-on-warning{background-color:var(--color-on-warning)}.sl-bg-on-danger{background-color:var(--color-on-danger)}.sl-bg-canvas-50{background-color:var(--color-canvas-50)}.sl-bg-canvas-100{background-color:var(--color-canvas-100)}.sl-bg-canvas-200{background-color:var(--color-canvas-200)}.sl-bg-canvas-300{background-color:var(--color-canvas-300)}.sl-bg-canvas-400{background-color:var(--color-canvas-400)}.sl-bg-canvas-500{background-color:var(--color-canvas-500)}.sl-bg-canvas-pure{background-color:var(--color-canvas-pure)}.sl-bg-canvas{background-color:var(--color-canvas)}.sl-bg-canvas-tint{background-color:var(--color-canvas-tint)}.sl-bg-canvas-dialog{background-color:var(--color-canvas-dialog)}.sl-bg-body{background-color:var(--color-text)}.sl-bg-body-muted{background-color:var(--color-text-muted)}.sl-bg-body-light{background-color:var(--color-text-light)}.hover\\:sl-bg-transparent:hover{background-color:initial}.hover\\:sl-bg-current:hover{background-color:currentColor}.hover\\:sl-bg-lighten-100:hover{background-color:var(--color-lighten-100)}.hover\\:sl-bg-darken-100:hover{background-color:var(--color-darken-100)}.hover\\:sl-bg-primary:hover{background-color:var(--color-primary)}.hover\\:sl-bg-primary-tint:hover{background-color:var(--color-primary-tint)}.hover\\:sl-bg-primary-light:hover{background-color:var(--color-primary-light)}.hover\\:sl-bg-primary-dark:hover{background-color:var(--color-primary-dark)}.hover\\:sl-bg-primary-darker:hover{background-color:var(--color-primary-darker)}.hover\\:sl-bg-success:hover{background-color:var(--color-success)}.hover\\:sl-bg-success-tint:hover{background-color:var(--color-success-tint)}.hover\\:sl-bg-success-light:hover{background-color:var(--color-success-light)}.hover\\:sl-bg-success-dark:hover{background-color:var(--color-success-dark)}.hover\\:sl-bg-success-darker:hover{background-color:var(--color-success-darker)}.hover\\:sl-bg-warning:hover{background-color:var(--color-warning)}.hover\\:sl-bg-warning-tint:hover{background-color:var(--color-warning-tint)}.hover\\:sl-bg-warning-light:hover{background-color:var(--color-warning-light)}.hover\\:sl-bg-warning-dark:hover{background-color:var(--color-warning-dark)}.hover\\:sl-bg-warning-darker:hover{background-color:var(--color-warning-darker)}.hover\\:sl-bg-danger:hover{background-color:var(--color-danger)}.hover\\:sl-bg-danger-tint:hover{background-color:var(--color-danger-tint)}.hover\\:sl-bg-danger-light:hover{background-color:var(--color-danger-light)}.hover\\:sl-bg-danger-dark:hover{background-color:var(--color-danger-dark)}.hover\\:sl-bg-danger-darker:hover{background-color:var(--color-danger-darker)}.hover\\:sl-bg-code:hover{background-color:var(--color-code)}.hover\\:sl-bg-on-code:hover{background-color:var(--color-on-code)}.hover\\:sl-bg-on-primary:hover{background-color:var(--color-on-primary)}.hover\\:sl-bg-on-success:hover{background-color:var(--color-on-success)}.hover\\:sl-bg-on-warning:hover{background-color:var(--color-on-warning)}.hover\\:sl-bg-on-danger:hover{background-color:var(--color-on-danger)}.hover\\:sl-bg-canvas-50:hover{background-color:var(--color-canvas-50)}.hover\\:sl-bg-canvas-100:hover{background-color:var(--color-canvas-100)}.hover\\:sl-bg-canvas-200:hover{background-color:var(--color-canvas-200)}.hover\\:sl-bg-canvas-300:hover{background-color:var(--color-canvas-300)}.hover\\:sl-bg-canvas-400:hover{background-color:var(--color-canvas-400)}.hover\\:sl-bg-canvas-500:hover{background-color:var(--color-canvas-500)}.hover\\:sl-bg-canvas-pure:hover{background-color:var(--color-canvas-pure)}.hover\\:sl-bg-canvas:hover{background-color:var(--color-canvas)}.hover\\:sl-bg-canvas-tint:hover{background-color:var(--color-canvas-tint)}.hover\\:sl-bg-canvas-dialog:hover{background-color:var(--color-canvas-dialog)}.hover\\:sl-bg-body:hover{background-color:var(--color-text)}.hover\\:sl-bg-body-muted:hover{background-color:var(--color-text-muted)}.hover\\:sl-bg-body-light:hover{background-color:var(--color-text-light)}.focus\\:sl-bg-transparent:focus{background-color:initial}.focus\\:sl-bg-current:focus{background-color:currentColor}.focus\\:sl-bg-lighten-100:focus{background-color:var(--color-lighten-100)}.focus\\:sl-bg-darken-100:focus{background-color:var(--color-darken-100)}.focus\\:sl-bg-primary:focus{background-color:var(--color-primary)}.focus\\:sl-bg-primary-tint:focus{background-color:var(--color-primary-tint)}.focus\\:sl-bg-primary-light:focus{background-color:var(--color-primary-light)}.focus\\:sl-bg-primary-dark:focus{background-color:var(--color-primary-dark)}.focus\\:sl-bg-primary-darker:focus{background-color:var(--color-primary-darker)}.focus\\:sl-bg-success:focus{background-color:var(--color-success)}.focus\\:sl-bg-success-tint:focus{background-color:var(--color-success-tint)}.focus\\:sl-bg-success-light:focus{background-color:var(--color-success-light)}.focus\\:sl-bg-success-dark:focus{background-color:var(--color-success-dark)}.focus\\:sl-bg-success-darker:focus{background-color:var(--color-success-darker)}.focus\\:sl-bg-warning:focus{background-color:var(--color-warning)}.focus\\:sl-bg-warning-tint:focus{background-color:var(--color-warning-tint)}.focus\\:sl-bg-warning-light:focus{background-color:var(--color-warning-light)}.focus\\:sl-bg-warning-dark:focus{background-color:var(--color-warning-dark)}.focus\\:sl-bg-warning-darker:focus{background-color:var(--color-warning-darker)}.focus\\:sl-bg-danger:focus{background-color:var(--color-danger)}.focus\\:sl-bg-danger-tint:focus{background-color:var(--color-danger-tint)}.focus\\:sl-bg-danger-light:focus{background-color:var(--color-danger-light)}.focus\\:sl-bg-danger-dark:focus{background-color:var(--color-danger-dark)}.focus\\:sl-bg-danger-darker:focus{background-color:var(--color-danger-darker)}.focus\\:sl-bg-code:focus{background-color:var(--color-code)}.focus\\:sl-bg-on-code:focus{background-color:var(--color-on-code)}.focus\\:sl-bg-on-primary:focus{background-color:var(--color-on-primary)}.focus\\:sl-bg-on-success:focus{background-color:var(--color-on-success)}.focus\\:sl-bg-on-warning:focus{background-color:var(--color-on-warning)}.focus\\:sl-bg-on-danger:focus{background-color:var(--color-on-danger)}.focus\\:sl-bg-canvas-50:focus{background-color:var(--color-canvas-50)}.focus\\:sl-bg-canvas-100:focus{background-color:var(--color-canvas-100)}.focus\\:sl-bg-canvas-200:focus{background-color:var(--color-canvas-200)}.focus\\:sl-bg-canvas-300:focus{background-color:var(--color-canvas-300)}.focus\\:sl-bg-canvas-400:focus{background-color:var(--color-canvas-400)}.focus\\:sl-bg-canvas-500:focus{background-color:var(--color-canvas-500)}.focus\\:sl-bg-canvas-pure:focus{background-color:var(--color-canvas-pure)}.focus\\:sl-bg-canvas:focus{background-color:var(--color-canvas)}.focus\\:sl-bg-canvas-tint:focus{background-color:var(--color-canvas-tint)}.focus\\:sl-bg-canvas-dialog:focus{background-color:var(--color-canvas-dialog)}.focus\\:sl-bg-body:focus{background-color:var(--color-text)}.focus\\:sl-bg-body-muted:focus{background-color:var(--color-text-muted)}.focus\\:sl-bg-body-light:focus{background-color:var(--color-text-light)}.active\\:sl-bg-transparent:active{background-color:initial}.active\\:sl-bg-current:active{background-color:currentColor}.active\\:sl-bg-lighten-100:active{background-color:var(--color-lighten-100)}.active\\:sl-bg-darken-100:active{background-color:var(--color-darken-100)}.active\\:sl-bg-primary:active{background-color:var(--color-primary)}.active\\:sl-bg-primary-tint:active{background-color:var(--color-primary-tint)}.active\\:sl-bg-primary-light:active{background-color:var(--color-primary-light)}.active\\:sl-bg-primary-dark:active{background-color:var(--color-primary-dark)}.active\\:sl-bg-primary-darker:active{background-color:var(--color-primary-darker)}.active\\:sl-bg-success:active{background-color:var(--color-success)}.active\\:sl-bg-success-tint:active{background-color:var(--color-success-tint)}.active\\:sl-bg-success-light:active{background-color:var(--color-success-light)}.active\\:sl-bg-success-dark:active{background-color:var(--color-success-dark)}.active\\:sl-bg-success-darker:active{background-color:var(--color-success-darker)}.active\\:sl-bg-warning:active{background-color:var(--color-warning)}.active\\:sl-bg-warning-tint:active{background-color:var(--color-warning-tint)}.active\\:sl-bg-warning-light:active{background-color:var(--color-warning-light)}.active\\:sl-bg-warning-dark:active{background-color:var(--color-warning-dark)}.active\\:sl-bg-warning-darker:active{background-color:var(--color-warning-darker)}.active\\:sl-bg-danger:active{background-color:var(--color-danger)}.active\\:sl-bg-danger-tint:active{background-color:var(--color-danger-tint)}.active\\:sl-bg-danger-light:active{background-color:var(--color-danger-light)}.active\\:sl-bg-danger-dark:active{background-color:var(--color-danger-dark)}.active\\:sl-bg-danger-darker:active{background-color:var(--color-danger-darker)}.active\\:sl-bg-code:active{background-color:var(--color-code)}.active\\:sl-bg-on-code:active{background-color:var(--color-on-code)}.active\\:sl-bg-on-primary:active{background-color:var(--color-on-primary)}.active\\:sl-bg-on-success:active{background-color:var(--color-on-success)}.active\\:sl-bg-on-warning:active{background-color:var(--color-on-warning)}.active\\:sl-bg-on-danger:active{background-color:var(--color-on-danger)}.active\\:sl-bg-canvas-50:active{background-color:var(--color-canvas-50)}.active\\:sl-bg-canvas-100:active{background-color:var(--color-canvas-100)}.active\\:sl-bg-canvas-200:active{background-color:var(--color-canvas-200)}.active\\:sl-bg-canvas-300:active{background-color:var(--color-canvas-300)}.active\\:sl-bg-canvas-400:active{background-color:var(--color-canvas-400)}.active\\:sl-bg-canvas-500:active{background-color:var(--color-canvas-500)}.active\\:sl-bg-canvas-pure:active{background-color:var(--color-canvas-pure)}.active\\:sl-bg-canvas:active{background-color:var(--color-canvas)}.active\\:sl-bg-canvas-tint:active{background-color:var(--color-canvas-tint)}.active\\:sl-bg-canvas-dialog:active{background-color:var(--color-canvas-dialog)}.active\\:sl-bg-body:active{background-color:var(--color-text)}.active\\:sl-bg-body-muted:active{background-color:var(--color-text-muted)}.active\\:sl-bg-body-light:active{background-color:var(--color-text-light)}.disabled\\:sl-bg-transparent:disabled{background-color:initial}.disabled\\:sl-bg-current:disabled{background-color:currentColor}.disabled\\:sl-bg-lighten-100:disabled{background-color:var(--color-lighten-100)}.disabled\\:sl-bg-darken-100:disabled{background-color:var(--color-darken-100)}.disabled\\:sl-bg-primary:disabled{background-color:var(--color-primary)}.disabled\\:sl-bg-primary-tint:disabled{background-color:var(--color-primary-tint)}.disabled\\:sl-bg-primary-light:disabled{background-color:var(--color-primary-light)}.disabled\\:sl-bg-primary-dark:disabled{background-color:var(--color-primary-dark)}.disabled\\:sl-bg-primary-darker:disabled{background-color:var(--color-primary-darker)}.disabled\\:sl-bg-success:disabled{background-color:var(--color-success)}.disabled\\:sl-bg-success-tint:disabled{background-color:var(--color-success-tint)}.disabled\\:sl-bg-success-light:disabled{background-color:var(--color-success-light)}.disabled\\:sl-bg-success-dark:disabled{background-color:var(--color-success-dark)}.disabled\\:sl-bg-success-darker:disabled{background-color:var(--color-success-darker)}.disabled\\:sl-bg-warning:disabled{background-color:var(--color-warning)}.disabled\\:sl-bg-warning-tint:disabled{background-color:var(--color-warning-tint)}.disabled\\:sl-bg-warning-light:disabled{background-color:var(--color-warning-light)}.disabled\\:sl-bg-warning-dark:disabled{background-color:var(--color-warning-dark)}.disabled\\:sl-bg-warning-darker:disabled{background-color:var(--color-warning-darker)}.disabled\\:sl-bg-danger:disabled{background-color:var(--color-danger)}.disabled\\:sl-bg-danger-tint:disabled{background-color:var(--color-danger-tint)}.disabled\\:sl-bg-danger-light:disabled{background-color:var(--color-danger-light)}.disabled\\:sl-bg-danger-dark:disabled{background-color:var(--color-danger-dark)}.disabled\\:sl-bg-danger-darker:disabled{background-color:var(--color-danger-darker)}.disabled\\:sl-bg-code:disabled{background-color:var(--color-code)}.disabled\\:sl-bg-on-code:disabled{background-color:var(--color-on-code)}.disabled\\:sl-bg-on-primary:disabled{background-color:var(--color-on-primary)}.disabled\\:sl-bg-on-success:disabled{background-color:var(--color-on-success)}.disabled\\:sl-bg-on-warning:disabled{background-color:var(--color-on-warning)}.disabled\\:sl-bg-on-danger:disabled{background-color:var(--color-on-danger)}.disabled\\:sl-bg-canvas-50:disabled{background-color:var(--color-canvas-50)}.disabled\\:sl-bg-canvas-100:disabled{background-color:var(--color-canvas-100)}.disabled\\:sl-bg-canvas-200:disabled{background-color:var(--color-canvas-200)}.disabled\\:sl-bg-canvas-300:disabled{background-color:var(--color-canvas-300)}.disabled\\:sl-bg-canvas-400:disabled{background-color:var(--color-canvas-400)}.disabled\\:sl-bg-canvas-500:disabled{background-color:var(--color-canvas-500)}.disabled\\:sl-bg-canvas-pure:disabled{background-color:var(--color-canvas-pure)}.disabled\\:sl-bg-canvas:disabled{background-color:var(--color-canvas)}.disabled\\:sl-bg-canvas-tint:disabled{background-color:var(--color-canvas-tint)}.disabled\\:sl-bg-canvas-dialog:disabled{background-color:var(--color-canvas-dialog)}.disabled\\:sl-bg-body:disabled{background-color:var(--color-text)}.disabled\\:sl-bg-body-muted:disabled{background-color:var(--color-text-muted)}.disabled\\:sl-bg-body-light:disabled{background-color:var(--color-text-light)}.sl-bg-none{background-image:none}.sl-bg-gradient-to-t{background-image:linear-gradient(to top,var(--tw-gradient-stops))}.sl-bg-gradient-to-tr{background-image:linear-gradient(to top right,var(--tw-gradient-stops))}.sl-bg-gradient-to-r{background-image:linear-gradient(to right,var(--tw-gradient-stops))}.sl-bg-gradient-to-br{background-image:linear-gradient(to bottom right,var(--tw-gradient-stops))}.sl-bg-gradient-to-b{background-image:linear-gradient(to bottom,var(--tw-gradient-stops))}.sl-bg-gradient-to-bl{background-image:linear-gradient(to bottom left,var(--tw-gradient-stops))}.sl-bg-gradient-to-l{background-image:linear-gradient(to left,var(--tw-gradient-stops))}.sl-bg-gradient-to-tl{background-image:linear-gradient(to top left,var(--tw-gradient-stops))}.sl-blur-0,.sl-blur-none{--tw-blur:blur(0)}.sl-blur-sm{--tw-blur:blur(4px)}.sl-blur{--tw-blur:blur(8px)}.sl-blur-md{--tw-blur:blur(12px)}.sl-blur-lg{--tw-blur:blur(16px)}.sl-blur-xl{--tw-blur:blur(24px)}.sl-blur-2xl{--tw-blur:blur(40px)}.sl-blur-3xl{--tw-blur:blur(64px)}.sl-border-transparent{border-color:transparent}.sl-border-current{border-color:currentColor}.sl-border-lighten-100{border-color:var(--color-lighten-100)}.sl-border-darken-100{border-color:var(--color-darken-100)}.sl-border-primary{border-color:var(--color-primary)}.sl-border-primary-tint{border-color:var(--color-primary-tint)}.sl-border-primary-light{border-color:var(--color-primary-light)}.sl-border-primary-dark{border-color:var(--color-primary-dark)}.sl-border-primary-darker{border-color:var(--color-primary-darker)}.sl-border-success{border-color:var(--color-success)}.sl-border-success-tint{border-color:var(--color-success-tint)}.sl-border-success-light{border-color:var(--color-success-light)}.sl-border-success-dark{border-color:var(--color-success-dark)}.sl-border-success-darker{border-color:var(--color-success-darker)}.sl-border-warning{border-color:var(--color-warning)}.sl-border-warning-tint{border-color:var(--color-warning-tint)}.sl-border-warning-light{border-color:var(--color-warning-light)}.sl-border-warning-dark{border-color:var(--color-warning-dark)}.sl-border-warning-darker{border-color:var(--color-warning-darker)}.sl-border-danger{border-color:var(--color-danger)}.sl-border-danger-tint{border-color:var(--color-danger-tint)}.sl-border-danger-light{border-color:var(--color-danger-light)}.sl-border-danger-dark{border-color:var(--color-danger-dark)}.sl-border-danger-darker{border-color:var(--color-danger-darker)}.sl-border-code{border-color:var(--color-code)}.sl-border-on-code{border-color:var(--color-on-code)}.sl-border-on-primary{border-color:var(--color-on-primary)}.sl-border-on-success{border-color:var(--color-on-success)}.sl-border-on-warning{border-color:var(--color-on-warning)}.sl-border-on-danger{border-color:var(--color-on-danger)}.sl-border-light{border-color:var(--color-border-light)}.sl-border-dark{border-color:var(--color-border-dark)}.sl-border-button{border-color:var(--color-border-button)}.sl-border-input{border-color:var(--color-border-input)}.sl-border-body{border-color:var(--color-text)}.hover\\:sl-border-transparent:hover{border-color:transparent}.hover\\:sl-border-current:hover{border-color:currentColor}.hover\\:sl-border-lighten-100:hover{border-color:var(--color-lighten-100)}.hover\\:sl-border-darken-100:hover{border-color:var(--color-darken-100)}.hover\\:sl-border-primary:hover{border-color:var(--color-primary)}.hover\\:sl-border-primary-tint:hover{border-color:var(--color-primary-tint)}.hover\\:sl-border-primary-light:hover{border-color:var(--color-primary-light)}.hover\\:sl-border-primary-dark:hover{border-color:var(--color-primary-dark)}.hover\\:sl-border-primary-darker:hover{border-color:var(--color-primary-darker)}.hover\\:sl-border-success:hover{border-color:var(--color-success)}.hover\\:sl-border-success-tint:hover{border-color:var(--color-success-tint)}.hover\\:sl-border-success-light:hover{border-color:var(--color-success-light)}.hover\\:sl-border-success-dark:hover{border-color:var(--color-success-dark)}.hover\\:sl-border-success-darker:hover{border-color:var(--color-success-darker)}.hover\\:sl-border-warning:hover{border-color:var(--color-warning)}.hover\\:sl-border-warning-tint:hover{border-color:var(--color-warning-tint)}.hover\\:sl-border-warning-light:hover{border-color:var(--color-warning-light)}.hover\\:sl-border-warning-dark:hover{border-color:var(--color-warning-dark)}.hover\\:sl-border-warning-darker:hover{border-color:var(--color-warning-darker)}.hover\\:sl-border-danger:hover{border-color:var(--color-danger)}.hover\\:sl-border-danger-tint:hover{border-color:var(--color-danger-tint)}.hover\\:sl-border-danger-light:hover{border-color:var(--color-danger-light)}.hover\\:sl-border-danger-dark:hover{border-color:var(--color-danger-dark)}.hover\\:sl-border-danger-darker:hover{border-color:var(--color-danger-darker)}.hover\\:sl-border-code:hover{border-color:var(--color-code)}.hover\\:sl-border-on-code:hover{border-color:var(--color-on-code)}.hover\\:sl-border-on-primary:hover{border-color:var(--color-on-primary)}.hover\\:sl-border-on-success:hover{border-color:var(--color-on-success)}.hover\\:sl-border-on-warning:hover{border-color:var(--color-on-warning)}.hover\\:sl-border-on-danger:hover{border-color:var(--color-on-danger)}.hover\\:sl-border-light:hover{border-color:var(--color-border-light)}.hover\\:sl-border-dark:hover{border-color:var(--color-border-dark)}.hover\\:sl-border-button:hover{border-color:var(--color-border-button)}.hover\\:sl-border-input:hover{border-color:var(--color-border-input)}.hover\\:sl-border-body:hover{border-color:var(--color-text)}.focus\\:sl-border-transparent:focus{border-color:transparent}.focus\\:sl-border-current:focus{border-color:currentColor}.focus\\:sl-border-lighten-100:focus{border-color:var(--color-lighten-100)}.focus\\:sl-border-darken-100:focus{border-color:var(--color-darken-100)}.focus\\:sl-border-primary:focus{border-color:var(--color-primary)}.focus\\:sl-border-primary-tint:focus{border-color:var(--color-primary-tint)}.focus\\:sl-border-primary-light:focus{border-color:var(--color-primary-light)}.focus\\:sl-border-primary-dark:focus{border-color:var(--color-primary-dark)}.focus\\:sl-border-primary-darker:focus{border-color:var(--color-primary-darker)}.focus\\:sl-border-success:focus{border-color:var(--color-success)}.focus\\:sl-border-success-tint:focus{border-color:var(--color-success-tint)}.focus\\:sl-border-success-light:focus{border-color:var(--color-success-light)}.focus\\:sl-border-success-dark:focus{border-color:var(--color-success-dark)}.focus\\:sl-border-success-darker:focus{border-color:var(--color-success-darker)}.focus\\:sl-border-warning:focus{border-color:var(--color-warning)}.focus\\:sl-border-warning-tint:focus{border-color:var(--color-warning-tint)}.focus\\:sl-border-warning-light:focus{border-color:var(--color-warning-light)}.focus\\:sl-border-warning-dark:focus{border-color:var(--color-warning-dark)}.focus\\:sl-border-warning-darker:focus{border-color:var(--color-warning-darker)}.focus\\:sl-border-danger:focus{border-color:var(--color-danger)}.focus\\:sl-border-danger-tint:focus{border-color:var(--color-danger-tint)}.focus\\:sl-border-danger-light:focus{border-color:var(--color-danger-light)}.focus\\:sl-border-danger-dark:focus{border-color:var(--color-danger-dark)}.focus\\:sl-border-danger-darker:focus{border-color:var(--color-danger-darker)}.focus\\:sl-border-code:focus{border-color:var(--color-code)}.focus\\:sl-border-on-code:focus{border-color:var(--color-on-code)}.focus\\:sl-border-on-primary:focus{border-color:var(--color-on-primary)}.focus\\:sl-border-on-success:focus{border-color:var(--color-on-success)}.focus\\:sl-border-on-warning:focus{border-color:var(--color-on-warning)}.focus\\:sl-border-on-danger:focus{border-color:var(--color-on-danger)}.focus\\:sl-border-light:focus{border-color:var(--color-border-light)}.focus\\:sl-border-dark:focus{border-color:var(--color-border-dark)}.focus\\:sl-border-button:focus{border-color:var(--color-border-button)}.focus\\:sl-border-input:focus{border-color:var(--color-border-input)}.focus\\:sl-border-body:focus{border-color:var(--color-text)}.active\\:sl-border-transparent:active{border-color:transparent}.active\\:sl-border-current:active{border-color:currentColor}.active\\:sl-border-lighten-100:active{border-color:var(--color-lighten-100)}.active\\:sl-border-darken-100:active{border-color:var(--color-darken-100)}.active\\:sl-border-primary:active{border-color:var(--color-primary)}.active\\:sl-border-primary-tint:active{border-color:var(--color-primary-tint)}.active\\:sl-border-primary-light:active{border-color:var(--color-primary-light)}.active\\:sl-border-primary-dark:active{border-color:var(--color-primary-dark)}.active\\:sl-border-primary-darker:active{border-color:var(--color-primary-darker)}.active\\:sl-border-success:active{border-color:var(--color-success)}.active\\:sl-border-success-tint:active{border-color:var(--color-success-tint)}.active\\:sl-border-success-light:active{border-color:var(--color-success-light)}.active\\:sl-border-success-dark:active{border-color:var(--color-success-dark)}.active\\:sl-border-success-darker:active{border-color:var(--color-success-darker)}.active\\:sl-border-warning:active{border-color:var(--color-warning)}.active\\:sl-border-warning-tint:active{border-color:var(--color-warning-tint)}.active\\:sl-border-warning-light:active{border-color:var(--color-warning-light)}.active\\:sl-border-warning-dark:active{border-color:var(--color-warning-dark)}.active\\:sl-border-warning-darker:active{border-color:var(--color-warning-darker)}.active\\:sl-border-danger:active{border-color:var(--color-danger)}.active\\:sl-border-danger-tint:active{border-color:var(--color-danger-tint)}.active\\:sl-border-danger-light:active{border-color:var(--color-danger-light)}.active\\:sl-border-danger-dark:active{border-color:var(--color-danger-dark)}.active\\:sl-border-danger-darker:active{border-color:var(--color-danger-darker)}.active\\:sl-border-code:active{border-color:var(--color-code)}.active\\:sl-border-on-code:active{border-color:var(--color-on-code)}.active\\:sl-border-on-primary:active{border-color:var(--color-on-primary)}.active\\:sl-border-on-success:active{border-color:var(--color-on-success)}.active\\:sl-border-on-warning:active{border-color:var(--color-on-warning)}.active\\:sl-border-on-danger:active{border-color:var(--color-on-danger)}.active\\:sl-border-light:active{border-color:var(--color-border-light)}.active\\:sl-border-dark:active{border-color:var(--color-border-dark)}.active\\:sl-border-button:active{border-color:var(--color-border-button)}.active\\:sl-border-input:active{border-color:var(--color-border-input)}.active\\:sl-border-body:active{border-color:var(--color-text)}.sl-rounded-none{border-radius:0}.sl-rounded-sm{border-radius:1px}.sl-rounded{border-radius:2px}.sl-rounded-lg{border-radius:5px}.sl-rounded-xl{border-radius:7px}.sl-rounded-full{border-radius:9999px}.sl-rounded-t-none{border-top-left-radius:0;border-top-right-radius:0}.sl-rounded-r-none{border-bottom-right-radius:0;border-top-right-radius:0}.sl-rounded-b-none{border-bottom-left-radius:0;border-bottom-right-radius:0}.sl-rounded-l-none{border-bottom-left-radius:0;border-top-left-radius:0}.sl-rounded-t-sm{border-top-left-radius:1px;border-top-right-radius:1px}.sl-rounded-r-sm{border-bottom-right-radius:1px;border-top-right-radius:1px}.sl-rounded-b-sm{border-bottom-left-radius:1px;border-bottom-right-radius:1px}.sl-rounded-l-sm{border-bottom-left-radius:1px;border-top-left-radius:1px}.sl-rounded-t{border-top-left-radius:2px;border-top-right-radius:2px}.sl-rounded-r{border-top-right-radius:2px}.sl-rounded-b,.sl-rounded-r{border-bottom-right-radius:2px}.sl-rounded-b,.sl-rounded-l{border-bottom-left-radius:2px}.sl-rounded-l{border-top-left-radius:2px}.sl-rounded-t-lg{border-top-left-radius:5px;border-top-right-radius:5px}.sl-rounded-r-lg{border-bottom-right-radius:5px;border-top-right-radius:5px}.sl-rounded-b-lg{border-bottom-left-radius:5px;border-bottom-right-radius:5px}.sl-rounded-l-lg{border-bottom-left-radius:5px;border-top-left-radius:5px}.sl-rounded-t-xl{border-top-left-radius:7px;border-top-right-radius:7px}.sl-rounded-r-xl{border-bottom-right-radius:7px;border-top-right-radius:7px}.sl-rounded-b-xl{border-bottom-left-radius:7px;border-bottom-right-radius:7px}.sl-rounded-l-xl{border-bottom-left-radius:7px;border-top-left-radius:7px}.sl-rounded-t-full{border-top-left-radius:9999px;border-top-right-radius:9999px}.sl-rounded-r-full{border-bottom-right-radius:9999px;border-top-right-radius:9999px}.sl-rounded-b-full{border-bottom-left-radius:9999px;border-bottom-right-radius:9999px}.sl-rounded-l-full{border-bottom-left-radius:9999px;border-top-left-radius:9999px}.sl-rounded-tl-none{border-top-left-radius:0}.sl-rounded-tr-none{border-top-right-radius:0}.sl-rounded-br-none{border-bottom-right-radius:0}.sl-rounded-bl-none{border-bottom-left-radius:0}.sl-rounded-tl-sm{border-top-left-radius:1px}.sl-rounded-tr-sm{border-top-right-radius:1px}.sl-rounded-br-sm{border-bottom-right-radius:1px}.sl-rounded-bl-sm{border-bottom-left-radius:1px}.sl-rounded-tl{border-top-left-radius:2px}.sl-rounded-tr{border-top-right-radius:2px}.sl-rounded-br{border-bottom-right-radius:2px}.sl-rounded-bl{border-bottom-left-radius:2px}.sl-rounded-tl-lg{border-top-left-radius:5px}.sl-rounded-tr-lg{border-top-right-radius:5px}.sl-rounded-br-lg{border-bottom-right-radius:5px}.sl-rounded-bl-lg{border-bottom-left-radius:5px}.sl-rounded-tl-xl{border-top-left-radius:7px}.sl-rounded-tr-xl{border-top-right-radius:7px}.sl-rounded-br-xl{border-bottom-right-radius:7px}.sl-rounded-bl-xl{border-bottom-left-radius:7px}.sl-rounded-tl-full{border-top-left-radius:9999px}.sl-rounded-tr-full{border-top-right-radius:9999px}.sl-rounded-br-full{border-bottom-right-radius:9999px}.sl-rounded-bl-full{border-bottom-left-radius:9999px}.sl-border-solid{border-style:solid}.sl-border-dashed{border-style:dashed}.sl-border-dotted{border-style:dotted}.sl-border-double{border-style:double}.sl-border-none{border-style:none}.sl-border-0{border-width:0}.sl-border-2{border-width:2px}.sl-border-4{border-width:4px}.sl-border-8{border-width:8px}.sl-border{border-width:1px}.sl-border-t-0{border-top-width:0}.sl-border-r-0{border-right-width:0}.sl-border-b-0{border-bottom-width:0}.sl-border-l-0{border-left-width:0}.sl-border-t-2{border-top-width:2px}.sl-border-r-2{border-right-width:2px}.sl-border-b-2{border-bottom-width:2px}.sl-border-l-2{border-left-width:2px}.sl-border-t-4{border-top-width:4px}.sl-border-r-4{border-right-width:4px}.sl-border-b-4{border-bottom-width:4px}.sl-border-l-4{border-left-width:4px}.sl-border-t-8{border-top-width:8px}.sl-border-r-8{border-right-width:8px}.sl-border-b-8{border-bottom-width:8px}.sl-border-l-8{border-left-width:8px}.sl-border-t{border-top-width:1px}.sl-border-r{border-right-width:1px}.sl-border-b{border-bottom-width:1px}.sl-border-l{border-left-width:1px}*{--tw-shadow:0 0 #0000}.sl-shadow-sm{--tw-shadow:var(--shadow-sm);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.sl-shadow,.sl-shadow-md{--tw-shadow:var(--shadow-md)}.sl-shadow,.sl-shadow-lg,.sl-shadow-md{box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.sl-shadow-lg{--tw-shadow:var(--shadow-lg)}.sl-shadow-xl{--tw-shadow:var(--shadow-xl)}.sl-shadow-2xl,.sl-shadow-xl{box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.sl-shadow-2xl{--tw-shadow:var(--shadow-2xl)}.hover\\:sl-shadow-sm:hover{--tw-shadow:var(--shadow-sm);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.hover\\:sl-shadow-md:hover,.hover\\:sl-shadow:hover{--tw-shadow:var(--shadow-md)}.hover\\:sl-shadow-lg:hover,.hover\\:sl-shadow-md:hover,.hover\\:sl-shadow:hover{box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.hover\\:sl-shadow-lg:hover{--tw-shadow:var(--shadow-lg)}.hover\\:sl-shadow-xl:hover{--tw-shadow:var(--shadow-xl)}.hover\\:sl-shadow-2xl:hover,.hover\\:sl-shadow-xl:hover{box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.hover\\:sl-shadow-2xl:hover{--tw-shadow:var(--shadow-2xl)}.focus\\:sl-shadow-sm:focus{--tw-shadow:var(--shadow-sm);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.focus\\:sl-shadow-md:focus,.focus\\:sl-shadow:focus{--tw-shadow:var(--shadow-md)}.focus\\:sl-shadow-lg:focus,.focus\\:sl-shadow-md:focus,.focus\\:sl-shadow:focus{box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.focus\\:sl-shadow-lg:focus{--tw-shadow:var(--shadow-lg)}.focus\\:sl-shadow-xl:focus{--tw-shadow:var(--shadow-xl)}.focus\\:sl-shadow-2xl:focus,.focus\\:sl-shadow-xl:focus{box-shadow:var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow)}.focus\\:sl-shadow-2xl:focus{--tw-shadow:var(--shadow-2xl)}.sl-box-border{box-sizing:border-box}.sl-box-content{box-sizing:initial}.sl-cursor-auto{cursor:auto}.sl-cursor{cursor:default}.sl-cursor-pointer{cursor:pointer}.sl-cursor-wait{cursor:wait}.sl-cursor-text{cursor:text}.sl-cursor-move{cursor:move}.sl-cursor-not-allowed{cursor:not-allowed}.sl-cursor-zoom-in{cursor:zoom-in}.sl-cursor-zoom-out{cursor:zoom-out}.sl-block{display:block}.sl-inline-block{display:inline-block}.sl-inline{display:inline}.sl-flex{display:flex}.sl-inline-flex{display:inline-flex}.sl-table{display:table}.sl-inline-table{display:inline-table}.sl-table-caption{display:table-caption}.sl-table-cell{display:table-cell}.sl-table-column{display:table-column}.sl-table-column-group{display:table-column-group}.sl-table-footer-group{display:table-footer-group}.sl-table-header-group{display:table-header-group}.sl-table-row-group{display:table-row-group}.sl-table-row{display:table-row}.sl-flow-root{display:flow-root}.sl-grid{display:grid}.sl-inline-grid{display:inline-grid}.sl-contents{display:contents}.sl-list-item{display:list-item}.sl-hidden{display:none}.sl-drop-shadow{--tw-drop-shadow:drop-shadow(var(--drop-shadow-default1)) drop-shadow(var(--drop-shadow-default2))}.sl-filter{--tw-blur:var(--tw-empty,/*!*/ /*!*/);--tw-brightness:var(--tw-empty,/*!*/ /*!*/);--tw-contrast:var(--tw-empty,/*!*/ /*!*/);--tw-grayscale:var(--tw-empty,/*!*/ /*!*/);--tw-hue-rotate:var(--tw-empty,/*!*/ /*!*/);--tw-invert:var(--tw-empty,/*!*/ /*!*/);--tw-saturate:var(--tw-empty,/*!*/ /*!*/);--tw-sepia:var(--tw-empty,/*!*/ /*!*/);--tw-drop-shadow:var(--tw-empty,/*!*/ /*!*/);filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.sl-filter-none{filter:none}.sl-flex-1{flex:1 1}.sl-flex-auto{flex:1 1 auto}.sl-flex-initial{flex:0 1 auto}.sl-flex-none{flex:none}.sl-flex-row{flex-direction:row}.sl-flex-row-reverse{flex-direction:row-reverse}.sl-flex-col{flex-direction:column}.sl-flex-col-reverse{flex-direction:column-reverse}.sl-flex-grow-0{flex-grow:0}.sl-flex-grow{flex-grow:1}.sl-flex-shrink-0{flex-shrink:0}.sl-flex-shrink{flex-shrink:1}.sl-flex-wrap{flex-wrap:wrap}.sl-flex-wrap-reverse{flex-wrap:wrap-reverse}.sl-flex-nowrap{flex-wrap:nowrap}.sl-font-sans,.sl-font-ui{font-family:var(--font-ui)}.sl-font-prose{font-family:var(--font-prose)}.sl-font-mono{font-family:var(--font-mono)}.sl-text-2xs{font-size:9px}.sl-text-xs{font-size:10px}.sl-text-sm{font-size:11px}.sl-text-base{font-size:12px}.sl-text-lg{font-size:14px}.sl-text-xl{font-size:16px}.sl-text-2xl{font-size:20px}.sl-text-3xl{font-size:24px}.sl-text-4xl{font-size:28px}.sl-text-5xl{font-size:36px}.sl-text-6xl{font-size:44px}.sl-text-paragraph-leading{font-size:var(--fs-paragraph-leading)}.sl-text-paragraph{font-size:var(--fs-paragraph)}.sl-text-paragraph-small{font-size:var(--fs-paragraph-small)}.sl-text-paragraph-tiny{font-size:var(--fs-paragraph-tiny)}.sl-antialiased{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.sl-subpixel-antialiased{-webkit-font-smoothing:auto;-moz-osx-font-smoothing:auto}.sl-italic{font-style:italic}.sl-not-italic{font-style:normal}.sl-font-light{font-weight:300}.sl-font-normal{font-weight:400}.sl-font-medium{font-weight:500}.sl-font-semibold{font-weight:600}.sl-font-bold{font-weight:700}.sl-h-0{height:0}.sl-h-1{height:4px}.sl-h-2{height:8px}.sl-h-3{height:12px}.sl-h-4{height:16px}.sl-h-5{height:20px}.sl-h-6{height:24px}.sl-h-7{height:28px}.sl-h-8{height:32px}.sl-h-9{height:36px}.sl-h-10{height:40px}.sl-h-11{height:44px}.sl-h-12{height:48px}.sl-h-14{height:56px}.sl-h-16{height:64px}.sl-h-20{height:80px}.sl-h-24{height:96px}.sl-h-32{height:128px}.sl-h-40{height:160px}.sl-h-60{height:240px}.sl-h-80{height:320px}.sl-h-auto{height:auto}.sl-h-px{height:1px}.sl-h-0\\.5{height:2px}.sl-h-1\\.5{height:6px}.sl-h-2\\.5{height:10px}.sl-h-3\\.5{height:14px}.sl-h-xs{height:20px}.sl-h-sm{height:24px}.sl-h-md{height:32px}.sl-h-lg{height:36px}.sl-h-xl{height:44px}.sl-h-2xl{height:52px}.sl-h-3xl{height:60px}.sl-h-full{height:100%}.sl-h-screen{height:100vh}.sl-inset-0{bottom:0;left:0;right:0;top:0}.sl-inset-1{bottom:4px;left:4px;right:4px;top:4px}.sl-inset-2{bottom:8px;left:8px;right:8px;top:8px}.sl-inset-3{bottom:12px;left:12px;right:12px;top:12px}.sl-inset-4{bottom:16px;left:16px;right:16px;top:16px}.sl-inset-5{bottom:20px;left:20px;right:20px;top:20px}.sl-inset-6{bottom:24px;left:24px;right:24px;top:24px}.sl-inset-7{bottom:28px;left:28px;right:28px;top:28px}.sl-inset-8{bottom:32px;left:32px;right:32px;top:32px}.sl-inset-9{bottom:36px;left:36px;right:36px;top:36px}.sl-inset-10{bottom:40px;left:40px;right:40px;top:40px}.sl-inset-11{bottom:44px;left:44px;right:44px;top:44px}.sl-inset-12{bottom:48px;left:48px;right:48px;top:48px}.sl-inset-14{bottom:56px;left:56px;right:56px;top:56px}.sl-inset-16{bottom:64px;left:64px;right:64px;top:64px}.sl-inset-20{bottom:80px;left:80px;right:80px;top:80px}.sl-inset-24{bottom:96px;left:96px;right:96px;top:96px}.sl-inset-32{bottom:128px;left:128px;right:128px;top:128px}.sl-inset-40{bottom:160px;left:160px;right:160px;top:160px}.sl-inset-60{bottom:240px;left:240px;right:240px;top:240px}.sl-inset-80{bottom:320px;left:320px;right:320px;top:320px}.sl-inset-auto{bottom:auto;left:auto;right:auto;top:auto}.sl-inset-px{bottom:1px;left:1px;right:1px;top:1px}.sl-inset-0\\.5{bottom:2px;left:2px;right:2px;top:2px}.sl-inset-1\\.5{bottom:6px;left:6px;right:6px;top:6px}.sl-inset-2\\.5{bottom:10px;left:10px;right:10px;top:10px}.sl-inset-3\\.5{bottom:14px;left:14px;right:14px;top:14px}.sl--inset-0{bottom:0;left:0;right:0;top:0}.sl--inset-1{bottom:-4px;left:-4px;right:-4px;top:-4px}.sl--inset-2{bottom:-8px;left:-8px;right:-8px;top:-8px}.sl--inset-3{bottom:-12px;left:-12px;right:-12px;top:-12px}.sl--inset-4{bottom:-16px;left:-16px;right:-16px;top:-16px}.sl--inset-5{bottom:-20px;left:-20px;right:-20px;top:-20px}.sl--inset-6{bottom:-24px;left:-24px;right:-24px;top:-24px}.sl--inset-7{bottom:-28px;left:-28px;right:-28px;top:-28px}.sl--inset-8{bottom:-32px;left:-32px;right:-32px;top:-32px}.sl--inset-9{bottom:-36px;left:-36px;right:-36px;top:-36px}.sl--inset-10{bottom:-40px;left:-40px;right:-40px;top:-40px}.sl--inset-11{bottom:-44px;left:-44px;right:-44px;top:-44px}.sl--inset-12{bottom:-48px;left:-48px;right:-48px;top:-48px}.sl--inset-14{bottom:-56px;left:-56px;right:-56px;top:-56px}.sl--inset-16{bottom:-64px;left:-64px;right:-64px;top:-64px}.sl--inset-20{bottom:-80px;left:-80px;right:-80px;top:-80px}.sl--inset-24{bottom:-96px;left:-96px;right:-96px;top:-96px}.sl--inset-32{bottom:-128px;left:-128px;right:-128px;top:-128px}.sl--inset-40{bottom:-160px;left:-160px;right:-160px;top:-160px}.sl--inset-60{bottom:-240px;left:-240px;right:-240px;top:-240px}.sl--inset-80{bottom:-320px;left:-320px;right:-320px;top:-320px}.sl--inset-px{bottom:-1px;left:-1px;right:-1px;top:-1px}.sl--inset-0\\.5{bottom:-2px;left:-2px;right:-2px;top:-2px}.sl--inset-1\\.5{bottom:-6px;left:-6px;right:-6px;top:-6px}.sl--inset-2\\.5{bottom:-10px;left:-10px;right:-10px;top:-10px}.sl--inset-3\\.5{bottom:-14px;left:-14px;right:-14px;top:-14px}.sl-inset-y-0{bottom:0;top:0}.sl-inset-x-0{left:0;right:0}.sl-inset-y-1{bottom:4px;top:4px}.sl-inset-x-1{left:4px;right:4px}.sl-inset-y-2{bottom:8px;top:8px}.sl-inset-x-2{left:8px;right:8px}.sl-inset-y-3{bottom:12px;top:12px}.sl-inset-x-3{left:12px;right:12px}.sl-inset-y-4{bottom:16px;top:16px}.sl-inset-x-4{left:16px;right:16px}.sl-inset-y-5{bottom:20px;top:20px}.sl-inset-x-5{left:20px;right:20px}.sl-inset-y-6{bottom:24px;top:24px}.sl-inset-x-6{left:24px;right:24px}.sl-inset-y-7{bottom:28px;top:28px}.sl-inset-x-7{left:28px;right:28px}.sl-inset-y-8{bottom:32px;top:32px}.sl-inset-x-8{left:32px;right:32px}.sl-inset-y-9{bottom:36px;top:36px}.sl-inset-x-9{left:36px;right:36px}.sl-inset-y-10{bottom:40px;top:40px}.sl-inset-x-10{left:40px;right:40px}.sl-inset-y-11{bottom:44px;top:44px}.sl-inset-x-11{left:44px;right:44px}.sl-inset-y-12{bottom:48px;top:48px}.sl-inset-x-12{left:48px;right:48px}.sl-inset-y-14{bottom:56px;top:56px}.sl-inset-x-14{left:56px;right:56px}.sl-inset-y-16{bottom:64px;top:64px}.sl-inset-x-16{left:64px;right:64px}.sl-inset-y-20{bottom:80px;top:80px}.sl-inset-x-20{left:80px;right:80px}.sl-inset-y-24{bottom:96px;top:96px}.sl-inset-x-24{left:96px;right:96px}.sl-inset-y-32{bottom:128px;top:128px}.sl-inset-x-32{left:128px;right:128px}.sl-inset-y-40{bottom:160px;top:160px}.sl-inset-x-40{left:160px;right:160px}.sl-inset-y-60{bottom:240px;top:240px}.sl-inset-x-60{left:240px;right:240px}.sl-inset-y-80{bottom:320px;top:320px}.sl-inset-x-80{left:320px;right:320px}.sl-inset-y-auto{bottom:auto;top:auto}.sl-inset-x-auto{left:auto;right:auto}.sl-inset-y-px{bottom:1px;top:1px}.sl-inset-x-px{left:1px;right:1px}.sl-inset-y-0\\.5{bottom:2px;top:2px}.sl-inset-x-0\\.5{left:2px;right:2px}.sl-inset-y-1\\.5{bottom:6px;top:6px}.sl-inset-x-1\\.5{left:6px;right:6px}.sl-inset-y-2\\.5{bottom:10px;top:10px}.sl-inset-x-2\\.5{left:10px;right:10px}.sl-inset-y-3\\.5{bottom:14px;top:14px}.sl-inset-x-3\\.5{left:14px;right:14px}.sl--inset-y-0{bottom:0;top:0}.sl--inset-x-0{left:0;right:0}.sl--inset-y-1{bottom:-4px;top:-4px}.sl--inset-x-1{left:-4px;right:-4px}.sl--inset-y-2{bottom:-8px;top:-8px}.sl--inset-x-2{left:-8px;right:-8px}.sl--inset-y-3{bottom:-12px;top:-12px}.sl--inset-x-3{left:-12px;right:-12px}.sl--inset-y-4{bottom:-16px;top:-16px}.sl--inset-x-4{left:-16px;right:-16px}.sl--inset-y-5{bottom:-20px;top:-20px}.sl--inset-x-5{left:-20px;right:-20px}.sl--inset-y-6{bottom:-24px;top:-24px}.sl--inset-x-6{left:-24px;right:-24px}.sl--inset-y-7{bottom:-28px;top:-28px}.sl--inset-x-7{left:-28px;right:-28px}.sl--inset-y-8{bottom:-32px;top:-32px}.sl--inset-x-8{left:-32px;right:-32px}.sl--inset-y-9{bottom:-36px;top:-36px}.sl--inset-x-9{left:-36px;right:-36px}.sl--inset-y-10{bottom:-40px;top:-40px}.sl--inset-x-10{left:-40px;right:-40px}.sl--inset-y-11{bottom:-44px;top:-44px}.sl--inset-x-11{left:-44px;right:-44px}.sl--inset-y-12{bottom:-48px;top:-48px}.sl--inset-x-12{left:-48px;right:-48px}.sl--inset-y-14{bottom:-56px;top:-56px}.sl--inset-x-14{left:-56px;right:-56px}.sl--inset-y-16{bottom:-64px;top:-64px}.sl--inset-x-16{left:-64px;right:-64px}.sl--inset-y-20{bottom:-80px;top:-80px}.sl--inset-x-20{left:-80px;right:-80px}.sl--inset-y-24{bottom:-96px;top:-96px}.sl--inset-x-24{left:-96px;right:-96px}.sl--inset-y-32{bottom:-128px;top:-128px}.sl--inset-x-32{left:-128px;right:-128px}.sl--inset-y-40{bottom:-160px;top:-160px}.sl--inset-x-40{left:-160px;right:-160px}.sl--inset-y-60{bottom:-240px;top:-240px}.sl--inset-x-60{left:-240px;right:-240px}.sl--inset-y-80{bottom:-320px;top:-320px}.sl--inset-x-80{left:-320px;right:-320px}.sl--inset-y-px{bottom:-1px;top:-1px}.sl--inset-x-px{left:-1px;right:-1px}.sl--inset-y-0\\.5{bottom:-2px;top:-2px}.sl--inset-x-0\\.5{left:-2px;right:-2px}.sl--inset-y-1\\.5{bottom:-6px;top:-6px}.sl--inset-x-1\\.5{left:-6px;right:-6px}.sl--inset-y-2\\.5{bottom:-10px;top:-10px}.sl--inset-x-2\\.5{left:-10px;right:-10px}.sl--inset-y-3\\.5{bottom:-14px;top:-14px}.sl--inset-x-3\\.5{left:-14px;right:-14px}.sl-top-0{top:0}.sl-right-0{right:0}.sl-bottom-0{bottom:0}.sl-left-0{left:0}.sl-top-1{top:4px}.sl-right-1{right:4px}.sl-bottom-1{bottom:4px}.sl-left-1{left:4px}.sl-top-2{top:8px}.sl-right-2{right:8px}.sl-bottom-2{bottom:8px}.sl-left-2{left:8px}.sl-top-3{top:12px}.sl-right-3{right:12px}.sl-bottom-3{bottom:12px}.sl-left-3{left:12px}.sl-top-4{top:16px}.sl-right-4{right:16px}.sl-bottom-4{bottom:16px}.sl-left-4{left:16px}.sl-top-5{top:20px}.sl-right-5{right:20px}.sl-bottom-5{bottom:20px}.sl-left-5{left:20px}.sl-top-6{top:24px}.sl-right-6{right:24px}.sl-bottom-6{bottom:24px}.sl-left-6{left:24px}.sl-top-7{top:28px}.sl-right-7{right:28px}.sl-bottom-7{bottom:28px}.sl-left-7{left:28px}.sl-top-8{top:32px}.sl-right-8{right:32px}.sl-bottom-8{bottom:32px}.sl-left-8{left:32px}.sl-top-9{top:36px}.sl-right-9{right:36px}.sl-bottom-9{bottom:36px}.sl-left-9{left:36px}.sl-top-10{top:40px}.sl-right-10{right:40px}.sl-bottom-10{bottom:40px}.sl-left-10{left:40px}.sl-top-11{top:44px}.sl-right-11{right:44px}.sl-bottom-11{bottom:44px}.sl-left-11{left:44px}.sl-top-12{top:48px}.sl-right-12{right:48px}.sl-bottom-12{bottom:48px}.sl-left-12{left:48px}.sl-top-14{top:56px}.sl-right-14{right:56px}.sl-bottom-14{bottom:56px}.sl-left-14{left:56px}.sl-top-16{top:64px}.sl-right-16{right:64px}.sl-bottom-16{bottom:64px}.sl-left-16{left:64px}.sl-top-20{top:80px}.sl-right-20{right:80px}.sl-bottom-20{bottom:80px}.sl-left-20{left:80px}.sl-top-24{top:96px}.sl-right-24{right:96px}.sl-bottom-24{bottom:96px}.sl-left-24{left:96px}.sl-top-32{top:128px}.sl-right-32{right:128px}.sl-bottom-32{bottom:128px}.sl-left-32{left:128px}.sl-top-40{top:160px}.sl-right-40{right:160px}.sl-bottom-40{bottom:160px}.sl-left-40{left:160px}.sl-top-60{top:240px}.sl-right-60{right:240px}.sl-bottom-60{bottom:240px}.sl-left-60{left:240px}.sl-top-80{top:320px}.sl-right-80{right:320px}.sl-bottom-80{bottom:320px}.sl-left-80{left:320px}.sl-top-auto{top:auto}.sl-right-auto{right:auto}.sl-bottom-auto{bottom:auto}.sl-left-auto{left:auto}.sl-top-px{top:1px}.sl-right-px{right:1px}.sl-bottom-px{bottom:1px}.sl-left-px{left:1px}.sl-top-0\\.5{top:2px}.sl-right-0\\.5{right:2px}.sl-bottom-0\\.5{bottom:2px}.sl-left-0\\.5{left:2px}.sl-top-1\\.5{top:6px}.sl-right-1\\.5{right:6px}.sl-bottom-1\\.5{bottom:6px}.sl-left-1\\.5{left:6px}.sl-top-2\\.5{top:10px}.sl-right-2\\.5{right:10px}.sl-bottom-2\\.5{bottom:10px}.sl-left-2\\.5{left:10px}.sl-top-3\\.5{top:14px}.sl-right-3\\.5{right:14px}.sl-bottom-3\\.5{bottom:14px}.sl-left-3\\.5{left:14px}.sl--top-0{top:0}.sl--right-0{right:0}.sl--bottom-0{bottom:0}.sl--left-0{left:0}.sl--top-1{top:-4px}.sl--right-1{right:-4px}.sl--bottom-1{bottom:-4px}.sl--left-1{left:-4px}.sl--top-2{top:-8px}.sl--right-2{right:-8px}.sl--bottom-2{bottom:-8px}.sl--left-2{left:-8px}.sl--top-3{top:-12px}.sl--right-3{right:-12px}.sl--bottom-3{bottom:-12px}.sl--left-3{left:-12px}.sl--top-4{top:-16px}.sl--right-4{right:-16px}.sl--bottom-4{bottom:-16px}.sl--left-4{left:-16px}.sl--top-5{top:-20px}.sl--right-5{right:-20px}.sl--bottom-5{bottom:-20px}.sl--left-5{left:-20px}.sl--top-6{top:-24px}.sl--right-6{right:-24px}.sl--bottom-6{bottom:-24px}.sl--left-6{left:-24px}.sl--top-7{top:-28px}.sl--right-7{right:-28px}.sl--bottom-7{bottom:-28px}.sl--left-7{left:-28px}.sl--top-8{top:-32px}.sl--right-8{right:-32px}.sl--bottom-8{bottom:-32px}.sl--left-8{left:-32px}.sl--top-9{top:-36px}.sl--right-9{right:-36px}.sl--bottom-9{bottom:-36px}.sl--left-9{left:-36px}.sl--top-10{top:-40px}.sl--right-10{right:-40px}.sl--bottom-10{bottom:-40px}.sl--left-10{left:-40px}.sl--top-11{top:-44px}.sl--right-11{right:-44px}.sl--bottom-11{bottom:-44px}.sl--left-11{left:-44px}.sl--top-12{top:-48px}.sl--right-12{right:-48px}.sl--bottom-12{bottom:-48px}.sl--left-12{left:-48px}.sl--top-14{top:-56px}.sl--right-14{right:-56px}.sl--bottom-14{bottom:-56px}.sl--left-14{left:-56px}.sl--top-16{top:-64px}.sl--right-16{right:-64px}.sl--bottom-16{bottom:-64px}.sl--left-16{left:-64px}.sl--top-20{top:-80px}.sl--right-20{right:-80px}.sl--bottom-20{bottom:-80px}.sl--left-20{left:-80px}.sl--top-24{top:-96px}.sl--right-24{right:-96px}.sl--bottom-24{bottom:-96px}.sl--left-24{left:-96px}.sl--top-32{top:-128px}.sl--right-32{right:-128px}.sl--bottom-32{bottom:-128px}.sl--left-32{left:-128px}.sl--top-40{top:-160px}.sl--right-40{right:-160px}.sl--bottom-40{bottom:-160px}.sl--left-40{left:-160px}.sl--top-60{top:-240px}.sl--right-60{right:-240px}.sl--bottom-60{bottom:-240px}.sl--left-60{left:-240px}.sl--top-80{top:-320px}.sl--right-80{right:-320px}.sl--bottom-80{bottom:-320px}.sl--left-80{left:-320px}.sl--top-px{top:-1px}.sl--right-px{right:-1px}.sl--bottom-px{bottom:-1px}.sl--left-px{left:-1px}.sl--top-0\\.5{top:-2px}.sl--right-0\\.5{right:-2px}.sl--bottom-0\\.5{bottom:-2px}.sl--left-0\\.5{left:-2px}.sl--top-1\\.5{top:-6px}.sl--right-1\\.5{right:-6px}.sl--bottom-1\\.5{bottom:-6px}.sl--left-1\\.5{left:-6px}.sl--top-2\\.5{top:-10px}.sl--right-2\\.5{right:-10px}.sl--bottom-2\\.5{bottom:-10px}.sl--left-2\\.5{left:-10px}.sl--top-3\\.5{top:-14px}.sl--right-3\\.5{right:-14px}.sl--bottom-3\\.5{bottom:-14px}.sl--left-3\\.5{left:-14px}.sl-justify-start{justify-content:flex-start}.sl-justify-end{justify-content:flex-end}.sl-justify-center{justify-content:center}.sl-justify-between{justify-content:space-between}.sl-justify-around{justify-content:space-around}.sl-justify-evenly{justify-content:space-evenly}.sl-justify-items-start{justify-items:start}.sl-justify-items-end{justify-items:end}.sl-justify-items-center{justify-items:center}.sl-justify-items-stretch{justify-items:stretch}.sl-justify-self-auto{justify-self:auto}.sl-justify-self-start{justify-self:start}.sl-justify-self-end{justify-self:end}.sl-justify-self-center{justify-self:center}.sl-justify-self-stretch{justify-self:stretch}.sl-tracking-tight{letter-spacing:-.025em}.sl-tracking-normal{letter-spacing:0}.sl-tracking-wide{letter-spacing:.025em}.sl-leading-none{line-height:1}.sl-leading-tight{line-height:1.2}.sl-leading-snug{line-height:1.375}.sl-leading-normal{line-height:1.5}.sl-leading-relaxed{line-height:1.625}.sl-leading-loose{line-height:2}.sl-leading-paragraph-leading{line-height:var(--lh-paragraph-leading)}.sl-leading-paragraph{line-height:var(--lh-paragraph)}.sl-leading-paragraph-small{line-height:var(--lh-paragraph-small)}.sl-leading-paragraph-tiny{line-height:var(--lh-paragraph-tiny)}.sl-m-0{margin:0}.sl-m-1{margin:4px}.sl-m-2{margin:8px}.sl-m-3{margin:12px}.sl-m-4{margin:16px}.sl-m-5{margin:20px}.sl-m-6{margin:24px}.sl-m-7{margin:28px}.sl-m-8{margin:32px}.sl-m-9{margin:36px}.sl-m-10{margin:40px}.sl-m-11{margin:44px}.sl-m-12{margin:48px}.sl-m-14{margin:56px}.sl-m-16{margin:64px}.sl-m-20{margin:80px}.sl-m-24{margin:96px}.sl-m-32{margin:128px}.sl-m-40{margin:160px}.sl-m-60{margin:240px}.sl-m-80{margin:320px}.sl-m-auto{margin:auto}.sl-m-px{margin:1px}.sl-m-0\\.5{margin:2px}.sl-m-1\\.5{margin:6px}.sl-m-2\\.5{margin:10px}.sl-m-3\\.5{margin:14px}.sl--m-0{margin:0}.sl--m-1{margin:-4px}.sl--m-2{margin:-8px}.sl--m-3{margin:-12px}.sl--m-4{margin:-16px}.sl--m-5{margin:-20px}.sl--m-6{margin:-24px}.sl--m-7{margin:-28px}.sl--m-8{margin:-32px}.sl--m-9{margin:-36px}.sl--m-10{margin:-40px}.sl--m-11{margin:-44px}.sl--m-12{margin:-48px}.sl--m-14{margin:-56px}.sl--m-16{margin:-64px}.sl--m-20{margin:-80px}.sl--m-24{margin:-96px}.sl--m-32{margin:-128px}.sl--m-40{margin:-160px}.sl--m-60{margin:-240px}.sl--m-80{margin:-320px}.sl--m-px{margin:-1px}.sl--m-0\\.5{margin:-2px}.sl--m-1\\.5{margin:-6px}.sl--m-2\\.5{margin:-10px}.sl--m-3\\.5{margin:-14px}.sl-my-0{margin-bottom:0;margin-top:0}.sl-mx-0{margin-left:0;margin-right:0}.sl-my-1{margin-bottom:4px;margin-top:4px}.sl-mx-1{margin-left:4px;margin-right:4px}.sl-my-2{margin-bottom:8px;margin-top:8px}.sl-mx-2{margin-left:8px;margin-right:8px}.sl-my-3{margin-bottom:12px;margin-top:12px}.sl-mx-3{margin-left:12px;margin-right:12px}.sl-my-4{margin-bottom:16px;margin-top:16px}.sl-mx-4{margin-left:16px;margin-right:16px}.sl-my-5{margin-bottom:20px;margin-top:20px}.sl-mx-5{margin-left:20px;margin-right:20px}.sl-my-6{margin-bottom:24px;margin-top:24px}.sl-mx-6{margin-left:24px;margin-right:24px}.sl-my-7{margin-bottom:28px;margin-top:28px}.sl-mx-7{margin-left:28px;margin-right:28px}.sl-my-8{margin-bottom:32px;margin-top:32px}.sl-mx-8{margin-left:32px;margin-right:32px}.sl-my-9{margin-bottom:36px;margin-top:36px}.sl-mx-9{margin-left:36px;margin-right:36px}.sl-my-10{margin-bottom:40px;margin-top:40px}.sl-mx-10{margin-left:40px;margin-right:40px}.sl-my-11{margin-bottom:44px;margin-top:44px}.sl-mx-11{margin-left:44px;margin-right:44px}.sl-my-12{margin-bottom:48px;margin-top:48px}.sl-mx-12{margin-left:48px;margin-right:48px}.sl-my-14{margin-bottom:56px;margin-top:56px}.sl-mx-14{margin-left:56px;margin-right:56px}.sl-my-16{margin-bottom:64px;margin-top:64px}.sl-mx-16{margin-left:64px;margin-right:64px}.sl-my-20{margin-bottom:80px;margin-top:80px}.sl-mx-20{margin-left:80px;margin-right:80px}.sl-my-24{margin-bottom:96px;margin-top:96px}.sl-mx-24{margin-left:96px;margin-right:96px}.sl-my-32{margin-bottom:128px;margin-top:128px}.sl-mx-32{margin-left:128px;margin-right:128px}.sl-my-40{margin-bottom:160px;margin-top:160px}.sl-mx-40{margin-left:160px;margin-right:160px}.sl-my-60{margin-bottom:240px;margin-top:240px}.sl-mx-60{margin-left:240px;margin-right:240px}.sl-my-80{margin-bottom:320px;margin-top:320px}.sl-mx-80{margin-left:320px;margin-right:320px}.sl-my-auto{margin-bottom:auto;margin-top:auto}.sl-mx-auto{margin-left:auto;margin-right:auto}.sl-my-px{margin-bottom:1px;margin-top:1px}.sl-mx-px{margin-left:1px;margin-right:1px}.sl-my-0\\.5{margin-bottom:2px;margin-top:2px}.sl-mx-0\\.5{margin-left:2px;margin-right:2px}.sl-my-1\\.5{margin-bottom:6px;margin-top:6px}.sl-mx-1\\.5{margin-left:6px;margin-right:6px}.sl-my-2\\.5{margin-bottom:10px;margin-top:10px}.sl-mx-2\\.5{margin-left:10px;margin-right:10px}.sl-my-3\\.5{margin-bottom:14px;margin-top:14px}.sl-mx-3\\.5{margin-left:14px;margin-right:14px}.sl--my-0{margin-bottom:0;margin-top:0}.sl--mx-0{margin-left:0;margin-right:0}.sl--my-1{margin-bottom:-4px;margin-top:-4px}.sl--mx-1{margin-left:-4px;margin-right:-4px}.sl--my-2{margin-bottom:-8px;margin-top:-8px}.sl--mx-2{margin-left:-8px;margin-right:-8px}.sl--my-3{margin-bottom:-12px;margin-top:-12px}.sl--mx-3{margin-left:-12px;margin-right:-12px}.sl--my-4{margin-bottom:-16px;margin-top:-16px}.sl--mx-4{margin-left:-16px;margin-right:-16px}.sl--my-5{margin-bottom:-20px;margin-top:-20px}.sl--mx-5{margin-left:-20px;margin-right:-20px}.sl--my-6{margin-bottom:-24px;margin-top:-24px}.sl--mx-6{margin-left:-24px;margin-right:-24px}.sl--my-7{margin-bottom:-28px;margin-top:-28px}.sl--mx-7{margin-left:-28px;margin-right:-28px}.sl--my-8{margin-bottom:-32px;margin-top:-32px}.sl--mx-8{margin-left:-32px;margin-right:-32px}.sl--my-9{margin-bottom:-36px;margin-top:-36px}.sl--mx-9{margin-left:-36px;margin-right:-36px}.sl--my-10{margin-bottom:-40px;margin-top:-40px}.sl--mx-10{margin-left:-40px;margin-right:-40px}.sl--my-11{margin-bottom:-44px;margin-top:-44px}.sl--mx-11{margin-left:-44px;margin-right:-44px}.sl--my-12{margin-bottom:-48px;margin-top:-48px}.sl--mx-12{margin-left:-48px;margin-right:-48px}.sl--my-14{margin-bottom:-56px;margin-top:-56px}.sl--mx-14{margin-left:-56px;margin-right:-56px}.sl--my-16{margin-bottom:-64px;margin-top:-64px}.sl--mx-16{margin-left:-64px;margin-right:-64px}.sl--my-20{margin-bottom:-80px;margin-top:-80px}.sl--mx-20{margin-left:-80px;margin-right:-80px}.sl--my-24{margin-bottom:-96px;margin-top:-96px}.sl--mx-24{margin-left:-96px;margin-right:-96px}.sl--my-32{margin-bottom:-128px;margin-top:-128px}.sl--mx-32{margin-left:-128px;margin-right:-128px}.sl--my-40{margin-bottom:-160px;margin-top:-160px}.sl--mx-40{margin-left:-160px;margin-right:-160px}.sl--my-60{margin-bottom:-240px;margin-top:-240px}.sl--mx-60{margin-left:-240px;margin-right:-240px}.sl--my-80{margin-bottom:-320px;margin-top:-320px}.sl--mx-80{margin-left:-320px;margin-right:-320px}.sl--my-px{margin-bottom:-1px;margin-top:-1px}.sl--mx-px{margin-left:-1px;margin-right:-1px}.sl--my-0\\.5{margin-bottom:-2px;margin-top:-2px}.sl--mx-0\\.5{margin-left:-2px;margin-right:-2px}.sl--my-1\\.5{margin-bottom:-6px;margin-top:-6px}.sl--mx-1\\.5{margin-left:-6px;margin-right:-6px}.sl--my-2\\.5{margin-bottom:-10px;margin-top:-10px}.sl--mx-2\\.5{margin-left:-10px;margin-right:-10px}.sl--my-3\\.5{margin-bottom:-14px;margin-top:-14px}.sl--mx-3\\.5{margin-left:-14px;margin-right:-14px}.sl-mt-0{margin-top:0}.sl-mr-0{margin-right:0}.sl-mb-0{margin-bottom:0}.sl-ml-0{margin-left:0}.sl-mt-1{margin-top:4px}.sl-mr-1{margin-right:4px}.sl-mb-1{margin-bottom:4px}.sl-ml-1{margin-left:4px}.sl-mt-2{margin-top:8px}.sl-mr-2{margin-right:8px}.sl-mb-2{margin-bottom:8px}.sl-ml-2{margin-left:8px}.sl-mt-3{margin-top:12px}.sl-mr-3{margin-right:12px}.sl-mb-3{margin-bottom:12px}.sl-ml-3{margin-left:12px}.sl-mt-4{margin-top:16px}.sl-mr-4{margin-right:16px}.sl-mb-4{margin-bottom:16px}.sl-ml-4{margin-left:16px}.sl-mt-5{margin-top:20px}.sl-mr-5{margin-right:20px}.sl-mb-5{margin-bottom:20px}.sl-ml-5{margin-left:20px}.sl-mt-6{margin-top:24px}.sl-mr-6{margin-right:24px}.sl-mb-6{margin-bottom:24px}.sl-ml-6{margin-left:24px}.sl-mt-7{margin-top:28px}.sl-mr-7{margin-right:28px}.sl-mb-7{margin-bottom:28px}.sl-ml-7{margin-left:28px}.sl-mt-8{margin-top:32px}.sl-mr-8{margin-right:32px}.sl-mb-8{margin-bottom:32px}.sl-ml-8{margin-left:32px}.sl-mt-9{margin-top:36px}.sl-mr-9{margin-right:36px}.sl-mb-9{margin-bottom:36px}.sl-ml-9{margin-left:36px}.sl-mt-10{margin-top:40px}.sl-mr-10{margin-right:40px}.sl-mb-10{margin-bottom:40px}.sl-ml-10{margin-left:40px}.sl-mt-11{margin-top:44px}.sl-mr-11{margin-right:44px}.sl-mb-11{margin-bottom:44px}.sl-ml-11{margin-left:44px}.sl-mt-12{margin-top:48px}.sl-mr-12{margin-right:48px}.sl-mb-12{margin-bottom:48px}.sl-ml-12{margin-left:48px}.sl-mt-14{margin-top:56px}.sl-mr-14{margin-right:56px}.sl-mb-14{margin-bottom:56px}.sl-ml-14{margin-left:56px}.sl-mt-16{margin-top:64px}.sl-mr-16{margin-right:64px}.sl-mb-16{margin-bottom:64px}.sl-ml-16{margin-left:64px}.sl-mt-20{margin-top:80px}.sl-mr-20{margin-right:80px}.sl-mb-20{margin-bottom:80px}.sl-ml-20{margin-left:80px}.sl-mt-24{margin-top:96px}.sl-mr-24{margin-right:96px}.sl-mb-24{margin-bottom:96px}.sl-ml-24{margin-left:96px}.sl-mt-32{margin-top:128px}.sl-mr-32{margin-right:128px}.sl-mb-32{margin-bottom:128px}.sl-ml-32{margin-left:128px}.sl-mt-40{margin-top:160px}.sl-mr-40{margin-right:160px}.sl-mb-40{margin-bottom:160px}.sl-ml-40{margin-left:160px}.sl-mt-60{margin-top:240px}.sl-mr-60{margin-right:240px}.sl-mb-60{margin-bottom:240px}.sl-ml-60{margin-left:240px}.sl-mt-80{margin-top:320px}.sl-mr-80{margin-right:320px}.sl-mb-80{margin-bottom:320px}.sl-ml-80{margin-left:320px}.sl-mt-auto{margin-top:auto}.sl-mr-auto{margin-right:auto}.sl-mb-auto{margin-bottom:auto}.sl-ml-auto{margin-left:auto}.sl-mt-px{margin-top:1px}.sl-mr-px{margin-right:1px}.sl-mb-px{margin-bottom:1px}.sl-ml-px{margin-left:1px}.sl-mt-0\\.5{margin-top:2px}.sl-mr-0\\.5{margin-right:2px}.sl-mb-0\\.5{margin-bottom:2px}.sl-ml-0\\.5{margin-left:2px}.sl-mt-1\\.5{margin-top:6px}.sl-mr-1\\.5{margin-right:6px}.sl-mb-1\\.5{margin-bottom:6px}.sl-ml-1\\.5{margin-left:6px}.sl-mt-2\\.5{margin-top:10px}.sl-mr-2\\.5{margin-right:10px}.sl-mb-2\\.5{margin-bottom:10px}.sl-ml-2\\.5{margin-left:10px}.sl-mt-3\\.5{margin-top:14px}.sl-mr-3\\.5{margin-right:14px}.sl-mb-3\\.5{margin-bottom:14px}.sl-ml-3\\.5{margin-left:14px}.sl--mt-0{margin-top:0}.sl--mr-0{margin-right:0}.sl--mb-0{margin-bottom:0}.sl--ml-0{margin-left:0}.sl--mt-1{margin-top:-4px}.sl--mr-1{margin-right:-4px}.sl--mb-1{margin-bottom:-4px}.sl--ml-1{margin-left:-4px}.sl--mt-2{margin-top:-8px}.sl--mr-2{margin-right:-8px}.sl--mb-2{margin-bottom:-8px}.sl--ml-2{margin-left:-8px}.sl--mt-3{margin-top:-12px}.sl--mr-3{margin-right:-12px}.sl--mb-3{margin-bottom:-12px}.sl--ml-3{margin-left:-12px}.sl--mt-4{margin-top:-16px}.sl--mr-4{margin-right:-16px}.sl--mb-4{margin-bottom:-16px}.sl--ml-4{margin-left:-16px}.sl--mt-5{margin-top:-20px}.sl--mr-5{margin-right:-20px}.sl--mb-5{margin-bottom:-20px}.sl--ml-5{margin-left:-20px}.sl--mt-6{margin-top:-24px}.sl--mr-6{margin-right:-24px}.sl--mb-6{margin-bottom:-24px}.sl--ml-6{margin-left:-24px}.sl--mt-7{margin-top:-28px}.sl--mr-7{margin-right:-28px}.sl--mb-7{margin-bottom:-28px}.sl--ml-7{margin-left:-28px}.sl--mt-8{margin-top:-32px}.sl--mr-8{margin-right:-32px}.sl--mb-8{margin-bottom:-32px}.sl--ml-8{margin-left:-32px}.sl--mt-9{margin-top:-36px}.sl--mr-9{margin-right:-36px}.sl--mb-9{margin-bottom:-36px}.sl--ml-9{margin-left:-36px}.sl--mt-10{margin-top:-40px}.sl--mr-10{margin-right:-40px}.sl--mb-10{margin-bottom:-40px}.sl--ml-10{margin-left:-40px}.sl--mt-11{margin-top:-44px}.sl--mr-11{margin-right:-44px}.sl--mb-11{margin-bottom:-44px}.sl--ml-11{margin-left:-44px}.sl--mt-12{margin-top:-48px}.sl--mr-12{margin-right:-48px}.sl--mb-12{margin-bottom:-48px}.sl--ml-12{margin-left:-48px}.sl--mt-14{margin-top:-56px}.sl--mr-14{margin-right:-56px}.sl--mb-14{margin-bottom:-56px}.sl--ml-14{margin-left:-56px}.sl--mt-16{margin-top:-64px}.sl--mr-16{margin-right:-64px}.sl--mb-16{margin-bottom:-64px}.sl--ml-16{margin-left:-64px}.sl--mt-20{margin-top:-80px}.sl--mr-20{margin-right:-80px}.sl--mb-20{margin-bottom:-80px}.sl--ml-20{margin-left:-80px}.sl--mt-24{margin-top:-96px}.sl--mr-24{margin-right:-96px}.sl--mb-24{margin-bottom:-96px}.sl--ml-24{margin-left:-96px}.sl--mt-32{margin-top:-128px}.sl--mr-32{margin-right:-128px}.sl--mb-32{margin-bottom:-128px}.sl--ml-32{margin-left:-128px}.sl--mt-40{margin-top:-160px}.sl--mr-40{margin-right:-160px}.sl--mb-40{margin-bottom:-160px}.sl--ml-40{margin-left:-160px}.sl--mt-60{margin-top:-240px}.sl--mr-60{margin-right:-240px}.sl--mb-60{margin-bottom:-240px}.sl--ml-60{margin-left:-240px}.sl--mt-80{margin-top:-320px}.sl--mr-80{margin-right:-320px}.sl--mb-80{margin-bottom:-320px}.sl--ml-80{margin-left:-320px}.sl--mt-px{margin-top:-1px}.sl--mr-px{margin-right:-1px}.sl--mb-px{margin-bottom:-1px}.sl--ml-px{margin-left:-1px}.sl--mt-0\\.5{margin-top:-2px}.sl--mr-0\\.5{margin-right:-2px}.sl--mb-0\\.5{margin-bottom:-2px}.sl--ml-0\\.5{margin-left:-2px}.sl--mt-1\\.5{margin-top:-6px}.sl--mr-1\\.5{margin-right:-6px}.sl--mb-1\\.5{margin-bottom:-6px}.sl--ml-1\\.5{margin-left:-6px}.sl--mt-2\\.5{margin-top:-10px}.sl--mr-2\\.5{margin-right:-10px}.sl--mb-2\\.5{margin-bottom:-10px}.sl--ml-2\\.5{margin-left:-10px}.sl--mt-3\\.5{margin-top:-14px}.sl--mr-3\\.5{margin-right:-14px}.sl--mb-3\\.5{margin-bottom:-14px}.sl--ml-3\\.5{margin-left:-14px}.sl-max-h-full{max-height:100%}.sl-max-h-screen{max-height:100vh}.sl-max-w-none{max-width:none}.sl-max-w-full{max-width:100%}.sl-max-w-min{max-width:-moz-min-content;max-width:min-content}.sl-max-w-max{max-width:-moz-max-content;max-width:max-content}.sl-max-w-prose{max-width:65ch}.sl-min-h-full{min-height:100%}.sl-min-h-screen{min-height:100vh}.sl-min-w-full{min-width:100%}.sl-min-w-min{min-width:-moz-min-content;min-width:min-content}.sl-min-w-max{min-width:-moz-max-content;min-width:max-content}.sl-object-contain{object-fit:contain}.sl-object-cover{object-fit:cover}.sl-object-fill{object-fit:fill}.sl-object-none{object-fit:none}.sl-object-scale-down{object-fit:scale-down}.sl-object-bottom{object-position:bottom}.sl-object-center{object-position:center}.sl-object-left{object-position:left}.sl-object-left-bottom{object-position:left bottom}.sl-object-left-top{object-position:left top}.sl-object-right{object-position:right}.sl-object-right-bottom{object-position:right bottom}.sl-object-right-top{object-position:right top}.sl-object-top{object-position:top}.sl-opacity-0{opacity:0}.sl-opacity-5{opacity:.05}.sl-opacity-10{opacity:.1}.sl-opacity-20{opacity:.2}.sl-opacity-30{opacity:.3}.sl-opacity-40{opacity:.4}.sl-opacity-50{opacity:.5}.sl-opacity-60{opacity:.6}.sl-opacity-70{opacity:.7}.sl-opacity-90{opacity:.9}.sl-opacity-100{opacity:1}.hover\\:sl-opacity-0:hover{opacity:0}.hover\\:sl-opacity-5:hover{opacity:.05}.hover\\:sl-opacity-10:hover{opacity:.1}.hover\\:sl-opacity-20:hover{opacity:.2}.hover\\:sl-opacity-30:hover{opacity:.3}.hover\\:sl-opacity-40:hover{opacity:.4}.hover\\:sl-opacity-50:hover{opacity:.5}.hover\\:sl-opacity-60:hover{opacity:.6}.hover\\:sl-opacity-70:hover{opacity:.7}.hover\\:sl-opacity-90:hover{opacity:.9}.hover\\:sl-opacity-100:hover{opacity:1}.focus\\:sl-opacity-0:focus{opacity:0}.focus\\:sl-opacity-5:focus{opacity:.05}.focus\\:sl-opacity-10:focus{opacity:.1}.focus\\:sl-opacity-20:focus{opacity:.2}.focus\\:sl-opacity-30:focus{opacity:.3}.focus\\:sl-opacity-40:focus{opacity:.4}.focus\\:sl-opacity-50:focus{opacity:.5}.focus\\:sl-opacity-60:focus{opacity:.6}.focus\\:sl-opacity-70:focus{opacity:.7}.focus\\:sl-opacity-90:focus{opacity:.9}.focus\\:sl-opacity-100:focus{opacity:1}.active\\:sl-opacity-0:active{opacity:0}.active\\:sl-opacity-5:active{opacity:.05}.active\\:sl-opacity-10:active{opacity:.1}.active\\:sl-opacity-20:active{opacity:.2}.active\\:sl-opacity-30:active{opacity:.3}.active\\:sl-opacity-40:active{opacity:.4}.active\\:sl-opacity-50:active{opacity:.5}.active\\:sl-opacity-60:active{opacity:.6}.active\\:sl-opacity-70:active{opacity:.7}.active\\:sl-opacity-90:active{opacity:.9}.active\\:sl-opacity-100:active{opacity:1}.disabled\\:sl-opacity-0:disabled{opacity:0}.disabled\\:sl-opacity-5:disabled{opacity:.05}.disabled\\:sl-opacity-10:disabled{opacity:.1}.disabled\\:sl-opacity-20:disabled{opacity:.2}.disabled\\:sl-opacity-30:disabled{opacity:.3}.disabled\\:sl-opacity-40:disabled{opacity:.4}.disabled\\:sl-opacity-50:disabled{opacity:.5}.disabled\\:sl-opacity-60:disabled{opacity:.6}.disabled\\:sl-opacity-70:disabled{opacity:.7}.disabled\\:sl-opacity-90:disabled{opacity:.9}.disabled\\:sl-opacity-100:disabled{opacity:1}.sl-outline-none{outline:2px solid transparent;outline-offset:2px}.sl-overflow-auto{overflow:auto}.sl-overflow-hidden{overflow:hidden}.sl-overflow-visible{overflow:visible}.sl-overflow-scroll{overflow:scroll}.sl-overflow-x-auto{overflow-x:auto}.sl-overflow-y-auto{overflow-y:auto}.sl-overflow-x-hidden{overflow-x:hidden}.sl-overflow-y-hidden{overflow-y:hidden}.sl-overflow-x-visible{overflow-x:visible}.sl-overflow-y-visible{overflow-y:visible}.sl-overflow-x-scroll{overflow-x:scroll}.sl-overflow-y-scroll{overflow-y:scroll}.sl-overscroll-auto{overscroll-behavior:auto}.sl-overscroll-contain{overscroll-behavior:contain}.sl-overscroll-none{overscroll-behavior:none}.sl-overscroll-y-auto{overscroll-behavior-y:auto}.sl-overscroll-y-contain{overscroll-behavior-y:contain}.sl-overscroll-y-none{overscroll-behavior-y:none}.sl-overscroll-x-auto{overscroll-behavior-x:auto}.sl-overscroll-x-contain{overscroll-behavior-x:contain}.sl-overscroll-x-none{overscroll-behavior-x:none}.sl-p-0{padding:0}.sl-p-1{padding:4px}.sl-p-2{padding:8px}.sl-p-3{padding:12px}.sl-p-4{padding:16px}.sl-p-5{padding:20px}.sl-p-6{padding:24px}.sl-p-7{padding:28px}.sl-p-8{padding:32px}.sl-p-9{padding:36px}.sl-p-10{padding:40px}.sl-p-11{padding:44px}.sl-p-12{padding:48px}.sl-p-14{padding:56px}.sl-p-16{padding:64px}.sl-p-20{padding:80px}.sl-p-24{padding:96px}.sl-p-32{padding:128px}.sl-p-40{padding:160px}.sl-p-60{padding:240px}.sl-p-80{padding:320px}.sl-p-px{padding:1px}.sl-p-0\\.5{padding:2px}.sl-p-1\\.5{padding:6px}.sl-p-2\\.5{padding:10px}.sl-p-3\\.5{padding:14px}.sl-py-0{padding-bottom:0;padding-top:0}.sl-px-0{padding-left:0;padding-right:0}.sl-py-1{padding-bottom:4px;padding-top:4px}.sl-px-1{padding-left:4px;padding-right:4px}.sl-py-2{padding-bottom:8px;padding-top:8px}.sl-px-2{padding-left:8px;padding-right:8px}.sl-py-3{padding-bottom:12px;padding-top:12px}.sl-px-3{padding-left:12px;padding-right:12px}.sl-py-4{padding-bottom:16px;padding-top:16px}.sl-px-4{padding-left:16px;padding-right:16px}.sl-py-5{padding-bottom:20px;padding-top:20px}.sl-px-5{padding-left:20px;padding-right:20px}.sl-py-6{padding-bottom:24px;padding-top:24px}.sl-px-6{padding-left:24px;padding-right:24px}.sl-py-7{padding-bottom:28px;padding-top:28px}.sl-px-7{padding-left:28px;padding-right:28px}.sl-py-8{padding-bottom:32px;padding-top:32px}.sl-px-8{padding-left:32px;padding-right:32px}.sl-py-9{padding-bottom:36px;padding-top:36px}.sl-px-9{padding-left:36px;padding-right:36px}.sl-py-10{padding-bottom:40px;padding-top:40px}.sl-px-10{padding-left:40px;padding-right:40px}.sl-py-11{padding-bottom:44px;padding-top:44px}.sl-px-11{padding-left:44px;padding-right:44px}.sl-py-12{padding-bottom:48px;padding-top:48px}.sl-px-12{padding-left:48px;padding-right:48px}.sl-py-14{padding-bottom:56px;padding-top:56px}.sl-px-14{padding-left:56px;padding-right:56px}.sl-py-16{padding-bottom:64px;padding-top:64px}.sl-px-16{padding-left:64px;padding-right:64px}.sl-py-20{padding-bottom:80px;padding-top:80px}.sl-px-20{padding-left:80px;padding-right:80px}.sl-py-24{padding-bottom:96px;padding-top:96px}.sl-px-24{padding-left:96px;padding-right:96px}.sl-py-32{padding-bottom:128px;padding-top:128px}.sl-px-32{padding-left:128px;padding-right:128px}.sl-py-40{padding-bottom:160px;padding-top:160px}.sl-px-40{padding-left:160px;padding-right:160px}.sl-py-60{padding-bottom:240px;padding-top:240px}.sl-px-60{padding-left:240px;padding-right:240px}.sl-py-80{padding-bottom:320px;padding-top:320px}.sl-px-80{padding-left:320px;padding-right:320px}.sl-py-px{padding-bottom:1px;padding-top:1px}.sl-px-px{padding-left:1px;padding-right:1px}.sl-py-0\\.5{padding-bottom:2px;padding-top:2px}.sl-px-0\\.5{padding-left:2px;padding-right:2px}.sl-py-1\\.5{padding-bottom:6px;padding-top:6px}.sl-px-1\\.5{padding-left:6px;padding-right:6px}.sl-py-2\\.5{padding-bottom:10px;padding-top:10px}.sl-px-2\\.5{padding-left:10px;padding-right:10px}.sl-py-3\\.5{padding-bottom:14px;padding-top:14px}.sl-px-3\\.5{padding-left:14px;padding-right:14px}.sl-pt-0{padding-top:0}.sl-pr-0{padding-right:0}.sl-pb-0{padding-bottom:0}.sl-pl-0{padding-left:0}.sl-pt-1{padding-top:4px}.sl-pr-1{padding-right:4px}.sl-pb-1{padding-bottom:4px}.sl-pl-1{padding-left:4px}.sl-pt-2{padding-top:8px}.sl-pr-2{padding-right:8px}.sl-pb-2{padding-bottom:8px}.sl-pl-2{padding-left:8px}.sl-pt-3{padding-top:12px}.sl-pr-3{padding-right:12px}.sl-pb-3{padding-bottom:12px}.sl-pl-3{padding-left:12px}.sl-pt-4{padding-top:16px}.sl-pr-4{padding-right:16px}.sl-pb-4{padding-bottom:16px}.sl-pl-4{padding-left:16px}.sl-pt-5{padding-top:20px}.sl-pr-5{padding-right:20px}.sl-pb-5{padding-bottom:20px}.sl-pl-5{padding-left:20px}.sl-pt-6{padding-top:24px}.sl-pr-6{padding-right:24px}.sl-pb-6{padding-bottom:24px}.sl-pl-6{padding-left:24px}.sl-pt-7{padding-top:28px}.sl-pr-7{padding-right:28px}.sl-pb-7{padding-bottom:28px}.sl-pl-7{padding-left:28px}.sl-pt-8{padding-top:32px}.sl-pr-8{padding-right:32px}.sl-pb-8{padding-bottom:32px}.sl-pl-8{padding-left:32px}.sl-pt-9{padding-top:36px}.sl-pr-9{padding-right:36px}.sl-pb-9{padding-bottom:36px}.sl-pl-9{padding-left:36px}.sl-pt-10{padding-top:40px}.sl-pr-10{padding-right:40px}.sl-pb-10{padding-bottom:40px}.sl-pl-10{padding-left:40px}.sl-pt-11{padding-top:44px}.sl-pr-11{padding-right:44px}.sl-pb-11{padding-bottom:44px}.sl-pl-11{padding-left:44px}.sl-pt-12{padding-top:48px}.sl-pr-12{padding-right:48px}.sl-pb-12{padding-bottom:48px}.sl-pl-12{padding-left:48px}.sl-pt-14{padding-top:56px}.sl-pr-14{padding-right:56px}.sl-pb-14{padding-bottom:56px}.sl-pl-14{padding-left:56px}.sl-pt-16{padding-top:64px}.sl-pr-16{padding-right:64px}.sl-pb-16{padding-bottom:64px}.sl-pl-16{padding-left:64px}.sl-pt-20{padding-top:80px}.sl-pr-20{padding-right:80px}.sl-pb-20{padding-bottom:80px}.sl-pl-20{padding-left:80px}.sl-pt-24{padding-top:96px}.sl-pr-24{padding-right:96px}.sl-pb-24{padding-bottom:96px}.sl-pl-24{padding-left:96px}.sl-pt-32{padding-top:128px}.sl-pr-32{padding-right:128px}.sl-pb-32{padding-bottom:128px}.sl-pl-32{padding-left:128px}.sl-pt-40{padding-top:160px}.sl-pr-40{padding-right:160px}.sl-pb-40{padding-bottom:160px}.sl-pl-40{padding-left:160px}.sl-pt-60{padding-top:240px}.sl-pr-60{padding-right:240px}.sl-pb-60{padding-bottom:240px}.sl-pl-60{padding-left:240px}.sl-pt-80{padding-top:320px}.sl-pr-80{padding-right:320px}.sl-pb-80{padding-bottom:320px}.sl-pl-80{padding-left:320px}.sl-pt-px{padding-top:1px}.sl-pr-px{padding-right:1px}.sl-pb-px{padding-bottom:1px}.sl-pl-px{padding-left:1px}.sl-pt-0\\.5{padding-top:2px}.sl-pr-0\\.5{padding-right:2px}.sl-pb-0\\.5{padding-bottom:2px}.sl-pl-0\\.5{padding-left:2px}.sl-pt-1\\.5{padding-top:6px}.sl-pr-1\\.5{padding-right:6px}.sl-pb-1\\.5{padding-bottom:6px}.sl-pl-1\\.5{padding-left:6px}.sl-pt-2\\.5{padding-top:10px}.sl-pr-2\\.5{padding-right:10px}.sl-pb-2\\.5{padding-bottom:10px}.sl-pl-2\\.5{padding-left:10px}.sl-pt-3\\.5{padding-top:14px}.sl-pr-3\\.5{padding-right:14px}.sl-pb-3\\.5{padding-bottom:14px}.sl-pl-3\\.5{padding-left:14px}.sl-placeholder::-ms-input-placeholder{color:var(--color-text-light)}.sl-placeholder::placeholder{color:var(--color-text-light)}.sl-placeholder-primary::-ms-input-placeholder{color:#3898ff ;}.sl-placeholder-primary::placeholder{color:#3898ff ;}.sl-placeholder-success::-ms-input-placeholder{color:#0ea06f ;}.sl-placeholder-success::placeholder{color:#0ea06f ;}.sl-placeholder-warning::-ms-input-placeholder{color:#f3602b ;}.sl-placeholder-warning::placeholder{color:#f3602b ;}.sl-placeholder-danger::-ms-input-placeholder{color:#f05151 ;}.sl-placeholder-danger::placeholder{color:#f05151 ;}.sl-pointer-events-none{pointer-events:none}.sl-pointer-events-auto{pointer-events:auto}.sl-static{position:static}.sl-fixed{position:fixed}.sl-absolute{position:absolute}.sl-relative{position:relative}.sl-sticky{position:-webkit-sticky;position:sticky}.sl-resize-none{resize:none}.sl-resize-y{resize:vertical}.sl-resize-x{resize:horizontal}.sl-resize{resize:both}.sl-ring-primary{--tw-ring-color:hsla(var(--primary-h),80%,61%,var(--tw-ring-opacity)) ;}.sl-ring-success{--tw-ring-color:hsla(var(--success-h),84%,34%,var(--tw-ring-opacity)) ;}.sl-ring-warning{--tw-ring-color:hsla(var(--warning-h),89%,56%,var(--tw-ring-opacity)) ;}.sl-ring-danger{--tw-ring-color:hsla(var(--danger-h),84%,63%,var(--tw-ring-opacity)) ;}.focus\\:sl-ring-primary:focus{--tw-ring-color:hsla(var(--primary-h),80%,61%,var(--tw-ring-opacity)) ;}.focus\\:sl-ring-success:focus{--tw-ring-color:hsla(var(--success-h),84%,34%,var(--tw-ring-opacity)) ;}.focus\\:sl-ring-warning:focus{--tw-ring-color:hsla(var(--warning-h),89%,56%,var(--tw-ring-opacity)) ;}.focus\\:sl-ring-danger:focus{--tw-ring-color:hsla(var(--danger-h),84%,63%,var(--tw-ring-opacity)) ;}.sl-ring-opacity-0{--tw-ring-opacity:0}.sl-ring-opacity-5{--tw-ring-opacity:0.05}.sl-ring-opacity-10{--tw-ring-opacity:0.1}.sl-ring-opacity-20{--tw-ring-opacity:0.2}.sl-ring-opacity-30{--tw-ring-opacity:0.3}.sl-ring-opacity-40{--tw-ring-opacity:0.4}.sl-ring-opacity-50{--tw-ring-opacity:0.5}.sl-ring-opacity-60{--tw-ring-opacity:0.6}.sl-ring-opacity-70{--tw-ring-opacity:0.7}.sl-ring-opacity-90{--tw-ring-opacity:0.9}.sl-ring-opacity-100{--tw-ring-opacity:1}.focus\\:sl-ring-opacity-0:focus{--tw-ring-opacity:0}.focus\\:sl-ring-opacity-5:focus{--tw-ring-opacity:0.05}.focus\\:sl-ring-opacity-10:focus{--tw-ring-opacity:0.1}.focus\\:sl-ring-opacity-20:focus{--tw-ring-opacity:0.2}.focus\\:sl-ring-opacity-30:focus{--tw-ring-opacity:0.3}.focus\\:sl-ring-opacity-40:focus{--tw-ring-opacity:0.4}.focus\\:sl-ring-opacity-50:focus{--tw-ring-opacity:0.5}.focus\\:sl-ring-opacity-60:focus{--tw-ring-opacity:0.6}.focus\\:sl-ring-opacity-70:focus{--tw-ring-opacity:0.7}.focus\\:sl-ring-opacity-90:focus{--tw-ring-opacity:0.9}.focus\\:sl-ring-opacity-100:focus{--tw-ring-opacity:1}*{--tw-ring-inset:var(--tw-empty,/*!*/ /*!*/);--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-color:rgba(147,197,253,0.5);--tw-ring-offset-shadow:0 0 #0000;--tw-ring-shadow:0 0 #0000}.sl-ring{--tw-ring-offset-shadow:var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow:var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow,0 0 #0000)}.sl-ring-inset{--tw-ring-inset:inset}.focus\\:sl-ring:focus{--tw-ring-offset-shadow:var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow:var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow,0 0 #0000)}.focus\\:sl-ring-inset:focus{--tw-ring-inset:inset}.sl-stroke-transparent{stroke:transparent}.sl-stroke-current{stroke:currentColor}.sl-stroke-lighten-100{stroke:var(--color-lighten-100)}.sl-stroke-darken-100{stroke:var(--color-darken-100)}.sl-stroke-primary{stroke:var(--color-primary)}.sl-stroke-primary-tint{stroke:var(--color-primary-tint)}.sl-stroke-primary-light{stroke:var(--color-primary-light)}.sl-stroke-primary-dark{stroke:var(--color-primary-dark)}.sl-stroke-primary-darker{stroke:var(--color-primary-darker)}.sl-stroke-success{stroke:var(--color-success)}.sl-stroke-success-tint{stroke:var(--color-success-tint)}.sl-stroke-success-light{stroke:var(--color-success-light)}.sl-stroke-success-dark{stroke:var(--color-success-dark)}.sl-stroke-success-darker{stroke:var(--color-success-darker)}.sl-stroke-warning{stroke:var(--color-warning)}.sl-stroke-warning-tint{stroke:var(--color-warning-tint)}.sl-stroke-warning-light{stroke:var(--color-warning-light)}.sl-stroke-warning-dark{stroke:var(--color-warning-dark)}.sl-stroke-warning-darker{stroke:var(--color-warning-darker)}.sl-stroke-danger{stroke:var(--color-danger)}.sl-stroke-danger-tint{stroke:var(--color-danger-tint)}.sl-stroke-danger-light{stroke:var(--color-danger-light)}.sl-stroke-danger-dark{stroke:var(--color-danger-dark)}.sl-stroke-danger-darker{stroke:var(--color-danger-darker)}.sl-stroke-code{stroke:var(--color-code)}.sl-stroke-on-code{stroke:var(--color-on-code)}.sl-stroke-on-primary{stroke:var(--color-on-primary)}.sl-stroke-on-success{stroke:var(--color-on-success)}.sl-stroke-on-warning{stroke:var(--color-on-warning)}.sl-stroke-on-danger{stroke:var(--color-on-danger)}.sl-stroke-text{stroke:var(--color-text)}.sl-table-auto{table-layout:auto}.sl-table-fixed{table-layout:fixed}.sl-text-left{text-align:left}.sl-text-center{text-align:center}.sl-text-right{text-align:right}.sl-text-justify{text-align:justify}.sl-text-transparent{color:transparent}.sl-text-current{color:currentColor}.sl-text-lighten-100{color:var(--color-lighten-100)}.sl-text-darken-100{color:var(--color-darken-100)}.sl-text-primary{color:var(--color-primary)}.sl-text-primary-tint{color:var(--color-primary-tint)}.sl-text-primary-light{color:var(--color-primary-light)}.sl-text-primary-dark{color:var(--color-primary-dark)}.sl-text-primary-darker{color:var(--color-primary-darker)}.sl-text-success{color:var(--color-success)}.sl-text-success-tint{color:var(--color-success-tint)}.sl-text-success-light{color:var(--color-success-light)}.sl-text-success-dark{color:var(--color-success-dark)}.sl-text-success-darker{color:var(--color-success-darker)}.sl-text-warning{color:var(--color-warning)}.sl-text-warning-tint{color:var(--color-warning-tint)}.sl-text-warning-light{color:var(--color-warning-light)}.sl-text-warning-dark{color:var(--color-warning-dark)}.sl-text-warning-darker{color:var(--color-warning-darker)}.sl-text-danger{color:var(--color-danger)}.sl-text-danger-tint{color:var(--color-danger-tint)}.sl-text-danger-light{color:var(--color-danger-light)}.sl-text-danger-dark{color:var(--color-danger-dark)}.sl-text-danger-darker{color:var(--color-danger-darker)}.sl-text-code{color:var(--color-code)}.sl-text-on-code{color:var(--color-on-code)}.sl-text-on-primary{color:var(--color-on-primary)}.sl-text-on-success{color:var(--color-on-success)}.sl-text-on-warning{color:var(--color-on-warning)}.sl-text-on-danger{color:var(--color-on-danger)}.sl-text-body{color:var(--color-text)}.sl-text-muted{color:var(--color-text-muted)}.sl-text-light{color:var(--color-text-light)}.sl-text-heading{color:var(--color-text-heading)}.sl-text-paragraph{color:var(--color-text-paragraph)}.sl-text-canvas-50{color:var(--color-canvas-50)}.sl-text-canvas-100{color:var(--color-canvas-100)}.sl-text-canvas-200{color:var(--color-canvas-200)}.sl-text-canvas-300{color:var(--color-canvas-300)}.sl-text-canvas-pure{color:var(--color-canvas-pure)}.sl-text-canvas{color:var(--color-canvas)}.sl-text-canvas-dialog{color:var(--color-canvas-dialog)}.sl-text-link{color:var(--color-link)}.sl-text-link-dark{color:var(--color-link-dark)}.hover\\:sl-text-transparent:hover{color:transparent}.hover\\:sl-text-current:hover{color:currentColor}.hover\\:sl-text-lighten-100:hover{color:var(--color-lighten-100)}.hover\\:sl-text-darken-100:hover{color:var(--color-darken-100)}.hover\\:sl-text-primary:hover{color:var(--color-primary)}.hover\\:sl-text-primary-tint:hover{color:var(--color-primary-tint)}.hover\\:sl-text-primary-light:hover{color:var(--color-primary-light)}.hover\\:sl-text-primary-dark:hover{color:var(--color-primary-dark)}.hover\\:sl-text-primary-darker:hover{color:var(--color-primary-darker)}.hover\\:sl-text-success:hover{color:var(--color-success)}.hover\\:sl-text-success-tint:hover{color:var(--color-success-tint)}.hover\\:sl-text-success-light:hover{color:var(--color-success-light)}.hover\\:sl-text-success-dark:hover{color:var(--color-success-dark)}.hover\\:sl-text-success-darker:hover{color:var(--color-success-darker)}.hover\\:sl-text-warning:hover{color:var(--color-warning)}.hover\\:sl-text-warning-tint:hover{color:var(--color-warning-tint)}.hover\\:sl-text-warning-light:hover{color:var(--color-warning-light)}.hover\\:sl-text-warning-dark:hover{color:var(--color-warning-dark)}.hover\\:sl-text-warning-darker:hover{color:var(--color-warning-darker)}.hover\\:sl-text-danger:hover{color:var(--color-danger)}.hover\\:sl-text-danger-tint:hover{color:var(--color-danger-tint)}.hover\\:sl-text-danger-light:hover{color:var(--color-danger-light)}.hover\\:sl-text-danger-dark:hover{color:var(--color-danger-dark)}.hover\\:sl-text-danger-darker:hover{color:var(--color-danger-darker)}.hover\\:sl-text-code:hover{color:var(--color-code)}.hover\\:sl-text-on-code:hover{color:var(--color-on-code)}.hover\\:sl-text-on-primary:hover{color:var(--color-on-primary)}.hover\\:sl-text-on-success:hover{color:var(--color-on-success)}.hover\\:sl-text-on-warning:hover{color:var(--color-on-warning)}.hover\\:sl-text-on-danger:hover{color:var(--color-on-danger)}.hover\\:sl-text-body:hover{color:var(--color-text)}.hover\\:sl-text-muted:hover{color:var(--color-text-muted)}.hover\\:sl-text-light:hover{color:var(--color-text-light)}.hover\\:sl-text-heading:hover{color:var(--color-text-heading)}.hover\\:sl-text-paragraph:hover{color:var(--color-text-paragraph)}.hover\\:sl-text-canvas-50:hover{color:var(--color-canvas-50)}.hover\\:sl-text-canvas-100:hover{color:var(--color-canvas-100)}.hover\\:sl-text-canvas-200:hover{color:var(--color-canvas-200)}.hover\\:sl-text-canvas-300:hover{color:var(--color-canvas-300)}.hover\\:sl-text-canvas-pure:hover{color:var(--color-canvas-pure)}.hover\\:sl-text-canvas:hover{color:var(--color-canvas)}.hover\\:sl-text-canvas-dialog:hover{color:var(--color-canvas-dialog)}.hover\\:sl-text-link:hover{color:var(--color-link)}.hover\\:sl-text-link-dark:hover{color:var(--color-link-dark)}.focus\\:sl-text-transparent:focus{color:transparent}.focus\\:sl-text-current:focus{color:currentColor}.focus\\:sl-text-lighten-100:focus{color:var(--color-lighten-100)}.focus\\:sl-text-darken-100:focus{color:var(--color-darken-100)}.focus\\:sl-text-primary:focus{color:var(--color-primary)}.focus\\:sl-text-primary-tint:focus{color:var(--color-primary-tint)}.focus\\:sl-text-primary-light:focus{color:var(--color-primary-light)}.focus\\:sl-text-primary-dark:focus{color:var(--color-primary-dark)}.focus\\:sl-text-primary-darker:focus{color:var(--color-primary-darker)}.focus\\:sl-text-success:focus{color:var(--color-success)}.focus\\:sl-text-success-tint:focus{color:var(--color-success-tint)}.focus\\:sl-text-success-light:focus{color:var(--color-success-light)}.focus\\:sl-text-success-dark:focus{color:var(--color-success-dark)}.focus\\:sl-text-success-darker:focus{color:var(--color-success-darker)}.focus\\:sl-text-warning:focus{color:var(--color-warning)}.focus\\:sl-text-warning-tint:focus{color:var(--color-warning-tint)}.focus\\:sl-text-warning-light:focus{color:var(--color-warning-light)}.focus\\:sl-text-warning-dark:focus{color:var(--color-warning-dark)}.focus\\:sl-text-warning-darker:focus{color:var(--color-warning-darker)}.focus\\:sl-text-danger:focus{color:var(--color-danger)}.focus\\:sl-text-danger-tint:focus{color:var(--color-danger-tint)}.focus\\:sl-text-danger-light:focus{color:var(--color-danger-light)}.focus\\:sl-text-danger-dark:focus{color:var(--color-danger-dark)}.focus\\:sl-text-danger-darker:focus{color:var(--color-danger-darker)}.focus\\:sl-text-code:focus{color:var(--color-code)}.focus\\:sl-text-on-code:focus{color:var(--color-on-code)}.focus\\:sl-text-on-primary:focus{color:var(--color-on-primary)}.focus\\:sl-text-on-success:focus{color:var(--color-on-success)}.focus\\:sl-text-on-warning:focus{color:var(--color-on-warning)}.focus\\:sl-text-on-danger:focus{color:var(--color-on-danger)}.focus\\:sl-text-body:focus{color:var(--color-text)}.focus\\:sl-text-muted:focus{color:var(--color-text-muted)}.focus\\:sl-text-light:focus{color:var(--color-text-light)}.focus\\:sl-text-heading:focus{color:var(--color-text-heading)}.focus\\:sl-text-paragraph:focus{color:var(--color-text-paragraph)}.focus\\:sl-text-canvas-50:focus{color:var(--color-canvas-50)}.focus\\:sl-text-canvas-100:focus{color:var(--color-canvas-100)}.focus\\:sl-text-canvas-200:focus{color:var(--color-canvas-200)}.focus\\:sl-text-canvas-300:focus{color:var(--color-canvas-300)}.focus\\:sl-text-canvas-pure:focus{color:var(--color-canvas-pure)}.focus\\:sl-text-canvas:focus{color:var(--color-canvas)}.focus\\:sl-text-canvas-dialog:focus{color:var(--color-canvas-dialog)}.focus\\:sl-text-link:focus{color:var(--color-link)}.focus\\:sl-text-link-dark:focus{color:var(--color-link-dark)}.disabled\\:sl-text-transparent:disabled{color:transparent}.disabled\\:sl-text-current:disabled{color:currentColor}.disabled\\:sl-text-lighten-100:disabled{color:var(--color-lighten-100)}.disabled\\:sl-text-darken-100:disabled{color:var(--color-darken-100)}.disabled\\:sl-text-primary:disabled{color:var(--color-primary)}.disabled\\:sl-text-primary-tint:disabled{color:var(--color-primary-tint)}.disabled\\:sl-text-primary-light:disabled{color:var(--color-primary-light)}.disabled\\:sl-text-primary-dark:disabled{color:var(--color-primary-dark)}.disabled\\:sl-text-primary-darker:disabled{color:var(--color-primary-darker)}.disabled\\:sl-text-success:disabled{color:var(--color-success)}.disabled\\:sl-text-success-tint:disabled{color:var(--color-success-tint)}.disabled\\:sl-text-success-light:disabled{color:var(--color-success-light)}.disabled\\:sl-text-success-dark:disabled{color:var(--color-success-dark)}.disabled\\:sl-text-success-darker:disabled{color:var(--color-success-darker)}.disabled\\:sl-text-warning:disabled{color:var(--color-warning)}.disabled\\:sl-text-warning-tint:disabled{color:var(--color-warning-tint)}.disabled\\:sl-text-warning-light:disabled{color:var(--color-warning-light)}.disabled\\:sl-text-warning-dark:disabled{color:var(--color-warning-dark)}.disabled\\:sl-text-warning-darker:disabled{color:var(--color-warning-darker)}.disabled\\:sl-text-danger:disabled{color:var(--color-danger)}.disabled\\:sl-text-danger-tint:disabled{color:var(--color-danger-tint)}.disabled\\:sl-text-danger-light:disabled{color:var(--color-danger-light)}.disabled\\:sl-text-danger-dark:disabled{color:var(--color-danger-dark)}.disabled\\:sl-text-danger-darker:disabled{color:var(--color-danger-darker)}.disabled\\:sl-text-code:disabled{color:var(--color-code)}.disabled\\:sl-text-on-code:disabled{color:var(--color-on-code)}.disabled\\:sl-text-on-primary:disabled{color:var(--color-on-primary)}.disabled\\:sl-text-on-success:disabled{color:var(--color-on-success)}.disabled\\:sl-text-on-warning:disabled{color:var(--color-on-warning)}.disabled\\:sl-text-on-danger:disabled{color:var(--color-on-danger)}.disabled\\:sl-text-body:disabled{color:var(--color-text)}.disabled\\:sl-text-muted:disabled{color:var(--color-text-muted)}.disabled\\:sl-text-light:disabled{color:var(--color-text-light)}.disabled\\:sl-text-heading:disabled{color:var(--color-text-heading)}.disabled\\:sl-text-paragraph:disabled{color:var(--color-text-paragraph)}.disabled\\:sl-text-canvas-50:disabled{color:var(--color-canvas-50)}.disabled\\:sl-text-canvas-100:disabled{color:var(--color-canvas-100)}.disabled\\:sl-text-canvas-200:disabled{color:var(--color-canvas-200)}.disabled\\:sl-text-canvas-300:disabled{color:var(--color-canvas-300)}.disabled\\:sl-text-canvas-pure:disabled{color:var(--color-canvas-pure)}.disabled\\:sl-text-canvas:disabled{color:var(--color-canvas)}.disabled\\:sl-text-canvas-dialog:disabled{color:var(--color-canvas-dialog)}.disabled\\:sl-text-link:disabled{color:var(--color-link)}.disabled\\:sl-text-link-dark:disabled{color:var(--color-link-dark)}.sl-underline{text-decoration:underline}.sl-line-through{text-decoration:line-through}.sl-no-underline{text-decoration:none}.sl-truncate{overflow:hidden;white-space:nowrap}.sl-overflow-ellipsis,.sl-truncate{text-overflow:ellipsis}.sl-overflow-clip{text-overflow:clip}.sl-uppercase{text-transform:uppercase}.sl-lowercase{text-transform:lowercase}.sl-capitalize{text-transform:capitalize}.sl-normal-case{text-transform:none}.sl-transform{transform:translateX(var(--tw-translate-x)) translateY(var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.sl-transform,.sl-transform-gpu{--tw-translate-x:0;--tw-translate-y:0;--tw-rotate:0;--tw-skew-x:0;--tw-skew-y:0;--tw-scale-x:1;--tw-scale-y:1}.sl-transform-gpu{transform:translate3d(var(--tw-translate-x),var(--tw-translate-y),0) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.sl-transform-none{transform:none}.sl-delay-75{transition-delay:75ms}.sl-delay-150{transition-delay:.15s}.sl-delay-300{transition-delay:.3s}.sl-delay-500{transition-delay:.5s}.sl-delay-1000{transition-delay:1s}.sl-duration-75{transition-duration:75ms}.sl-duration-150{transition-duration:.15s}.sl-duration-300{transition-duration:.3s}.sl-duration-500{transition-duration:.5s}.sl-duration-1000{transition-duration:1s}.sl-transition{transition-duration:.15s;transition-property:background-color,border-color,color,fill,stroke,opacity,box-shadow,transform;transition-timing-function:cubic-bezier(.4,0,.2,1)}.sl-translate-x-0{--tw-translate-x:0px}.sl-translate-x-1{--tw-translate-x:4px}.sl-translate-x-2{--tw-translate-x:8px}.sl-translate-x-3{--tw-translate-x:12px}.sl-translate-x-4{--tw-translate-x:16px}.sl-translate-x-5{--tw-translate-x:20px}.sl-translate-x-6{--tw-translate-x:24px}.sl-translate-x-7{--tw-translate-x:28px}.sl-translate-x-8{--tw-translate-x:32px}.sl-translate-x-9{--tw-translate-x:36px}.sl-translate-x-10{--tw-translate-x:40px}.sl-translate-x-11{--tw-translate-x:44px}.sl-translate-x-12{--tw-translate-x:48px}.sl-translate-x-14{--tw-translate-x:56px}.sl-translate-x-16{--tw-translate-x:64px}.sl-translate-x-20{--tw-translate-x:80px}.sl-translate-x-24{--tw-translate-x:96px}.sl-translate-x-32{--tw-translate-x:128px}.sl-translate-x-40{--tw-translate-x:160px}.sl-translate-x-60{--tw-translate-x:240px}.sl-translate-x-80{--tw-translate-x:320px}.sl-translate-x-px{--tw-translate-x:1px}.sl-translate-x-0\\.5{--tw-translate-x:2px}.sl-translate-x-1\\.5{--tw-translate-x:6px}.sl-translate-x-2\\.5{--tw-translate-x:10px}.sl-translate-x-3\\.5{--tw-translate-x:14px}.sl--translate-x-0{--tw-translate-x:0px}.sl--translate-x-1{--tw-translate-x:-4px}.sl--translate-x-2{--tw-translate-x:-8px}.sl--translate-x-3{--tw-translate-x:-12px}.sl--translate-x-4{--tw-translate-x:-16px}.sl--translate-x-5{--tw-translate-x:-20px}.sl--translate-x-6{--tw-translate-x:-24px}.sl--translate-x-7{--tw-translate-x:-28px}.sl--translate-x-8{--tw-translate-x:-32px}.sl--translate-x-9{--tw-translate-x:-36px}.sl--translate-x-10{--tw-translate-x:-40px}.sl--translate-x-11{--tw-translate-x:-44px}.sl--translate-x-12{--tw-translate-x:-48px}.sl--translate-x-14{--tw-translate-x:-56px}.sl--translate-x-16{--tw-translate-x:-64px}.sl--translate-x-20{--tw-translate-x:-80px}.sl--translate-x-24{--tw-translate-x:-96px}.sl--translate-x-32{--tw-translate-x:-128px}.sl--translate-x-40{--tw-translate-x:-160px}.sl--translate-x-60{--tw-translate-x:-240px}.sl--translate-x-80{--tw-translate-x:-320px}.sl--translate-x-px{--tw-translate-x:-1px}.sl--translate-x-0\\.5{--tw-translate-x:-2px}.sl--translate-x-1\\.5{--tw-translate-x:-6px}.sl--translate-x-2\\.5{--tw-translate-x:-10px}.sl--translate-x-3\\.5{--tw-translate-x:-14px}.sl-translate-y-0{--tw-translate-y:0px}.sl-translate-y-1{--tw-translate-y:4px}.sl-translate-y-2{--tw-translate-y:8px}.sl-translate-y-3{--tw-translate-y:12px}.sl-translate-y-4{--tw-translate-y:16px}.sl-translate-y-5{--tw-translate-y:20px}.sl-translate-y-6{--tw-translate-y:24px}.sl-translate-y-7{--tw-translate-y:28px}.sl-translate-y-8{--tw-translate-y:32px}.sl-translate-y-9{--tw-translate-y:36px}.sl-translate-y-10{--tw-translate-y:40px}.sl-translate-y-11{--tw-translate-y:44px}.sl-translate-y-12{--tw-translate-y:48px}.sl-translate-y-14{--tw-translate-y:56px}.sl-translate-y-16{--tw-translate-y:64px}.sl-translate-y-20{--tw-translate-y:80px}.sl-translate-y-24{--tw-translate-y:96px}.sl-translate-y-32{--tw-translate-y:128px}.sl-translate-y-40{--tw-translate-y:160px}.sl-translate-y-60{--tw-translate-y:240px}.sl-translate-y-80{--tw-translate-y:320px}.sl-translate-y-px{--tw-translate-y:1px}.sl-translate-y-0\\.5{--tw-translate-y:2px}.sl-translate-y-1\\.5{--tw-translate-y:6px}.sl-translate-y-2\\.5{--tw-translate-y:10px}.sl-translate-y-3\\.5{--tw-translate-y:14px}.sl--translate-y-0{--tw-translate-y:0px}.sl--translate-y-1{--tw-translate-y:-4px}.sl--translate-y-2{--tw-translate-y:-8px}.sl--translate-y-3{--tw-translate-y:-12px}.sl--translate-y-4{--tw-translate-y:-16px}.sl--translate-y-5{--tw-translate-y:-20px}.sl--translate-y-6{--tw-translate-y:-24px}.sl--translate-y-7{--tw-translate-y:-28px}.sl--translate-y-8{--tw-translate-y:-32px}.sl--translate-y-9{--tw-translate-y:-36px}.sl--translate-y-10{--tw-translate-y:-40px}.sl--translate-y-11{--tw-translate-y:-44px}.sl--translate-y-12{--tw-translate-y:-48px}.sl--translate-y-14{--tw-translate-y:-56px}.sl--translate-y-16{--tw-translate-y:-64px}.sl--translate-y-20{--tw-translate-y:-80px}.sl--translate-y-24{--tw-translate-y:-96px}.sl--translate-y-32{--tw-translate-y:-128px}.sl--translate-y-40{--tw-translate-y:-160px}.sl--translate-y-60{--tw-translate-y:-240px}.sl--translate-y-80{--tw-translate-y:-320px}.sl--translate-y-px{--tw-translate-y:-1px}.sl--translate-y-0\\.5{--tw-translate-y:-2px}.sl--translate-y-1\\.5{--tw-translate-y:-6px}.sl--translate-y-2\\.5{--tw-translate-y:-10px}.sl--translate-y-3\\.5{--tw-translate-y:-14px}.hover\\:sl-translate-x-0:hover{--tw-translate-x:0px}.hover\\:sl-translate-x-1:hover{--tw-translate-x:4px}.hover\\:sl-translate-x-2:hover{--tw-translate-x:8px}.hover\\:sl-translate-x-3:hover{--tw-translate-x:12px}.hover\\:sl-translate-x-4:hover{--tw-translate-x:16px}.hover\\:sl-translate-x-5:hover{--tw-translate-x:20px}.hover\\:sl-translate-x-6:hover{--tw-translate-x:24px}.hover\\:sl-translate-x-7:hover{--tw-translate-x:28px}.hover\\:sl-translate-x-8:hover{--tw-translate-x:32px}.hover\\:sl-translate-x-9:hover{--tw-translate-x:36px}.hover\\:sl-translate-x-10:hover{--tw-translate-x:40px}.hover\\:sl-translate-x-11:hover{--tw-translate-x:44px}.hover\\:sl-translate-x-12:hover{--tw-translate-x:48px}.hover\\:sl-translate-x-14:hover{--tw-translate-x:56px}.hover\\:sl-translate-x-16:hover{--tw-translate-x:64px}.hover\\:sl-translate-x-20:hover{--tw-translate-x:80px}.hover\\:sl-translate-x-24:hover{--tw-translate-x:96px}.hover\\:sl-translate-x-32:hover{--tw-translate-x:128px}.hover\\:sl-translate-x-40:hover{--tw-translate-x:160px}.hover\\:sl-translate-x-60:hover{--tw-translate-x:240px}.hover\\:sl-translate-x-80:hover{--tw-translate-x:320px}.hover\\:sl-translate-x-px:hover{--tw-translate-x:1px}.hover\\:sl-translate-x-0\\.5:hover{--tw-translate-x:2px}.hover\\:sl-translate-x-1\\.5:hover{--tw-translate-x:6px}.hover\\:sl-translate-x-2\\.5:hover{--tw-translate-x:10px}.hover\\:sl-translate-x-3\\.5:hover{--tw-translate-x:14px}.hover\\:sl--translate-x-0:hover{--tw-translate-x:0px}.hover\\:sl--translate-x-1:hover{--tw-translate-x:-4px}.hover\\:sl--translate-x-2:hover{--tw-translate-x:-8px}.hover\\:sl--translate-x-3:hover{--tw-translate-x:-12px}.hover\\:sl--translate-x-4:hover{--tw-translate-x:-16px}.hover\\:sl--translate-x-5:hover{--tw-translate-x:-20px}.hover\\:sl--translate-x-6:hover{--tw-translate-x:-24px}.hover\\:sl--translate-x-7:hover{--tw-translate-x:-28px}.hover\\:sl--translate-x-8:hover{--tw-translate-x:-32px}.hover\\:sl--translate-x-9:hover{--tw-translate-x:-36px}.hover\\:sl--translate-x-10:hover{--tw-translate-x:-40px}.hover\\:sl--translate-x-11:hover{--tw-translate-x:-44px}.hover\\:sl--translate-x-12:hover{--tw-translate-x:-48px}.hover\\:sl--translate-x-14:hover{--tw-translate-x:-56px}.hover\\:sl--translate-x-16:hover{--tw-translate-x:-64px}.hover\\:sl--translate-x-20:hover{--tw-translate-x:-80px}.hover\\:sl--translate-x-24:hover{--tw-translate-x:-96px}.hover\\:sl--translate-x-32:hover{--tw-translate-x:-128px}.hover\\:sl--translate-x-40:hover{--tw-translate-x:-160px}.hover\\:sl--translate-x-60:hover{--tw-translate-x:-240px}.hover\\:sl--translate-x-80:hover{--tw-translate-x:-320px}.hover\\:sl--translate-x-px:hover{--tw-translate-x:-1px}.hover\\:sl--translate-x-0\\.5:hover{--tw-translate-x:-2px}.hover\\:sl--translate-x-1\\.5:hover{--tw-translate-x:-6px}.hover\\:sl--translate-x-2\\.5:hover{--tw-translate-x:-10px}.hover\\:sl--translate-x-3\\.5:hover{--tw-translate-x:-14px}.hover\\:sl-translate-y-0:hover{--tw-translate-y:0px}.hover\\:sl-translate-y-1:hover{--tw-translate-y:4px}.hover\\:sl-translate-y-2:hover{--tw-translate-y:8px}.hover\\:sl-translate-y-3:hover{--tw-translate-y:12px}.hover\\:sl-translate-y-4:hover{--tw-translate-y:16px}.hover\\:sl-translate-y-5:hover{--tw-translate-y:20px}.hover\\:sl-translate-y-6:hover{--tw-translate-y:24px}.hover\\:sl-translate-y-7:hover{--tw-translate-y:28px}.hover\\:sl-translate-y-8:hover{--tw-translate-y:32px}.hover\\:sl-translate-y-9:hover{--tw-translate-y:36px}.hover\\:sl-translate-y-10:hover{--tw-translate-y:40px}.hover\\:sl-translate-y-11:hover{--tw-translate-y:44px}.hover\\:sl-translate-y-12:hover{--tw-translate-y:48px}.hover\\:sl-translate-y-14:hover{--tw-translate-y:56px}.hover\\:sl-translate-y-16:hover{--tw-translate-y:64px}.hover\\:sl-translate-y-20:hover{--tw-translate-y:80px}.hover\\:sl-translate-y-24:hover{--tw-translate-y:96px}.hover\\:sl-translate-y-32:hover{--tw-translate-y:128px}.hover\\:sl-translate-y-40:hover{--tw-translate-y:160px}.hover\\:sl-translate-y-60:hover{--tw-translate-y:240px}.hover\\:sl-translate-y-80:hover{--tw-translate-y:320px}.hover\\:sl-translate-y-px:hover{--tw-translate-y:1px}.hover\\:sl-translate-y-0\\.5:hover{--tw-translate-y:2px}.hover\\:sl-translate-y-1\\.5:hover{--tw-translate-y:6px}.hover\\:sl-translate-y-2\\.5:hover{--tw-translate-y:10px}.hover\\:sl-translate-y-3\\.5:hover{--tw-translate-y:14px}.hover\\:sl--translate-y-0:hover{--tw-translate-y:0px}.hover\\:sl--translate-y-1:hover{--tw-translate-y:-4px}.hover\\:sl--translate-y-2:hover{--tw-translate-y:-8px}.hover\\:sl--translate-y-3:hover{--tw-translate-y:-12px}.hover\\:sl--translate-y-4:hover{--tw-translate-y:-16px}.hover\\:sl--translate-y-5:hover{--tw-translate-y:-20px}.hover\\:sl--translate-y-6:hover{--tw-translate-y:-24px}.hover\\:sl--translate-y-7:hover{--tw-translate-y:-28px}.hover\\:sl--translate-y-8:hover{--tw-translate-y:-32px}.hover\\:sl--translate-y-9:hover{--tw-translate-y:-36px}.hover\\:sl--translate-y-10:hover{--tw-translate-y:-40px}.hover\\:sl--translate-y-11:hover{--tw-translate-y:-44px}.hover\\:sl--translate-y-12:hover{--tw-translate-y:-48px}.hover\\:sl--translate-y-14:hover{--tw-translate-y:-56px}.hover\\:sl--translate-y-16:hover{--tw-translate-y:-64px}.hover\\:sl--translate-y-20:hover{--tw-translate-y:-80px}.hover\\:sl--translate-y-24:hover{--tw-translate-y:-96px}.hover\\:sl--translate-y-32:hover{--tw-translate-y:-128px}.hover\\:sl--translate-y-40:hover{--tw-translate-y:-160px}.hover\\:sl--translate-y-60:hover{--tw-translate-y:-240px}.hover\\:sl--translate-y-80:hover{--tw-translate-y:-320px}.hover\\:sl--translate-y-px:hover{--tw-translate-y:-1px}.hover\\:sl--translate-y-0\\.5:hover{--tw-translate-y:-2px}.hover\\:sl--translate-y-1\\.5:hover{--tw-translate-y:-6px}.hover\\:sl--translate-y-2\\.5:hover{--tw-translate-y:-10px}.hover\\:sl--translate-y-3\\.5:hover{--tw-translate-y:-14px}.sl-select-none{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.sl-select-text{-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text}.sl-select-all{-webkit-user-select:all;-moz-user-select:all;user-select:all}.sl-select-auto{-webkit-user-select:auto;-moz-user-select:auto;-ms-user-select:auto;user-select:auto}.sl-align-baseline{vertical-align:initial}.sl-align-top{vertical-align:top}.sl-align-middle{vertical-align:middle}.sl-align-bottom{vertical-align:bottom}.sl-align-text-top{vertical-align:text-top}.sl-align-text-bottom{vertical-align:text-bottom}.sl-visible{visibility:visible}.sl-invisible{visibility:hidden}.sl-group:hover .group-hover\\:sl-visible{visibility:visible}.sl-group:hover .group-hover\\:sl-invisible{visibility:hidden}.sl-group:focus .group-focus\\:sl-visible{visibility:visible}.sl-group:focus .group-focus\\:sl-invisible{visibility:hidden}.sl-whitespace-normal{white-space:normal}.sl-whitespace-nowrap{white-space:nowrap}.sl-whitespace-pre{white-space:pre}.sl-whitespace-pre-line{white-space:pre-line}.sl-whitespace-pre-wrap{white-space:pre-wrap}.sl-w-0{width:0}.sl-w-1{width:4px}.sl-w-2{width:8px}.sl-w-3{width:12px}.sl-w-4{width:16px}.sl-w-5{width:20px}.sl-w-6{width:24px}.sl-w-7{width:28px}.sl-w-8{width:32px}.sl-w-9{width:36px}.sl-w-10{width:40px}.sl-w-11{width:44px}.sl-w-12{width:48px}.sl-w-14{width:56px}.sl-w-16{width:64px}.sl-w-20{width:80px}.sl-w-24{width:96px}.sl-w-32{width:128px}.sl-w-40{width:160px}.sl-w-60{width:240px}.sl-w-80{width:320px}.sl-w-auto{width:auto}.sl-w-px{width:1px}.sl-w-0\\.5{width:2px}.sl-w-1\\.5{width:6px}.sl-w-2\\.5{width:10px}.sl-w-3\\.5{width:14px}.sl-w-xs{width:20px}.sl-w-sm{width:24px}.sl-w-md{width:32px}.sl-w-lg{width:36px}.sl-w-xl{width:44px}.sl-w-2xl{width:52px}.sl-w-3xl{width:60px}.sl-w-1\\/2{width:50%}.sl-w-1\\/3{width:33.333333%}.sl-w-2\\/3{width:66.666667%}.sl-w-1\\/4{width:25%}.sl-w-2\\/4{width:50%}.sl-w-3\\/4{width:75%}.sl-w-1\\/5{width:20%}.sl-w-2\\/5{width:40%}.sl-w-3\\/5{width:60%}.sl-w-4\\/5{width:80%}.sl-w-1\\/6{width:16.666667%}.sl-w-2\\/6{width:33.333333%}.sl-w-3\\/6{width:50%}.sl-w-4\\/6{width:66.666667%}.sl-w-5\\/6{width:83.333333%}.sl-w-full{width:100%}.sl-w-screen{width:100vw}.sl-w-min{width:-moz-min-content;width:min-content}.sl-w-max{width:-moz-max-content;width:max-content}.sl-break-normal{overflow-wrap:normal;word-break:normal}.sl-break-words{overflow-wrap:break-word}.sl-break-all{word-break:break-all}.sl-z-0{z-index:0}.sl-z-10{z-index:10}.sl-z-20{z-index:20}.sl-z-30{z-index:30}.sl-z-40{z-index:40}.sl-z-50{z-index:50}.sl-z-auto{z-index:auto}.focus\\:sl-z-0:focus{z-index:0}.focus\\:sl-z-10:focus{z-index:10}.focus\\:sl-z-20:focus{z-index:20}.focus\\:sl-z-30:focus{z-index:30}.focus\\:sl-z-40:focus{z-index:40}.focus\\:sl-z-50:focus{z-index:50}.focus\\:sl-z-auto:focus{z-index:auto}:root{--font-prose:ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";--font-ui:Inter,ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";--font-mono:\"SF Mono\",ui-monospace,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace;--font-code:var(--font-mono);--fs-paragraph-leading:22px;--fs-paragraph:16px;--fs-code:14px;--fs-paragraph-small:14px;--fs-paragraph-tiny:12px;--lh-paragraph-leading:1.875;--lh-paragraph:1.625;--lh-code:1.5;--lh-paragraph-small:1.625;--lh-paragraph-tiny:1.625;--color-code:var(--color-canvas-tint);--color-on-code:var(--color-text-heading)}.sl-aspect-ratio:before{content:\"\";display:block;height:0;padding-bottom:calc(1/var(--ratio)*100%)}.sl-aspect-ratio>:not(style){align-items:center;bottom:0;display:flex;height:100%;justify-content:center;left:0;overflow:hidden;position:absolute;right:0;top:0;width:100%}.sl-aspect-ratio>img,.sl-aspect-ratio>video{object-fit:cover}.sl-badge{align-items:center;border-width:1px;display:inline-flex;outline:2px solid transparent;outline-offset:2px}.sl-badge a{color:var(--color-text-muted)}.sl-badge a:hover{color:var(--color-text);cursor:pointer}.sl-button{align-items:center;display:inline-flex;line-height:0;outline:2px solid transparent;outline-offset:2px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.sl-button-group>.sl-button:not(:first-child):not(:last-child){border-radius:0;border-right:0}.sl-button-group>.sl-button:first-child:not(:last-child){border-bottom-right-radius:0;border-right:0;border-top-right-radius:0}.sl-button-group>.sl-button:last-child:not(:first-child){border-bottom-left-radius:0;border-top-left-radius:0}.sl-image--inverted{filter:invert(1) hue-rotate(180deg);mix-blend-mode:screen}.Link,.Link>code{color:var(--color-link)}.Link:hover,.Link:hover>code{color:var(--color-link-dark)}.sl-link-heading:hover .sl-link-heading__icon{opacity:1}.sl-link-heading__icon{opacity:0}.sl-menu{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.sl-menu--pointer-interactions .sl-menu-item:not(.sl-menu-item--disabled):hover{background-color:var(--color-primary);color:var(--color-on-primary)}.sl-menu--pointer-interactions .sl-menu-item:not(.sl-menu-item--disabled):hover .sl-menu-item__icon{color:var(--color-on-primary)!important}.sl-menu-item__link-icon,.sl-menu-item__meta{opacity:.6}.sl-menu-item--focused{background-color:var(--color-primary);color:var(--color-on-primary)}.sl-menu-item--focused .sl-menu-item__link-icon,.sl-menu-item--focused .sl-menu-item__meta{opacity:1}.sl-menu-item--focused .sl-menu-item__icon{color:var(--color-on-primary)!important}.sl-menu-item--submenu-active{background-color:var(--color-primary-tint)}.sl-popover{--tw-blur:var(--tw-empty,/*!*/ /*!*/);--tw-brightness:var(--tw-empty,/*!*/ /*!*/);--tw-contrast:var(--tw-empty,/*!*/ /*!*/);--tw-grayscale:var(--tw-empty,/*!*/ /*!*/);--tw-hue-rotate:var(--tw-empty,/*!*/ /*!*/);--tw-invert:var(--tw-empty,/*!*/ /*!*/);--tw-saturate:var(--tw-empty,/*!*/ /*!*/);--tw-sepia:var(--tw-empty,/*!*/ /*!*/);--tw-drop-shadow:var(--tw-empty,/*!*/ /*!*/);--tw-drop-shadow:drop-shadow(var(--drop-shadow-default1)) drop-shadow(var(--drop-shadow-default2));border-radius:2px;filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.sl-popover>:not(.sl-popover__tip){border-radius:2px;position:relative;z-index:10}.sl-prose{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;--fs-paragraph:1em;--fs-paragraph-small:0.875em;--fs-code:0.875em;font-family:var(--font-prose);font-size:16px;line-height:var(--lh-paragraph)}.sl-prose>:first-child{margin-top:0}.sl-prose>:last-child{margin-bottom:0}.sl-prose h1{font-size:2.25em}.sl-prose>h1{margin-bottom:1.11em;margin-top:0}.sl-prose h2{font-size:1.75em;line-height:1.3333333}.sl-prose>h2{margin-bottom:1em;margin-top:1.428em}.sl-prose>h1:first-child+h2{color:var(--color-text-muted);font-size:20px;font-size:1.25em;font-weight:400;line-height:1.5;margin-bottom:2em;margin-top:-1.5em}.sl-prose h3{font-size:1.25em}.sl-prose>h3{margin-bottom:.8em;margin-top:2em}.sl-prose h4{font-size:1em}.sl-prose>h4{margin-bottom:.5em;margin-top:2em}.sl-prose h2+*,.sl-prose h3+*,.sl-prose h4+*{margin-top:0}.sl-prose strong{font-weight:600}.sl-prose .sl-text-lg{font-size:.875em}.sl-prose p{color:var(--color-text-paragraph);font-size:var(--fs-paragraph);margin-bottom:1em;margin-top:1em}.sl-prose p:first-child{margin-top:0}.sl-prose p:last-child{margin-bottom:0}.sl-prose p>a>img{display:inline}.sl-prose caption a,.sl-prose figcaption a,.sl-prose li a,.sl-prose p a,.sl-prose table a{color:var(--color-link)}.sl-prose caption a:hover,.sl-prose figcaption a:hover,.sl-prose li a:hover,.sl-prose p a:hover,.sl-prose table a:hover{color:var(--color-link-dark)}.sl-prose caption a,.sl-prose figcaption a,.sl-prose li a,.sl-prose p a,.sl-prose table a{--color-link:var(--color-text-primary);--color-link-dark:var(--color-primary-dark)}.sl-prose hr{margin-bottom:1em;margin-top:1em}.sl-prose .sl-live-code{margin-bottom:1.25em;margin-left:-4px;margin-right:-4px;margin-top:1.25em;table-layout:auto;width:100%}.sl-prose .sl-live-code__inner>pre{margin-bottom:0;margin-top:0}.sl-prose .sl-callout{margin-bottom:1.5em;margin-top:1.5em}.sl-prose ol,.sl-prose ul{counter-reset:list-counter;line-height:var(--lh-paragraph);margin-bottom:1.5em;margin-top:1.5em}.sl-prose ol li,.sl-prose ul li{padding-left:2em}.sl-prose ol li{counter-increment:list-counter;position:relative}.sl-prose ol li:before{content:counter(list-counter) \".\";left:.75em;position:absolute}.sl-prose ul:not(.contains-task-list) li{position:relative}.sl-prose ul:not(.contains-task-list) li:before{background-color:var(--color-text);border-radius:50%;content:\"\";height:.375em;left:.75em;opacity:.7;position:absolute;top:.625em;width:.375em}.sl-prose li{margin-bottom:4px;margin-top:4px;padding-left:1.75em}.sl-prose li p{margin-bottom:.75em;margin-top:.75em}.sl-prose li>:first-child{margin-top:0}.sl-prose>ol p+:last-child,.sl-prose>ul p+:last-child{margin-bottom:.75em}.sl-prose ol ol,.sl-prose ol ul,.sl-prose ul ol,.sl-prose ul ul{margin-bottom:2px;margin-top:2px}.sl-prose ul.contains-task-list input{margin-left:-1.875em;margin-right:.625em;position:relative;top:1px}.sl-prose ul.contains-task-list p{margin-top:0}.sl-prose figure{margin-bottom:1.5em;margin-top:1.5em}.sl-prose figure figure,.sl-prose figure img,.sl-prose figure video{margin-bottom:0;margin-top:0}.sl-prose figure>figcaption,.sl-prose figure>figcaption p{color:var(--color-text-muted);font-size:var(--fs-paragraph-small);line-height:var(--lh-paragraph-small);margin-top:8px;padding-left:16px;padding-right:16px;text-align:center}.sl-prose blockquote p{margin-bottom:.5em;margin-top:.5em}.sl-prose table{font-size:var(--fs-paragraph-small);margin-bottom:1.5em;margin-left:-4px;margin-right:-4px;overflow-x:auto;table-layout:auto;width:100%}.sl-prose thead td,.sl-prose thead th{color:var(--color-text-muted);font-size:.857em;font-weight:500;padding:8px 12px;text-transform:uppercase}.sl-prose thead td:first-child,.sl-prose thead th:first-child{padding-left:4px}.sl-prose tbody{border-radius:5px;box-shadow:0 0 0 1px var(--color-border,currentColor)}.sl-prose tbody tr{border-top-width:1px}.sl-prose tbody tr:first-child{border-top:0}.sl-prose tbody tr:nth-child(2n){background-color:var(--color-canvas-tint)}.sl-prose td{margin:.625em .75em;padding:10px 12px;vertical-align:top}.sl-prose td:not([align=center],[align=right]),.sl-prose th:not([align=center],[align=right]){text-align:left}.sl-prose .JsonSchemaViewer{border-radius:5px;border-width:1px;margin-left:-4px;margin-right:-4px}.sl-prose .mermaid{margin-bottom:1.5em;margin-top:1.5em}.sl-prose .mermaid>svg{border-radius:5px;border-width:1px;height:auto!important;padding:1.25em}.sl-prose .sl-code-group .mermaid,.sl-prose .sl-code-group pre{margin-top:0}.sl-svg-focus{filter:drop-shadow(0 0 1px hsla(var(--primary-h),80%,51%,.9))}.sl-radio-group__radio:hover{cursor:pointer}.sl-radio-group__radio--disabled{opacity:.6}.sl-radio-group__radio--disabled:hover{cursor:not-allowed}.sl-stack--horizontal.sl-stack--2>:not(style)~:not(style){margin-left:8px}.sl-stack--horizontal.sl-stack--3>:not(style)~:not(style){margin-left:12px}.sl-stack--horizontal.sl-stack--4>:not(style)~:not(style){margin-left:16px}.sl-stack--horizontal.sl-stack--6>:not(style)~:not(style){margin-left:24px}.sl-stack--horizontal.sl-stack--8>:not(style)~:not(style){margin-left:32px}.sl-stack--horizontal.sl-stack--10>:not(style)~:not(style){margin-left:40px}.sl-stack--horizontal.sl-stack--12>:not(style)~:not(style){margin-left:48px}.sl-stack--horizontal.sl-stack--14>:not(style)~:not(style){margin-left:56px}.sl-stack--horizontal.sl-stack--16>:not(style)~:not(style){margin-left:64px}.sl-stack--horizontal.sl-stack--20>:not(style)~:not(style){margin-left:80px}.sl-stack--horizontal.sl-stack--24>:not(style)~:not(style){margin-left:96px}.sl-stack--horizontal.sl-stack--32>:not(style)~:not(style){margin-left:128px}.sl-stack--vertical.sl-stack--2>:not(style)~:not(style){margin-top:8px}.sl-stack--vertical.sl-stack--3>:not(style)~:not(style){margin-top:12px}.sl-stack--vertical.sl-stack--4>:not(style)~:not(style){margin-top:16px}.sl-stack--vertical.sl-stack--6>:not(style)~:not(style){margin-top:24px}.sl-stack--vertical.sl-stack--8>:not(style)~:not(style){margin-top:32px}.sl-stack--vertical.sl-stack--10>:not(style)~:not(style){margin-top:40px}.sl-stack--vertical.sl-stack--12>:not(style)~:not(style){margin-top:48px}.sl-stack--vertical.sl-stack--14>:not(style)~:not(style){margin-top:56px}.sl-stack--vertical.sl-stack--16>:not(style)~:not(style){margin-top:64px}.sl-stack--vertical.sl-stack--20>:not(style)~:not(style){margin-top:80px}.sl-stack--vertical.sl-stack--24>:not(style)~:not(style){margin-top:96px}.sl-stack--vertical.sl-stack--32>:not(style)~:not(style){margin-top:128px}.sl-switch .sl-switch__indicator{transition:background-color .1s cubic-bezier(.4,1,.75,.9)}.sl-switch .sl-switch__indicator .sl-switch__icon{visibility:hidden}.sl-switch .sl-switch__indicator:before{background-color:var(--color-canvas);border-radius:50%;content:\"\";height:calc(100% - 4px);left:0;margin:2px;position:absolute;transition:left .1s cubic-bezier(.4,1,.75,.9);width:calc(50% - 4px)}.sl-switch input:checked:disabled~.sl-switch__indicator{background-color:var(--color-primary-light)}.sl-switch input:checked~.sl-switch__indicator{background-color:var(--color-primary)}.sl-switch input:checked~.sl-switch__indicator .sl-switch__icon{visibility:visible}.sl-switch input:checked~.sl-switch__indicator:before{left:50%}.sl-tooltip{--tw-blur:var(--tw-empty,/*!*/ /*!*/);--tw-brightness:var(--tw-empty,/*!*/ /*!*/);--tw-contrast:var(--tw-empty,/*!*/ /*!*/);--tw-grayscale:var(--tw-empty,/*!*/ /*!*/);--tw-hue-rotate:var(--tw-empty,/*!*/ /*!*/);--tw-invert:var(--tw-empty,/*!*/ /*!*/);--tw-saturate:var(--tw-empty,/*!*/ /*!*/);--tw-sepia:var(--tw-empty,/*!*/ /*!*/);--tw-drop-shadow:var(--tw-empty,/*!*/ /*!*/);--tw-drop-shadow:drop-shadow(var(--drop-shadow-default1)) drop-shadow(var(--drop-shadow-default2));border-radius:2px;filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);font-size:11px;max-width:300px;padding:4px 6px}.sl-tooltip>:not(.sl-tooltip_tip){position:relative;z-index:10}input{background-color:initial}.sl-focus-ring{--tw-ring-color:hsla(var(--primary-h),80%,61%,var(--tw-ring-opacity)) ;;--tw-ring-opacity:0.5;--tw-ring-offset-shadow:var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow:var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);border-radius:2px;box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow,0 0 #0000)}";
var GLOBAL_CSS_ID = 'mosaic-global';
var GLOBAL_CSS_THEME_ID = 'mosaic-theme';

var injectStyles = function injectStyles() {
  var _ref21 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      mode = _ref21.mode;

  // do not attempt if we are not in a browser environment
  if (typeof document === 'undefined') return;
  appendCss(GLOBAL_CSS_ID, css);
  return subscribeTheme({
    mode: mode
  });
};

var subscribeTheme = function subscribeTheme() {
  var _ref22 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      initialMode = _ref22.mode;

  // do not attempt if we are not in a browser environment
  if (typeof document === 'undefined') return; // allow user to force a starting theme mode if they so desire

  if (initialMode) {
    useThemeStore.getState().setMode(initialMode);
  }

  var _useThemeStore$getSta = useThemeStore.getState(),
      theme = _useThemeStore$getSta.theme,
      mode = _useThemeStore$getSta.mode;
  /**
   * If user did not init theme earlier, do so now
   */


  var dataTheme = document.documentElement.getAttribute('data-theme');

  if (!dataTheme) {
    document.documentElement.setAttribute('data-theme', getResolvedThemeMode(mode));
  }

  injectTheme(theme, mode);
  var unsub = useThemeStore.subscribe(function (state) {
    try {
      injectTheme(state.theme, state.mode);
    } catch (e) {
      // noop, usually due to in flight theme change while user is editing
      console.warn('Error computing and applying theme', e);
    }
  }, function (s) {
    return {
      mode: s.mode,
      theme: s.theme
    };
  }, shallow);
  return unsub;
};

var injectTheme = function injectTheme(theme, mode) {
  var _useThemeStore$getSta2 = useThemeStore.getState(),
      setColorValues = _useThemeStore$getSta2.setColorValues,
      setInvertedColorValues = _useThemeStore$getSta2.setInvertedColorValues;

  if (typeof document !== 'undefined') {
    var userMode = getResolvedThemeMode(mode);
    document.documentElement.setAttribute('data-theme', userMode);
  }

  var _computeTheme = computeTheme(theme, 'light'),
      lightCss = _computeTheme.css;

  var _computeTheme2 = computeTheme(theme, 'dark'),
      darkCss = _computeTheme2.css;

  replaceCss("".concat(GLOBAL_CSS_THEME_ID, "-light"), lightCss);
  replaceCss("".concat(GLOBAL_CSS_THEME_ID, "-dark"), darkCss);

  var _computeTheme3 = computeTheme(theme, mode),
      colorValues = _computeTheme3.colorValues,
      invertedColorValues = _computeTheme3.invertedColorValues;

  setColorValues(colorValues);
  setInvertedColorValues(invertedColorValues);
};

var InlineStyles = function InlineStyles() {
  return jsxs(Fragment, {
    children: [jsx("style", {
      id: GLOBAL_CSS_ID,
      type: "text/css",
      dangerouslySetInnerHTML: {
        __html: css
      }
    }, void 0), jsx(InlineTheme, {}, void 0)]
  }, void 0);
};

var InlineTheme = function InlineTheme() {
  var _useThemeStore3 = useThemeStore(),
      theme = _useThemeStore3.theme;

  return jsxs(Fragment, {
    children: [jsx("style", {
      id: "".concat(GLOBAL_CSS_THEME_ID, "-light"),
      type: "text/css",
      dangerouslySetInnerHTML: {
        __html: computeTheme(theme, 'light').css
      }
    }, void 0), jsx("style", {
      id: "".concat(GLOBAL_CSS_THEME_ID, "-dark"),
      type: "text/css",
      dangerouslySetInnerHTML: {
        __html: computeTheme(theme, 'dark').css
      }
    }, void 0)]
  }, void 0);
};
/**
 * Small snippet to set the basics re theme as early as possible during rendering, to avoid major flashes of white etc.
 */


var INIT_THEME_JS = "try {\n  var query = window.matchMedia(\"(prefers-color-scheme: dark)\");\n\n  var preference = window.localStorage.getItem('".concat(THEME_STORAGE_KEY, "');\n  preference = preference ? JSON.parse(preference) : { mode: \"").concat(DEFAULT_THEME_MODE, "\" };\n\n  var theme = (preference.mode === \"system\" && query.matches) || preference.mode === \"dark\" ? \"dark\" : \"light\";\n  document.documentElement.setAttribute('data-theme', theme);\n} catch (e) {\n  console.warn('problem setting initial theme mode', e);\n}");

var InitTheme = function InitTheme() {
  return jsx("script", {
    dangerouslySetInnerHTML: {
      __html: INIT_THEME_JS
    }
  }, void 0);
};

export { Article, AspectRatio, Avatar, Badge, Box, _Button as Button, ButtonGroup, Callout, Card, Code, Container, _CopyButton as CopyButton, DEFAULT_THEME_MODE, Divider$1 as Divider, EntityName, _FieldButton as FieldButton, Flex, GLOBAL_CSS_ID, GLOBAL_CSS_THEME_ID, Grid, HStack, Heading, INIT_THEME_JS, Icon, Image, InitTheme, InlineStyles, Input, InvertTheme, InvertThemeContext, Link, LinkHeading, ListBox, ListBoxItem, Menu, Modal, NoSsr, _Overlay as Overlay, Panel, Paragraph, Popover, ProductImage, Prose, MosaicProvider as Provider, Radio, RadioGroup, _Select as Select, Stack, Switch, THEME_STORAGE_KEY, Tab, TabImpl, TabList, TabPanel, TabPanels, Tabs, Text, Textarea, Tooltip, TreeItem, VStack, WithDomRef, __DEV__, accumulateCollectionKeysByProp, appendCss, borderPropNames, borderProps, colorPropNames, colorProps, computeTheme, containerSizes, defaultTheme, error, findCss, flexPropNames, flexProps, getContrastColor, getCssVariable, getInteractionModality, getResolvedThemeMode, injectStyles, interactivityPropNames, interactivityProps, isArray, isDefined, isEmpty, isEmptyArray, isEmptyObject, isFunction, isIconDefinition, isIconProp, isInputEvent, isNotEmptyObject, isNotNumber, isNull, isNumber, isNumeric, isObject$1 as isObject, isString, isUndefined, layoutPropNames, layoutProps, marginProps, noop, once, paddingProps, parseHsl, positionPropNames, positionProps, prefersDarkMode, replaceCss, ringPropNames, ringProps, runIfFn, shadowPropNames, shadowProps, sizePropNames, sizeProps, spacingPropNames, splitBoxProps, splitProps, stringifyHsl, subscribeTheme, transformPropNames, transformProps, typographyPropNames, typographyProps, useClipboard, useCollectionKeyAccumulator, useControllableProp, useControllableState, useIconStore, useInteractionModality, useModalState, useMosaicContext, useOverlay, useOverlayPosition, useTheme, useThemeIsDark, useThemeIsInverted, useThemeMode, useThemeStore, warn };